import _defineProperty from '@babel/runtime/helpers/defineProperty';

var basic = {
	card: {
		from: "From",
		people: "people"
	},
	search: {
		clear: "Empty",
		holder: "Search"
	},
	inviteNotify: {
		title: "Invited to join the collaboration",
		subTitle: "You can remind the other party to log in to the WPS Docs and view your invitation in \"Home-Message\"",
		confirmText: "I see"
	},
	linkCreate: {
		title: "Share link permissions",
		cancelTxt: "Cancel",
		confirmTxt: "Create and share"
	},
	memberItem: {
		more: "More information"
	},
	deleteContent: {
		cancelDel: "Please confirm deletion",
		delDesc: "After deleting the contact, the user will not appear in my contact list",
		confirmDel: "Please confirm deletion",
		files: "File, folder",
		delNopower: "After deletion, team members will not be able to access the team",
		members: "Members",
		confirmOut: "Please confirm exit",
		outNopower: "You will not be able to access the team after logging out",
		cancel: "Cancel",
		confirm: "Confirm"
	},
	noticeCard: {
		markWait: "Mark for later",
		markDeal: "Mark as \"To be Processed\"",
		title: "Unknown type notification"
	},
	scroll: {
		loadingText: "Loading..."
	},
	voice: {
		errorText: "Playback failed"
	},
	clinkCreate: {
		txt0: "Share publicly",
		txt1: "Anyone can view",
		txt2: "Suitable for public sharing of files",
		txt3: "Anyone can edit",
		txt4: "Suitable for multi-person collaboration, edited content updates in real time",
		txt5: "Specified sharing",
		txt6: "Members of this enterprise can view",
		txt7: "Members of this enterprise can edit",
		txt8: "Only designated people can view/edit",
		txt9: "Only designated people can view",
		txt10: "Applicable to private files, viewing/editing permissions are specified",
		txt11: "Applicable to private files, can specify viewing permissions",
		txt12: "Cancel",
		txt13: "Create and share",
		company_admin: "The enterprise administrator",
		group_admin: "The team administrator",
		txt14: " has banned file sharing outside the enterprise",
		txt15: " has banned file sharing outside the team",
		txt16: "Understand the link sharing feature quickly ",
		securetip_head: "This document is protected by encryption",
		securetip_txt1: "The sharing permission control only allows the specified person to view/edit the document.",
		securetip_txt2: "Members authorized in the document can automatically obtain link access permission.",
		txt17: "Enterprise Edition Exclusive",
		anyone_comment: "Anyone can comment",
		anyone_comment_tip: "Used for files shared with public that allow comments.",
		company_comment: "Members of this enterprise can comment",
		someoneAllPerm: "Only specified users can view/comment/edit",
		someoneAllPermSubTitle: "Used for private files that can specify view/comment/edit permissions.",
		someoneAllPermsShowMore: "Anyone can view/comment/edit"
	},
	shareGuide: {
		txt0: "The following are the people who have joined the sharing. You can manage their permissions",
		txt1: "Next",
		txt2: "Click to obtain a login-free link, and visitors can open the file without login",
		txt3: "Got it"
	},
	certification: {
		desc: "Bind a mobile number to your account, and then you can go to the next step.",
		cancel: "Cancel",
		bind: "To Bind",
		bindSuccess: "The phone number has been successfully bound.",
		descCertification: "The next step can only be carried out after the account completes real name certification.",
		cert: "Go for Real Name Certification",
		certificationSuccess: "Real name certification succeeded.",
		forbiddenTitle: "Account sharing has been suspended.",
		forbiddenDesc: "Please send emails to wps@wps.cn to contact customer service, email title remarks【账号已被暂停分享问题咨询】",
		forbiddenReasonTemAttemp: "Please try again after {time}",
		forbiddenReasonPer: "The service is temporarily unavailable due to technical reasons",
		forbiddenText: "You can download/export/save to local and perform other operations",
		forbiddenSuggestion: "If you have any questions, please contact customer service at 400-677-5005. The staff will check and follow up in a timely manner",
		downloadBtn: "Download/export it to your local device to view"
	},
	batchClinkCreate: {
		txt0: "Share with Public",
		txt1: "Viewable by Anyone",
		txt3: "Editable by Anyone",
		txt5: "Specify Sharing Scope",
		txt6: "Viewable by Members of Enterprise",
		txt7: "Editable by Members of Enterprise",
		txt8: "Only designated people can view",
		txt9: "/edit",
		cancel: "Cancel",
		confirm: "Confirm",
		company_admin: "Enterprise Administrator",
		group_admin: "Team Administrator",
		txt14: "File sharing outside the enterprise is prohibited.",
		txt15: "File sharing outside the team is prohibited.",
		txt16: "Learn about link sharing",
		include_folder: "The selected file contains \"folder\".",
		ignore_folder: "Ignore folder",
		include_other: "The selected file contains \"image, video, compressed package\", etc.",
		ignore_other: "Ignore these files",
		modify_success: "Modified successfully.",
		txt18: "Permission Type",
		txt19: "Anyone",
		txt22: "The file sharing outside the company has been disabled by the enterprise administrator",
		txt23: "The file sharing outside the team has been disabled by the team administrator",
		txt24: "The selected file is an encrypted protected document and cannot be shared via link",
		txt25: "The selected files contain encrypted protected documents and cannot be shared via link",
		txt26: "The selected files contain mind maps, flowcharts, or lightweight tables",
		txt27: "The selected files contain images, videos, compressed files, etc.",
		txt28: "The selected files contain mind maps, flowcharts, images, etc.",
		txt20: "Members of this Company",
		txt21: "Only specified users can access",
		txt17: "Scope of Authorization"
	},
	CancelSyncFolderConfirm: {
		desc: "The folder has been set as a sync folder by \"{0}\",",
		subDesc: "{0} will cause the sync folder to be canceled and become a normal folder.",
		confirm: "OK",
		cancel: "Cancel"
	}
};
var basic$1 = {
	basic: basic
};

var combine = {
	dialog: {
		cancel: "Cancel",
		confirm: "Confirm",
		memberSeletor: "Select member"
	},
	finder: {
		cancel: "Cancel",
		newBuilt: "New folder",
		selected: "Selected",
		selectedUnit: "item",
		notGroupMember: "Your permission has been taken back by the author",
		expired: "You do not have permission to operate the file",
		permissionDenied: "You do not have permission to operate the file",
		okText: "Confirm",
		move: "Move",
		copy: "Copy",
		saveas: "Save",
		confirm: "Confirm",
		messageErr: "The file format does not support initiating a meeting",
		docs: "My Cloud",
		copy1: "Copy"
	},
	aside: {
		latest: "Recent",
		star: "Starred",
		alls: "My Cloud",
		share1: "Shared",
		localfile: "local files",
		receive: "Shared with me",
		myTeams: "My Team"
	},
	main: {
		holder1: "Enter file name",
		holder2: "Enter folder name",
		clear: "Empty",
		compFile: "Enterprise Documents",
		share: "Share with me",
		receive: "Shared with me",
		"private": "Private",
		cloudFile: "My Cloud",
		myFile: "My Cloud",
		autoUpload: "Autoupload",
		myDevice: "My devices",
		latestOpen: "Recently opened",
		latest: "Recent",
		recBin: "Recycle bin",
		teamDocs: "Team documentation",
		search: "search results",
		privateFile: "Private folder",
		team: "team",
		appDriveTitle: "WPS Cloud Document-Edit your office documents anytime, anywhere",
		appAccountTitle: "Personal center",
		appDriveTitleSimple: "WPS Docs",
		appDriveForgetTitle: "WPS Docs-Retrieve Private Folder Password",
		starredFile: "Star file",
		stared: "Starred",
		cooperation: "Recent collaboration",
		shareCom: "shared",
		roles1: "Enterprise owner",
		roles2: "Enterprise Administrator",
		roles3: "Member",
		newFile: "New folder",
		newFileErr: " failed to create folder",
		myTeams: "My Team"
	},
	mainEmp: {
		groupNumLimit: "Your 3 free teams have been used up, you can upgrade your membership to have the privilege of creating 50 teams and 100G cloud space.",
		groupLengthTooShort: "The team name should be at least 2 Chinese characters or 4 letters",
		illegalGroupName: "The team name cannot contain the following characters: \\/;:*?\"<>|%&",
		groupLengthTooLong: "Team name cannot exceed 100 characters",
		userNotLogin: "Account has been logged out, please log in again",
		InvalidArgument: "Invalid parameters submitted",
		errServerException: "The server is busy, please try again later",
		ServerError: "Server error",
		LicenseNotFound: "Account is not authorized",
		LicenseExpired: "Account has expired",
		permissionDenied: "Your operation authority is insufficient",
		DomainExist: "Domain name already exists",
		CompanymMemberNotExist: "Enterprise does not exist",
		InvalidCompanyName: "Invalid enterprise name",
		CompanyNameTooLong: "Enterprise name is too long",
		UserAlreadyExists: "User already exists",
		DeptNotEmpty: "Department is not empty",
		GroupMemberExists: "This team already exists",
		GroupMemberLimit: "The team has reached the upper limit",
		InvalidAccount: "Please enter a correct email/phone number",
		groupNotExist: "The team no longer exists",
		teamLinkNotExist: "Team link no longer exists",
		notPersonalUser: "Cannot add business account",
		UserNotExists: "User does not exist",
		fileNameLengthExceed: "File name cannot exceed 100 characters",
		fileNameConflict: "A file with the same name exists",
		fileNotExists: "File (folder) does not exist",
		notGroupMember: "You are no longer a member of this team",
		illegalFname: "The name cannot contain illegal characters and special symbols \\/:*?\"<>|",
		illegalLinkFolderName: "The name cannot contain illegal characters and special symbols: \\/;:*?\"<>|%&",
		fileNameEmpty: "File name cannot be empty",
		moveFilePermission: "Ordinary members can only move their own files",
		moveFileSelfPermission: "The file move position remains unchanged",
		lightLinkExist: "Link already exists",
		lightLinkNotExist: "The link does not exist or has been reset",
		SecretGroupPermissionDenied: "Private folder privilege has expired",
		checkPerFail: "Permission verification failed, please refresh and try again",
		noFolderOperatePermission: "There is no operation permission for the current directory, please contact the administrator",
		noNewFilePermission: "No new permission for the current directory",
		MustHasOneBind: "Please keep either email or mobile phone",
		apiRateLimitExceede: "Your operating frequency is too fast, please try again later",
		SMSLimitReached: "This mobile phone has exceeded the maximum number of verification codes, please try again tomorrow",
		InvalidPhone: "Incorrect phone format",
		PhoneAlreadyInUsed: "This phone has been bound to another account",
		CellPhoneAlreadyInUsed: "This phone has been bound to another account",
		InvalidEmail: "Please enter the correct email format",
		EmailAlreadyInUsed: "The mailbox has been bound to another account, please change one",
		InvalidBindCode: "Verification code error",
		EmailAlreadyExists: "The mailbox has been bound to another account, please change one",
		hasEmailAccount: "Unable to unbind, at least one email or mobile account is required, please bind the email first and then unbind the mobile phone",
		invalidVerifyCode: "Verification code error",
		PasswordWeak: "Password is 8-16 digits, 3 combinations of uppercase and lowercase letters, numbers or symbols",
		UserHasBindedPhone: "You have bound your phone",
		CellPhoneBind: "This phone has been bound to another account",
		codeNotEmpty: "verification code must be filled",
		InvalidEmailCode: "The verification code is incorrect. Please re-enter",
		InvalidSMSCode: "The verification code is incorrect. Please re-enter",
		UserHasBindedEmail: "You have bound the mailbox",
		EmailNotExists: "Email does not exist",
		InvalidToken: "Illegal operation",
		InvalidNickname: "Cannot contain characters! @#$^*<>?",
		wrongPassword: "wrong password",
		chkCodeReset: "Failed to open the file, the light address password has been changed.",
		commentLengthTooLong: "Comment content exceeds 255 characters",
		shareFail: "Sharing failed",
		commentTooLong: "Comments cannot exceed 255 words",
		moveFilesFail: "Failed to move file",
		linkClosed: "Link closed",
		FileNoExists: "file does not exist",
		IPCError: "internal error",
		IOError: "File content read error",
		batchDownloadTooDeep: "Too many folder levels, please select again",
		batchDownloadFailed: "Download failed, the selected file format does not support download",
		batchDownloadEmptyFolder: "Download failed, downloading empty folders is not supported",
		batchDownloadEmpty: "You have not selected any physical file, please confirm whether the file exists",
		fileSearchNoPermission: "No file search function permission",
		copyFileFail: "Copy to subfolder is not supported, please select again",
		noCopyMultiFolders: "Copying directories with subfolders is not supported, please select again",
		copyTooDeep: "Copying directories with subfolders is not supported, please select again",
		fileTaskFailed: "File batch operation task failed",
		fileTaskNumLimit: "Does not support operating more than 5000 files, please select again",
		fileTaskNotExist: "File batch operation task does not exist",
		fileTaskDuplicated: "File operation is in progress, please try again later",
		NicknameTooLong: "Name is too long",
		InvalidSsid: "Invalid ssid",
		userContracted: "User has signed up",
		fileImportSameAccount: "Cannot import data from the same account",
		HaveNotVerify: "Verification result has expired",
		InvalidVerifyCode: "The verification code is incorrect. Please re-enter",
		SsidIsMissing: "Parameter missing ssid",
		SsidParamError: "ssid parameter error",
		GetAccountMergeUserInfoFailed: "Failed to obtain user information of the merged account",
		ReportAccountMergeFailed: "Report merge completion failed",
		CanNotMergeUsersFromDiffrentCompany: "Cannot merge accounts of different companies",
		CanNotMergerUsersFromThisCompany: "Users of this enterprise cannot merge accounts",
		QueryPermittedDocumentFaild: "Failed to obtain user authorized security document",
		CanNotGetLoginUserInfo: "Unable to get the information of the logged in user",
		InconsistentAccount: "The verification information is inconsistent with the bound account",
		IrregularOauthBinded: "Binding time is too short",
		ErrLinkShareGroupNotFound: "The collaboration has been disbanded",
		ErrGroupCountExceedLimit: "Exceeded team limit",
		ErrLinkShareGroupMemberNotFound: "You are no longer a member of this group",
		searching: "searching...",
		latestHere: "The recently moved, copied and searched locations will be shown here",
		noFindContain: "File name not found contains ",
		de: " of ",
		pitera: "Not here ",
		file: "file",
		finder: "folder"
	},
	mainList: {
		finder: "folder",
		nickname: "nickname",
		deptName: "department",
		email: "mailbox",
		phone: "phone number",
		markname: "Remark name",
		holder: "Add note name",
		addContact: "Add to my contacts",
		nickDesc: "Use real avatars and nicknames to let work partners know you.",
		toSet: " To set",
		sendWoaMessage: "Chat",
		location: "IP territory"
	},
	memSelector: {
		myContact: "My contact",
		addBook: "Enterprise Directory",
		emptyInfo: "No optional members",
		emptySearchInfo: "No matching users found",
		errorInfo: "Failed to get members, please try again",
		deptEmpty: "Department is empty",
		empSearchInfo: "No matching contacts found",
		empInfo: "No contacts available",
		noGroup: "No group",
		latestMember: "Recently selected users will appear here",
		canEdit: "Editable",
		canRead: "Viewable",
		contactor: "Contacts",
		docsRelated: "Document collaboration",
		recent: "Recent",
		formCollect: "Form collection group",
		rightTitle: "Please select the members to be added",
		addContactor: "Add contacts",
		addTips: "From here, you can add people who have filed with you recently",
		lookUser: "Find users with this mobile phone number:",
		choose: "Selected",
		cancel: "Cancel",
		confirm: "Confirm",
		myGroup: "My group",
		newGroup: "New group selection function",
		defaultGroup: "The form group I joined is displayed by default",
		checkAll: "Tick ​​all groups with one click, making it more convenient to select people",
		position: "Position",
		teamMember: "Team Members",
		tagsTeam: "Custom Group",
		tagsTeamManage: "Manage Custom Group",
		deptAndPosition: "By Department/Position",
		accordDept: "By Department",
		accordPosition: "By Position",
		noSubDept: "This department has no subdivisions. Therefore, you cannot grant permissions by department.",
		noPosition: "You have not entered positions for members in the Contacts on the management background. Therefore, you cannot grant permissions by position.",
		noMember: "No members",
		teamNoTags: "No custom groups for members",
		newTags: "New Custom Group",
		notInTeam: "The following members do not join a team. Add them into a team and then you can grant permissions to them.",
		hasNoSubDept: "No sub-departments.",
		emptySearchInfo2: "No matching data found.",
		externalStaff: "External Staff",
		myTeams: "My Team",
		noMyTeams: "No teams available.",
		myGroups: "My Group",
		noMyGroups: "No groups available.",
		corpTeams: "Enterprise Team",
		personalTeams: "Personal Team",
		noPermission: "No permission. Contact the team administrator.",
		canComment: " can comment "
	},
	phone: {
		title: "Bind your mobile phone and enable two-step verification for login, making your account more secure.",
		phoneHolder: "mobile phone number",
		codeHolder: "Phone verification code",
		repeat: "Resend",
		getCode: "get verification code",
		immeBind: "Bind now",
		smsCodeErr: "SMS verification code error",
		freqAction: "Your operating frequency is too fast, please try again later",
		bindAlready: "You have already bound your phone, please do not bind again",
		importTel: "Please enter phone number",
		currentTel: "Please enter the correct phone number",
		importSms: "Please enter the SMS verification code",
		needBind: "The account needs to be bound to a mobile phone to proceed to the next step",
		cancel: "Cancel",
		bind: "To bind",
		needCertification: "The next step can only be carried out after the account completes mobile phone verification.",
		certification: "Verify Now"
	},
	recentSelector: {
		relatedContact: "Related Contact",
		wordCoop: "Document collaborator",
		latestContact: "recent contact",
		msgOther: "Message to remind each other",
		empty: "No",
		selectList: "Select from contact list",
		msgTip: "After 5 minutes, the person you selected will receive a message reminder",
		coop: "Collaborating members, my contacts, etc.",
		book: "Select from Contacts",
		endTips: "Oops. You have reached the bottom.",
		mention: "You may want to mention",
		search: "Search"
	},
	NotLoginInfoCard: {
		txt0: "A nickname temporarily assigned by the system to users who are not logged in",
		txt1: "Log in to use more functions",
		txt2: "log in",
		txt3: "Invite the other party to log in to verify their identity",
		txt4: "invite",
		txt5: "Invited, waiting for the other party to log in to verify their identity",
		txt6: "(I)",
		txt7: " (not logged in)"
	},
	ThumbnailViewer: {
		txt0: "Image preview failed to get",
		txt1: "You do not have access rights",
		txt2: "The picture size exceeds the limit and cannot be previewed",
		txt3: "Failed to get preview",
		txt4: "Please click on the file name to view the original image",
		txt5: "Preview image loading",
		txt6: " Thumbnail"
	},
	TeamInfo: {
		"0": " The members of the following teams can view this folder.",
		"1": "You are the only person who can view this folder.",
		"2": "Upgrade to Team",
		"3": "Click to access the team"
	},
	upgradePrivilege: {
		upgradeNow: "Upgrade Now",
		purchaseNow: "Buy Now",
		confirm: "OK"
	},
	externalLinkTip: {
		desc: "Due to applet restrictions, you need to copy the link and use the browser to access it.",
		btnTxt: "Copy Link",
		tipSucc: "Copied successfully.",
		tipFail: "Copy failed."
	},
	memberInfo: {
		companyLabel: "Enterprise"
	},
	LimitMode: {
		userChatPrivilegesPermissionText: "This person has restricted chat permissions",
		groupChatDenyToast: "Some people in this group have restricted chat permissions. Cannot directly send a message."
	},
	commonUserCard: {
		sendMsgTips: "Please use WPS collaboration to view or send messages"
	}
};
var combine$1 = {
	combine: combine
};

var mCombine = {
	file: {
		emptyTxt: "No file available",
		noMore: "No more documents",
		recent: "Recent",
		myDocs: "My Documents",
		noTeam: "No teams",
		noMoreTeam: "No more teams",
		title: "WPS Docs",
		errTry: "An error occurred. Please click here to try again",
		share: "Share with Me"
	}
};
var miCombine = {
	mCombine: mCombine
};

var inputSearch = "Please enter your email";
var searchRes = "search results";
var searchCon = "The following users recently shared files with you";
var noFind = "Could not find related user";
var copyAdd = "You can copy the link and send friends to add";
var searchInvite = "Search by \"Phone Number\"";
var searchInvite1 = "or";
var searchInvite2 = "Send invitation link to add contacts";
var inviteAdd$2 = "Add using link";
var validLink = "The link";
var validLink1 = "Effective, the other party also joined the collaboration \"";
var validLink2 = "\"";
var inviteRoad$1 = "Add friends through the invitation link";
var copyLink$6 = "Copy";
var inviteEdit = "Invite you to edit \"";
var applyContact = "Applies to add you as a contact, click to view";
var inner = " inside";
var seInner = "Within 7 days";
var validContac = "The other party has joined the collaboration, you can send verification to add it as a contact, and wait for the other party to pass";
var inviteFail = "Failed to open invitation";
var correctMsg = "Please fill in the email address correctly";
var me$4 = "I";
var add$2 = "added";
var send$2 = "Has been sent";
var invite$2 = "Add to";
var copySucc = "Copy successfully";
var copyFail$1 = "Copy failed, please try again";
var getLink = "Those who get the link can join this document to collaborate, the link is valid ";
var txt0$3c = "You need to send a verification message and wait for the other party to pass";
var member_selector_tab_title_address = "Contact";
var member_selector_tab_title_secret_invite = "WeChat private invitation";
var member_selector_tab_title_secret_invite_tip = "Only your friends/group members can access it. Forwarding by others will be invalid.";
var member_selector_quick_add = "Quick Add";
var member_selector_copy_link = "Copy link";
var member_selector_qrcode_title = "QR code";
var member_selector_qr_code_subtitle = "Use WeChat to scan the QR code and send collaboration invitations to friends";
var member_selector_qr_code_alt = "Mini Program Code";
var AddRecommendContact = {
	inputSearch: inputSearch,
	searchRes: searchRes,
	searchCon: searchCon,
	noFind: noFind,
	copyAdd: copyAdd,
	searchInvite: searchInvite,
	searchInvite1: searchInvite1,
	searchInvite2: searchInvite2,
	inviteAdd: inviteAdd$2,
	validLink: validLink,
	validLink1: validLink1,
	validLink2: validLink2,
	inviteRoad: inviteRoad$1,
	copyLink: copyLink$6,
	inviteEdit: inviteEdit,
	applyContact: applyContact,
	inner: inner,
	seInner: seInner,
	validContac: validContac,
	inviteFail: inviteFail,
	correctMsg: correctMsg,
	me: me$4,
	add: add$2,
	send: send$2,
	invite: invite$2,
	copySucc: copySucc,
	copyFail: copyFail$1,
	getLink: getLink,
	txt0: txt0$3c,
	member_selector_tab_title_address: member_selector_tab_title_address,
	member_selector_tab_title_secret_invite: member_selector_tab_title_secret_invite,
	member_selector_tab_title_secret_invite_tip: member_selector_tab_title_secret_invite_tip,
	member_selector_quick_add: member_selector_quick_add,
	member_selector_copy_link: member_selector_copy_link,
	member_selector_qrcode_title: member_selector_qrcode_title,
	member_selector_qr_code_subtitle: member_selector_qr_code_subtitle,
	member_selector_qr_code_alt: member_selector_qr_code_alt
};

var txt0$3b = "Contacts";
var txt1$2T = "Add Contact";
var txt2$2D = "My Contacts";
var txt3$2n = "Enterprise Contact";
var txt4$22 = "Find users with this mobile phone number:";
var txt5$1S = "No members";
var txt6$1F = "You can add frequently-used contacts";
var txt7$1t = "Specify the other party to participate in collaboration";
var txt8$1n = "Add";
var txt9$1f = "No matching contacts found";
var txt10$18 = "No contacts";
var txt11$10 = "Department is empty";
var txt12$X = "Only the administrator can invite colleagues to join the enterprise";
var txt13$X = "Delete Contact";
var txt14$N = ",";
var txt15$I = "You will not be able to collaborate with this contact, are you sure you want to delete?";
var txt16$G = "Delete only this contact";
var txt17$B = "Terminate the collaboration with this company and delete all contacts of this company";
var txt18$A = "Confirm";
var txt19$y = "Cancel";
var txt20$v = "Delete Successful";
var txt21$r = "Delete Failed";
var txt22$o = "None (Individual User)";
var txt23$l = "You have established a collaboration with the company [{compName}] where this contact is located, and you have a collaboration relationship with the members of this company: {nameTexts}{num}, please choose:";
var txt24$h = "And {total} others";
var txt25$g = "Company";
var txt26$g = "Individual";
var txt27$e = "External Contacts";
var txt28$d = "Company Contacts";
var txt29$9 = "Add External Contact";
var txt30$8 = "Send the link to the other party, after the other party opens the link, they can initiate the add request:";
var txt31$9 = "Copy Link";
var txt32$7 = "Link valid until";
var txt33$6 = "Reset Link";
var txt34$6 = "Hint";
var txt35$6 = "After resetting, the previously shared link will become invalid, are you sure you want to reset?";
var txt36$6 = "Confirm Reset";
var txt37$6 = "Reset Successful";
var txt38$6 = "Invites you to become an external contact of '{compName}', facilitating cross-organizational collaboration. Click the link to handle (valid until {month} month {day} day {time})";
var txt39$6 = "Your operation permissions are insufficient";
var txt40$6 = "Search";
var txt49$6 = "Invite To Join";
var txt41$6 = "Search Results";
var txt42$6 = "Organizational Structure";
var txt43$6 = "Delete my contacts";
var txt44$6 = "Deleting external contacts";
var txt45$6 = "Deleting a business contacts";
var txt46$6 = "Copy Success";
var txt47$6 = "Copy Failure";
var txt48$6 = "No data yet";
var AddressBook = {
	txt0: txt0$3b,
	txt1: txt1$2T,
	txt2: txt2$2D,
	txt3: txt3$2n,
	txt4: txt4$22,
	txt5: txt5$1S,
	txt6: txt6$1F,
	txt7: txt7$1t,
	txt8: txt8$1n,
	txt9: txt9$1f,
	txt10: txt10$18,
	txt11: txt11$10,
	txt12: txt12$X,
	txt13: txt13$X,
	txt14: txt14$N,
	txt15: txt15$I,
	txt16: txt16$G,
	txt17: txt17$B,
	txt18: txt18$A,
	txt19: txt19$y,
	txt20: txt20$v,
	txt21: txt21$r,
	txt22: txt22$o,
	txt23: txt23$l,
	txt24: txt24$h,
	txt25: txt25$g,
	txt26: txt26$g,
	txt27: txt27$e,
	txt28: txt28$d,
	txt29: txt29$9,
	txt30: txt30$8,
	txt31: txt31$9,
	txt32: txt32$7,
	txt33: txt33$6,
	txt34: txt34$6,
	txt35: txt35$6,
	txt36: txt36$6,
	txt37: txt37$6,
	txt38: txt38$6,
	txt39: txt39$6,
	txt40: txt40$6,
	txt49: txt49$6,
	txt41: txt41$6,
	txt42: txt42$6,
	txt43: txt43$6,
	txt44: txt44$6,
	txt45: txt45$6,
	txt46: txt46$6,
	txt47: txt47$6,
	txt48: txt48$6
};

var txt0$3a = "The other party is not your contact yet, you can send a message to invite them to join the collaboration and add them as contacts.";
var txt1$2S = "Cancel";
var txt2$2C = "Send";
var AddToCoop = {
	txt0: txt0$3a,
	txt1: txt1$2S,
	txt2: txt2$2C
};

var create = "creation";
var more$1 = "More";
var placeholder$3 = "Enter a topic and let WPS AI create it for you, for example: Work Weekly";
var command = "Weekly Work Report";
var search$2 = "You may need:";
var AInewfileRecommend = {
	create: create,
	more: more$1,
	placeholder: placeholder$3,
	command: command,
	search: search$2
};

var bottomReject = "Exit";
var content$1 = "Welcome to choose to use WPS AI service provided by Kingsoft Office! In order to protect your rights and interests and help you understand WPS AI service easily, we have formulated $protocol$ , briefly introduced WPS AI service to you, and agreed on the disclaimer and usage restrictions for providing this service to you, as well as how we will legally protect and handle your personal information. Please check and read it in a timely manner. You can use this service only after you confirm and agree to the terms of the agreement.";
var title$t = "WPS AI Service Notice";
var linkCopy2 = "WPS AI Privacy Agreement";
var bottomAgree = "Understand and agree";
var linkCopy = "WPS AI Terms of Service";
var AiProtocol = {
	bottomReject: bottomReject,
	content: content$1,
	title: title$t,
	linkCopy2: linkCopy2,
	bottomAgree: bottomAgree,
	linkCopy: linkCopy
};

var txt0$39 = "Download";
var txt1$2R = "Download APP";
var txt2$2B = "Windows version";
var txt3$2m = "Mac version";
var txt4$21 = "APP";
var txt5$1R = "Mobile scan code download";
var txt6$1E = " Support Android / iOS";
var txt7$1s = "MiniProgram";
var txt8$1m = " file into the applet";
var txt9$1e = "Open WeChat scan code to use";
var webPageCollectionPlugin = "Web Clipper";
var AppDownload = {
	txt0: txt0$39,
	txt1: txt1$2R,
	txt2: txt2$2B,
	txt3: txt3$2m,
	txt4: txt4$21,
	txt5: txt5$1R,
	txt6: txt6$1E,
	txt7: txt7$1s,
	txt8: txt8$1m,
	txt9: txt9$1e,
	webPageCollectionPlugin: webPageCollectionPlugin
};

var components_dialog_appeal_index0 = "Feedback Reason";
var components_dialog_appeal_index1 = "(Please enter 5~50 characters)";
var components_dialog_appeal_index2 = "Please describe the reason for the feedback in detail to speed up the feedback process";
var components_dialog_appeal_index3 = "submit";
var components_dialog_appeal_index4 = "feedback";
var components_dialog_appeal_index5 = "Please enter the number of characters within {0}~{1}";
var components_dialog_appeal_index6 = "Feedback resume sharing";
var components_dialog_appeal_index7 = "Current document is violated";
var components_dialog_appeal_index8 = "Code of Content and Conduct";
var components_dialog_appeal_index9 = "Access has been discontinued";
var components_dialog_appeal_index10 = "Feedback is being processed";
var components_dialog_appeal_index11 = "feedback failed";
var components_dialog_appeal_index12 = "Please contact the file owner";
var components_dialog_appeal_index13 = "Download to local";
var components_dialog_appeal_index14 = "Network exception, download failed";
var components_dialog_appeal_index15 = "Downloading";
var components_dialog_appeal_index16 = "Cancel";
var components_dialog_appeal_index17 = "Feeback";
var components_dialog_appeal_index18 = "Feedback Reason";
var components_dialog_appeal_index19 = "Please describe the reason for the feedback in detail to speed up the feedback process";
var components_dialog_appeal_index20 = "Feedback is being processed";
var components_dialog_appeal_index21 = "Failed to feedback";
var components_dialog_appeal_index22 = "Feedback resume sharing";
var AppealIllegalFile = {
	components_dialog_appeal_index0: components_dialog_appeal_index0,
	components_dialog_appeal_index1: components_dialog_appeal_index1,
	components_dialog_appeal_index2: components_dialog_appeal_index2,
	components_dialog_appeal_index3: components_dialog_appeal_index3,
	components_dialog_appeal_index4: components_dialog_appeal_index4,
	components_dialog_appeal_index5: components_dialog_appeal_index5,
	components_dialog_appeal_index6: components_dialog_appeal_index6,
	components_dialog_appeal_index7: components_dialog_appeal_index7,
	components_dialog_appeal_index8: components_dialog_appeal_index8,
	components_dialog_appeal_index9: components_dialog_appeal_index9,
	components_dialog_appeal_index10: components_dialog_appeal_index10,
	components_dialog_appeal_index11: components_dialog_appeal_index11,
	components_dialog_appeal_index12: components_dialog_appeal_index12,
	components_dialog_appeal_index13: components_dialog_appeal_index13,
	components_dialog_appeal_index14: components_dialog_appeal_index14,
	components_dialog_appeal_index15: components_dialog_appeal_index15,
	components_dialog_appeal_index16: components_dialog_appeal_index16,
	components_dialog_appeal_index17: components_dialog_appeal_index17,
	components_dialog_appeal_index18: components_dialog_appeal_index18,
	components_dialog_appeal_index19: components_dialog_appeal_index19,
	components_dialog_appeal_index20: components_dialog_appeal_index20,
	components_dialog_appeal_index21: components_dialog_appeal_index21,
	components_dialog_appeal_index22: components_dialog_appeal_index22
};

var txt0$38 = "People who have joined sharing";
var txt1$2Q = "Copied successfully";
var txt2$2A = "Only specified people can view";
var txt3$2l = "Only specified people can view and edit";
var txt4$20 = "People who opened the link";
var txt5$1Q = "Only you can view or edit";
var txt6$1D = "Anyone";
var txt7$1r = "Copied successfully. ";
var txt8$1l = "Copy failed";
var txt9$1d = "Your browser does not support automatic copy. Press ";
var txt10$17 = "to copy the content in the following input box";
var txt11$$ = "The sharing function is in upgrade and maintenance";
var txt12$W = "Specify editable parts to prevent data from being mistakenly changed by others.";
var txt13$W = "Selected";
var txt14$M = "Batch Operation";
var txt15$H = "Set to Editable";
var txt16$F = "Set to Viewable";
var txt17$A = "Batch Remove";
var txt18$z = "Partial modification failed.";
var txt19$x = "Modification failed.";
var txt20$u = "Partial remove failed.";
var txt21$q = "Remove failed.";
var txt22$n = "Confirm to remove the specified {0} member(s)";
var txt23$k = "Batch Delete";
var txt24$g = "Modified successfully.";
var txt25$f = "Removed successfully.";
var txt26$f = "Once enabled, people with only view permission will not be able to download, print, save or copy the content.";
var someoneAllPerm = "Only specified users can view/comment/edit";
var setComment = "Set to Allow Comments";
var advanceSettingTxt$1 = "Advanced Settings";
var fileBan = "File sharing stopped";
var linkNotExist = "The link you visited does not exist or has been removed";
var serverError$1 = "Server Error";
var ClinkCoopBox = {
	txt0: txt0$38,
	txt1: txt1$2Q,
	txt2: txt2$2A,
	txt3: txt3$2l,
	txt4: txt4$20,
	txt5: txt5$1Q,
	txt6: txt6$1D,
	txt7: txt7$1r,
	txt8: txt8$1l,
	txt9: txt9$1d,
	txt10: txt10$17,
	txt11: txt11$$,
	txt12: txt12$W,
	txt13: txt13$W,
	txt14: txt14$M,
	txt15: txt15$H,
	txt16: txt16$F,
	txt17: txt17$A,
	txt18: txt18$z,
	txt19: txt19$x,
	txt20: txt20$u,
	txt21: txt21$q,
	txt22: txt22$n,
	txt23: txt23$k,
	txt24: txt24$g,
	txt25: txt25$f,
	txt26: txt26$f,
	someoneAllPerm: someoneAllPerm,
	setComment: setComment,
	advanceSettingTxt: advanceSettingTxt$1,
	fileBan: fileBan,
	linkNotExist: linkNotExist,
	serverError: serverError$1
};

var txt0$37 = "File share link has expired";
var txt1$2P = "Link has been reset";
var txt2$2z = "The sharing function is in upgrade and maintenance";
var ClinkPerm = {
	txt0: txt0$37,
	txt1: txt1$2P,
	txt2: txt2$2z
};

var txt0$36 = "File";
var txt1$2O = "Folder";
var txt2$2y = "is shared by";
var txt3$2k = "\"";
var txt4$1$ = "\"Administrator has set permissions";
var txt5$1P = "Can't get a name";
var txt5_1 = "the sharer has set the permission.";
var txt6$1C = ", ";
var txt6_1 = " the permission has been set.";
var txt6_2 = "Sharer";
var txt7$1q = "Sharing canceled";
var txt8$1k = "Invite others to join sharing";
var txt9$1c = "Get the login-free link";
var txt10$16 = "File sharing link has expired";
var txt11$_ = "Share link not created";
var txt12$V = "Open now";
var txt13$V = "Create link";
var txt14$L = "Get the login-free link";
var txt15$G = "Open link";
var txt16$E = "Copy";
var txt17$z = "Click the link to get login-free, visitors can open the file without login";
var txt18$y = "The sharing permission can only be accessed by members of the enterprise, and login-free is not supported";
var txt19$w = "Sharing permission is only accessible to designated members, and no login is not supported";
var txt20$t = "Successfully opened the link";
var txt21$p = "WPS Docs";
var txt22$m = "Scan the code to send to friends";
var txt23$j = "This link with no sign-in required still works, and anyone can access it";
var secure_title = "Share encrypted files, accessible only to specified persons";
var sendIMLoading = "sending...";
var sendIMSuccess = "Sent successfully";
var sendIMFail = "Failed to send";
var overMaxCountTxt = "You can only select up to {0} chats";
var sendWOAMsgFail1 = "Failed to send to '{0}'";
var sendWOAMsgFail2 = "Failed to send to '{0}' and {1} other conversations";
var sendWOAMsgFail3 = "Sending to external companies is not supported for secure documents";
var ClinkSettingBox = {
	txt0: txt0$36,
	txt1: txt1$2O,
	txt2: txt2$2y,
	txt3: txt3$2k,
	txt4: txt4$1$,
	txt5: txt5$1P,
	txt5_1: txt5_1,
	txt6: txt6$1C,
	txt6_1: txt6_1,
	txt6_2: txt6_2,
	txt7: txt7$1q,
	txt8: txt8$1k,
	txt9: txt9$1c,
	txt10: txt10$16,
	txt11: txt11$_,
	txt12: txt12$V,
	txt13: txt13$V,
	txt14: txt14$L,
	txt15: txt15$G,
	txt16: txt16$E,
	txt17: txt17$z,
	txt18: txt18$y,
	txt19: txt19$w,
	txt20: txt20$t,
	txt21: txt21$p,
	txt22: txt22$m,
	txt23: txt23$j,
	secure_title: secure_title,
	sendIMLoading: sendIMLoading,
	sendIMSuccess: sendIMSuccess,
	sendIMFail: sendIMFail,
	overMaxCountTxt: overMaxCountTxt,
	sendWOAMsgFail1: sendWOAMsgFail1,
	sendWOAMsgFail2: sendWOAMsgFail2,
	sendWOAMsgFail3: sendWOAMsgFail3
};

var txt0$35 = "Permanent";
var txt1$2N = " Effective";
var txt2$2x = "Link validity period";
var txt3$2j = " days";
var setSucc = "The link validity period is set successfully";
var diyDate = "Customize Effective Period";
var timeSuffix = "before";
var timeFront = " ago";
var selectTimeTxt = "Select a validity period.";
var expired = "expired";
var ClinkTime = {
	txt0: txt0$35,
	txt1: txt1$2N,
	txt2: txt2$2x,
	txt3: txt3$2j,
	setSucc: setSucc,
	diyDate: diyDate,
	timeSuffix: timeSuffix,
	timeFront: timeFront,
	selectTimeTxt: selectTimeTxt,
	expired: expired
};

var txt0$34 = "Parameter cannot be empty";
var txt1$2M = "Invalid parameter type. The correct value should be:";
var txt2$2w = "No elements passed in";
var txt3$2i = "Did not pass in the correct element";
var txt4$1_ = "Parameter passed in cannot be empty";
var txt5$1O = "Quickly understand how to solve office problems and collaborate efficiently with colleagues";
var txt6$1B = "Do you have the following problems at work:";
var txt7$1p = "Work documents are scattered everywhere and often repeatedly transmitted";
var txt8$1j = "Documents are accidentally lost or modified and cannot be retrieved or recovered";
var txt9$1b = "Documents written by multiple people need to be summarized many times, which is inefficient";
var txt10$15 = "Documents cannot be accessed at any time at home or during business trips";
var txt11$Z = "Learn Now";
var txt12$U = "Use Directly";
var txt13$U = "You have completed the exploration of enterprise functions.";
var txt14$K = "Now you can share documents in the team for collaborative office";
var txt15$F = "Go Now";
var txt16$D = "Or you can choose to view the following content";
var txt17$y = "Industry Cases";
var txt18$x = "Understand how different industries use WPS+ for collaborative office";
var txt19$v = "Help Center";
var txt20$s = "Instructions for how to use all functions are here";
var txt21$o = "Operating Tips";
var txt22$l = "Useful tips to improve work efficiency";
var txt23$i = "1. Build a work team";
var txt24$f = "Contact the administrator to invite you to join the work team. You can also create a team based on your business requirements and invite colleagues to join the team";
var txt25$e = "Next";
var txt26$e = "2. Share office documents";
var txt27$d = "Documents are shared in the team to form an office database to avoid scattered documents and repeated transmission. History versions are well maintained and prevented from being modified by mistake";
var txt28$c = "3. Efficient collaborative editing";
var txt29$8 = "Team documents can be edited by multiple people at the same time, and the content is updated and synchronized in real time. This avoids the trouble of filling in separately and summarizing, and improves the efficiency of collaboration";
var txt30$7 = "4. Conveniently share files";
var txt31$8 = "Use the sharing feature to easily and quickly send files (folders) to colleagues. Your colleagues do not need to install software, and they can click the link to view the files or folders, which improves communication efficiency";
var txt32$6 = "5. Multi-terminal document synchronization";
var txt33$5 = "Work documents are synchronized on multiple terminals such as computers and mobile phones, so you can work anytime and anywhere, whether you are on a business trip or at home";
var txt34$5 = "Complete";
var txt35$5 = "Welcome";
var txt36$5 = "'s Enterprise Cloud Office";
var txt37$5 = "Work collaboratively with your colleagues";
var txt38$5 = "Learn More Now";
var txt39$5 = "Use Directly";
var txt40$5 = "You have completed the exploration of enterprise functions.";
var txt41$5 = "Now you can share documents in the team for collaborative office";
var txt42$5 = "Go Now";
var txt43$5 = "Or you can choose to view the following content";
var txt44$5 = "Industry Cases";
var txt45$5 = "Understand how different industries use WPS+ for collaborative office";
var txt46$5 = "Help Center";
var txt47$5 = "Instructions for how to use all functions are here";
var txt48$5 = "Operating Tips";
var txt49$5 = "Useful tips to improve work efficiency";
var txt50$5 = "First of all,";
var txt51$3 = "build your own work team";
var txt52$3 = "You can create a team based on your department, such as finance department and operation department";
var txt53$3 = "Now,";
var txt54$3 = "you can start collaborative office";
var txt55$2 = "Then,";
var txt56$2 = "invite collaborating members to join your team";
var txt57$2 = "Members can view or edit documents in the team";
var txt58$2 = "The team members can edit the same document at the same time";
var txt59$2 = "You have completed the exploration of enterprise functions.";
var txt60$2 = "Now you can share documents in the team for collaborative office";
var txt61$2 = "Go Now";
var txt62$2 = "Or you can choose to view the following content";
var txt63$2 = "Industry Cases";
var txt64$1 = "Understand how different industries use WPS+ for collaborative office";
var txt65$1 = "Help Center";
var txt66$1 = "Instructions for how to use all functions are here";
var txt67$1 = "Operating Tips";
var txt68$1 = "Useful tips to improve work efficiency";
var txt69$1 = "You can invite colleagues to join your enterprise here, and you don't need to repeatedly transfer team documents after they join your enterprise.";
var txt70$1 = "Invite Now";
var txt71$1 = "Create a work team that requires document collaboration, such as the Finance Department/Operation Department or Project Team";
var txt72 = "Create Now";
var txt73 = "Re-enter the operation guide here";
var txt74 = "Welcome to";
var txt75 = "'s Enterprise Cloud Office";
var txt76 = "It only takes a few steps to improve enterprise office efficiency";
var txt77 = "Learn more about the application scenarios of enterprise teams";
var txt78 = "Later";
var txt79 = "Enterprise created successfully";
var txt80 = "Invite Colleagues to Join";
var txt81 = "Build a work team";
var txt82 = "Created Enterprises";
var CompanyGuidePanel = {
	txt0: txt0$34,
	txt1: txt1$2M,
	txt2: txt2$2w,
	txt3: txt3$2i,
	txt4: txt4$1_,
	txt5: txt5$1O,
	txt6: txt6$1B,
	txt7: txt7$1p,
	txt8: txt8$1j,
	txt9: txt9$1b,
	txt10: txt10$15,
	txt11: txt11$Z,
	txt12: txt12$U,
	txt13: txt13$U,
	txt14: txt14$K,
	txt15: txt15$F,
	txt16: txt16$D,
	txt17: txt17$y,
	txt18: txt18$x,
	txt19: txt19$v,
	txt20: txt20$s,
	txt21: txt21$o,
	txt22: txt22$l,
	txt23: txt23$i,
	txt24: txt24$f,
	txt25: txt25$e,
	txt26: txt26$e,
	txt27: txt27$d,
	txt28: txt28$c,
	txt29: txt29$8,
	txt30: txt30$7,
	txt31: txt31$8,
	txt32: txt32$6,
	txt33: txt33$5,
	txt34: txt34$5,
	txt35: txt35$5,
	txt36: txt36$5,
	txt37: txt37$5,
	txt38: txt38$5,
	txt39: txt39$5,
	txt40: txt40$5,
	txt41: txt41$5,
	txt42: txt42$5,
	txt43: txt43$5,
	txt44: txt44$5,
	txt45: txt45$5,
	txt46: txt46$5,
	txt47: txt47$5,
	txt48: txt48$5,
	txt49: txt49$5,
	txt50: txt50$5,
	txt51: txt51$3,
	txt52: txt52$3,
	txt53: txt53$3,
	txt54: txt54$3,
	txt55: txt55$2,
	txt56: txt56$2,
	txt57: txt57$2,
	txt58: txt58$2,
	txt59: txt59$2,
	txt60: txt60$2,
	txt61: txt61$2,
	txt62: txt62$2,
	txt63: txt63$2,
	txt64: txt64$1,
	txt65: txt65$1,
	txt66: txt66$1,
	txt67: txt67$1,
	txt68: txt68$1,
	txt69: txt69$1,
	txt70: txt70$1,
	txt71: txt71$1,
	txt72: txt72,
	txt73: txt73,
	txt74: txt74,
	txt75: txt75,
	txt76: txt76,
	txt77: txt77,
	txt78: txt78,
	txt79: txt79,
	txt80: txt80,
	txt81: txt81,
	txt82: txt82
};

var txt0$33 = "Already ";
var txt1$2L = "Send Verification Message";
var txt2$2v = "You can remind the other party to log in to WPS Docs and agree to your application in \"Home-Message\"";
var txt3$2h = "Got it";
var txt4$1Z = "Invitation sent successfully";
var ContactInvitationPanel = {
	txt0: txt0$33,
	txt1: txt1$2L,
	txt2: txt2$2v,
	txt3: txt3$2h,
	txt4: txt4$1Z
};

var txt0$32 = " People can edit";
var txt1$2K = "People can view, where";
var txt2$2u = "People can view";
var txt3$2g = "The administrator has set up viewing and editing members";
var txt4$1Y = "No collaborators have joined yet, you can add collaborators first";
var txt5$1N = "You can add additional collaborators and specify viewing/editing permissions";
var txt6$1A = "You do not have permission to access the file";
var txt7$1o = "Who can visit";
var txt8$1i = "Collaboration is on for the document, you";
var txt9$1a = "Viewable only";
var txt10$14 = "Can edit with others";
var txt11$Y = "Creator";
var txt14$J = "Can only view, not comment and edit files";
var txt15$E = "Can view, comment and edit files";
var txt16$C = "Remove";
var txt17$x = "Invited";
var txt12$T = "Viewable";
var txt13$T = "Editable";
var CoopMember = {
	txt0: txt0$32,
	txt1: txt1$2K,
	txt2: txt2$2u,
	txt3: txt3$2g,
	txt4: txt4$1Y,
	txt5: txt5$1N,
	txt6: txt6$1A,
	txt7: txt7$1o,
	txt8: txt8$1i,
	txt9: txt9$1a,
	txt10: txt10$14,
	txt11: txt11$Y,
	txt14: txt14$J,
	txt15: txt15$E,
	txt16: txt16$C,
	txt17: txt17$x,
	txt12: txt12$T,
	txt13: txt13$T
};

var txt0$31 = "Current team";
var txt1$2J = " People can edit";
var txt2$2t = " People can view, where ";
var txt3$2f = " People can edit";
var txt4$1X = "People can view";
var txt5$1M = "The administrator has set up viewing and editing members";
var txt6$1z = "Creator";
var txt9$19 = "Can only view, not comment and edit files";
var txt10$13 = "Can view, comment and edit files";
var txt11$X = "Remove";
var txt12$S = "Only team administrators can set team member permissions";
var txt13$S = "File creator";
var txt14$I = "Join via link";
var txt15$D = "Directly specify to add";
var txt16$B = "View Member Authorization";
var transferOwner$1 = "Transfer Document Ownership";
var transferOwnerTips = "You are the creator of the document and have ownership of the document.";
var chooseNewOwner = "Select a new owner.";
var transferOwnerDisableForSecret$1 = "Encrypted documents cannot be transferred.";
var transferOwnerDisableForPrivate = "Transfer failed. Sharing is not enabled. Enable sharing first.";
var transferOwnerTipForTeam = "The team document only supports transfer to team members.";
var transferOwnerTipForShareFolder = "This is a shared folder document and can only be transferred to members of a shared folder.";
var comment$8 = " can comment ";
var txt7$1n = "Viewable";
var txt8$1h = "Editable";
var encryptertxt = "Encrypted By";
var transferOwnerTipForCorp = "This document is an enterprise document and can only be transferred to members of this enterprise";
var removeMember = "Remove from Collaboration";
var canNotChangeGroupMemberPerm$1 = "Adjusting permission for an individual team member is not supported.";
var removeMemberAndClear = "Cancel the authorization";
var canNotRemoveGroupMemberPerm = "The current user is a member of a team/shared folder, and deauthorization is not currently supported";
var CoopMemberList = {
	txt0: txt0$31,
	txt1: txt1$2J,
	txt2: txt2$2t,
	txt3: txt3$2f,
	txt4: txt4$1X,
	txt5: txt5$1M,
	txt6: txt6$1z,
	txt9: txt9$19,
	txt10: txt10$13,
	txt11: txt11$X,
	txt12: txt12$S,
	txt13: txt13$S,
	txt14: txt14$I,
	txt15: txt15$D,
	txt16: txt16$B,
	transferOwner: transferOwner$1,
	transferOwnerTips: transferOwnerTips,
	chooseNewOwner: chooseNewOwner,
	transferOwnerDisableForSecret: transferOwnerDisableForSecret$1,
	transferOwnerDisableForPrivate: transferOwnerDisableForPrivate,
	transferOwnerTipForTeam: transferOwnerTipForTeam,
	transferOwnerTipForShareFolder: transferOwnerTipForShareFolder,
	comment: comment$8,
	txt7: txt7$1n,
	txt8: txt8$1h,
	encryptertxt: encryptertxt,
	transferOwnerTipForCorp: transferOwnerTipForCorp,
	removeMember: removeMember,
	canNotChangeGroupMemberPerm: canNotChangeGroupMemberPerm$1,
	removeMemberAndClear: removeMemberAndClear,
	canNotRemoveGroupMemberPerm: canNotRemoveGroupMemberPerm
};

var txt0$30 = "Search user name to add collaborators";
var txt1$2I = "Corresponding user not found";
var txt2$2s = "You can directly copy the link and send";
var txt4$1W = "Viewable only. No permission to comment or edit files";
var txt6$1y = "Can view, comment, and edit files";
var txt7$1m = "Select from Contacts";
var txt8$1g = "Sent successfully";
var txt9$18 = "Added successfully";
var txt10$12 = "Add";
var txt11$W = "Invitation sent successfully";
var txt12$R = "Me";
var txt13$R = "Failed to add, ";
var sendToWoa = "Send File to Chat";
var comment$7 = " can comment ";
var sendRemind = "Send messages to remind others";
var noAddListTxt = "Not added";
var txt3$2e = "Viewable";
var txt5$1L = "Editable";
var addListTxt = "Added";
var fileCreator$2 = "Creator";
var sendToWoaFail = "Failed to send";
var department = "department";
var groupChat$2 = "Group Chat";
var team$2 = "team";
var CoopMemberSearch = {
	txt0: txt0$30,
	txt1: txt1$2I,
	txt2: txt2$2s,
	txt4: txt4$1W,
	txt6: txt6$1y,
	txt7: txt7$1m,
	txt8: txt8$1g,
	txt9: txt9$18,
	txt10: txt10$12,
	txt11: txt11$W,
	txt12: txt12$R,
	txt13: txt13$R,
	sendToWoa: sendToWoa,
	comment: comment$7,
	sendRemind: sendRemind,
	noAddListTxt: noAddListTxt,
	txt3: txt3$2e,
	txt5: txt5$1L,
	addListTxt: addListTxt,
	fileCreator: fileCreator$2,
	sendToWoaFail: sendToWoaFail,
	department: department,
	groupChat: groupChat$2,
	team: team$2
};

var txt0$2$ = "Search for contact name and mobile phone number to add collaborators";
var txt1$2H = "Corresponding user not found";
var txt2$2r = "You can send a link to invite friends";
var txt3$2d = "Select from Contacts";
var txt4$1V = "Me";
var txt5$1K = "Sent successfully";
var txt6$1x = "Added successfully";
var txt7$1l = "Add";
var CoopMemberSearcher = {
	txt0: txt0$2$,
	txt1: txt1$2H,
	txt2: txt2$2r,
	txt3: txt3$2d,
	txt4: txt4$1V,
	txt5: txt5$1K,
	txt6: txt6$1x,
	txt7: txt7$1l
};

var txt0$2_ = "Other ways to add:";
var txt1$2G = "Scan to send to friends";
var txt2$2q = "Effective within, can collaborate after joining";
var txt3$2c = "The invitation link";
var txt4$1U = "Valid within, you can collaborate after joining \"";
var txt5$1J = "\"";
var txt7$1k = "Invite you to edit \"";
var txt8$1f = "\"";
var txt9$17 = "day";
var txt10$11 = "Failed to open invitation";
var txt6$1w = "Copy";
var CopyEditLink = {
	txt0: txt0$2_,
	txt1: txt1$2G,
	txt2: txt2$2q,
	txt3: txt3$2c,
	txt4: txt4$1U,
	txt5: txt5$1J,
	txt7: txt7$1k,
	txt8: txt8$1f,
	txt9: txt9$17,
	txt10: txt10$11,
	txt6: txt6$1w
};

var txt0$2Z = "Due to applet restrictions, you need to copy the link and use the browser to access it.";
var txt1$2F = "Copy Link";
var txt2$2p = "Copied successfully.";
var txt3$2b = "Copy failed.";
var txt4$1T = "Download Tips";
var CopyLink = {
	txt0: txt0$2Z,
	txt1: txt1$2F,
	txt2: txt2$2p,
	txt3: txt3$2b,
	txt4: txt4$1T
};

var txt0$2Y = "Enterprise space capacity is full. Upgrade the enterprise package to expand enterprise space";
var txt1$2E = "Upgrade Package";
var txt2$2o = "Enterprise space capacity is full. Please notify the super administrator";
var txt3$2a = ". Upgrade the enterprise package.";
var txt4$1S = "Cancel";
var CorpSpaceFull = {
	txt0: txt0$2Y,
	txt1: txt1$2E,
	txt2: txt2$2o,
	txt3: txt3$2a,
	txt4: txt4$1S
};

var txt0$2X = "Team name";
var txt0_beemwork$3 = "Name";
var txt1$2D = "(Turn on encryption protection";
var txt2$2n = "Team documents are automatically encrypted and cannot be viewed by non-team members";
var txt3$29 = "Team member";
var txt4$1R = " Members";
var txt5$1I = "Move from shared folder";
var txt6$1v = "Cancel";
var txt7$1j = "Confirm";
var txt8$1e = "`s team";
var txt9$16 = "Apply for";
var txt3_beemwork = "Team Members";
var placeholder$2 = "Please fill in the team name";
var teamsettings = {
	txt1: "team settings",
	txt2: "Turn on \"Team Document Watermark\"",
	txt3: "Set \"Team document sharing scope\" to",
	txt4: "Team files can be prohibited from being shared outside the enterprise/team",
	txt5: "Enable \"Team Intelligent Question and Answer Service\"",
	txt6: "You can obtain document information within the team through conversation",
	publishMenu: "Publish Settings"
};
var presetFail = {
	txt1: "The following team settings failed to be modified due to insufficient rights and interests. You can directly enter the team or purchase a package. After purchasing the package, you can enable the team document watermark and control the scope of document sharing.",
	txt2: "Team document watermark",
	txt3: "Team document sharing scope",
	txt4: "buy package",
	txt5: "enter the team"
};
var presetSucc = {
	txt1: "If you need to adjust, you can go to \"Team Settings-Document Settings\" to modify.",
	txt2: "enter the team"
};
var noMemberToSelect$1 = "No members available yet";
var CreateTeam = {
	txt0: txt0$2X,
	txt0_beemwork: txt0_beemwork$3,
	txt1: txt1$2D,
	txt2: txt2$2n,
	txt3: txt3$29,
	txt4: txt4$1R,
	txt5: txt5$1I,
	txt6: txt6$1v,
	txt7: txt7$1j,
	txt8: txt8$1e,
	txt9: txt9$16,
	txt3_beemwork: txt3_beemwork,
	placeholder: placeholder$2,
	teamsettings: teamsettings,
	presetFail: presetFail,
	presetSucc: presetSucc,
	noMemberToSelect: noMemberToSelect$1
};

var txt0$2W = "Select file/folder to view details";
var txt1$2C = "No access";
var txt2$2m = "Please contact the author to enable access";
var txt3$28 = "Sharing settings";
var txt4$1Q = "Not shared";
var txt5$1H = "Set sharing permissions";
var txt6$1u = "Share";
var txt7$1i = "After sharing, you can view and edit files together";
var txt8$1d = "Shared files can be edited by multiple people and synchronized in real time";
var txt9$15 = "Invite members to join";
var txt10$10 = "Shared files can be edited by multiple people and synchronized in real time";
var txt11$V = "Historic version";
var txt12$Q = "View all";
var txt13$Q = "One-click recovery of files/documents to any version";
var txt14$H = "Modify";
var txt15$C = "Preview";
var txt16$A = "More information";
var txt17$w = "Owner";
var txt18$w = "Last modified";
var txt19$u = "Creation time";
var txt20$r = "Expired";
var cooperation = "Collaborative Office";
var addSchedule = "Add Event";
var clickToSeeMember = "Click to view participants.";
var scheduleEmpty = "No events.";
var scheduleEmptyTips = "Add a file as an event. The event will be recorded and you will be timely notified.";
var label = {
	title: "Labels",
	favor: "Frequently Used",
	watch_all: "View All Labels",
	add: "Add Label"
};
var fileSize = "File Size";
var onlineFileSize = "Do not occupy cloud space.";
var fileType = "File Type";
var filePath = "File Location";
var share2me = "Shared to Me";
var path_received = "Light Address Received";
var formatFileType = {
	otl: "Intelligence Docs",
	ksheet: "Intelligence Sheet ",
	dbt: "DBsheet",
	pof: "Mind Map",
	pom: "Flowchart",
	kw: "Whiteboard",
	wpsnote: "Note",
	ckt: "Poster",
	ofd: "Sample Page",
	resh: "CV",
	form: "Intelligence Form"
};
var myDocs = "My Cloud";
var share$1 = "Share";
var sharewithme = "Share with Me";
var me$3 = "Me";
var docInfo_today = "Today";
var docInfo_yesterday = "Yesterday";
var docInfo_month_day = "m-d";
var docInfo_year_month_day = "Y-m-d";
var txt21$n = "Invite";
var myCloudDocs = "My Cloud documents";
var DocInfo = {
	txt0: txt0$2W,
	txt1: txt1$2C,
	txt2: txt2$2m,
	txt3: txt3$28,
	txt4: txt4$1Q,
	txt5: txt5$1H,
	txt6: txt6$1u,
	txt7: txt7$1i,
	txt8: txt8$1d,
	txt9: txt9$15,
	txt10: txt10$10,
	txt11: txt11$V,
	txt12: txt12$Q,
	txt13: txt13$Q,
	txt14: txt14$H,
	txt15: txt15$C,
	txt16: txt16$A,
	txt17: txt17$w,
	txt18: txt18$w,
	txt19: txt19$u,
	txt20: txt20$r,
	cooperation: cooperation,
	addSchedule: addSchedule,
	clickToSeeMember: clickToSeeMember,
	scheduleEmpty: scheduleEmpty,
	scheduleEmptyTips: scheduleEmptyTips,
	label: label,
	fileSize: fileSize,
	onlineFileSize: onlineFileSize,
	fileType: fileType,
	filePath: filePath,
	share2me: share2me,
	path_received: path_received,
	formatFileType: formatFileType,
	myDocs: myDocs,
	share: share$1,
	sharewithme: sharewithme,
	me: me$3,
	docInfo_today: docInfo_today,
	docInfo_yesterday: docInfo_yesterday,
	docInfo_month_day: docInfo_month_day,
	docInfo_year_month_day: docInfo_year_month_day,
	txt21: txt21$n,
	myCloudDocs: myCloudDocs
};

var txt0$2V = "Please confirm to delete";
var txt1$2B = "After deleting the contact, the user will not appear in my contact list";
var txt2$2l = "Cancel";
var txt3$27 = "delete";
var DeleteContact = {
	txt0: txt0$2V,
	txt1: txt1$2B,
	txt2: txt2$2l,
	txt3: txt3$27
};

var txt0$2U = "The Cloud space is full";
var DialogCorpSpaceFull = {
	txt0: txt0$2U
};

var txt0$2T = "Create Team";
var txt0_beemwork$2 = "Create shared folder";
var txt1$2A = "Add Contact";
var txt2$2k = "Delete Contact";
var txt3$26 = "Application for New Team";
var txt4$1P = "Team Type";
var txt5$1G = "Create General Team";
var txt6$1t = "Preview";
var txt7$1h = "Use";
var txt8$1c = "Loading";
var txt9$14 = "Reload";
var txt10$$ = "Failed to initialize the scenario.";
var txt11$U = "Failed to activate the application.";
var txt12$P = "Failed to activate part of the application.";
var txt13$P = "Failed to activate the self-built application.";
var docTemplateError = {
	"40000105": "The space is full. Failed to create the template.",
	"40000201": "Failed to create the template. Please create again."
};
var upToMyTeam = "Upgrade to Personal Team";
var selectGroup = "Select a folder to upgrade to a team shared folder";
var upToGuide = "Move-in Description";
var oem = {
	normal: {
		title: "General Team",
		subtitle: "Invite members to upload files on demand for collaborative work."
	},
	secure: {
		title: "Encrypted Team",
		subtitle: "All files are automatically encrypted and only visible to team members."
	}
};
var txt14$G = "The team is successfully created and the settings have taken effect";
var txt15$B = "The team was successfully created but the settings did not take effect";
var defaulScenarios = {
	scenariosTitle: "Basic Usage Scenarios",
	general: {
		title: "Ordinary Team",
		subtitle: "Invite members as needed<br/>to upload files and share collaboration"
	},
	secure: {
		title: "Encrypted Team",
		subtitle: "All files are automatically encrypted<br/>visible only to team members"
	}
};
var DialogCreateTeam = {
	txt0: txt0$2T,
	txt0_beemwork: txt0_beemwork$2,
	txt1: txt1$2A,
	txt2: txt2$2k,
	txt3: txt3$26,
	txt4: txt4$1P,
	txt5: txt5$1G,
	txt6: txt6$1t,
	txt7: txt7$1h,
	txt8: txt8$1c,
	txt9: txt9$14,
	txt10: txt10$$,
	txt11: txt11$U,
	txt12: txt12$P,
	txt13: txt13$P,
	docTemplateError: docTemplateError,
	upToMyTeam: upToMyTeam,
	selectGroup: selectGroup,
	upToGuide: upToGuide,
	oem: oem,
	txt14: txt14$G,
	txt15: txt15$B,
	defaulScenarios: defaulScenarios
};

var txt0$2S = "Not a member of the enterprise";
var txt1$2z = "Enterprise id is a required parameter";
var DialogEntCardsGuide = {
	txt0: txt0$2S,
	txt1: txt1$2z
};

var txt0$2R = "Example of the pin to top function";
var DialogEntDemo = {
	txt0: txt0$2R
};

var txt0$2Q = "Free upgrade to WPS+ collaboration version";
var DialogEntGetCooper = {
	txt0: txt0$2Q
};

var txt0$2P = "Enterprise id is a required parameter";
var DialogEntGuide = {
	txt0: txt0$2P
};

var txt0$2O = "You will be redirected to a third-party website. It is recommended to check that the website is safe. ";
var txt1$2y = "Cancel";
var txt2$2j = "carry on";
var txt3$25 = "Jump prompt";
var DialogLinkJumpTip = {
	txt0: txt0$2O,
	txt1: txt1$2y,
	txt2: txt2$2j,
	txt3: txt3$25
};

var txt0$2N = "Folder Permission Settings";
var txt1$2x = "Document Permission Settings";
var DialogModifyFilePermission = {
	txt0: txt0$2N,
	txt1: txt1$2x
};

var txt0$2M = "Document Permission Settings";
var DialogModifyFilePerSetting = {
	txt0: txt0$2M
};

var txt0$2L = "A team of \"Collection of Knowledge on Epidemic Prevention and Control and Staff Status\" has been prepared to facilitate statistics";
var txt1$2w = "Staff situation and issuing notices, etc. The following documents are included. Are you sure you want to create the team?";
var txt2$2i = "Create Now";
var txt3$24 = "No, thanks";
var Ent2019nCovGuide = {
	txt0: txt0$2L,
	txt1: txt1$2w,
	txt2: txt2$2i,
	txt3: txt3$24
};

var txt0$2K = "Efficient and secure multi-person collaborative office services";
var txt1$2v = "The following tips can help you get started quickly";
var txt2$2h = "Skip the guide and start using";
var EntCardsGuide = {
	txt0: txt0$2K,
	txt1: txt1$2v,
	txt2: txt2$2h
};

var txt0$2J = "View detailed graphic tutorials";
var EntCardsGuideVideo = {
	txt0: txt0$2J
};

var txt0$2I = "You have been granted the following permissions";
var txt1$2u = "WPS+ Collaboration Edition Rights";
var txt2$2g = "If you need more rights, you can";
var txt3$23 = "Fill out the application form";
var txt4$1O = "Got it";
var txt5$1F = "people";
var txt6$1s = "Larger space for centralized management of enterprise documents";
var txt7$1g = "Support large file upload and barrier-free sharing";
var txt8$1b = "Remote office and efficient collaboration";
var txt9$13 = "Voice conference, form statistics, and collaborative editing";
var txt10$_ = "Enterprise File Security Protection";
var txt11$T = "Control the visible range of important documents to prevent leakage";
var txt12$O = "WPS+ Collaboration Edition Rights";
var txt13$O = "Congratulations, you have successfully got the rights to use the WPS+ collaboration version for 6 months";
var txt14$F = "Enable Digital Office";
var txt15$A = "Provide One-Stop Solutions";
var txt16$z = "From now until June 21, 2020, the number of activated enterprise members reaches";
var txt17$v = "Current";
var txt18$v = "Invite";
var txt19$t = "You can claim the rights to use the WPS+ collaboration version for 6 months";
var txt20$q = "Only the enterprise administrator can claim rights and notify";
var txt21$m = "To Claim";
var txt22$k = "Claim Now";
var txt23$h = "The server is running short. Please try again later";
var EntGetCooper = {
	txt0: txt0$2I,
	txt1: txt1$2u,
	txt2: txt2$2g,
	txt3: txt3$23,
	txt4: txt4$1O,
	txt5: txt5$1F,
	txt6: txt6$1s,
	txt7: txt7$1g,
	txt8: txt8$1b,
	txt9: txt9$13,
	txt10: txt10$_,
	txt11: txt11$T,
	txt12: txt12$O,
	txt13: txt13$O,
	txt14: txt14$F,
	txt15: txt15$A,
	txt16: txt16$z,
	txt17: txt17$v,
	txt18: txt18$v,
	txt19: txt19$t,
	txt20: txt20$q,
	txt21: txt21$m,
	txt22: txt22$k,
	txt23: txt23$h
};

var txt0$2H = "Check out the WPS+ User Guide to help enterprises resume work";
var txt1$2t = "View User Guide >";
var txt2$2f = "Show Less Guide";
var txt3$22 = "\"Help Center\"";
var txt4$1N = "View";
var txt5$1E = "For more remote office guides and industry use cases, go to";
var txt6$1r = "You can enter the remote office guides here";
var txt7$1f = "Use forms to collect and efficiently summarize information";
var txt8$1a = "Applicable to various scenarios such as customer demand collection, sales statistics, and epidemic prevention materials statistics";
var txt9$12 = "Transform the table into a form and send it to relevant personnel to fill in. This function can be used to automatically summarize content into a table, which is convenient and efficient";
var txt10$Z = "Realize office data sharing with enterprise teams";
var txt11$S = "Documents are shared in the team to form an office database to avoid scattered documents and repeated transmission";
var txt12$N = "Control employees' read and write permissions on demand, prevent important documents from being compromised and accidentally modified";
var txt13$N = "Supports simultaneous editing by multiple people, avoiding the trouble of filling in separately and summarizing";
var txt14$E = "Start a remote meeting with a document";
var txt15$z = "Use the \"remote conference\" feature to avoid gatherings of people and hold conferences from anywhere";
var txt16$y = "Multiple people can view the document at the same time, and the document will automatically turn the page, following the speaker, which is as efficient as in-person communication";
var txt17$u = "Use WPS calendar to arrange office schedule";
var txt18$u = "The office schedule is synchronized with all employees, and the nodes are clear at a glance";
var txt19$s = "Automatically send a reminder when the schedule is due. No delay in important work";
var EntRemoteWorkGuide = {
	txt0: txt0$2H,
	txt1: txt1$2t,
	txt2: txt2$2f,
	txt3: txt3$22,
	txt4: txt4$1N,
	txt5: txt5$1E,
	txt6: txt6$1r,
	txt7: txt7$1f,
	txt8: txt8$1a,
	txt9: txt9$12,
	txt10: txt10$Z,
	txt11: txt11$S,
	txt12: txt12$N,
	txt13: txt13$N,
	txt14: txt14$E,
	txt15: txt15$z,
	txt16: txt16$y,
	txt17: txt17$u,
	txt18: txt18$u,
	txt19: txt19$s
};

var txt0$2G = "Add Pin-to-Top Announcement";
var txt1$2s = "Set team goals or work instructions for newcomers";
var txt2$2e = "Add Pinned File";
var txt3$21 = "Let members pay attention to important team documents";
var txt4$1M = "Click";
var txt5$1D = "Add";
var txt6$1q = "Team Announcement Pined Top";
var txt7$1e = "Sales this quarter increased by 30% year-on-year.";
var txt8$19 = "Customer Information Registration Form.xlsx";
var txt9$11 = "Pin to Team Top";
var txt10$Y = "Pin-to-Top Content";
var txt11$R = "Team Documents";
var txt12$M = "Sales Department";
var EntTeamtopDemo = {
	txt0: txt0$2G,
	txt1: txt1$2s,
	txt2: txt2$2e,
	txt3: txt3$21,
	txt4: txt4$1M,
	txt5: txt5$1D,
	txt6: txt6$1q,
	txt7: txt7$1e,
	txt8: txt8$19,
	txt9: txt9$11,
	txt10: txt10$Y,
	txt11: txt11$R,
	txt12: txt12$M
};

var txt0$2F = "link sharing";
var txt1$2r = "The file has permissions set";
var txt2$2d = "Share to designated users";
var txt3$20 = "my group";
var txt4$1L = "my permissions";
var txt6$1p = "select from address book";
var txt7$1d = "Share with users and groups";
var txt8$18 = "my group";
var txt9$10 = "The parent directory has enabled sharing, the permission is \"{0}\"";
var txt10$X = "The folder is not shared";
var txt11$Q = "Inherited parent directory permissions";
var txt12$L = "(Inherit parent folder sharing settings)";
var cancel$e = "Cancel";
var confirm$4 = "Sure";
var openLink$1 = "open link";
var openShare = "open sharing";
var copyLink$5 = "copy Link";
var modify$2 = "Revise";
var shareTo = "share to";
var moreShareWay = "More ways to share";
var unopened = "Unopened";
var advanceSetting = "advanced settings";
var someoneTip1 = "Only specified users and groups can be opened by link";
var someoneTip2 = "Only users below can access";
var inheritFirstDir = "Inherit parent folder sharing settings";
var unopenedFolderLink = "Folder not open link";
var someone$1 = "Only users below";
var anyone$3 = "Anyone";
var company$1 = "Member of the company";
var noRangePerm = "Sharing scope and permission not set";
var linkNotOpenShare = "The file is not shared";
var linkExpired = "The file sharing link has expired";
var closeShareLink = "close link sharing";
var cancelShare = "unshare";
var remove$1 = "remove";
var getOut = "Remove";
var read$8 = "viewable";
var write$7 = "editable";
var notFound = "No corresponding user, group or department found";
var openPublicShare = "Open external sharing";
var canManage = "manageable";
var shareGuideTip = "Want to share with designated people? Try recreating the share.";
var entEmpowerPermConfirm_txt0 = "Please confirm to enable sharing \"{0}\"";
var entEmpowerPermConfirm_txt1 = "External sharing is not enabled for the current file, and members outside the team cannot be added";
var entEmpowerPermConfirm_txt2 = "{0} members";
var yourself = "yourself";
var teamMember = "team member";
var cancelShareConfirmTitle = "Please confirm to unshare \"{0}\"";
var cancelShareConfirmSubTitle = "After canceling, only {name} can access, the following members will no longer be able to access";
var linkCopied = "link copied";
var copySuccess$2 = "copy successfully";
var copyFail = "replication failed";
var noPermission$2 = "no access";
var directToAdd = "Directly specify to add";
var linkToAdd = "join via link";
var fileBelongToTeam = "The team the document belongs to";
var wpsDoc = "Kingsoft document";
var manualCopyTips = "Your browser does not support automatic copying, please press {0} + C to copy the contents of the input box below";
var openShareSuccess = "Open share success";
var openLinkSuccess$1 = "Open the link successfully";
var inputTip = "Enter username, group or department";
var cancelShareSuccess = "Unshared successfully";
var cancelShareFail = "Unshare failed";
var updateSuccess = "Successfully modified";
var updateFail = "fail to edit";
var addSuccess = "Added successfully";
var shareChargeInCompany = "{role} has disabled file sharing outside the enterprise";
var shareChargeInTeam = "{role} has disabled file sharing outside the team";
var teamAdmin = "team admin";
var entAdmin = "enterprise administrator";
var condition1 = "{0} users have been searched";
var condition2 = ", and {0} of them have permissions";
var someoneTip5 = "Only the creator can specify user access";
var stopCoop = "Stop collaboration";
var send$1 = "Send";
var permsSetting = "Permission Settings";
var someoneTip3 = "Specified User";
var someoneTip4 = "Only specified users can access";
var someone1 = "Only specified users";
var stopCoopSuccess = "Collaboration stopped.";
var failTryAgain = "Failure. Please try again.";
var linkPerm = "Link Permissions";
var manageCorpMembers = "Manage Collaborators";
var addCorpMembers = "Add Collaborator";
var corp = "Collaboration";
var shareRange$2 = "Sharing Scope";
var sharePerms = "Sharing Permission";
var multiCompoundPerms = "Combination Permission";
var selectDate = "Select date";
var selectTime = "Select time";
var requestShareOutside$2 = "Application for outsourcing";
var EntSharePanel = {
	txt0: txt0$2F,
	txt1: txt1$2r,
	txt2: txt2$2d,
	txt3: txt3$20,
	txt4: txt4$1L,
	txt6: txt6$1p,
	txt7: txt7$1d,
	txt8: txt8$18,
	txt9: txt9$10,
	txt10: txt10$X,
	txt11: txt11$Q,
	txt12: txt12$L,
	cancel: cancel$e,
	confirm: confirm$4,
	openLink: openLink$1,
	openShare: openShare,
	copyLink: copyLink$5,
	modify: modify$2,
	shareTo: shareTo,
	moreShareWay: moreShareWay,
	unopened: unopened,
	advanceSetting: advanceSetting,
	someoneTip1: someoneTip1,
	someoneTip2: someoneTip2,
	inheritFirstDir: inheritFirstDir,
	unopenedFolderLink: unopenedFolderLink,
	someone: someone$1,
	anyone: anyone$3,
	company: company$1,
	noRangePerm: noRangePerm,
	linkNotOpenShare: linkNotOpenShare,
	linkExpired: linkExpired,
	closeShareLink: closeShareLink,
	cancelShare: cancelShare,
	remove: remove$1,
	getOut: getOut,
	read: read$8,
	write: write$7,
	notFound: notFound,
	openPublicShare: openPublicShare,
	canManage: canManage,
	shareGuideTip: shareGuideTip,
	entEmpowerPermConfirm_txt0: entEmpowerPermConfirm_txt0,
	entEmpowerPermConfirm_txt1: entEmpowerPermConfirm_txt1,
	entEmpowerPermConfirm_txt2: entEmpowerPermConfirm_txt2,
	yourself: yourself,
	teamMember: teamMember,
	cancelShareConfirmTitle: cancelShareConfirmTitle,
	cancelShareConfirmSubTitle: cancelShareConfirmSubTitle,
	linkCopied: linkCopied,
	copySuccess: copySuccess$2,
	copyFail: copyFail,
	noPermission: noPermission$2,
	directToAdd: directToAdd,
	linkToAdd: linkToAdd,
	fileBelongToTeam: fileBelongToTeam,
	wpsDoc: wpsDoc,
	manualCopyTips: manualCopyTips,
	openShareSuccess: openShareSuccess,
	openLinkSuccess: openLinkSuccess$1,
	inputTip: inputTip,
	cancelShareSuccess: cancelShareSuccess,
	cancelShareFail: cancelShareFail,
	updateSuccess: updateSuccess,
	updateFail: updateFail,
	addSuccess: addSuccess,
	shareChargeInCompany: shareChargeInCompany,
	shareChargeInTeam: shareChargeInTeam,
	teamAdmin: teamAdmin,
	entAdmin: entAdmin,
	condition1: condition1,
	condition2: condition2,
	someoneTip5: someoneTip5,
	stopCoop: stopCoop,
	send: send$1,
	permsSetting: permsSetting,
	someoneTip3: someoneTip3,
	someoneTip4: someoneTip4,
	someone1: someone1,
	stopCoopSuccess: stopCoopSuccess,
	failTryAgain: failTryAgain,
	linkPerm: linkPerm,
	manageCorpMembers: manageCorpMembers,
	addCorpMembers: addCorpMembers,
	corp: corp,
	shareRange: shareRange$2,
	sharePerms: sharePerms,
	multiCompoundPerms: multiCompoundPerms,
	selectDate: selectDate,
	selectTime: selectTime,
	requestShareOutside: requestShareOutside$2
};

var txt0$2E = "Document Label";
var txt1$2q = "Enter the label and press Enter to add it.";
var txt2$2c = "The label text is too long.";
var txt3$1$ = "Recommended Label";
var txt4$1K = "Too many labels are not easy to manage.";
var txt5$1C = "The label already exists.";
var txt6$1o = "Cancel";
var txt7$1c = "OK";
var companyLabel = "Enterprise Label";
var groupLabel = "Team Label";
var groupLabelInfo = "(Visible to all members)";
var companyOrGroupLabel = "Enterprise/Team Label";
var myLabel = "My Labels";
var noCreateGroupPermission = "You have no permission to create a team label. Select it from the drop-down menu.";
var inputKeywordWarning = "There are labels not added in the input box.";
var createLabelFailed = "Failed to add it.";
var EditLabel = {
	txt0: txt0$2E,
	txt1: txt1$2q,
	txt2: txt2$2c,
	txt3: txt3$1$,
	txt4: txt4$1K,
	txt5: txt5$1C,
	txt6: txt6$1o,
	txt7: txt7$1c,
	companyLabel: companyLabel,
	groupLabel: groupLabel,
	groupLabelInfo: groupLabelInfo,
	companyOrGroupLabel: companyOrGroupLabel,
	myLabel: myLabel,
	noCreateGroupPermission: noCreateGroupPermission,
	inputKeywordWarning: inputKeywordWarning,
	createLabelFailed: createLabelFailed
};

var txt0$2D = "Save As";
var txt1$2p = "Copy";
var txt2$2b = "Selected";
var txt3$1_ = "items";
var txt4$1J = "File copied successfully";
var txt5$1B = "Paste";
var txt6$1n = "Copy to";
var txt7$1b = "You are not authorized to decrypt this file because it is not encrypted by you. You can contact {0} (who encrypted the document) for decryption.";
var FileCopy = {
	txt0: txt0$2D,
	txt1: txt1$2p,
	txt2: txt2$2b,
	txt3: txt3$1_,
	txt4: txt4$1J,
	txt5: txt5$1B,
	txt6: txt6$1n,
	txt7: txt7$1b
};

var txt0$2C = "Sign in and download the specified file.";
var txt1$2o = "Failed to get the team.";
var txt2$2a = "Failed to get the file download address.";
var txt3$1Z = "Failed to download the specified file list completely.";
var txt4$1I = "Failed to download {0}. The file format does not support downloading.";
var txt5$1A = "Failed to download {1} files including {0}. The file format does not support downloading.";
var txt6$1m = "Preparing to download";
var txt7$1a = "You cannot batch download more than 300 files. Please select again.";
var txt8$17 = "You cannot batch download more than 100 files.";
var txt9$$ = "Upgrade to WPS Premium to increase the upper limit";
var txt10$W = "You cannot batch download files larger than 500 MB. Please select again.";
var txt11$P = "You cannot batch download files larger than 200 MB.";
var txt12$K = "Upgrade to WPS Premium to increase the upper limit";
var txt13$M = "API not supported by the client side.";
var tooManyRequests = "This request cannot be completed at this time, please try again later";
var imageResourcesTooLarge = "The size of the image in the current document exceeds 2GB, and export is not supported for the time being";
var fail$1 = "Export failed, please try again later";
var VisiblePermissionDenied = "The document contains invisible areas, this operation is not supported";
var permissionDenied$1 = "You do not have permission to download this file";
var FileDownload = {
	txt0: txt0$2C,
	txt1: txt1$2o,
	txt2: txt2$2a,
	txt3: txt3$1Z,
	txt4: txt4$1I,
	txt5: txt5$1A,
	txt6: txt6$1m,
	txt7: txt7$1a,
	txt8: txt8$17,
	txt9: txt9$$,
	txt10: txt10$W,
	txt11: txt11$P,
	txt12: txt12$K,
	txt13: txt13$M,
	tooManyRequests: tooManyRequests,
	imageResourcesTooLarge: imageResourcesTooLarge,
	fail: fail$1,
	VisiblePermissionDenied: VisiblePermissionDenied,
	permissionDenied: permissionDenied$1
};

var txt0$2B = "Move";
var txt1$2n = "Selected";
var txt2$29 = "items";
var txt3$1Y = "File moved successfully";
var txt4$1H = "Move to";
var FileMove = {
	txt0: txt0$2B,
	txt1: txt1$2n,
	txt2: txt2$29,
	txt3: txt3$1Y,
	txt4: txt4$1H
};

var title$s = "Document Information";
var view_t1 = "Traffic Data";
var view_t2 = "The edited data was collected from April 28, 2022.";
var view_today = "Today";
var view_pv = "Views";
var view_dv = "Viewers";
var view_ev = "Editors";
var view_pv_desc = "The number of times the document was successfully opened.";
var view_dv_desc = "The number of people who successfully opened the document.";
var view_ev_desc = "The total number of people who edited the document.";
var export_btn = "Export Data";
var creator$1 = "Owner";
var otl = "Online AirPage";
var dbt = "DBsheet";
var pof = "Mind Map";
var pom = "Flowchart";
var kw = "Whiteboard";
var wpsnote = "Note";
var ckt = "Poster";
var ofd = "Sample Page";
var ksheet = "Online AirSheet";
var size_text = "-";
var netError_desc = "Network error. Load failed.";
var export_title = "Export Traffic Data";
var export_desc = "Only supports exporting data of the last 30 days.";
var export_btn_error = "Export failed.";
var export_btn_retry = "Retry";
var export_path = "Save to";
var filename = "File Name";
var createtime = "Creation Time";
var filetype = "Type";
var filesize = "Size";
var filepath = "Location";
var form = "Collection Form";
var myfile = "Shared with me";
var netError_btn = "Reload";
var export_btn_cancel = "Cancel";
var export_btn_open = "Open Document";
var count_title = "Basic Information";
var count_total = "total word count";
var count_char1 = "Number of characters: count spaces";
var count_char2 = "Number of characters: excluding spaces";
var group_viewer_title = "Group visitors";
var group_viewer_btn = "View the number of WeChat group visitors";
var group_viewer_tip = "Use mobile phone WeChat to \"scan\" to check the number of WeChat group visitors";
var group_viewer_bottom_btn = "to check";
var FileInfo = {
	title: title$s,
	view_t1: view_t1,
	view_t2: view_t2,
	view_today: view_today,
	view_pv: view_pv,
	view_dv: view_dv,
	view_ev: view_ev,
	view_pv_desc: view_pv_desc,
	view_dv_desc: view_dv_desc,
	view_ev_desc: view_ev_desc,
	export_btn: export_btn,
	creator: creator$1,
	otl: otl,
	dbt: dbt,
	pof: pof,
	pom: pom,
	kw: kw,
	wpsnote: wpsnote,
	ckt: ckt,
	ofd: ofd,
	ksheet: ksheet,
	size_text: size_text,
	netError_desc: netError_desc,
	export_title: export_title,
	export_desc: export_desc,
	export_btn_error: export_btn_error,
	export_btn_retry: export_btn_retry,
	export_path: export_path,
	filename: filename,
	createtime: createtime,
	filetype: filetype,
	filesize: filesize,
	filepath: filepath,
	form: form,
	myfile: myfile,
	netError_btn: netError_btn,
	export_btn_cancel: export_btn_cancel,
	export_btn_open: export_btn_open,
	count_title: count_title,
	count_total: count_total,
	count_char1: count_char1,
	count_char2: count_char2,
	group_viewer_title: group_viewer_title,
	group_viewer_btn: group_viewer_btn,
	group_viewer_tip: group_viewer_tip,
	group_viewer_bottom_btn: group_viewer_bottom_btn
};

var decryptFiles = "Decrypt File";
var confirm$3 = "Decrypt and Continue";
var cancel$d = "Cancel";
var txt1$2m = "The current team has enabled document encryption protection. Please read and check the following options:";
var txt2$28 = "Documents removed from the team need to be decrypted first, and the decrypted documents can be shared with and viewed by anyone.";
var txt3$1X = "If you need to encrypt the selected file (folder) again, enable document encryption protection in [Team Settings] of the team to which the file (folder) belongs.";
var cryptDocs = "{action} encrypt document";
var operationTip = "After encrypting the document {action} to the security team \"{team}\", the document can only be accessed by \"{team}\" members, and the person who encrypted the document has changed to the owner of the team. Do you want to continue?";
var actConfirm = "confirm {action}";
var noMoreRemind = "never remind again";
var checkPermTip = "You are not an encryptor and have no right to operate, you can contact {name} (document encryptor) to operate";
var copy$1 = "copy";
var move = "move";
var saveAs$1 = "save as";
var SecureTeamConfirm = {
	decryptFiles: decryptFiles,
	confirm: confirm$3,
	cancel: cancel$d,
	txt1: txt1$2m,
	txt2: txt2$28,
	txt3: txt3$1X,
	cryptDocs: cryptDocs,
	operationTip: operationTip,
	actConfirm: actConfirm,
	noMoreRemind: noMoreRemind,
	checkPermTip: checkPermTip,
	copy: copy$1,
	move: move,
	saveAs: saveAs$1
};

var txt0$2A = "Congratulations, your enterprise has joined the SME Growth Plan!";
var txt1$2l = "has got the following rights";
var txt2$27 = "people";
var txt3$1W = "Storage";
var txt4$1G = "Upload Document Size";
var txt5$1z = "Enterprise Headcount Expansion";
var txt6$1l = "Use Training";
var txt7$19 = "If you need to learn more about enterprise headcount expansion and use training, you can join the QQ group: 695850612";
var txt8$16 = "Got it";
var txt9$_ = "Congratulations, you have claimed the activated enterprise rights";
var txt10$V = "Get More Advanced Rights";
var FinishCompPrivilege = {
	txt0: txt0$2A,
	txt1: txt1$2l,
	txt2: txt2$27,
	txt3: txt3$1W,
	txt4: txt4$1G,
	txt5: txt5$1z,
	txt6: txt6$1l,
	txt7: txt7$19,
	txt8: txt8$16,
	txt9: txt9$_,
	txt10: txt10$V
};

var txt0$2z = "Within the enterprise,";
var txt1$2k = "The following tasks can be completed more securely and efficiently";
var txt2$26 = "Skip the guide and start using";
var txt3$1V = "Use template team to achieve";
var txt5$1y = "Learn Now";
var GroupTemplateGuide = {
	txt0: txt0$2z,
	txt1: txt1$2k,
	txt2: txt2$26,
	txt3: txt3$1V,
	txt5: txt5$1y
};

var txt0$2y = "create \"";
var txt1$2j = "\" team";
var txt2$25 = "Failed to create the team. Please try again later";
var GroupTplVideo = {
	txt0: txt0$2y,
	txt1: txt1$2j,
	txt2: txt2$25
};

var txt0$2x = "Invite Colleagues";
var txt1$2i = "Click here to invite colleagues to join the enterprise next time";
var txt2$24 = "To Invite";
var txt3$1U = "1/2 Upload files";
var txt4$1F = "Click here to upload documents to the team next time";
var txt5$1x = "Next";
var txt6$1k = "2/2 Share files";
var txt7$18 = "Click the \"Share\" button, set sharing permissions, create a sharing link, and then share the file with colleagues";
var txt8$15 = "Go to Share";
var txt9$Z = "Apply to join the \"Enterprise Growth Plan\" to claim enterprise rights";
var txt10$U = "Invite {0} or more people to join to upgrade enterprise rights";
var txt11$O = "Invite 2 or more people to join to upgrade enterprise rights";
var txt12$J = "Apply to join the Enterprise Growth Plan";
var txt13$L = "Invite Colleagues to Join";
var txt14$D = "people";
var GuideReminder = {
	txt0: txt0$2x,
	txt1: txt1$2i,
	txt2: txt2$24,
	txt3: txt3$1U,
	txt4: txt4$1F,
	txt5: txt5$1x,
	txt6: txt6$1k,
	txt7: txt7$18,
	txt8: txt8$15,
	txt9: txt9$Z,
	txt10: txt10$U,
	txt11: txt11$O,
	txt12: txt12$J,
	txt13: txt13$L,
	txt14: txt14$D
};

var txt0$2w = "You can create more team templates here next time";
var GuideSingleTip = {
	txt0: txt0$2w
};

var txt0$2v = "You can invite enterprise managers/HR and other related colleagues to join the team here to facilitate access to employee information and information synchronization";
var txt1$2h = "Invite Now";
var txt2$23 = "Generate a statistical table to a form and share it with employees. After the employee fills in the form, the summary table can be automatically generated, which is convenient, efficient, time-saving, and effort-saving";
var txt3$1T = "See operation guide";
var txt4$1E = "To learn more about \"How to use WPS+ for remote office\", please check the document";
var txt5$1w = "View Now";
var txt6$1j = "Parameter cannot be empty";
var txt7$17 = "Invalid parameter type. The correct value should be:";
var GuideStepTips = {
	txt0: txt0$2v,
	txt1: txt1$2h,
	txt2: txt2$23,
	txt3: txt3$1T,
	txt4: txt4$1E,
	txt5: txt5$1w,
	txt6: txt6$1j,
	txt7: txt7$17
};

var txt0$2u = "Import instructions";
var txt1$2g = "Join the enterprise quickly";
var txt2$22 = "We will send to the folder collaboration members";
var txt3$1S = "Invitation notice, join directly after accepting";
var txt4$1D = "Smooth migration";
var txt5$1v = "Original member permissions, folder directory permissions,";
var txt6$1i = "Sharing links and collaborating members remain unchanged";
var txt7$16 = "Enterprise advanced features";
var txt8$14 = "Get enterprise team documents";
var txt9$Y = "Advanced features such as encryption";
var txt10$T = "Select shared folder";
var txt11$N = "Select the shared folder you want to import to the enterprise";
var txt12$I = "Personal shared folder";
var txt13$K = "No shared folders";
var txt14$C = "Members·";
var txt15$y = "Enterprise team";
var txt16$x = "Click on the shared folder on the left";
var txt17$t = "Import files and members into the enterprise";
var txt18$t = "Import the shared folder successfully";
var txt19$r = "The following members need to accept the invitation to join the enterprise to access the team normally";
var txt20$p = "I see";
var txt21$l = "Has been imported successfully,";
var txt22$j = " Import failed, ";
var txt23$g = "Reason for failure: The number of enterprise teams reached the upper limit";
var txt24$e = "Please try to import again";
var txt25$d = "Talk later";
var txt26$d = "Confirm";
var txt27$c = "Retry";
var ImportPersonalFolder = {
	txt0: txt0$2u,
	txt1: txt1$2g,
	txt2: txt2$22,
	txt3: txt3$1S,
	txt4: txt4$1D,
	txt5: txt5$1v,
	txt6: txt6$1i,
	txt7: txt7$16,
	txt8: txt8$14,
	txt9: txt9$Y,
	txt10: txt10$T,
	txt11: txt11$N,
	txt12: txt12$I,
	txt13: txt13$K,
	txt14: txt14$C,
	txt15: txt15$y,
	txt16: txt16$x,
	txt17: txt17$t,
	txt18: txt18$t,
	txt19: txt19$r,
	txt20: txt20$p,
	txt21: txt21$l,
	txt22: txt22$j,
	txt23: txt23$g,
	txt24: txt24$e,
	txt25: txt25$d,
	txt26: txt26$d,
	txt27: txt27$c
};

var txt0$2t = "Transfer Instructions";
var txt1$2f = "Transfer the selected file (folder).";
var DialogImportFromSpecail = {
	txt0: txt0$2t,
	txt1: txt1$2f
};

var txt0$2s = "The enterprise administrator has prohibited the transfer of enterprise documents outside the enterprise. After the personal documents are transferred, the documents will be under enterprise control.";
var txt1$2e = "The file cannot be transferred or copied outside the enterprise.";
var txt2$21 = "To Transfer";
var txt3$1R = "Cancel";
var ImportFromSpecailTips = {
	txt0: txt0$2s,
	txt1: txt1$2e,
	txt2: txt2$21,
	txt3: txt3$1R
};

var txt0$2r = "The shared folder cannot be transferred to \"My Enterprise Documents\". Upgrade to a team first.";
var txt1$2d = "File transferred successfully.";
var txt2$20 = "Transfer";
var ImportFromSpecail = {
	txt0: txt0$2r,
	txt1: txt1$2d,
	txt2: txt2$20
};

var txt0$2q = "Join the enterprise quickly";
var txt1$2c = "We will send to the folder collaboration members";
var txt2$1$ = "Invitation notice, join directly after accepting";
var txt3$1Q = "Smooth migration";
var txt4$1C = "Original member permissions, folder directory permissions,";
var txt5$1u = "Sharing links and collaborating members remain unchanged";
var txt6$1h = "Enterprise advanced features";
var txt7$15 = "Get enterprise team documents";
var txt8$13 = "Advanced features such as encryption";
var txt9$X = "Select shared folder";
var txt10$S = "Select the shared folder you want to move into the enterprise";
var txt11$M = "Personal shared folder";
var txt12$H = "No shared folders";
var txt13$J = "Members·";
var txt14$B = "Enterprise team";
var txt15$x = "Click on the shared folder on the left";
var txt16$w = "Move files and members into the enterprise";
var txt17$s = "Move in now";
var txt18$s = "Successfully moved into the shared folder";
var txt19$q = "The following members need to accept the invitation to join the enterprise to access the team normally";
var txt20$o = "I see";
var txt21$k = "Has been successfully moved,";
var txt22$i = " Failed to move in,";
var txt23$f = "Reason for failure: The number of enterprise teams reached the upper limit";
var txt24$d = "Please try to move in again";
var txt25$c = "Talk later";
var txt26$c = "Confirm";
var txt27$b = "Retry";
var txt28$b = "Support moving into up to 20 shared folders";
var txt29$7 = "Move in instructions";
var txt30$6 = "Apply for moving into";
var txt31$7 = "shared folders";
var ImportPersonalFolderPlus = {
	txt0: txt0$2q,
	txt1: txt1$2c,
	txt2: txt2$1$,
	txt3: txt3$1Q,
	txt4: txt4$1C,
	txt5: txt5$1u,
	txt6: txt6$1h,
	txt7: txt7$15,
	txt8: txt8$13,
	txt9: txt9$X,
	txt10: txt10$S,
	txt11: txt11$M,
	txt12: txt12$H,
	txt13: txt13$J,
	txt14: txt14$B,
	txt15: txt15$x,
	txt16: txt16$w,
	txt17: txt17$s,
	txt18: txt18$s,
	txt19: txt19$q,
	txt20: txt20$o,
	txt21: txt21$k,
	txt22: txt22$i,
	txt23: txt23$f,
	txt24: txt24$d,
	txt25: txt25$c,
	txt26: txt26$c,
	txt27: txt27$b,
	txt28: txt28$b,
	txt29: txt29$7,
	txt30: txt30$6,
	txt31: txt31$7
};

var txt0$2p = "Invitation sent";
var txt1$2b = "Members can join the enterprise after accepting";
var txt2$1_ = "Send the link to a colleague, and the colleague can apply to join the enterprise by clicking";
var txt3$1P = "Scan the QR code to send invitations to colleagues";
var txt4$1B = "Copy";
var txt5$1t = "My contact";
var txt6$1g = "Cancel";
var txt7$14 = "Confirm";
var txt8$12 = "Copy failed";
var txt9$W = "Copy successfully";
var InviteColleague = {
	txt0: txt0$2p,
	txt1: txt1$2b,
	txt2: txt2$1_,
	txt3: txt3$1P,
	txt4: txt4$1B,
	txt5: txt5$1t,
	txt6: txt6$1g,
	txt7: txt7$14,
	txt8: txt8$12,
	txt9: txt9$W
};

var txt0$2o = "Degree of Completion";
var txt1$2a = "You can apply to join the growth plan if you reach your goal";
var txt2$1Z = "Creation Days";
var txt3$1O = "days";
var txt4$1A = "Number of people who have used the team function";
var txt5$1s = "Enterprise Index";
var txt6$1f = "Understand enterprise Index";
var txt7$13 = "Free application to join";
var txt8$11 = "SME Growth Plan Rights";
var txt9$V = "people";
var txt10$R = "Storage";
var txt11$L = "Upload Document Size";
var txt12$G = "Enterprise Headcount Expansion";
var txt13$I = "Use Training";
var txt15$w = "Or learn more about";
var txt16$v = "Paid Package";
var txt17$r = "You still have a growth plan to complete";
var txt18$r = "Insufficient permission";
var txt19$p = "The account has been logged out. Please log in again";
var txt14$A = "Completed";
var expansionDesc = "Company Staff Expansion Application";
var expansionJumpDesc = "Apply Now";
var awardsDescLink = "2023 Growth Plan Benefit Adjustment";
var JoinCompPrivilege = {
	txt0: txt0$2o,
	txt1: txt1$2a,
	txt2: txt2$1Z,
	txt3: txt3$1O,
	txt4: txt4$1A,
	txt5: txt5$1s,
	txt6: txt6$1f,
	txt7: txt7$13,
	txt8: txt8$11,
	txt9: txt9$V,
	txt10: txt10$R,
	txt11: txt11$L,
	txt12: txt12$G,
	txt13: txt13$I,
	txt15: txt15$w,
	txt16: txt16$v,
	txt17: txt17$r,
	txt18: txt18$r,
	txt19: txt19$p,
	txt14: txt14$A,
	expansionDesc: expansionDesc,
	expansionJumpDesc: expansionJumpDesc,
	awardsDescLink: awardsDescLink
};

var txt0$2n = "Collaborate";
var txt1$29 = "Public Sharing";
var txt2$1Y = "Share";
var txt3$1N = "Share Privately";
var txt4$1z = "Copied successfully";
var txt5$1r = "Copy failed";
var txt6$1e = "Copied successfully. ";
var txt7$12 = "People who opened the link";
var txt8$10 = "Only you can view or edit";
var txt9$U = "Your browser does not support automatic copy. Press";
var txt10$Q = "to copy the content in the following input box";
var txt11$K = "The sharing function is in upgrade and maintenance";
var txt12$F = "All Members";
var LinkCoopBox = {
	txt0: txt0$2n,
	txt1: txt1$29,
	txt2: txt2$1Y,
	txt3: txt3$1N,
	txt4: txt4$1z,
	txt5: txt5$1r,
	txt6: txt6$1e,
	txt7: txt7$12,
	txt8: txt8$10,
	txt9: txt9$U,
	txt10: txt10$Q,
	txt11: txt11$K,
	txt12: txt12$F
};

var txt0$2m = "Prevent viewers from downloading, saving, and printing files.";
var txt1$28 = "With this feature enabled, people with only viewing permissions will not be able to download, print, save, and copy content";
var openComment$2 = "People who join the sharing are allowed to view and post full-text comments.";
var openCommentTips$1 = "After this feature is enabled, others can open the document to post and view full-text comments.";
var ksheetForbid$2 = "Prohibit viewers from exporting, printing, saving a copy, and copying.";
var txt2$1X = "Applicable to the document for prohibited viewers.";
var ksheetPopText$1 = "When enabled, people with only view permission will not be able to export, print, save a copy, or copy the content.";
var kdbtForbid$1 = "Prohibit viewers from exporting, saving a copy, and copying.";
var kdbtPopText$1 = "After opening, people with only viewing permissions will not be exported, stored, and replicated.";
var kprocessonPopText$1 = "When enabled, people with only view permission will not be able to export or save a copy.";
var kimgForbid$1 = "Prohibit viewers from downloading and saving a copy.";
var kimgPopText$1 = "When enabled, people with only view permission will not be able to download or save a copy.";
var showFullComment = "Show Full-text Comments";
var kfpForbid$1 = "Prohibit export and save by viewers";
var kfpPopText$1 = "When this feature is enabled, people with only view permission cannot export or save it as a copy.";
var kprocessonForbid$1 = "Prohibit export and save by viewers";
var LinkDownloadPerm = {
	txt0: txt0$2m,
	txt1: txt1$28,
	openComment: openComment$2,
	openCommentTips: openCommentTips$1,
	ksheetForbid: ksheetForbid$2,
	txt2: txt2$1X,
	ksheetPopText: ksheetPopText$1,
	kdbtForbid: kdbtForbid$1,
	kdbtPopText: kdbtPopText$1,
	kprocessonPopText: kprocessonPopText$1,
	kimgForbid: kimgForbid$1,
	kimgPopText: kimgPopText$1,
	showFullComment: showFullComment,
	kfpForbid: kfpForbid$1,
	kfpPopText: kfpPopText$1,
	kprocessonForbid: kprocessonForbid$1
};

var ksheetForbid$1 = "Prohibit viewers from exporting, printing, saving a copy, and copying.";
var ksheetRenameForbid$1 = "Prohibit adding and deleting worksheets";
var ksheetRenameForbidDesc = "Used for information collection spreadsheet filled by multiple people.";
var ksheetRenameForbidPop$1 = "When enabled, collaborators are prohibited from deleting, creating, moving, and renaming worksheets.";
var noNetwork = "Network failure. Try again later.";
var serverError = "Server error. Try again later.";
var error$4 = "Operation failed. Try again later.";
var permissionDenied = "Permission denied";
var LinkRenamePerm = {
	ksheetForbid: ksheetForbid$1,
	ksheetRenameForbid: ksheetRenameForbid$1,
	ksheetRenameForbidDesc: ksheetRenameForbidDesc,
	ksheetRenameForbidPop: ksheetRenameForbidPop$1,
	noNetwork: noNetwork,
	serverError: serverError,
	error: error$4,
	permissionDenied: permissionDenied
};

var txt0$2l = "\"";
var txt1$27 = "\"Administrator has set permissions";
var txt2$1W = "File";
var txt3$1M = "folder";
var txt4$1y = " by";
var txt5$1q = "Sharing, the other party has set permissions. ";
var txt6$1d = "Sharing canceled";
var txt7$11 = "File sharing link has expired";
var txt8$$ = "Share link not created";
var txt9$T = "Open now";
var txt10$P = "Create link";
var txt12$E = "[WPS Docs]";
var txt13$H = "Successfully opened the link";
var txt11$J = "Copy";
var LinkSettingBox = {
	txt0: txt0$2l,
	txt1: txt1$27,
	txt2: txt2$1W,
	txt3: txt3$1M,
	txt4: txt4$1y,
	txt5: txt5$1q,
	txt6: txt6$1d,
	txt7: txt7$11,
	txt8: txt8$$,
	txt9: txt9$T,
	txt10: txt10$P,
	txt12: txt12$E,
	txt13: txt13$H,
	txt11: txt11$J
};

var txt0$2k = "Permanent";
var txt1$26 = "Link Validity Period";
var txt2$1V = "days";
var txt13$G = " Effective";
var txt14$z = "The link validity period is set successfully";
var LinkTime = {
	txt0: txt0$2k,
	txt1: txt1$26,
	txt2: txt2$1V,
	txt13: txt13$G,
	txt14: txt14$z
};

var txt0$2j = "with";
var txt1$25 = "and external partners";
var txt2$1U = "Add";
var txt3$1L = "Editable by:";
var txt5$1p = "Viewable Only";
var txt6$1c = "Specified People:";
var txt7$10 = "Editable by: only you";
var LinkToCoop = {
	txt0: txt0$2j,
	txt1: txt1$25,
	txt2: txt2$1U,
	txt3: txt3$1L,
	txt5: txt5$1p,
	txt6: txt6$1c,
	txt7: txt7$10
};

var txt0$2i = "Sent successfully";
var txt1$24 = "Deleted successfully";
var txt2$1T = "Selected";
var txt3$1K = "Users";
var MemberSelectorPlus = {
	txt0: txt0$2i,
	txt1: txt1$24,
	txt2: txt2$1T,
	txt3: txt3$1K
};

var txt0$2h = "Who can view";
var txt1$23 = "Prohibit";
var txt2$1S = "allow";
var txt3$1J = "download";
var txt4$1x = "Settings";
var txt5$1o = "see";
var txt6$1b = "Add to";
var txt7$$ = "Who can edit";
var txt8$_ = "modify";
var txt9$S = "Document permission settings";
var txt10$O = "Select member";
var txt11$I = "Folder permissions";
var txt12$D = "Cannot change administrator permissions";
var txt13$F = "Folder permission settings";
var txt14$y = "Set successfully";
var txt15$v = "The setting is successful, and the permissions of all files (folders) under the folder have been updated synchronously";
var txt16$u = "All";
var txt17$q = "All members can ";
var txt18$q = "Some people only";
var txt19$o = "The selected members can ";
var txt20$n = "File Permissions ";
var ModifyFilePermission = {
	txt0: txt0$2h,
	txt1: txt1$23,
	txt2: txt2$1S,
	txt3: txt3$1J,
	txt4: txt4$1x,
	txt5: txt5$1o,
	txt6: txt6$1b,
	txt7: txt7$$,
	txt8: txt8$_,
	txt9: txt9$S,
	txt10: txt10$O,
	txt11: txt11$I,
	txt12: txt12$D,
	txt13: txt13$F,
	txt14: txt14$y,
	txt15: txt15$v,
	txt16: txt16$u,
	txt17: txt17$q,
	txt18: txt18$q,
	txt19: txt19$o,
	txt20: txt20$n
};

var txt0$2g = "The following is the document operation permission setting for team members, which is effective for all files in the team";
var txt1$22 = "Download Settings";
var txt2$1R = "Persons with file viewing rights are prohibited from downloading, printing, and saving files";
var txt3$1I = "Sharing Settings";
var txt4$1w = "Forbid team members to create share links and change share link permissions";
var txt5$1n = "Delete Settings";
var txt6$1a = "Forbid team members to delete files created by them";
var ModifyFilePerSetting = {
	txt0: txt0$2g,
	txt1: txt1$22,
	txt2: txt2$1R,
	txt3: txt3$1I,
	txt4: txt4$1w,
	txt5: txt5$1n,
	txt6: txt6$1a
};

var txt0$2f = "Who Can View";
var txt1$21 = "see";
var txt2$1Q = "Add";
var txt3$1H = "Who Can Edit";
var txt4$1v = "Modify";
var txt5$1m = "Everyone";
var txt6$19 = "All members can";
var txt7$_ = "Only certain people";
var txt8$Z = "Selected members can";
var txt9$R = "Select Member";
var txt10$N = "File Permissions";
var txt11$H = "Administrator permissions cannot be changed";
var txt12$C = "Set successfully";
var ModifyPermission = {
	txt0: txt0$2f,
	txt1: txt1$21,
	txt2: txt2$1Q,
	txt3: txt3$1H,
	txt4: txt4$1v,
	txt5: txt5$1m,
	txt6: txt6$19,
	txt7: txt7$_,
	txt8: txt8$Z,
	txt9: txt9$R,
	txt10: txt10$N,
	txt11: txt11$H,
	txt12: txt12$C
};

var txt3$1G = "The following";
var txt4$1u = "sub-files (folders) have been set permissions separately. Confirm whether to synchronously modify the permissions as \"Anyone can";
var txt5$1l = "sub-files (folders) have been set permissions separately. Confirm whether to synchronously add the permission \"Grant";
var txt6$18 = "the permission to";
var txt7$Z = "view";
var txt8$Y = "edit";
var txt10$M = "etc.";
var txt11$G = "people";
var txt13$E = "\"?";
var ModifyPermissionInfoSub = {
	txt3: txt3$1G,
	txt4: txt4$1u,
	txt5: txt5$1l,
	txt6: txt6$18,
	txt7: txt7$Z,
	txt8: txt8$Y,
	txt10: txt10$M,
	txt11: txt11$G,
	txt13: txt13$E
};

var yes = "yes";
var no = "no";
var add$1 = "Increase";
var modify$1 = "Revise";
var base = "The permissions of the following {num} subfolders (folders) have been set individually,";
var none = "Do you want to synchronize [{action}] to [{perm}]?";
var single = "Do you want to synchronize 【{action}】{name} to 【{perm}】?";
var mutilate = "Do you want to synchronize [{action}] {name} and other {count} items to [{perm}]?";
var cancel$c = "Do you want to sync [Unshare]?";
var timeoutBase = "There may be sub-files with individually set permissions";
var ModifyPermissionInfoTip = {
	yes: yes,
	no: no,
	add: add$1,
	modify: modify$1,
	base: base,
	none: none,
	single: single,
	mutilate: mutilate,
	cancel: cancel$c,
	timeoutBase: timeoutBase
};

var anyone$2 = "Anyone";
var txt0$2e = "Free login link is closed";
var txt1$20 = "Open link";
var txt3$1F = "[WPS Docs]";
var txt4$1t = "can view";
var txt5$1k = "can edit";
var txt6$17 = "Close the login-free link";
var txt7$Y = "The login-free link has been generated, please copy and send again";
var txt8$X = "Copy is successful, anyone can view";
var txt9$Q = "Copy is successful, anyone can edit";
var txt10$L = "Your browser does not support automatic copy, please click";
var txt11$F = "Copy the content of the input box below";
var txt12$B = "Sharing function upgrade and maintenance";
var txt13$D = "The login-free link has been generated, please copy and send again";
var txt14$x = "Free login link is closed";
var txt15$u = "Copy failed";
var txt16$t = "Click \"Open\" to get the login-free link again";
var secureCopy_txt = "Copy succeeded. Only the specified person can view/edit";
var txt2$1P = "Copy";
var OpenShare = {
	anyone: anyone$2,
	txt0: txt0$2e,
	txt1: txt1$20,
	txt3: txt3$1F,
	txt4: txt4$1t,
	txt5: txt5$1k,
	txt6: txt6$17,
	txt7: txt7$Y,
	txt8: txt8$X,
	txt9: txt9$Q,
	txt10: txt10$L,
	txt11: txt11$F,
	txt12: txt12$B,
	txt13: txt13$D,
	txt14: txt14$x,
	txt15: txt15$u,
	txt16: txt16$t,
	secureCopy_txt: secureCopy_txt,
	txt2: txt2$1P
};

var txt0$2d = "Tip";
var txt1$1$ = "Do not attempt to call the API on the client side";
var txt2$1O = "API not supported by the client side.";
var txt3$1E = "Failed to open special files (wdoc, wxls, wppt, pom, h5) on the client side.";
var OpenClient = {
	txt0: txt0$2d,
	txt1: txt1$1$,
	txt2: txt2$1O,
	txt3: txt3$1E
};

var copy_text = "[WPS Docs]";
var title$r = "Publish File";
var shareTitle$1 = "Share";
var update$1 = "Update";
var updated = "Version updated successfully.";
var copy_link = "Copy Link";
var copy_success$1 = "Copy succeeded. Send it to your friends.";
var copy_fail$1 = "Copy failed.";
var published = "Published";
var del_publish = "Unpublish";
var del_published = "Unpublished";
var review = "Confirm to unpublish";
var publish = "publishing";
var result = "After cancellation, everyone will not be able to access the published link.";
var title_template = "Send as Template";
var copy_text_template = "[WPS Docs | Template]";
var review_template = "Confirm to disable the template link created for";
var publish_template = "Template links created";
var result_template = "After this feature is disabled, everyone will not be able to access the template file through the link.";
var del_published_template = "The template is disabled.";
var del_publish_template = "Disable Link";
var guide_desc1 = "You can use the publish feature to generate a public link, and anyone can view the content of the current document without signing in.";
var guide_desc2 = "To update the link content, edit the document and publish it again.";
var guide_desc3 = "What can I do with the publish feature?";
var guide_go_publish = "Publish File";
var preview = "Preview";
var author = "Author";
var mbLink = "Template link";
var mobile = "Mobile version";
var pc = "Desktop version";
var save_as_fail = "Failed to save";
var wechat$1 = "WeChat";
var moment = "Moments";
var update_template = "The document content has changed, do you want to update the template link";
var load_error = "Failed to load, please try again later";
var loading$3 = "Template loading...";
var docSave = "Document saved as template";
var useDesc = "Template saved successfully, you can view and use the template in [Template Library - My Templates]";
var useBtn = "Use Template";
var cancelBtn = "Cancel";
var save_as_template = "Save as My Template";
var save_as_success = "Saved successfully";
var qrcode = "QR Code";
var title_review_error = "The operation failed, please modify the title and try again";
var PublishFile = {
	copy_text: copy_text,
	title: title$r,
	shareTitle: shareTitle$1,
	update: update$1,
	updated: updated,
	copy_link: copy_link,
	copy_success: copy_success$1,
	copy_fail: copy_fail$1,
	published: published,
	del_publish: del_publish,
	del_published: del_published,
	review: review,
	publish: publish,
	result: result,
	title_template: title_template,
	copy_text_template: copy_text_template,
	review_template: review_template,
	publish_template: publish_template,
	result_template: result_template,
	del_published_template: del_published_template,
	del_publish_template: del_publish_template,
	guide_desc1: guide_desc1,
	guide_desc2: guide_desc2,
	guide_desc3: guide_desc3,
	guide_go_publish: guide_go_publish,
	preview: preview,
	author: author,
	mbLink: mbLink,
	mobile: mobile,
	pc: pc,
	save_as_fail: save_as_fail,
	wechat: wechat$1,
	moment: moment,
	update_template: update_template,
	load_error: load_error,
	loading: loading$3,
	docSave: docSave,
	useDesc: useDesc,
	useBtn: useBtn,
	cancelBtn: cancelBtn,
	"share-to-tip": "Share to",
	save_as_template: save_as_template,
	save_as_success: save_as_success,
	qrcode: qrcode,
	title_review_error: title_review_error
};

var txt0$2c = "Submitted successfully";
var txt1$1_ = "Submission failed";
var txt2$1N = "Customer Case";
var txt3$1D = "Report \"";
var txt31$6 = "\"";
var txt4$1s = "Please try again later";
var txt5$1j = "Operation succeeded";
var txt6$16 = "Operation failed. Please try again later";
var txt7$X = "Select a problem";
var txt8$W = "Violation of national laws and regulations";
var txt9$P = "Piracy, without the legal authorization of the right holder";
var txt10$K = "Disclosure of business secrets";
var txt11$E = "Invasion of privacy";
var txt12$A = "Spam harassment";
var txt13$C = "Minor safety";
var txt14$w = "(Specail area for minors)";
var txt15$t = "Reporting Files";
var txt16$s = "Open External Link";
var txt17$p = "Report Reason（required）";
var txt18$p = "Description about 5-200 words";
var txt19$n = " (required)";
var label10 = "Sensitive content";
var label20 = "Sexual content";
var label40 = "Illegality and Violation";
var txt20$m = " words";
var txt21$j = "Report number：400-677-5005";
var public_Report_submit = "Submit";
var txt22$h = "Why report this comment";
var text23 = "Select the reason for reporting (single choice)";
var text24 = "Agree to obtain session information to assist in judgment";
var Report = {
	txt0: txt0$2c,
	txt1: txt1$1_,
	txt2: txt2$1N,
	txt3: txt3$1D,
	txt31: txt31$6,
	txt4: txt4$1s,
	txt5: txt5$1j,
	txt6: txt6$16,
	txt7: txt7$X,
	txt8: txt8$W,
	txt9: txt9$P,
	txt10: txt10$K,
	txt11: txt11$E,
	txt12: txt12$A,
	txt13: txt13$C,
	txt14: txt14$w,
	txt15: txt15$t,
	txt16: txt16$s,
	txt17: txt17$p,
	txt18: txt18$p,
	txt19: txt19$n,
	label10: label10,
	label20: label20,
	label40: label40,
	txt20: txt20$m,
	txt21: txt21$j,
	public_Report_submit: public_Report_submit,
	txt22: txt22$h,
	text23: text23,
	text24: text24
};

var requestShareOutside$1 = "Application for outsourcing";
var tips$3 = "The company prohibits sharing documents outside the company. You can apply to share the current document outside the company.";
var shareRange$1 = "Sharing range";
var rangeAnyone = "Anyone";
var rangeSelect = "Only specify users outside the enterprise";
var reason = "reason";
var placeholder$1 = "Please enter the reason for your application";
var pleaseInputReason = "Please enter the reason for your application";
var cancel$b = "Cancel";
var submit$3 = "Send Application";
var submitSuccess$1 = "Application sent";
var submitFail = "Network abnormality, please try again";
var RequestShareOutside = {
	requestShareOutside: requestShareOutside$1,
	tips: tips$3,
	shareRange: shareRange$1,
	rangeAnyone: rangeAnyone,
	rangeSelect: rangeSelect,
	reason: reason,
	placeholder: placeholder$1,
	pleaseInputReason: pleaseInputReason,
	cancel: cancel$b,
	submit: submit$3,
	submitSuccess: submitSuccess$1,
	submitFail: submitFail
};

var txt0$2b = "After you enable WPS Premium, you can use the Batch Download feature.";
var txt1$1Z = "View More WPS Premium Privileges";
var txt2$1M = "Note: Batch downloading online files (such as collaboration documents and flow charts) is not supported.";
var txt3$1C = "Cancel";
var txt4$1r = "Upgrade to WPS Premium";
var txt5$1i = "Upgrade to WPS Premium";
var DriveRegisterVip = {
	txt0: txt0$2b,
	txt1: txt1$1Z,
	txt2: txt2$1M,
	txt3: txt3$1C,
	txt4: txt4$1r,
	txt5: txt5$1i
};

var txt0$2a = "You need to send a verification message and wait for the other party to pass";
var txt1$1Y = "Since verification messages are sent frequently, please go to";
var txt2$1L = "Customer case";
var ucenter = "Personal center";
var txt3$1B = "Retry after binding mobile phone number";
var cancel$a = "Cancel";
var send = "Send";
var SendVerfiyMessage = {
	txt0: txt0$2a,
	txt1: txt1$1Y,
	txt2: txt2$1L,
	ucenter: ucenter,
	txt3: txt3$1B,
	cancel: cancel$a,
	send: send
};

var name0 = "Invite colleagues to join the enterprise";
var name1 = "Members fill in the application";
var name2 = "Approve colleagues' applications";
var name3 = "Build a work team";
var name4 = "Add the corresponding colleague to the team";
var err0$1 = "No elements passed in";
var err1$1 = "Did not pass in the correct element";
var err2$1 = "Parameter cannot be empty";
var err3$1 = "Invalid parameter type. The correct value should be:";
var guide = "User Guide";
var more = "More";
var txt0$29 = "Fill in Feedback";
var txt1$1X = "User Manual";
var txt2$1K = "Customer Case";
var txt3$1A = "Catalog";
var SlideHelper = {
	name0: name0,
	name1: name1,
	name2: name2,
	name3: name3,
	name4: name4,
	err0: err0$1,
	err1: err1$1,
	err2: err2$1,
	err3: err3$1,
	guide: guide,
	more: more,
	txt0: txt0$29,
	txt1: txt1$1X,
	txt2: txt2$1K,
	txt3: txt3$1A
};

var txt0$28 = "You may need";
var txt1$1W = "View Video Introduction";
var txt2$1J = "Try Now";
var txt3$1z = "Have suggestions or questions about team templates?";
var txt4$1q = "Contact Us";
var txt5$1h = "Failed to initialize the scene";
var txt6$15 = "\"";
var txt8$V = "Only the super administrator can create a team template. Please contact \"";
var txt9$O = "\" create";
var txt10$J = "\" video introduction";
var error$3 = {
	"40000105": "Space is full. Failed to create a template",
	"40000201": "Failed to create a template. Please create a template again",
	"40020010": "The enterprise prohibits this IP from saving files to \"{0}\".",
	"40020011": "This IP only allows files to be saved to the enterprise space.",
	network: "Network exception."
};
var txt11$D = "Create General Team";
var txt12$z = "Now";
var txt13$B = "Enable document encryption protection";
var txt14$v = "Enterprise Package";
var txt15$s = "Upgrade Package";
var txt16$r = "WPS Project Manager";
var txt17$o = "Super Administrator";
var txt18$o = "process authorization upgrade";
var txt19$m = "The features and services purchased by your enterprise have exceeded the maximum quantity allowed. Please contact";
var txt20$l = "Purchase";
var txt21$i = "Upgrade";
var txt22$g = "Regular team";
var txt23$e = "Upload files, share and collaborate";
var txt24$c = "Create";
var txt25$b = "Import Team";
var txt26$b = "Batch import of individual teams";
var txt27$a = "Import";
var txt28$a = "Selected team templates";
var TeamSceneSelector = {
	txt0: txt0$28,
	txt1: txt1$1W,
	txt2: txt2$1J,
	txt3: txt3$1z,
	txt4: txt4$1q,
	txt5: txt5$1h,
	txt6: txt6$15,
	txt8: txt8$V,
	txt9: txt9$O,
	txt10: txt10$J,
	error: error$3,
	txt11: txt11$D,
	txt12: txt12$z,
	txt13: txt13$B,
	txt14: txt14$v,
	txt15: txt15$s,
	txt16: txt16$r,
	txt17: txt17$o,
	txt18: txt18$o,
	txt19: txt19$m,
	txt20: txt20$l,
	txt21: txt21$i,
	txt22: txt22$g,
	txt23: txt23$e,
	txt24: txt24$c,
	txt25: txt25$b,
	txt26: txt26$b,
	txt27: txt27$a,
	txt28: txt28$a
};

var txt0$27 = "create \"";
var txt1$1V = "\" team";
var txt2$1I = "Only the super administrator";
var txt3$1y = "can create a team template and authorize the enterprise finance/HR to use the template. You can view the video to learn more";
var txt4$1p = "Notice \"";
var txt5$1g = "\" create";
var txt6$14 = "Got it";
var TeamSceneVideo = {
	txt0: txt0$27,
	txt1: txt1$1V,
	txt2: txt2$1I,
	txt3: txt3$1y,
	txt4: txt4$1p,
	txt5: txt5$1g,
	txt6: txt6$14
};

var click = "Click here to ";
var add = " ADD ";
var txt0$26 = "pinned team announcement or files to get members' attention.";
var txt1$1U = "See example";
var placeHolder = "Add team pin information, all members can view";
var cancel$9 = "Cancel";
var ok$4 = "Confirm";
var maxLengthError = "Up to {0} characters supported.";
var newPlaceHolder = "Additional group announcements, owned by members can be viewed";
var tips$2 = "Post announcements or pin files to the top for members to follow";
var TeamTopAreaNotice = {
	click: click,
	add: add,
	txt0: txt0$26,
	txt1: txt1$1U,
	placeHolder: placeHolder,
	cancel: cancel$9,
	ok: ok$4,
	maxLengthError: maxLengthError,
	newPlaceHolder: newPlaceHolder,
	tips: tips$2
};

var label_panel_txt0 = "This is ";
var label_panel_txt1 = "search result";
var table_header_txt0 = "document";
var table_header_txt1 = "Last modified";
var table_header_txt2 = "Size";
var TeamTagPanel = {
	label_panel_txt0: label_panel_txt0,
	label_panel_txt1: label_panel_txt1,
	table_header_txt0: table_header_txt0,
	table_header_txt1: table_header_txt1,
	table_header_txt2: table_header_txt2
};

var open$2 = "open a file";
var upload = "Upload";
var complete = "carry out";
var txt0$25 = "Item failed";
var txt1$1T = "Being ";
var file = "file";
var err1 = "Your cloud space is full";
var err2 = "The owner's cloud space is full";
var err3 = "The file exceeds 200M and cannot be uploaded";
var confirm$2 = "The upload is in progress, closing will cancel the uploading file, do you want to close?";
var tips$1 = "Tips";
var close$4 = "shut down";
var cancel$8 = "Cancel";
var err0 = "Cloud space is full";
var err4 = "File size exceeds limit";
var opening = "Opening file, please wait...";
var uploadFile = "upload files";
var uploadFail = "upload failed";
var err5 = "Your membership has expired and you cannot use the private folder function. Please use it after renewal";
var err6 = "There is no operation permission for the current directory, please contact the administrator";
var err7 = "unknown mistake";
var err8 = "The file type you uploaded is inconsistent with the current file";
var err9 = "Cannot upload empty files";
var err10 = "File size exceeds limit";
var canceled$2 = "Cancelled";
var Upload = {
	open: open$2,
	upload: upload,
	complete: complete,
	txt0: txt0$25,
	txt1: txt1$1T,
	file: file,
	err1: err1,
	err2: err2,
	err3: err3,
	confirm: confirm$2,
	tips: tips$1,
	close: close$4,
	cancel: cancel$8,
	err0: err0,
	err4: err4,
	opening: opening,
	uploadFile: uploadFile,
	uploadFail: uploadFail,
	err5: err5,
	err6: err6,
	err7: err7,
	err8: err8,
	err9: err9,
	err10: err10,
	canceled: canceled$2
};

var title$q = "Why upgrade the enterprise team?";
var content0$1 = "Safer enterprise documents";
var content1$1 = "Enterprise documents and personal documents";
var content2 = "Not afraid of personnel changes";
var content3 = "Privacy leak";
var content4 = "Enterprise Directory";
var content5 = "One-click application to join, unified members";
var content6 = "Management can be directly without adding friends";
var content7 = "Share files";
var content8 = "Richer team permissions";
var content9 = "Support team document encryption";
var content10 = "Team operation log management";
var upgrade$1 = "Upgrade";
var txt0$24 = "Upgrade to a enterprise team";
var txt1$1S = "Please choose to upgrade the shared folder to";
var txt2$1H = "Upgrade the enterprise team";
var txt3$1x = "Please make sure";
var txt4$1o = "Upgrade to";
var txt5$1f = "Enterprise team";
var cancel$7 = "Cancel";
var txt7$W = "Successfully upgrade the enterprise team";
var txt8$U = "The following members need to accept the invitation to join the enterprise to access the team normally";
var txt9$N = "I see";
var close$3 = "shut down";
var check$1 = "View";
var txt10$I = "Has been imported successfully,";
var txt11$C = " Import failed, ";
var txt12$y = "Reason for failure: The number of enterprise teams reached the upper limit";
var txt13$A = "Please try to import again";
var txt14$u = "Talk later";
var ok$3 = "Confirm";
var retry$1 = "Retry";
var applyUpgrade = "Apply for Upgrading";
var defaultReason = "Members have not yet filled in the team creation purpose";
var txt15$r = "shared folders";
var UpToCorpTeam = {
	title: title$q,
	content0: content0$1,
	content1: content1$1,
	content2: content2,
	content3: content3,
	content4: content4,
	content5: content5,
	content6: content6,
	content7: content7,
	content8: content8,
	content9: content9,
	content10: content10,
	upgrade: upgrade$1,
	txt0: txt0$24,
	txt1: txt1$1S,
	txt2: txt2$1H,
	txt3: txt3$1x,
	txt4: txt4$1o,
	txt5: txt5$1f,
	cancel: cancel$7,
	txt7: txt7$W,
	txt8: txt8$U,
	txt9: txt9$N,
	close: close$3,
	check: check$1,
	txt10: txt10$I,
	txt11: txt11$C,
	txt12: txt12$y,
	txt13: txt13$A,
	txt14: txt14$u,
	ok: ok$3,
	retry: retry$1,
	applyUpgrade: applyUpgrade,
	defaultReason: defaultReason,
	txt15: txt15$r
};

var txt0$23 = "Are you sure you want to upgrade";
var txt1$1R = " to a personal team?";
var txt2$1G = "Upgrade Now";
var txt3$1w = "Cancel";
var UpToPersonalTeam = {
	txt0: txt0$23,
	txt1: txt1$1R,
	txt2: txt2$1G,
	txt3: txt3$1w
};

var title$p = "Upgrade Instructions";
var content0 = "Team Collaboration Space";
var content1 = "Smooth Migration";
var description1 = "Use apps such as Task and Project Management Library";
var description2 = "Better team collaboration";
var description3 = "Original member permissions, folder directory permissions";
var description4 = "Shared links and collaboration members remain the same";
var upgrade = "Upgrade Now";
var select = "Select the shared folder.";
var UpToPersonalTeamGuide = {
	title: title$p,
	content0: content0,
	content1: content1,
	description1: description1,
	description2: description2,
	description3: description3,
	description4: description4,
	upgrade: upgrade,
	select: select
};

var txt0$22 = "member(s)";
var txt1$1Q = "Cancel";
var txt2$1F = "Confirm";
var UpToPersonalTeamSelect = {
	txt0: txt0$22,
	txt1: txt1$1Q,
	txt2: txt2$1F
};

var tips_title = "Upgrade Instructions";
var title$o = "Upgrade to Personal Team";
var select_title = "Select a folder to upgrade to a team shared folder";
var DialogUpToPersonalTeam = {
	tips_title: tips_title,
	title: title$o,
	select_title: select_title
};

var txt0$21 = "User Guide";
var txt1$1P = "No relevant content found";
var txt2$1E = "Scan code to contact customer service";
var txt3$1v = "No content available";
var txt4$1n = "Enter your question, such as \"Create a team\"";
var searchTitle = "How can I help you?";
var recommendTitle = "Recommended Links";
var moreHelpTitle = "More";
var open$1 = "Expand";
var close$2 = "Collapse";
var subscribe = {
	all: "Notification",
	text: "Receive Notification"
};
var CompanyHelpContent = {
	txt0: txt0$21,
	txt1: txt1$1P,
	txt2: txt2$1E,
	txt3: txt3$1v,
	txt4: txt4$1n,
	searchTitle: searchTitle,
	recommendTitle: recommendTitle,
	moreHelpTitle: moreHelpTitle,
	open: open$1,
	close: close$2,
	subscribe: subscribe
};

var txt0$20 = "No members can be selected";
var txt1$1O = "Please select a new owner";
var TransferTeamMembers = {
	txt0: txt0$20,
	txt1: txt1$1O
};

var transferOwner = "Transfer Document Ownership";
var willTransferTo = "Please confirm the transfer of the document ownership to ";
var tipsAfterTransfer = "After transfer, you will become a member with the edit permission of the document.";
var afterTransfer = "After transfer, ";
var willReceiveMessage = "will receive a message notification.";
var confirm$1 = "OK";
var cancel$6 = "Cancel";
var transferSuccess$1 = "Transferred successfully.";
var currentFileOwner = "current document owner";
var me$2 = "I";
var transfer_file_only = "This document can only be transferred to people who have joined the collaboration";
var iknow = "I have known";
var transfer = "transfer";
var TransferOwnerConfirm = {
	transferOwner: transferOwner,
	willTransferTo: willTransferTo,
	tipsAfterTransfer: tipsAfterTransfer,
	afterTransfer: afterTransfer,
	willReceiveMessage: willReceiveMessage,
	confirm: confirm$1,
	cancel: cancel$6,
	transferSuccess: transferSuccess$1,
	currentFileOwner: currentFileOwner,
	me: me$2,
	transfer_file_only: transfer_file_only,
	iknow: iknow,
	transfer: transfer
};

var txt0$1$ = "Please confirm to transfer the team to";
var txt1$1N = "After the transfer, you will become a team member";
var txt2$1D = "Cancel";
var txt3$1u = "Transfer team";
var txt4$1m = "Successful transfer team";
var txt5$1e = "The transfer failed and is not a member of the team";
var txt6$13 = "The team cannot be transferred to a pending member";
var txt7$V = "After transfer:";
var txt8$T = "you will become a team member.";
var txt9$M = "The permissions of users who have subscribed to WPS Premium will be assigned and managed by the team owner and the administrator.";
var TransferTeamComfirm = {
	txt0: txt0$1$,
	txt1: txt1$1N,
	txt2: txt2$1D,
	txt3: txt3$1u,
	txt4: txt4$1m,
	txt5: txt5$1e,
	txt6: txt6$13,
	txt7: txt7$V,
	txt8: txt8$T,
	txt9: txt9$M
};

var txt0$1_ = "No members can be selected";
var txt1$1M = "Please select a new owner";
var TransferTeam = {
	txt0: txt0$1_,
	txt1: txt1$1M
};

var shareTitle = "Share";
var ShareingTitle = "Sharing documents with others";
var toShareTitle = "Share documents with others (not enabled)";
var DocLinkIsExpired = "The document sharing link has expired";
var copyLink$4 = "Copy Link";
var copyLinkSuccess = "Copy successfully";
var openLink = "Open Sharing";
var openExpiredLink = "Open Link";
var openLinkSuccess = "Sharing enabled successfully.";
var pleaseOpenShare = "Enable cloud document sharing to make office more efficient";
var noMoreTip = "Don't remind me again";
var setSuccess = "Set successfully.";
var wechat = "WeChat";
var wechatFriend$1 = "WeChat";
var guideTitle = "Real-time synchronization of updates and online editing by multiple people";
var setUp = "Settings";
var limitedToCompany = "The team administrator has prohibited file sharing outside the enterprise.";
var limitedToGroup = "The team administrator has prohibited file sharing outside the team.";
var anyoneRead = "Viewable by All";
var anyoneComment = "Commentable by All";
var anyoneWrite = "Editable by All";
var companyRead = "Viewable by Enterprise Members";
var companyComment = "Commentable by Enterprise Members";
var companyWrite = "Editable by Enterprise Members";
var anyoneClose = "Only Accessible to Specified Person";
var anyoneRead1 = "Viewable by All";
var anyoneComment1 = "Commentable by All";
var anyoneWrite1 = "Editable by All";
var companyRead1 = "Viewable by Enterprise Members";
var companyComment1 = "Commentable by Enterprise Members";
var companyWrite1 = "Editable by Enterprise Members";
var anyoneClose1 = "Only Accessible to Specified Person";
var receiverTitle0 = "Document is created by ";
var receiverTitle1 = ", allowing the ";
var receiverTitle2 = ", only allowing the ";
var groupName = "「{0}」";
var groupMemberCanVisit = "Accessible to Members";
var ShareV2 = {
	shareTitle: shareTitle,
	ShareingTitle: ShareingTitle,
	toShareTitle: toShareTitle,
	DocLinkIsExpired: DocLinkIsExpired,
	copyLink: copyLink$4,
	copyLinkSuccess: copyLinkSuccess,
	openLink: openLink,
	openExpiredLink: openExpiredLink,
	openLinkSuccess: openLinkSuccess,
	pleaseOpenShare: pleaseOpenShare,
	noMoreTip: noMoreTip,
	setSuccess: setSuccess,
	wechat: wechat,
	wechatFriend: wechatFriend$1,
	guideTitle: guideTitle,
	setUp: setUp,
	limitedToCompany: limitedToCompany,
	limitedToGroup: limitedToGroup,
	anyoneRead: anyoneRead,
	anyoneComment: anyoneComment,
	anyoneWrite: anyoneWrite,
	companyRead: companyRead,
	companyComment: companyComment,
	companyWrite: companyWrite,
	anyoneClose: anyoneClose,
	anyoneRead1: anyoneRead1,
	anyoneComment1: anyoneComment1,
	anyoneWrite1: anyoneWrite1,
	companyRead1: companyRead1,
	companyComment1: companyComment1,
	companyWrite1: companyWrite1,
	anyoneClose1: anyoneClose1,
	receiverTitle0: receiverTitle0,
	receiverTitle1: receiverTitle1,
	receiverTitle2: receiverTitle2,
	groupName: groupName,
	groupMemberCanVisit: groupMemberCanVisit
};

var collabortorsCoopTitle = "Persons who joined the collaboration";
var collabortorsShareTitle = "Persons who joined the sharing";
var collaboratorsSubTitle = "Add your partners to the list and grant them access in advance";
var collaboratorsAdd = "Add from Contacts";
var approvalTitle = "When the collaboration is re-enabled, the access for the following members is restored directly.";
var noUserRecord = "No access record";
var userForbidTitle = "Share reminder";
var secureForbidAnyone = "Encrypted documents cannot be shared directly with all members";
var memberText = "Team members";
var permissionText = "Permission";
var settingTitle = "Download prohibition, watermarks and other settings";
var linkIsExpired = "The link has expired";
var wechatFriend = "WeChat friends";
var whoCanOpen = "Who can open";
var originalGroupPerm = "Original team permissions";
var setLinkTimeTxt$1 = "Link validity period";
var canCelShareSuccTxt = "Share canceled successfully";
var anyoneTxt = "All";
var companyTxt = "This company";
var linkAdjustTxt = "Link permissions changed.";
var stopCoopTipTxt = "After you stop the collaboration, your partners are not able to view your document until you re-enable the collaboration.";
var stopShareTipTxt = "Stop sharing this document?";
var stopTxt = "Stop";
var coopSwitchNew = "View/edit with others";
var openTips = "All members can view the latest document content";
var openCoopTips = "Enable collaboration and get cloud document links";
var openShareTips = "Send the link so that the recipient can always view the latest content";
var applyEditPerm = "Apply for editing permission";
var howToAssign = "How to specify?";
var secureFileTips1 = "Send the document link so that the recipient can access after your approval;";
var secureFileTips2 = "Send the WeChat applet card so that the receiver can access directly (this card cannot be forwarded)";
var viewCorpMember = "View collaborators";
var notAllowInSecureFile = "(not applicable to protected documents)";
var allowDisplayCollaborator = "Allow collaborators to view recent visitors";
var selectAll$1 = "Select all";
var noPermission$1 = "No permission";
var operateLoading = "Processing...";
var alreadyAdd = "The user has been added";
var lookDetail = "View Details";
var mainShareTitle = "Link";
var blockEditApply$3 = "Prohibit applying for the editing permission";
var blockEditApplyTip$1 = "Once enabled, people who join the sharing will not be able to apply for the permission.";
var openComment$1 = "Allow people who join the sharing to view and leave comments.";
var openCommentTips = "Once enabled, people who open the document can leave and view comments.";
var resetLinkText$1 = "The file sharing link has expired";
var resetShareLinkText = "The link has been reset";
var forbidCopyText = "Prohibit viewers from downloading, printing, saving a copy, and copying.";
var forbidCopyTipText = "Once enabled, people with the view permission only will not be able to download, print, save a copy, or copy the content.";
var ksheetForbid = "Prohibit viewers from exporting, printing, saving a copy, and copying.";
var ksheetPopText = "Once enabled, people with the view permission only will not be able to export, print, save a copy, or copy the content.";
var kfpForbid = "Prohibit viewers from exporting and saving a copy.";
var kfpPopText = "Once enabled, people with the view permission only will not be able to export or save a copy.";
var kdbtForbid = "Prohibit viewers from exporting, saving a copy, and copying.";
var kdbtPopText = "Once enabled, people with the view permission only will not be able to export, save a copy, or copy the content.";
var kprocessonPopText = "Once enabled, people with the view permission only will not be able to export or save a copy.";
var kimgForbid = "Prohibit viewers from downloading and saving a copy.";
var kimgPopText = "Once enabled, people with the view permission only will not be able to download or save a copy.";
var ksheetRenameForbid = "Prohibit adding and deleting worksheets";
var ksheetRenameForbidPop = "Once enabled, collaborators are prohibited from deleting, creating, moving, and renaming worksheets.";
var waterMarkSettingTit$1 = "Document Watermarks Settings";
var openWaterMarkStatus$1 = "Watermarks enabled";
var openByOnlineText = "Online Editing";
var openByWpsText = "Open with WPS Office";
var sendWordText = "Download as a DOCX file";
var sendXlsxNewText = "Download as an XLSX file";
var sendPPTText = "Download as a PPTX file";
var sendPDFNewText = "Download as a PDF file";
var sendToDeviesText = "Send to My Device";
var downloadfail = "Exporting failed. Try again later.";
var advancedSettingText = "Advanced Settings";
var expiredText = "Expired";
var errorMsgTxt = "Failed! Try again";
var multiCompPermsScenesTip = "The permissions for this user come from the group and cannot be removed separately. You may operate in the \"Manage Collaborators - All\" page.";
var multiCompPermsScenesTip2 = "The permissions for this user come from the group set.";
var personalReadPermission = "View";
var personalWritePermission = "Edit";
var personalCommentPermission = "View and Comment";
var onlyTxt = "Only";
var secureForbidAnyoneTip = "This document is encrypted: <br/>1. By default, the share permission is set as only specified persons can access. You can set the permission in the \"Manage Collaborators\" page. <br/>2. Members authorized in the document can automatically obtain the link access permission.";
var banShareTxt = "Unable to ensure security of the file {0}. The file sharing has been stopped.";
var isMeTag = "(I)";
var unloginTxt = "(not logged in)";
var fileCreator$1 = "creator";
var sharePageTitle = "collaboration";
var allowComment = "can comment";
var copyLink$3 = "Copy Link";
var sendShareLink = "Send shared link";
var sendCoopLink = "Send collaboration link";
var unknownErrorTxt$1 = "Unknown Error, please retry";
var hasOpenCoopTxt = "Collaboration enabled";
var coopDetailTxt = "Collaboration detail";
var shareOpenShareTxt = "Share link enabled";
var shareDetailTxt = "Shared link detail";
var stopCoopTxt = "Stop collaboration";
var cancelShareTxt = "Unshare";
var stopCoopSuccTxt = "Stop collaboration successfully";
var failTxt = "Failed, please retry";
var closeTxt$1 = "Specified People";
var wechatFriendTxt = "WeChat friends";
var cancelTxt = "Cancel";
var confirmTxt = "confirm";
var manageCorpMember = "Manage collaborator";
var addCorpMember = "Add collaborator";
var changePermSuccess$1 = "Permission set successfully";
var removeSuccess$1 = "{0}has been moved";
var dropdownItem1 = "Can edit";
var dropdownItem2 = "Can view";
var mainCoopTitle = "collaboration";
var kprocessonForbid = "Prohibit viewers from exporting and saving a copy.";
var settingTxt$3 = "Setting";
var sendFileText = "Send";
var sendShareFileText = "Send file";
var sendPDFText = "Export as PDF";
var sendXlsxText = "Export as xlsx";
var downloadSuccesTxt$1 = "Exported successfully.";
var noPermDownloadTxt$1 = "No download permission";
var SharePermText = "Link permissions";
var canUpdate = "Can edit";
var canComment = "Can comment";
var canView = "Can view";
var permission = "Permission";
var latestVisit = "Recently visited";
var all$2 = "All";
var share = "Share";
var closeShare = "Turn off sharing";
var watermarkSetting = "Watermark Settings";
var startCoopTxt = "Enable collaboration";
var latestOnline = "Recently online：";
var online$1 = "Online";
var today$1 = "Today ";
var justNow = "Just Now";
var me$1 = "Me";
var wechatShareDesc = "Share with friends/groups via WeChat 'Scan'";
var unloginLoginTxt = "Login to view sharing details";
var unloginCopyTxt = "Copy link";
var kdocsTtitleTxt = "WPS Docs";
var copySuccessTxt = "Copy successfully, anyone can access";
var changeDocOwnershipTxt = "Transfer document ownership";
var onlyCreatorOperation = "Only the document owner can operate";
var chooseContactsTransfer = "Select contact to transfer";
var linkTransfer = "Transfer via link";
var unloginCoopTxt = "Collaboration";
var txt_remove_1 = "Already";
var txt_remove_2 = "Remove";
var shareDisableInMyDoc = "You are not the document creator and cannot close collaboration";
var shareDisableInGroupDoc = "You are not a team member and cannot close collaboration";
var wechatFriendTxt2 = "WeChat/Enterprise WeChat friends";
var wechatShareDesc2 = "Use WeChat/Enterprise WeChat to \"Scan\" and share with friends/group chats, and the other party can directly obtain document permissions";
var wxWork = "WeChat Business";
var kemail = "WPS Mailbox";
var onlineFile = "WPS 365 Online Documentation";
var createDesc = "Created by {0}";
var sendToMyWPSText = "Send to my WPS Office";
var face2faceReadFileTxt = "Read documents face to face";
var addFileTxt$1 = "Add Document";
var cancelShareInSelfTips = "After unsharing the \"Multi-format Preview Example\", other users will lose access rights:";
var cancelShareInGroupTips = "After the \"Multi-format Preview Example\" is unshared, only team members can access it, and external users will lose access rights:";
var shareChildFile = "Share sub-files";
var shareChildFileTip = "After opening, users can view the sub-files they have permission to view.";
var tipsTxt = "hint";
var openCoopTooltip = "Share after opening";
var anyoneCanWrite = "Editable by everyone";
var anyoneCanRead = "Visible to everyone";
var someoneCanRead = "Only designated people can access";
var sendFile = "Send File";
var downloadFile = "Download File";
var send2Wps = "Send to WPS";
var send2Device = "My Devices";
var exportFile = "Exporting Files";
var exportPic = "Export as image";
var exportPdf = "Export to PDF";
var exportPicPdf = "Export pure image PDF";
var downloadPermDenied = "You do not have permission to download this document";
var ShareV3 = {
	collabortorsCoopTitle: collabortorsCoopTitle,
	collabortorsShareTitle: collabortorsShareTitle,
	collaboratorsSubTitle: collaboratorsSubTitle,
	collaboratorsAdd: collaboratorsAdd,
	approvalTitle: approvalTitle,
	noUserRecord: noUserRecord,
	userForbidTitle: userForbidTitle,
	secureForbidAnyone: secureForbidAnyone,
	memberText: memberText,
	permissionText: permissionText,
	settingTitle: settingTitle,
	linkIsExpired: linkIsExpired,
	wechatFriend: wechatFriend,
	whoCanOpen: whoCanOpen,
	originalGroupPerm: originalGroupPerm,
	setLinkTimeTxt: setLinkTimeTxt$1,
	canCelShareSuccTxt: canCelShareSuccTxt,
	anyoneTxt: anyoneTxt,
	companyTxt: companyTxt,
	linkAdjustTxt: linkAdjustTxt,
	stopCoopTipTxt: stopCoopTipTxt,
	stopShareTipTxt: stopShareTipTxt,
	stopTxt: stopTxt,
	coopSwitchNew: coopSwitchNew,
	openTips: openTips,
	openCoopTips: openCoopTips,
	openShareTips: openShareTips,
	applyEditPerm: applyEditPerm,
	howToAssign: howToAssign,
	secureFileTips1: secureFileTips1,
	secureFileTips2: secureFileTips2,
	viewCorpMember: viewCorpMember,
	notAllowInSecureFile: notAllowInSecureFile,
	allowDisplayCollaborator: allowDisplayCollaborator,
	selectAll: selectAll$1,
	noPermission: noPermission$1,
	operateLoading: operateLoading,
	alreadyAdd: alreadyAdd,
	lookDetail: lookDetail,
	mainShareTitle: mainShareTitle,
	blockEditApply: blockEditApply$3,
	blockEditApplyTip: blockEditApplyTip$1,
	openComment: openComment$1,
	openCommentTips: openCommentTips,
	resetLinkText: resetLinkText$1,
	resetShareLinkText: resetShareLinkText,
	forbidCopyText: forbidCopyText,
	forbidCopyTipText: forbidCopyTipText,
	ksheetForbid: ksheetForbid,
	ksheetPopText: ksheetPopText,
	kfpForbid: kfpForbid,
	kfpPopText: kfpPopText,
	kdbtForbid: kdbtForbid,
	kdbtPopText: kdbtPopText,
	kprocessonPopText: kprocessonPopText,
	kimgForbid: kimgForbid,
	kimgPopText: kimgPopText,
	ksheetRenameForbid: ksheetRenameForbid,
	ksheetRenameForbidPop: ksheetRenameForbidPop,
	waterMarkSettingTit: waterMarkSettingTit$1,
	openWaterMarkStatus: openWaterMarkStatus$1,
	openByOnlineText: openByOnlineText,
	openByWpsText: openByWpsText,
	sendWordText: sendWordText,
	sendXlsxNewText: sendXlsxNewText,
	sendPPTText: sendPPTText,
	sendPDFNewText: sendPDFNewText,
	sendToDeviesText: sendToDeviesText,
	downloadfail: downloadfail,
	advancedSettingText: advancedSettingText,
	expiredText: expiredText,
	errorMsgTxt: errorMsgTxt,
	multiCompPermsScenesTip: multiCompPermsScenesTip,
	multiCompPermsScenesTip2: multiCompPermsScenesTip2,
	personalReadPermission: personalReadPermission,
	personalWritePermission: personalWritePermission,
	personalCommentPermission: personalCommentPermission,
	onlyTxt: onlyTxt,
	secureForbidAnyoneTip: secureForbidAnyoneTip,
	banShareTxt: banShareTxt,
	isMeTag: isMeTag,
	unloginTxt: unloginTxt,
	fileCreator: fileCreator$1,
	sharePageTitle: sharePageTitle,
	allowComment: allowComment,
	copyLink: copyLink$3,
	sendShareLink: sendShareLink,
	sendCoopLink: sendCoopLink,
	unknownErrorTxt: unknownErrorTxt$1,
	hasOpenCoopTxt: hasOpenCoopTxt,
	coopDetailTxt: coopDetailTxt,
	shareOpenShareTxt: shareOpenShareTxt,
	shareDetailTxt: shareDetailTxt,
	stopCoopTxt: stopCoopTxt,
	cancelShareTxt: cancelShareTxt,
	stopCoopSuccTxt: stopCoopSuccTxt,
	failTxt: failTxt,
	closeTxt: closeTxt$1,
	wechatFriendTxt: wechatFriendTxt,
	cancelTxt: cancelTxt,
	confirmTxt: confirmTxt,
	manageCorpMember: manageCorpMember,
	addCorpMember: addCorpMember,
	changePermSuccess: changePermSuccess$1,
	removeSuccess: removeSuccess$1,
	dropdownItem1: dropdownItem1,
	dropdownItem2: dropdownItem2,
	mainCoopTitle: mainCoopTitle,
	kprocessonForbid: kprocessonForbid,
	settingTxt: settingTxt$3,
	sendFileText: sendFileText,
	sendShareFileText: sendShareFileText,
	sendPDFText: sendPDFText,
	sendXlsxText: sendXlsxText,
	downloadSuccesTxt: downloadSuccesTxt$1,
	noPermDownloadTxt: noPermDownloadTxt$1,
	SharePermText: SharePermText,
	canUpdate: canUpdate,
	canComment: canComment,
	canView: canView,
	permission: permission,
	latestVisit: latestVisit,
	all: all$2,
	share: share,
	closeShare: closeShare,
	watermarkSetting: watermarkSetting,
	startCoopTxt: startCoopTxt,
	latestOnline: latestOnline,
	online: online$1,
	today: today$1,
	justNow: justNow,
	me: me$1,
	wechatShareDesc: wechatShareDesc,
	unloginLoginTxt: unloginLoginTxt,
	unloginCopyTxt: unloginCopyTxt,
	kdocsTtitleTxt: kdocsTtitleTxt,
	copySuccessTxt: copySuccessTxt,
	changeDocOwnershipTxt: changeDocOwnershipTxt,
	onlyCreatorOperation: onlyCreatorOperation,
	chooseContactsTransfer: chooseContactsTransfer,
	linkTransfer: linkTransfer,
	unloginCoopTxt: unloginCoopTxt,
	txt_remove_1: txt_remove_1,
	txt_remove_2: txt_remove_2,
	shareDisableInMyDoc: shareDisableInMyDoc,
	shareDisableInGroupDoc: shareDisableInGroupDoc,
	wechatFriendTxt2: wechatFriendTxt2,
	wechatShareDesc2: wechatShareDesc2,
	wxWork: wxWork,
	kemail: kemail,
	onlineFile: onlineFile,
	createDesc: createDesc,
	sendToMyWPSText: sendToMyWPSText,
	face2faceReadFileTxt: face2faceReadFileTxt,
	addFileTxt: addFileTxt$1,
	cancelShareInSelfTips: cancelShareInSelfTips,
	cancelShareInGroupTips: cancelShareInGroupTips,
	shareChildFile: shareChildFile,
	shareChildFileTip: shareChildFileTip,
	tipsTxt: tipsTxt,
	openCoopTooltip: openCoopTooltip,
	anyoneCanWrite: anyoneCanWrite,
	anyoneCanRead: anyoneCanRead,
	someoneCanRead: someoneCanRead,
	sendFile: sendFile,
	downloadFile: downloadFile,
	send2Wps: send2Wps,
	send2Device: send2Device,
	exportFile: exportFile,
	exportPic: exportPic,
	exportPdf: exportPdf,
	exportPicPdf: exportPicPdf,
	downloadPermDenied: downloadPermDenied
};

var txt0$1Z = "Add Other Shared Members";
var ShareWithContactsEntry = {
	txt0: txt0$1Z
};

var txt0$1Y = "You need to send a verification message and wait for the other party to pass";
var txt1$1L = "Since verification messages are sent frequently, please go to";
var txt2$1C = "Personal center";
var txt3$1t = "Retry after binding mobile phone number";
var txt4$1l = "Cancel";
var txt5$1d = "Send";
var txt6$12 = "I'm";
var txt7$U = "Sent successfully";
var txt8$S = "Please enter a verification message";
var SendAddContactInvitation = {
	txt0: txt0$1Y,
	txt1: txt1$1L,
	txt2: txt2$1C,
	txt3: txt3$1t,
	txt4: txt4$1l,
	txt5: txt5$1d,
	txt6: txt6$12,
	txt7: txt7$U,
	txt8: txt8$S
};

var txt0$1X = "Your current account security level is too low, please bind your phone number and try again";
var txt1$1K = "Cancel";
var txt2$1B = "Bind now";
var SecureInfo = {
	txt0: txt0$1X,
	txt1: txt1$1K,
	txt2: txt2$1B
};

var txt0$1W = "To be enabled";
var txt1$1J = "To Invite";
var txt2$1A = "Go to Upload";
var txt3$1s = "Claimed successfully";
var txt4$1k = "Claiming failed";
var txt5$1c = "To Claim";
var NoviceTaskList = {
	txt0: txt0$1W,
	txt1: txt1$1J,
	txt2: txt2$1A,
	txt3: txt3$1s,
	txt4: txt4$1k,
	txt5: txt5$1c
};

var txt0$1V = "Click to claim enterprise space for free";
var txt1$1I = "Complete the task to obtain free storage space: 4G per person";
var txt2$1z = "Invite Colleagues";
var txt3$1r = "Click here to invite colleagues to join the enterprise next time";
var txt4$1j = "To Invite";
var txt5$1b = "1/2 Upload files";
var txt6$11 = "Click here to upload documents to the team next time";
var txt7$T = "Next";
var txt8$R = "2/2 Share Files";
var txt9$L = "Click the \"Share\" button, set sharing permissions, create a sharing link, and then share the file with colleagues";
var txt10$H = "Go to Share";
var txt11$B = "Exclusive Rights for New Enterprises";
var NoviceGuideReminder = {
	txt0: txt0$1V,
	txt1: txt1$1I,
	txt2: txt2$1z,
	txt3: txt3$1r,
	txt4: txt4$1j,
	txt5: txt5$1b,
	txt6: txt6$11,
	txt7: txt7$T,
	txt8: txt8$R,
	txt9: txt9$L,
	txt10: txt10$H,
	txt11: txt11$B
};

var txt0$1U = "Please enter member name";
var txt1$1H = "Cancel";
var txt2$1y = "Confirm";
var txt3$1q = " cannot contain special characters! @#$^*<>?";
var txt4$1i = "No more than 30 characters";
var txt5$1a = "Renamed successfully";
var txt6$10 = "Your operation authority is insufficient";
var ModifyMemberName = {
	txt0: txt0$1U,
	txt1: txt1$1H,
	txt2: txt2$1y,
	txt3: txt3$1q,
	txt4: txt4$1i,
	txt5: txt5$1a,
	txt6: txt6$10
};

var txt0$1T = "No colleague has applied to join the enterprise";
var txt1$1G = "Approved";
var txt2$1x = "Rejected";
var txt3$1p = "Approve";
var txt4$1h = "Reject";
var txt5$19 = "Joined by verified mobile number";
var txt6$$ = "Joined by verified email address";
var txt7$S = "Join without review";
var txt8$Q = "Approval failed";
var txt9$K = "go to buy";
var txt10$G = "The member seat is full, the member cannot be added, please purchase additional seats before approval";
var txt11$A = "The member seat is full and the member cannot be added. You can purchase a package with enough seats for approval.";
var MemberApproval = {
	txt0: txt0$1T,
	txt1: txt1$1G,
	txt2: txt2$1x,
	txt3: txt3$1p,
	txt4: txt4$1h,
	txt5: txt5$19,
	txt6: txt6$$,
	txt7: txt7$S,
	txt8: txt8$Q,
	txt9: txt9$K,
	txt10: txt10$G,
	txt11: txt11$A
};

var txt0$1S = "The number of users has exceeded the limit";
var txt1$1F = "Selected";
var txt2$1w = "Members viewable";
var txt3$1o = "Invitation sent. Please wait for the administrator’s approval";
var txt4$1g = "Added successfully";
var txt5$18 = "Sent successfully";
var txt6$_ = "Deleted successfully";
var txt7$R = "Failed to delete the contact";
var txt8$P = " the following  ";
var txt9$J = " people can not be added: ";
var txt10$F = "Got it";
var txt11$z = "This team has prohibited external members from joining document collaboration";
var txt12$x = "The company has prohibited external members from joining document collaboration. Please contact the company administrator for permissions";
var txt13$z = "The team's parent company has prohibited external members from joining document collaboration";
var txt14$t = "External members joining encrypted teams is not supported";
var txt15$q = "Adding team members, please wait...";
var groupChat$1 = "Group Chat";
var InviteContact = {
	txt0: txt0$1S,
	txt1: txt1$1F,
	txt2: txt2$1w,
	txt3: txt3$1o,
	txt4: txt4$1g,
	txt5: txt5$18,
	txt6: txt6$_,
	txt7: txt7$R,
	txt8: txt8$P,
	txt9: txt9$J,
	txt10: txt10$F,
	txt11: txt11$z,
	txt12: txt12$x,
	txt13: txt13$z,
	txt14: txt14$t,
	txt15: txt15$q,
	groupChat: groupChat$1
};

var txt0$1R = "The following users are not members of the enterprise. Are you sure you want to invite them to join the enterprise?";
var txt1$1E = "Yes. Invite them to join the enterprise";
var txt2$1v = "Skip";
var txt3$1n = "No contacts selected";
var txt4$1f = "You can invite up to";
var txt5$17 = "persons at a time";
var txt6$Z = "Added successfully.";
var txt7$Q = " etc. ";
var txt8$O = " members";
var txt9$I = " will be automatically added to the team after joining the enterprise";
var InviteBySend = {
	txt0: txt0$1R,
	txt1: txt1$1E,
	txt2: txt2$1v,
	txt3: txt3$1n,
	txt4: txt4$1f,
	txt5: txt5$17,
	txt6: txt6$Z,
	txt7: txt7$Q,
	txt8: txt8$O,
	txt9: txt9$I
};

var txt0$1Q = "Confirm whether to cancel sharing";
var txt1$1D = "After cancellation, only";
var txt2$1u = "members";
var txt3$1m = " yourself";
var txt4$1e = " has permission. The following members will no longer be able to visit";
var txt5$16 = " members";
var txt6$Y = " has permission";
var txt7$P = "After cancellation, only you can access it";
var txt8$N = "Cancel";
var txt9$H = "OK";
var cancelShareFileTxt = "Share canceled successfully.";
var DelLink = {
	txt0: txt0$1Q,
	txt1: txt1$1D,
	txt2: txt2$1u,
	txt3: txt3$1m,
	txt4: txt4$1e,
	txt5: txt5$16,
	txt6: txt6$Y,
	txt7: txt7$P,
	txt8: txt8$N,
	txt9: txt9$H,
	cancelShareFileTxt: cancelShareFileTxt
};

var txt0$1P = "Confirm to remove the specified ";
var txt1$1C = "Cancel";
var txt2$1t = "OK";
var txt3$1l = " member(s)";
var DelMember = {
	txt0: txt0$1P,
	txt1: txt1$1C,
	txt2: txt2$1t,
	txt3: txt3$1l
};

var txt0$1O = "Allow members to invite contacts to join the team";
var txt1$1B = "Admin review is required when joining";
var txt2$1s = "Members are only allowed to view after joining";
var txt3$1k = "Administrators can still modify the permissions of designated members";
var txt4$1d = "Invitation link validity period";
var txt5$15 = "Unshare";
var txt6$X = "Cancel";
var txt7$O = "Confirm";
var txt8$M = "day";
var txt9$G = "permanent";
var txt10$E = "Successfully modified";
var FolderShareSetting = {
	txt0: txt0$1O,
	txt1: txt1$1B,
	txt2: txt2$1s,
	txt3: txt3$1k,
	txt4: txt4$1d,
	txt5: txt5$15,
	txt6: txt6$X,
	txt7: txt7$O,
	txt8: txt8$M,
	txt9: txt9$G,
	txt10: txt10$E
};

var txt0$1N = "Allow members to invite contacts to join the team";
var txt1$1A = "Administrator audit is required when joining";
var txt2$1r = "Allow administrators to access all team files and manage file permissions";
var txt4$1c = "The period of validity of the invitation link";
var txt5$14 = "Cancel Sharing";
var txt6$W = "Cancel";
var txt7$N = "OK";
var txt8$L = " days";
var txt9$F = "Permanent";
var txt10$D = "Modified successfully";
var EntFolderShareSetting = {
	txt0: txt0$1N,
	txt1: txt1$1A,
	txt2: txt2$1r,
	txt4: txt4$1c,
	txt5: txt5$14,
	txt6: txt6$W,
	txt7: txt7$N,
	txt8: txt8$L,
	txt9: txt9$F,
	txt10: txt10$D
};

var txt0$1M = "Set as shared";
var txt1$1z = "Invite designated members to join the sharing, view and edit files together";
var txt2$1q = "Cancel";
var txt3$1j = "Share now";
var txt4$1b = "A shared folder already exists in this folder, and sharing is not currently supported.";
var txt5$13 = "Confirm";
var FolderShareOpen = {
	txt0: txt0$1M,
	txt1: txt1$1z,
	txt2: txt2$1q,
	txt3: txt3$1j,
	txt4: txt4$1b,
	txt5: txt5$13
};

var txt0$1L = "Add member";
var txt1$1y = "Settings";
var txt2$1p = "copy";
var txt3$1i = "Please send the link to your WeChat/QQ friends, click to join";
var txt4$1a = "team";
var txt5$12 = "shared";
var txt6$V = "Invite QQ and WeChat friends to join";
var txt7$M = "Add from contacts";
var txt8$K = "Add members from enterprise address book";
var txt9$E = "Only administrators can invite members to join";
var txt10$C = "Choose from contacts";
var txt11$y = "Add members from enterprise address book";
var txt12$w = "Joined members";
var txt13$y = "Selected";
var txt14$s = "Batch operation";
var txt15$p = "Set as administrator";
var txt16$q = "Set as member · Allow editing";
var txt17$n = "Set as member · View only";
var txt18$n = "Bulk removal";
var txt19$l = "Search members";
var txt20$k = "No matching contacts found";
var txt21$h = "Owner";
var txt22$f = "You are the owner of the shared folder, and the files only occupy the Cloud space of yours";
var txt23$d = "You are the team owner, files only occupy your enterprise cloud space";
var txt24$b = "Transfer shared folders";
var txt25$a = "Transfer team";
var txt26$a = "Owner";
var txt27$9 = "Remove this member";
var txt28$9 = "Administrator";
var txt29$6 = "Member · Edit allowed";
var txt30$5 = "Members · view only";
var txt31$5 = "Member";
var txt32$5 = "Viewer";
var txt33$4 = "Can't choose anymore";
var txt34$4 = "Removed successfully";
var txt35$4 = "Partial removal failed";
var txt36$4 = "Partial modification failed";
var txt37$4 = "Successfully modified";
var txt38$4 = "(To be accepted)";
var txt39$4 = "Copy successfully";
var txt40$4 = "Copy failed";
var txt41$4 = "Your browser does not support automatic copy, please click";
var txt42$4 = "Copy the content of the input box below";
var txt43$4 = "(Invited)";
var txt44$4 = "Select up to 4000 people at a time";
var txt45$4 = " member removal failed";
var txt46$4 = " name member modification failed";
var txt47$4 = "Admin review is required when joining";
var txt49$4 = "Select from Contacts";
var txt50$4 = " Members can view after joining";
var txt51$2 = " Members can edit after joining";
var txt52$2 = "Unshare";
var txt53$2 = " valid for 3 days";
var txt54$2 = "Permanent";
var txt55$1 = "Successfully modified";
var txt56$1 = "Successful transfer";
var txt57$1 = "The opponent’s team has reached the upper limit, and the transfer is not currently supported";
var txt58$1 = " link has been copied, sent to WeChat to invite friends to join";
var txt59$1 = " link has been copied, sent to QQ to invite friends to join";
var txt60$1 = "Search joined members";
var txt61$1 = "search results";
var txt62$1 = " Delete up to 100 people at a time";
var txt63$1 = "You can add or delete members and conduct team management";
var link_v1_ShareFolder38 = "Invite friends to join";
var link_v1_ShareFolder39 = "Please send the link to friends, click to join the team";
var link_v1_ShareFolder40 = "Use the Invite Link";
var link_v1_ShareFolder41 = "After the link is sent, click to join the team";
var shareFolderDialogTitle = "QR Code of the share folder";
var qrcode_invite$1 = "Invitation Through QR Code";
var qrcode_scan$1 = "Scan the QR code to join the share folder";
var footer_link$1 = "To learn more ways to share, please";
var footer_link_tell_us$1 = " tell us";
var txt48$4 = "Copy";
var FolderShareMain = {
	txt0: txt0$1L,
	txt1: txt1$1y,
	txt2: txt2$1p,
	txt3: txt3$1i,
	txt4: txt4$1a,
	txt5: txt5$12,
	txt6: txt6$V,
	txt7: txt7$M,
	txt8: txt8$K,
	txt9: txt9$E,
	txt10: txt10$C,
	txt11: txt11$y,
	txt12: txt12$w,
	txt13: txt13$y,
	txt14: txt14$s,
	txt15: txt15$p,
	txt16: txt16$q,
	txt17: txt17$n,
	txt18: txt18$n,
	txt19: txt19$l,
	txt20: txt20$k,
	txt21: txt21$h,
	txt22: txt22$f,
	txt23: txt23$d,
	txt24: txt24$b,
	txt25: txt25$a,
	txt26: txt26$a,
	txt27: txt27$9,
	txt28: txt28$9,
	txt29: txt29$6,
	txt30: txt30$5,
	txt31: txt31$5,
	txt32: txt32$5,
	txt33: txt33$4,
	txt34: txt34$4,
	txt35: txt35$4,
	txt36: txt36$4,
	txt37: txt37$4,
	txt38: txt38$4,
	txt39: txt39$4,
	txt40: txt40$4,
	txt41: txt41$4,
	txt42: txt42$4,
	txt43: txt43$4,
	txt44: txt44$4,
	txt45: txt45$4,
	txt46: txt46$4,
	txt47: txt47$4,
	txt49: txt49$4,
	txt50: txt50$4,
	txt51: txt51$2,
	txt52: txt52$2,
	txt53: txt53$2,
	txt54: txt54$2,
	txt55: txt55$1,
	txt56: txt56$1,
	txt57: txt57$1,
	txt58: txt58$1,
	txt59: txt59$1,
	txt60: txt60$1,
	txt61: txt61$1,
	txt62: txt62$1,
	txt63: txt63$1,
	link_v1_ShareFolder38: link_v1_ShareFolder38,
	link_v1_ShareFolder39: link_v1_ShareFolder39,
	link_v1_ShareFolder40: link_v1_ShareFolder40,
	link_v1_ShareFolder41: link_v1_ShareFolder41,
	shareFolderDialogTitle: shareFolderDialogTitle,
	qrcode_invite: qrcode_invite$1,
	qrcode_scan: qrcode_scan$1,
	footer_link: footer_link$1,
	footer_link_tell_us: footer_link_tell_us$1,
	txt48: txt48$4
};

var txt0$1K = "Add Member";
var txt1$1x = "Settings";
var txt2$1o = "Copy";
var txt3$1h = "Please send the link to WeChat/QQ friends, click to join ";
var txt4$19 = "team.";
var txt5$11 = "share.";
var txt6$U = "Invite Friends";
var txt7$L = "Add from Contacts";
var txt8$J = "Add from Enterprise Address Book";
var txt9$D = "Only administrators can invite members to join";
var txt10$B = "Choose from Contacts";
var txt11$x = "Add from Enterprise Address Book";
var txt12$v = "Joined Members";
var txt13$x = "Selected";
var txt14$r = "Batch Operation";
var txt15$o = "Set as Administrator";
var txt16$p = "Set as Member";
var txt18$m = "Batch Removal";
var txt19$k = "Search for Members";
var txt20$j = "No matching contacts found";
var txt21$g = "Owner";
var txt22$e = "Team Owner";
var txt23$c = "Team Owner";
var txt24$a = "Transfer Shared Folder";
var txt25$9 = "Transfer Team";
var txt26$9 = "Owner";
var txt27$8 = "Remove the Member";
var txt28$8 = "Administrator";
var txt29$5 = "Member";
var txt30$4 = "Members · View Only";
var txt31$4 = "You can add or delete members and set document permissions.";
var txt32$4 = "You can access team documents to which you have access permissions.";
var txt33$3 = "Can't choose anymore";
var txt34$3 = "Removed successfully";
var txt35$3 = "Partial removal failed";
var txt36$3 = "Partial modification failed";
var txt37$3 = "Modified successfully";
var txt38$3 = "(To be accepted)";
var txt39$3 = "Copied successfully";
var txt40$3 = "Copy failed";
var txt41$3 = "Your browser does not support automatic copy. Press";
var txt42$3 = "to copy the content in the following input box";
var txt43$3 = "(Invited)";
var txt44$3 = "Select up to 4,000 people at a time";
var txt45$3 = " members failed to be removed";
var txt46$3 = " members failed to be renamed";
var txt47$3 = "Administrator approval required for joining";
var txt48$3 = "Copy Link";
var txt49$3 = "Select from Contacts";
var txt50$3 = " Members can view after joining";
var txt51$1 = " members can edit after joining";
var txt52$1 = "Unshare";
var txt53$1 = " valid for 3 days";
var txt54$1 = "Permanent";
var txt55 = "Modified successfully";
var txt56 = "Transferred successfully";
var txt57 = "Transferring is not supported because the number of teams of the other party has reached the upper limit";
var txt58 = " link has been copied. Send the link to your friends to invite them.";
var txt59 = " link has been copied. Send the link to your friends to invite them.";
var txt60 = "Search joined members";
var txt61 = "Search Result";
var txt62 = " Delete up to 100 people at a time";
var txt63 = "You can add or delete members and manage your teams.";
var txt64 = "Use Invitation Link";
var txt65 = "The recipient clicks the link to join the ";
var qrcode_invite = "Invitation Through QR Code";
var qrcode_scan = "Scan the QR code to join the team";
var footer_link = "To learn more ways to share, please";
var footer_link_tell_us = " tell us";
var txt66 = "Enterprise Members";
var txt67 = "Add from Enterprise Contacts";
var txt68 = "External Contacts";
var txt69 = "Send a link to the work group to invite colleagues, and colleagues can click to apply to join the enterprise team.";
var txt71 = "To ensure data security, external members cannot be set as administrators";
var txt70 = "Copy the link and send it to WeChat/QQ friends to invite them";
var EntFolderShareMain = {
	txt0: txt0$1K,
	txt1: txt1$1x,
	txt2: txt2$1o,
	txt3: txt3$1h,
	txt4: txt4$19,
	txt5: txt5$11,
	txt6: txt6$U,
	txt7: txt7$L,
	txt8: txt8$J,
	txt9: txt9$D,
	txt10: txt10$B,
	txt11: txt11$x,
	txt12: txt12$v,
	txt13: txt13$x,
	txt14: txt14$r,
	txt15: txt15$o,
	txt16: txt16$p,
	txt18: txt18$m,
	txt19: txt19$k,
	txt20: txt20$j,
	txt21: txt21$g,
	txt22: txt22$e,
	txt23: txt23$c,
	txt24: txt24$a,
	txt25: txt25$9,
	txt26: txt26$9,
	txt27: txt27$8,
	txt28: txt28$8,
	txt29: txt29$5,
	txt30: txt30$4,
	txt31: txt31$4,
	txt32: txt32$4,
	txt33: txt33$3,
	txt34: txt34$3,
	txt35: txt35$3,
	txt36: txt36$3,
	txt37: txt37$3,
	txt38: txt38$3,
	txt39: txt39$3,
	txt40: txt40$3,
	txt41: txt41$3,
	txt42: txt42$3,
	txt43: txt43$3,
	txt44: txt44$3,
	txt45: txt45$3,
	txt46: txt46$3,
	txt47: txt47$3,
	txt48: txt48$3,
	txt49: txt49$3,
	txt50: txt50$3,
	txt51: txt51$1,
	txt52: txt52$1,
	txt53: txt53$1,
	txt54: txt54$1,
	txt55: txt55,
	txt56: txt56,
	txt57: txt57,
	txt58: txt58,
	txt59: txt59,
	txt60: txt60,
	txt61: txt61,
	txt62: txt62,
	txt63: txt63,
	txt64: txt64,
	txt65: txt65,
	qrcode_invite: qrcode_invite,
	qrcode_scan: qrcode_scan,
	footer_link: footer_link,
	footer_link_tell_us: footer_link_tell_us,
	txt66: txt66,
	txt67: txt67,
	txt68: txt68,
	txt69: txt69,
	txt71: txt71,
	txt70: txt70
};

var txt0$1J = "Please confirm to remove the specified ";
var txt1$1w = " Members";
var txt2$1n = "Cancel";
var txt3$1g = "Confirm";
var FolderShareDelete = {
	txt0: txt0$1J,
	txt1: txt1$1w,
	txt2: txt2$1n,
	txt3: txt3$1g
};

var txt0$1I = "Please confirm cancel sharing ";
var txt1$1v = "After cancellation, only you can access, other members will no longer be able to access the folder";
var txt2$1m = " Members";
var txt3$1f = "Cancel";
var txt4$18 = "Confirm";
var txt5$10 = "Folder sharing canceled";
var txt6$T = "copy";
var txt7$K = "Paste";
var txt8$I = "delete";
var txt9$C = "Move";
var txt10$A = "Cancel folder sharing";
var txt11$w = "Being";
var txt12$u = "Please wait...";
var txt13$w = "file";
var FolderShareCancel = {
	txt0: txt0$1I,
	txt1: txt1$1v,
	txt2: txt2$1m,
	txt3: txt3$1f,
	txt4: txt4$18,
	txt5: txt5$10,
	txt6: txt6$T,
	txt7: txt7$K,
	txt8: txt8$I,
	txt9: txt9$C,
	txt10: txt10$A,
	txt11: txt11$w,
	txt12: txt12$u,
	txt13: txt13$w
};

var txt0$1H = "Feedback";
var txt1$1u = "Team Members";
var txt2$1l = "Server error";
var txt3$1e = "Settings";
var txt4$17 = "Unshare";
var txt5$$ = "Add Member";
var txt6$S = "Team Members";
var txt7$J = "Batch Removal";
var FolderShare = {
	txt0: txt0$1H,
	txt1: txt1$1u,
	txt2: txt2$1l,
	txt3: txt3$1e,
	txt4: txt4$17,
	txt5: txt5$$,
	txt6: txt6$S,
	txt7: txt7$J
};

var txt0$1G = "Exclusive Rights for New Enterprises";
var DialogNoviceTask = {
	txt0: txt0$1G
};

var txt0$1F = "Membership Approval";
var DialogMemberApproval = {
	txt0: txt0$1F
};

var txt0$1E = "Enterprise Growth Plan";
var txt1$1t = "Enterprise Index";
var DialogJoinCompPrivilege = {
	txt0: txt0$1E,
	txt1: txt1$1t
};

var txt0$1D = "Team Settings";
var txt1$1s = "Settings";
var txt2$1k = "Batch Removal";
var txt3$1d = "Transfer Team";
var txt4$16 = "Security Reminder";
var txt5$_ = "Team Members";
var txt6$R = "Add Contact";
var txt7$I = "Transfer Shared Folder";
var txt8$H = "Unshare";
var txt9$B = "Delete Contact";
var txt10$z = "Security Verification";
var qrcode_dialog_title$1 = "Team QR code";
var noMemberToSelect = "No members available.";
var txt5_beemwork = "Team Members";
var some_member_add_failed = "Failed to add some members";
var DialogFolderShare = {
	txt0: txt0$1D,
	txt1: txt1$1s,
	txt2: txt2$1k,
	txt3: txt3$1d,
	txt4: txt4$16,
	txt5: txt5$_,
	txt6: txt6$R,
	txt7: txt7$I,
	txt8: txt8$H,
	txt9: txt9$B,
	txt10: txt10$z,
	qrcode_dialog_title: qrcode_dialog_title$1,
	noMemberToSelect: noMemberToSelect,
	txt5_beemwork: txt5_beemwork,
	some_member_add_failed: some_member_add_failed
};

var txt0$1C = "Invite Colleagues";
var DialogCompanyInvite = {
	txt0: txt0$1C
};

var txt0$1B = "Enterprise Members";
var txt1$1r = "Rename";
var txt2$1j = "Settings";
var txt3$1c = "Delete Member";
var txt4$15 = "Invite Colleagues";
var txt5$Z = "Exit the Enterprise";
var txt6$Q = "Security Verification";
var DialogAddEntMember = {
	txt0: txt0$1B,
	txt1: txt1$1r,
	txt2: txt2$1j,
	txt3: txt3$1c,
	txt4: txt4$15,
	txt5: txt5$Z,
	txt6: txt6$Q
};

var txt0$1A = "After deletion, the member will withdraw from all joined teams and cannot continue to access enterprise documents. Are you sure you want to delete?";
var txt1$1q = "Cancel";
var txt2$1i = "delete";
var txt3$1b = "successfully deleted";
var txt4$14 = "Your operation authority is insufficient";
var DeleteEntMember = {
	txt0: txt0$1A,
	txt1: txt1$1q,
	txt2: txt2$1i,
	txt3: txt3$1b,
	txt4: txt4$14
};

var txt0$1z = "Allow members to invite colleagues to join the enterprise";
var txt1$1p = "After being invited by members, colleagues need to be approved by administrators before they can join the enterprise";
var txt2$1h = "You do not have enough permissions";
var CompanyMemberInviteSetting = {
	txt0: txt0$1z,
	txt1: txt1$1p,
	txt2: txt2$1h
};

var txt0$1y = "Modify";
var CompanyLogo = {
	txt0: txt0$1y
};

var txt0$1x = "Enterprise Growth Plan";
var txt1$1o = "Enterprise Package:";
var txt2$1g = "due";
var txt3$1a = "Used/Total Enterprise Space:";
var txt4$13 = "Invite";
var txt5$Y = "Approval";
var txt6$P = "Data Overview";
var txt7$H = "Management Background";
var txt8$G = "joined";
var txt9$A = "people";
var txt10$y = "Manage member permissions here. Members are prohibited from uploading files at will in the full-member team.";
var txt11$v = "Configure";
var txt12$t = "Enterprise space and file upload rights to be claimed";
var txt13$v = "View the impact after the package expires";
var txt14$q = "Understand Education Enhanced Edition";
var txt15$n = "Automatically renew for a year after the service expires.";
var txt16$o = "Enterprise super admin: ";
var txt17$m = "Enterprise ID: ";
var txt18$l = "Upgrade";
var txt19$j = "Renew";
var txt20$i = "ll";
var txt21$f = "Benefits to be claimed";
var txt22$d = "Purchase Package";
var txt23$b = "Renew Now";
var txt24$9 = "Used/Maximum User Limit";
var txt25$8 = "Additional Purchasers";
var txt26$8 = "Upgrade Package";
var CompanyHelpHead = {
	txt0: txt0$1x,
	txt1: txt1$1o,
	txt2: txt2$1g,
	txt3: txt3$1a,
	txt4: txt4$13,
	txt5: txt5$Y,
	txt6: txt6$P,
	txt7: txt7$H,
	txt8: txt8$G,
	txt9: txt9$A,
	txt10: txt10$y,
	txt11: txt11$v,
	txt12: txt12$t,
	txt13: txt13$v,
	txt14: txt14$q,
	txt15: txt15$n,
	txt16: txt16$o,
	txt17: txt17$m,
	txt18: txt18$l,
	txt19: txt19$j,
	txt20: txt20$i,
	txt21: txt21$f,
	txt22: txt22$d,
	txt23: txt23$b,
	txt24: txt24$9,
	txt25: txt25$8,
	txt26: txt26$8
};

var txt0$1w = "Add Member";
var txt1$1n = "Settings";
var txt2$1f = "Invite Colleagues";
var txt3$19 = "Only the administrator can invite colleagues to join the enterprise";
var txt4$12 = "Joined Members";
var txt5$X = "Search for Members";
var txt6$O = "Delete";
var txt7$G = "No matching members found";
var txt8$F = "Rename";
var txt9$z = "Exit the Enterprise";
var AddEntMember = {
	txt0: txt0$1w,
	txt1: txt1$1n,
	txt2: txt2$1f,
	txt3: txt3$19,
	txt4: txt4$12,
	txt5: txt5$X,
	txt6: txt6$O,
	txt7: txt7$G,
	txt8: txt8$F,
	txt9: txt9$z
};

var txt0$1v = "Get Login-Free Link";
var txt1$1m = "With this feature enabled, people with only viewing permissions will not be able to download, print, save, and copy content";
var txt2$1e = "Advanced Settings";
var txt3$18 = "After this feature is disabled, members with only the read permission cannot download, print, or copy the file, or save the file as other formats.";
var ClinkAdvancedSetting = {
	txt0: txt0$1v,
	txt1: txt1$1m,
	txt2: txt2$1e,
	txt3: txt3$18
};

var txt0$1u = "Use team documents to activate rights";
var txt1$1l = "Rights have expired";
var ActivityContent = {
	txt0: txt0$1u,
	txt1: txt1$1l
};

var txt0$1t = "Application Center";
var txt1$1k = "Unpin the application in the application center";
var txt2$1d = "Meeting";
var txt3$17 = "Meeting on the Cloud, seamless collaboration";
var txt4$11 = "Form";
var txt5$W = "Quick creation, efficient collection";
var txt6$N = "To-Do";
var txt7$F = "Team task collaboration, multi-platform synchronization";
var txt8$E = "Calendar";
var txt9$y = "Efficient schedule management tool";
var txt10$x = "Contacts";
var txt11$u = "Add partners for efficient team work";
var txt12$s = "Unpin from Top";
var txt13$u = "Pin to Top";
var txt14$p = "A maximum of 4 applications can be pinned to top. Please unpin other applications first";
var txt15$m = "Pin to top failed";
var AppCenter = {
	txt0: txt0$1t,
	txt1: txt1$1k,
	txt2: txt2$1d,
	txt3: txt3$17,
	txt4: txt4$11,
	txt5: txt5$W,
	txt6: txt6$N,
	txt7: txt7$F,
	txt8: txt8$E,
	txt9: txt9$y,
	txt10: txt10$x,
	txt11: txt11$u,
	txt12: txt12$s,
	txt13: txt13$u,
	txt14: txt14$p,
	txt15: txt15$m
};

var txt0$1s = "View All Members";
var txt1$1j = "Owner";
var txt2$1c = "(Me)";
var txt3$16 = "Offline";
var txt4$10 = "Collaborating Members";
var txt5$V = "Not Logged In";
var txt6$M = "View Only";
var txt7$E = "Editable";
var txt8$D = "Me";
var txt9$x = "Document Owner";
var txt10$w = "is collaborating. Click the avatar to locate";
var txt11$t = "is viewing the file. Click the avatar to locate";
var txt12$r = "Read-Only Permissions";
var txt13$t = "Enable Editing";
var txt10_dbt = "Collaborating";
var txt11_dbt = "Viewing";
var comment$6 = " can comment ";
var commentOnly = "Comment Permission";
var AvatarList = {
	txt0: txt0$1s,
	txt1: txt1$1j,
	txt2: txt2$1c,
	txt3: txt3$16,
	txt4: txt4$10,
	txt5: txt5$V,
	txt6: txt6$M,
	txt7: txt7$E,
	txt8: txt8$D,
	txt9: txt9$x,
	txt10: txt10$w,
	txt11: txt11$t,
	txt12: txt12$r,
	txt13: txt13$t,
	txt10_dbt: txt10_dbt,
	txt11_dbt: txt11_dbt,
	comment: comment$6,
	commentOnly: commentOnly
};

var txt0$1r = "Please make sure to turn off the document encryption protection";
var txt1$1i = "After closing the document encryption protection,";
var txt2$1b = "Encrypted team documents will be decrypted";
var txt3$15 = ", After the file is shared, users outside the team can also view it";
var txt4$$ = "Close and decrypt protected documents";
var txt5$U = "Cancel";
var txt6$L = "Turn off protection";
var txt7$D = "Closed successfully";
var txt8$C = "Close failed, please try again";
var txt9$w = "Turn off document encryption protection";
var CloseSecure = {
	txt0: txt0$1r,
	txt1: txt1$1i,
	txt2: txt2$1b,
	txt3: txt3$15,
	txt4: txt4$$,
	txt5: txt5$U,
	txt6: txt6$L,
	txt7: txt7$D,
	txt8: txt8$C,
	txt9: txt9$w
};

var txt0$1q = "Team Settings";
var txt0_beemwork$1 = "Setting";
var txt1$1h = "Rename";
var txt2$1a = "Document Permission Settings";
var txt3$14 = "Enable Document Encryption Protection";
var txt4$_ = "Security Verification";
var txt5$T = "Security Reminder";
var txt8$B = "Transfer Team";
var txt10$v = "Team Members";
var txt11$s = "Settings";
var txt13$s = "Batch Removal";
var txt16$n = "Add Contact";
var txt17$l = "Add Contact";
var txt18$k = "Manage Document Sharing Scope";
var txt10_beemwork$2 = "Team Members";
var DialogTeamSettings = {
	txt0: txt0$1q,
	txt0_beemwork: txt0_beemwork$1,
	txt1: txt1$1h,
	txt2: txt2$1a,
	txt3: txt3$14,
	txt4: txt4$_,
	txt5: txt5$T,
	txt8: txt8$B,
	txt10: txt10$v,
	txt11: txt11$s,
	txt13: txt13$s,
	txt16: txt16$n,
	txt17: txt17$l,
	txt18: txt18$k,
	txt10_beemwork: txt10_beemwork$2
};

var txt0$1p = "Settings";
var txt1$1g = "Rename";
var txt2$19 = "Permission";
var txt3$13 = "Enable document encryption protection";
var txt4$Z = "Security Verification";
var txt5$S = "Security Reminder";
var txt8$A = "Transfer Team";
var txt10$u = "Team Member";
var txt11$r = "Settings";
var txt13$r = "Batch Remove";
var txt16$m = "Add Contacts";
var txt17$k = "Add Contacts";
var txt18$j = "Sharing Range Control";
var txt19$i = "Rename Application";
var txt20$h = "Application Management";
var txt21$e = "Dissolve The Team";
var txt22$c = "hint";
var DialogTeamAppSettings = {
	txt0: txt0$1p,
	txt1: txt1$1g,
	txt2: txt2$19,
	txt3: txt3$13,
	txt4: txt4$Z,
	txt5: txt5$S,
	txt8: txt8$A,
	txt10: txt10$u,
	txt11: txt11$r,
	txt13: txt13$r,
	txt16: txt16$m,
	txt17: txt17$k,
	txt18: txt18$j,
	txt19: txt19$i,
	txt20: txt20$h,
	txt21: txt21$e,
	txt22: txt22$c
};

var txt0$1o = "Share";
var txt1$1f = "Login-free access link";
var txt3$12 = "Result";
var txt4$Y = "QR Code";
var batchRemove$1 = "Batch Remove";
var txt5$R = "Create Enterprise";
var shareMiniCode$2 = "Send to WeChat friends by applet";
var txt6$K = "Real Name Certification";
var banShare = "Unable to ensure the safety of {0} file. Sharing of the file has been suspended.";
var txt2$18 = "Unshare";
var iSee = "Got it";
var txt7$C = "People who have joined sharing";
var txt8$z = "Sharing settings";
var txt9$v = "Document watermark";
var DialogShareFile = {
	txt0: txt0$1o,
	txt1: txt1$1f,
	txt3: txt3$12,
	txt4: txt4$Y,
	batchRemove: batchRemove$1,
	txt5: txt5$R,
	shareMiniCode: shareMiniCode$2,
	txt6: txt6$K,
	banShare: banShare,
	txt2: txt2$18,
	iSee: iSee,
	txt7: txt7$C,
	txt8: txt8$z,
	txt9: txt9$v
};

var txt0$1n = "Insert Schedule";
var txt1$1e = "Enter a title to search for an existing schedule.";
var txt2$17 = "Initiate";
var txt3$11 = "New Schedule";
var txt4$X = "No search results found.";
var txt5$Q = "Mon.";
var txt6$J = "Tue.";
var txt7$B = "Wed.";
var txt8$y = "Thu.";
var txt9$u = "Fri.";
var txt10$t = "Sat.";
var txt11$q = "Sun.";
var txt12$q = "Server error.";
var txt13$q = "No schedules available.";
var txt14$o = "Year";
var txt15$l = "Month";
var txt16$l = "Day";
var txt17$j = "All Day";
var DialogSchedule = {
	txt0: txt0$1n,
	txt1: txt1$1e,
	txt2: txt2$17,
	txt3: txt3$11,
	txt4: txt4$X,
	txt5: txt5$Q,
	txt6: txt6$J,
	txt7: txt7$B,
	txt8: txt8$y,
	txt9: txt9$u,
	txt10: txt10$t,
	txt11: txt11$q,
	txt12: txt12$q,
	txt13: txt13$q,
	txt14: txt14$o,
	txt15: txt15$l,
	txt16: txt16$l,
	txt17: txt17$j
};

var txt0$1m = "Settings";
var txt1$1d = "Auto-Backup of Directory Settings";
var DialogBackupSettings = {
	txt0: txt0$1m,
	txt1: txt1$1d
};

var txt0$1l = "Automatically Backup Directory :";
var txt1$1c = "My Enterprise Space";
var txt2$16 = "Modify";
var txt3$10 = "Used";
var txt4$W = "My Documents/My Devices";
var txt5$P = "My Enterprise Documents/Automatic Backup";
var txt6$I = "My Cloud Document/My Device";
var BackupSetting = {
	txt0: txt0$1l,
	txt1: txt1$1c,
	txt2: txt2$16,
	txt3: txt3$10,
	txt4: txt4$W,
	txt5: txt5$P,
	txt6: txt6$I
};

var txt0$1k = "Confirm";
var txt1$1b = "Cancel";
var BackupSettingSelect = {
	txt0: txt0$1k,
	txt1: txt1$1b
};

var txt0$1j = "We need your phone number";
var txt1$1a = "Perform security verification";
var txt2$15 = "please enter verification code";
var txt3$$ = "get verification code";
var txt4$V = "Reacquire";
var txt5$O = "Cancel";
var txt6$H = "Confirm";
var txt7$A = "Please fill in the verification code";
var SecurePhoneCheck = {
	txt0: txt0$1j,
	txt1: txt1$1a,
	txt2: txt2$15,
	txt3: txt3$$,
	txt4: txt4$V,
	txt5: txt5$O,
	txt6: txt6$H,
	txt7: txt7$A
};

var txt0$1i = "After opening the document encryption protection, the Office documents under 600M in the team will be converted into a secure document format (excluding historical versions), and only this team member can access and edit";
var txt1$19 = "Cancel";
var txt2$14 = "Turn on";
var txt3$_ = "Successfully opened, the first conversion is time-consuming, please be patient";
var txt4$U = "Failed to open, please try again";
var SecureTips = {
	txt0: txt0$1i,
	txt1: txt1$19,
	txt2: txt2$14,
	txt3: txt3$_,
	txt4: txt4$U
};

var txt0$1h = "confirm delete";
var txt1$18 = "confirm exit";
var txt2$13 = "After deleting, you can restore it in the recycle bin";
var txt3$Z = "After logging out, you will not be able to access";
var txt4$T = "Cancel";
var txt5$N = "delete";
var txt6$G = "Confirm";
var txt7$z = "Delete team";
var txt8$x = "Exit the team";
var txt9$t = "After disbanding:";
var txt10$s = "After exit:";
var txt11$p = "All the content in the team will be moved to the Recycle Bin.";
var txt12$p = "WPS Premium benefits you purchased will be automatically allocated to your personal account.";
var txt13$p = "This operation cannot be undone. Please exercise caution.";
var txt14$n = "WPS Premium benefits you purchased will be automatically allocated to your personal account.";
var txt15$k = "WPS Premium benefits purchased by the administrator and assigned to you will be automatically reclaimed.";
var txt16$k = "WPS Premium benefits assigned to you by the administrator will be automatically reclaimed.";
var tipsTitle$2 = "After dissolution:";
var tips1$2 = "Team members will not be able to access the team";
var tips2$2 = "All files will be moved to the \"disbanded team\" in the enterprise management background";
var reminder = "This action cannot be undone, please proceed with caution";
var tips3$2 = "Synchronously delete the smart document library \"{0}\"";
var TeamDeleteOrExit = {
	txt0: txt0$1h,
	txt1: txt1$18,
	txt2: txt2$13,
	txt3: txt3$Z,
	txt4: txt4$T,
	txt5: txt5$N,
	txt6: txt6$G,
	txt7: txt7$z,
	txt8: txt8$x,
	txt9: txt9$t,
	txt10: txt10$s,
	txt11: txt11$p,
	txt12: txt12$p,
	txt13: txt13$p,
	txt14: txt14$n,
	txt15: txt15$k,
	txt16: txt16$k,
	tipsTitle: tipsTitle$2,
	tips1: tips1$2,
	tips2: tips2$2,
	reminder: reminder,
	tips3: tips3$2
};

var txt0$1g = "Cancel";
var txt1$17 = "Confirm";
var txt2$12 = " fill in the name";
var TeamRename = {
	txt0: txt0$1g,
	txt1: txt1$17,
	txt2: txt2$12
};

var txt0$1f = "Cancel";
var txt1$16 = "OK";
var txt2$11 = "Fill in the application name.";
var success$4 = "Modified successfully.";
var TeamAppRename = {
	txt0: txt0$1f,
	txt1: txt1$16,
	txt2: txt2$11,
	success: success$4
};

var txt0$1e = "Team Name";
var txt0_beemwork = "Name";
var txt1$15 = "Modify";
var txt2$10 = "Member Management";
var txt3$Y = " Members";
var txt4$S = "View";
var txt5$M = "Document Permission Settings";
var txt6$F = "Settings";
var txt7$y = "You can configure the permissions to download, share, and delete team documents";
var txt8$w = "Document Encryption Protection";
var txt9$s = "With this feature enabled, Office documents that are smaller than 600 MB in the team will be encrypted and saved in the WPS secure format. Only members of the team can open the documents";
var txt10$r = "Transfer Team";
var txt10_beemwork$1 = "Transfer";
var txt11$o = "Delete Team";
var txt11_beemwork = "Delete";
var txt12$o = "Exit Team";
var txt13$o = "After deleting the team, you will be unable to access the team";
var txt14$m = "After exiting the team, you will be unable to access the team";
var txt15$j = "No members can be selected";
var txt16$j = "Only the team creator can disable document encryption protection";
var txt17$i = "Team Space";
var txt18$i = "After transferring the team, you will become a team member";
var txt19$h = "Manage Document Sharing Scope";
var txt20$g = "You can set to prevent sharing team files to non-enterprise members.";
var txt21$d = "Anyone";
var txt22$b = "Only users in your enterprise";
var txt23$a = "Only users in your team";
var txt24$8 = "Modified successfully";
var txt25$7 = "Document Watermark";
var txt26$7 = "The enterprise administrator has enabled the watermark feature. You cannot disable it.";
var txt27$7 = "After this feature is enabled, watermarks will be displayed on team documents when members are viewing the documents. Watermarks contain the following information: ";
var water_mark_var1 = "Enterprise name";
var water_mark_var2 = "Department name";
var water_mark_var3 = "Member name";
var water_mark_var4 = "Tail numbers of WPS account ID";
var water_mark_var5 = "Tail numbers of mobile phone";
var water_mark_var6 = "IP address";
var water_mark_var7 = "Custom content";
var water_mark_var8 = "Custom content";
var success_txt = "Modified successfully";
var decryption_incomplete_txt = "This team has an unfinished document decryption task, please try again later";
var encryption_incomplete_txt = "This team has an unfinished document encryption task, please try again later";
var txt28$7 = "3 teams/enterprises are free for a limited time";
var txt29$4 = "Purchase Enterprise Package";
var txt30$3 = "The features and services purchased by your enterprise have exceeded the maximum quantity allowed. Please contact";
var txt31$3 = "WPS Project Manager";
var txt32$3 = "Super Administrator";
var txt33$2 = "process authorization upgrade";
var txt34$2 = "Upgrade Package";
var txt35$2 = "Enable Team Watermark";
var txt36$2 = " to set document sharing range control.";
var txt37$2 = "Enable document encryption protection";
var txt38$2 = "Network exception.";
var txt39$2 = "Shared File Management";
var txt40$2 = "Enter";
var txt41$2 = "You can centrally manage shared files in your team.";
var txt42$2 = "Files shared in the last month can be viewed for free for a limited time";
var txt43$2 = "Manage and distribute purchased WPS Premium benefits";
var txt44$2 = "Assign WPS Premium Benefits";
var txt46$2 = "Only members of your company and related organizations";
var base_info = "Basic Information";
var team_safety = "Team Security";
var water_mark_var9 = " (it can be set by the enterprise administrator in the backend) ";
var delete_group_tips = "After disbanding, all the content in the team will be moved to the Recycle Bin.";
var teamMenu = "Team Settings";
var docsMenu = "Document Settings";
var teamApp_errorPage_tips = "Failed to load the page. Please try again.";
var teamApp_errorPage_reload = "Reload";
var teamApp_moduleNotExist_tips = "Failed to load the page. The app does not exist.";
var no_permission_txt1 = "Available only to owner";
var no_permission_txt2 = "Available only to owner and administrator";
var introTip = "Click to view feature introduction";
var secure_desc_owner = "When enabled, the team's Office documents smaller than 600 MB are automatically encrypted and can only be accessed by team members. (The enterprise admin has enabled automatic document encryption protection for the team.)";
var secure_desc_user = "When enabled, the team's Office documents smaller than 600 MB are automatically encrypted and can only be accessed by team members.";
var creator_can_manage = "Allow file creators to manage the files they create";
var creator_can_manage_tips = "When enabled, the creator of the file can delete, move, and manage file permissions (excluding folders)";
var filePermissionForNonEnt = "Default file permissions for external members";
var txt47$2 = "Customize";
var txt48$2 = "Customize viewing, downloading, editing permissions";
var txt49$2 = "Define the default file permissions for external members joining the team";
var txt50$2 = "The current team has prohibited external personnel from joining document collaboration";
var water_mark_var11 = "Email";
var shareRange_selectButton_title = "Prompt";
var no_transfer_to_nonEntMember = "Transferring team ownership to external members is not supported";
var set_success = "Settings successfully";
var set_failed = "Settings failed";
var forbid_FileSecure_CoopGroup = "Currently, it is not supported to enable document encryption protection after allowing non-company members to join the team";
var txt45$2 = "The company administrator has prohibited sharing this document outside the company.";
var water_mark_var10 = "Document Opened At";
var water_mark_var12 = "Employee Number";
var shareRange_status_reclaiming = "Permissions are being revoked. Authorized users can still access the file until revocation is completed.";
var shareRange_status_done = "Permissions revoked.";
var shareRange_selectButton_content = "Permission revocation is not completed. The document sharing scope is not changed.";
var teamDocTemplate = "Team Document Templates";
var tabTeamAI = "AI Services";
var companyJustAssoc = "Only allowed to share with members of this company and related organizations";
var companyJustOutContact = "Only share with the company and external contacts";
var companyJustAssocAndOutContact = "Sharing is only allowed to this company, affiliated organizations and external contacts";
var groupChat = "Group Chat";
var teamAI = {
	switchLabel: "Enable team intelligent question-and-answer service",
	switchDesc: "After it is turned on, you can obtain document information within the team through conversation",
	processingTitle: "Data processing...{percentage}%",
	processingDesc: "The background is processing data. There are many files in the current team. It will take several hours.",
	errorTips: "Operation failed",
	inforIconContent: "Currently supported formats are: doc/docx, xls/xlsx, ppt/pptx, pdf, smart document",
	processingBtnDesc: "AI is parsing the document in the background. Performing other operations will not affect the parsing process...",
	processingBtnDesc1: "Re-parsing {N} documents. Performing other operations will not affect the parsing process.",
	closeBtnText: "Close Q&A",
	openBtnText: "Enabled",
	processingBtnText: "Opening",
	openNow: "Start now",
	closeDialog: {
		title: "Turn off smart question and answer?",
		content: "After turning it off, you will not be able to obtain document information within the team in the form of a conversation, and the team documents will need to be parsed again the next time you turn on this feature.",
		confirmBtn: "Turn off Smart Q&A",
		cancelBtn: "Cancel"
	},
	forbidTips: {
		indexGroup: "The whole team does not support intelligent question and answer yet",
		secureGroup: "The encryption team does not currently support enabling smart Q&A",
		noPermission: "Only available to administrators, please contact team administrator ({name})"
	}
};
var publishWikiMenu = "Knowledge View Settings";
var publishWikiDialog = {
	title: "Enable Knowledge View for Team Documents",
	subtitle: "After it is turned on, the documents within the team can be organized more clearly in the form of a directory tree, improving the efficiency of document reading.",
	scopeOption: "Visible range",
	closeWikiTxt: "You need to close the view before you can modify the publishing scope again",
	managerCloseGroupWikiTxt: "The enterprise administrator has restricted the knowledge view of team documents",
	secureGroupUnSupportWiki: "The encryption team does not support enterprise disclosure",
	reviewingEntGroupWikiTooltip: "The enterprise administrator is reviewing the application. Once the application is approved, the visible range will automatically change to \"public in the enterprise\"",
	inTeamScopeReviewingEntGroupWikiTooltip: "The current visible scope is \"Visible to team members\", and it will automatically become \"Public within the company\" after approval by the company administrator",
	scopeItem1Txt1: "Visible to team members",
	scopeItem1Txt2: "No approval required, follow the team's authority",
	scopeItem2Txt1: "Public within the company",
	scopeItem2Txt2: "Need approval from enterprise administrator, non-team members can only view",
	coverOption: "Cover",
	descOption: "Introduction",
	descPlaceholder: "Briefly describe the content of the knowledge, related fields, etc.",
	reviewResultNotice: "The review results will be notified via message",
	cancelReview: "Cancel approval",
	closeWiki: "Close Knowledge View",
	saveUpdate: "Save changes",
	reviewing: "Under review",
	confirmOpen: "Start now",
	openSuccess: "Start Success",
	updateSuccess: "Modification successful",
	applyReviewSuccess: "The application has been sent, and the approval result will be notified by \"Message\"",
	closeWikiSuccess: "Knowledge view closed",
	closeWikiFail: "Failed to close knowledge view, please try again later",
	recallApplyReviewSuccess: "Withdrawn approval application",
	enterGroupWiki: "Enter the knowledge view"
};
var publishWikiCover = {
	locationUpload: "Local upload",
	uploadFail: "Upload failed",
	customCover: "Customize Cover",
	uploaLargerError: "Currently, we do not support uploading images larger than 5M.",
	uploadMaxLarger: "The maximum size of the image is 5M",
	uploadFileTypeError: "The file format is incorrect. Only jpg, jpeg, and png formats are supported.",
	uploadImg: "Upload pictures",
	suggestUploadSize: "The recommended size is 508*320px, only JPG / JPEG / PNG format is supported",
	cancelTxt: "Cancel",
	confirmTxt: "Sure"
};
var unPublishWikiDialog = {
	title1: "Turn off knowledge view?",
	title2: "Turn off knowledge view?",
	txt1: "After closing, the team document will no longer support the directory tree view",
	txt2: "The company administrator is reviewing your \"Company Public\" application. Closing the knowledge view will withdraw the application information.",
	cancelBtn: "Think again",
	confirmBtn1: "Close Knowledge View",
	confirmBtn2: "Close Knowledge View"
};
var pulishWikiReasonDialog = {
	title: "Application Open",
	placeholderTxt: "Briefly explain to the company administrator the reason for setting the setting to company public",
	cancelBtn: "Cancel",
	confirmBtn: "Send Application"
};
var publishWikiAlertDialog = {
	title: "Modify visible range?",
	content: "The company administrator is reviewing your \"Company Public\" application. Changing the visible range will withdraw the application.",
	cancelBtn: "Think again",
	confirmBtn: "Revise"
};
var TeamSettings = {
	txt0: txt0$1e,
	txt0_beemwork: txt0_beemwork,
	txt1: txt1$15,
	txt2: txt2$10,
	txt3: txt3$Y,
	txt4: txt4$S,
	txt5: txt5$M,
	txt6: txt6$F,
	txt7: txt7$y,
	txt8: txt8$w,
	txt9: txt9$s,
	txt10: txt10$r,
	txt10_beemwork: txt10_beemwork$1,
	txt11: txt11$o,
	txt11_beemwork: txt11_beemwork,
	txt12: txt12$o,
	txt13: txt13$o,
	txt14: txt14$m,
	txt15: txt15$j,
	txt16: txt16$j,
	txt17: txt17$i,
	txt18: txt18$i,
	txt19: txt19$h,
	txt20: txt20$g,
	txt21: txt21$d,
	txt22: txt22$b,
	txt23: txt23$a,
	txt24: txt24$8,
	txt25: txt25$7,
	txt26: txt26$7,
	txt27: txt27$7,
	water_mark_var1: water_mark_var1,
	water_mark_var2: water_mark_var2,
	water_mark_var3: water_mark_var3,
	water_mark_var4: water_mark_var4,
	water_mark_var5: water_mark_var5,
	water_mark_var6: water_mark_var6,
	water_mark_var7: water_mark_var7,
	water_mark_var8: water_mark_var8,
	success_txt: success_txt,
	decryption_incomplete_txt: decryption_incomplete_txt,
	encryption_incomplete_txt: encryption_incomplete_txt,
	txt28: txt28$7,
	txt29: txt29$4,
	txt30: txt30$3,
	txt31: txt31$3,
	txt32: txt32$3,
	txt33: txt33$2,
	txt34: txt34$2,
	txt35: txt35$2,
	txt36: txt36$2,
	txt37: txt37$2,
	txt38: txt38$2,
	txt39: txt39$2,
	txt40: txt40$2,
	txt41: txt41$2,
	txt42: txt42$2,
	txt43: txt43$2,
	txt44: txt44$2,
	txt46: txt46$2,
	base_info: base_info,
	team_safety: team_safety,
	water_mark_var9: water_mark_var9,
	delete_group_tips: delete_group_tips,
	teamMenu: teamMenu,
	docsMenu: docsMenu,
	teamApp_errorPage_tips: teamApp_errorPage_tips,
	teamApp_errorPage_reload: teamApp_errorPage_reload,
	teamApp_moduleNotExist_tips: teamApp_moduleNotExist_tips,
	no_permission_txt1: no_permission_txt1,
	no_permission_txt2: no_permission_txt2,
	introTip: introTip,
	secure_desc_owner: secure_desc_owner,
	secure_desc_user: secure_desc_user,
	creator_can_manage: creator_can_manage,
	creator_can_manage_tips: creator_can_manage_tips,
	filePermissionForNonEnt: filePermissionForNonEnt,
	txt47: txt47$2,
	txt48: txt48$2,
	txt49: txt49$2,
	txt50: txt50$2,
	water_mark_var11: water_mark_var11,
	shareRange_selectButton_title: shareRange_selectButton_title,
	no_transfer_to_nonEntMember: no_transfer_to_nonEntMember,
	set_success: set_success,
	set_failed: set_failed,
	forbid_FileSecure_CoopGroup: forbid_FileSecure_CoopGroup,
	txt45: txt45$2,
	water_mark_var10: water_mark_var10,
	water_mark_var12: water_mark_var12,
	shareRange_status_reclaiming: shareRange_status_reclaiming,
	shareRange_status_done: shareRange_status_done,
	shareRange_selectButton_content: shareRange_selectButton_content,
	teamDocTemplate: teamDocTemplate,
	tabTeamAI: tabTeamAI,
	companyJustAssoc: companyJustAssoc,
	companyJustOutContact: companyJustOutContact,
	companyJustAssocAndOutContact: companyJustAssocAndOutContact,
	groupChat: groupChat,
	teamAI: teamAI,
	publishWikiMenu: publishWikiMenu,
	publishWikiDialog: publishWikiDialog,
	publishWikiCover: publishWikiCover,
	unPublishWikiDialog: unPublishWikiDialog,
	pulishWikiReasonDialog: pulishWikiReasonDialog,
	publishWikiAlertDialog: publishWikiAlertDialog
};

var openSuccess = "Application enabled.";
var closeSuccess = "Application disabled.";
var check = "View";
var openFail = "Failed to enable it. Please try again.";
var closeFail = "Failed to disable it. Please try again.";
var openedApp = "Application enabled.";
var allApp = "All Applications";
var open = "Enable";
var close$1 = "Disable";
var setting$1 = "Settings";
var permissionsOpenTips = "Only the owner and administrator have the permission to enable";
var permissionsRenameTips = "Only the owner and administrator have the permission to rename";
var permissionsCloseTips = "Only the owner and administrator have the permission to disable";
var permissionsCloseDocsTips = "The document application cannot be disabled.";
var createApp = "Create Application";
var createAppDesc = "A management application more suitable for business";
var permissionsCreateTips = "Only the owner and administrator have the permission to create";
var TeamAppManage = {
	openSuccess: openSuccess,
	closeSuccess: closeSuccess,
	check: check,
	openFail: openFail,
	closeFail: closeFail,
	openedApp: openedApp,
	allApp: allApp,
	open: open,
	close: close$1,
	setting: setting$1,
	permissionsOpenTips: permissionsOpenTips,
	permissionsRenameTips: permissionsRenameTips,
	permissionsCloseTips: permissionsCloseTips,
	permissionsCloseDocsTips: permissionsCloseDocsTips,
	createApp: createApp,
	createAppDesc: createAppDesc,
	permissionsCreateTips: permissionsCreateTips
};

var txt0$1d = "Please confirm the folder";
var txt1$14 = "Transfer to";
var txt2$$ = "After the transfer, you will become a member of the folder's editing permissions";
var txt3$X = "You can";
var txt4$R = "Shared with me";
var txt5$L = "Folder found in";
var txt6$E = "Cancel";
var txt7$x = "Confirm";
var preview_MoreMenus_transferfile_aftertransfer2 = "After transfer,";
var preview_MoreMenus_transferfile_aftertransfer3 = "will be notified";
var preview_MoreMenus_transferfile_other = "other side";
var preview_MoreMenus_transferfile_choseowner = "select a contact";
var preview_MoreMenus_Tem_NetWork_Error = "Network anomalies, please try again later";
var TransferConfirm = {
	txt0: txt0$1d,
	txt1: txt1$14,
	txt2: txt2$$,
	txt3: txt3$X,
	txt4: txt4$R,
	txt5: txt5$L,
	txt6: txt6$E,
	txt7: txt7$x,
	preview_MoreMenus_transferfile_aftertransfer2: preview_MoreMenus_transferfile_aftertransfer2,
	preview_MoreMenus_transferfile_aftertransfer3: preview_MoreMenus_transferfile_aftertransfer3,
	preview_MoreMenus_transferfile_other: preview_MoreMenus_transferfile_other,
	preview_MoreMenus_transferfile_choseowner: preview_MoreMenus_transferfile_choseowner,
	preview_MoreMenus_Tem_NetWork_Error: preview_MoreMenus_Tem_NetWork_Error
};

var txt0$1c = "No members can be selected";
var txt1$13 = "Please select a new owner";
var TransferMembers = {
	txt0: txt0$1c,
	txt1: txt1$13
};

var txt0$1b = "After binding the mobile phone, the shared folder can be transferred and the account security can be improved";
var txt1$12 = "Cancel";
var txt2$_ = "Confirm";
var TransferTips = {
	txt0: txt0$1b,
	txt1: txt1$12,
	txt2: txt2$_
};

var txt0$1a = " respectively to:";
var txt1$11 = "etc";
var txt2$Z = "people";
var txt3$W = "Leave a message to the contact";
var txt4$Q = "Cancel";
var txt5$K = "Send";
var txt6$D = "Please enter a message within 100 words";
var ContactLeaveMessage = {
	txt0: txt0$1a,
	txt1: txt1$11,
	txt2: txt2$Z,
	txt3: txt3$W,
	txt4: txt4$Q,
	txt5: txt5$K,
	txt6: txt6$D
};

var helper = "I am WPS Docs assistant";
var message$1 = "Messages";
var usageHelp = "How to Use";
var helpAndAdvise = "Help and Feedback";
var moreSkill = "More Skills";
var advise = "Feedback";
var cancelSuspend = "Unpin Tooltip";
var fixSuspend = "Pin Tooltip";
var corpHelper = "Enterprise Assistant";
var title$n = "WPS Docs";
var emptyTitle = "If you can't find what you want, try searching like this:";
var filter$1 = "Filter";
var cellPicture = "Cell Image";
var sort = "Sort";
var freezeFirstLine = "Freeze Top Row";
var moreUserHelp = "More Help >";
var expend = "Enable Full-Text Comments";
var noExpend = "Disable Full-Text Comments";
var position = "Locate to Full-Text Comments";
var showComment1 = "Enable full-text comments and exchange ideas more freely.";
var showComment2 = "Post full-text comments and exchange ideas more freely.";
var openComment = "After this feature is enabled, people who join the sharing can view and post full-text comments.";
var closeTitle = "Disable Full-Text Comments";
var closeText = "After this feature is disabled, others will not be able to post or view full-text comments.";
var cancel$5 = "Cancel";
var submit$2 = "OK";
var fold = "Hide Full-Text Comments";
var unfold = "Show Full-Text Comments";
var bilibili = "Video Tutorials";
var bilibiliTips = "Enter the bilibili official account of WPS Docs to learn the tips.";
var shortcutKey = "Shortcut keys";
var shortcutWarn = "The 'Shortcut Key Panel' is not supported in tables/applications";
var functionIntro = "Function introduction";
var wpsDocumentEmbedTitle = "Company Assistant";
var springVersionUpdateDetail = "New Visual Upgrade Details";
var webSpringBubble = "Collaboration mode new visual upgrade";
var wpsWebSpringBubble = "WPS Docs new visual upgrade";
var springBubbleKnowMore = "Learn more";
var versionUpdateLog = "Version Update Description";
var recommendQs = "Ask intelligent customer service";
var searchWant = "Search for desired functions";
var FloatBox = {
	helper: helper,
	message: message$1,
	usageHelp: usageHelp,
	helpAndAdvise: helpAndAdvise,
	moreSkill: moreSkill,
	advise: advise,
	cancelSuspend: cancelSuspend,
	fixSuspend: fixSuspend,
	corpHelper: corpHelper,
	title: title$n,
	emptyTitle: emptyTitle,
	filter: filter$1,
	cellPicture: cellPicture,
	sort: sort,
	freezeFirstLine: freezeFirstLine,
	moreUserHelp: moreUserHelp,
	expend: expend,
	noExpend: noExpend,
	position: position,
	showComment1: showComment1,
	showComment2: showComment2,
	openComment: openComment,
	closeTitle: closeTitle,
	closeText: closeText,
	cancel: cancel$5,
	submit: submit$2,
	fold: fold,
	unfold: unfold,
	bilibili: bilibili,
	bilibiliTips: bilibiliTips,
	shortcutKey: shortcutKey,
	shortcutWarn: shortcutWarn,
	functionIntro: functionIntro,
	wpsDocumentEmbedTitle: wpsDocumentEmbedTitle,
	springVersionUpdateDetail: springVersionUpdateDetail,
	webSpringBubble: webSpringBubble,
	wpsWebSpringBubble: wpsWebSpringBubble,
	springBubbleKnowMore: springBubbleKnowMore,
	versionUpdateLog: versionUpdateLog,
	recommendQs: recommendQs,
	searchWant: searchWant
};

var txt0$19 = "Load timed out";
var txt1$10 = "Please confirm whether to allow third-party cookies";
var txt2$Y = "Retry";
var txt3$V = "Loading failed";
var txt4$P = "Go to Full Application";
var txt5$J = "Close Application";
var AppsSidebar = {
	txt0: txt0$19,
	txt1: txt1$10,
	txt2: txt2$Y,
	txt3: txt3$V,
	txt4: txt4$P,
	txt5: txt5$J
};

var inviteAdd$1 = "Add using link";
var inviteRoad = "Invite QQ, WeChat and other friends";
var memberSelect = "Select member";
var deleteContact = "Delete contact";
var inviteSucceedMessage = "Invitation sent successfully";
var deleteContactMessage = "successfully deleted";
var copyLink$2 = "Copy";
var MContactSelector = {
	inviteAdd: inviteAdd$1,
	inviteRoad: inviteRoad,
	memberSelect: memberSelect,
	deleteContact: deleteContact,
	inviteSucceedMessage: inviteSucceedMessage,
	deleteContactMessage: deleteContactMessage,
	copyLink: copyLink$2
};

var txt1$$ = "search results";
var txt2$X = " directory is empty";
var txt3$U = "No more documents";
var txt4$O = "Confirm";
var txt5$I = "Your permission has been taken back by the author";
var txt6$C = "You do not have permission to operate the file";
var txt7$w = "My devices";
var txt8$v = "Please complete the real-name authentication first";
var txt9$r = "Private folder";
var txt10$q = "recent";
var txt11$n = "Star";
var txt12$n = "My Cloud";
var txt13$n = "Shared with me";
var txt0$18 = "Search";
var AppFinder = {
	txt1: txt1$$,
	txt2: txt2$X,
	txt3: txt3$U,
	txt4: txt4$O,
	txt5: txt5$I,
	txt6: txt6$C,
	txt7: txt7$w,
	txt8: txt8$v,
	txt9: txt9$r,
	txt10: txt10$q,
	txt11: txt11$n,
	txt12: txt12$n,
	txt13: txt13$n,
	txt0: txt0$18
};

var txt0$17 = "Please enter the folder password";
var txt1$_ = "Please enter password";
var txt2$W = "Please fill in the password";
var txt3$T = "The password is incorrect";
var txt4$N = "forget password";
var txt5$H = "Cancel";
var txt6$B = "Confirm";
var txt7$v = "The password is incorrect, you can still try today";
var txt8$u = "Times";
var txt9$q = "The password input error reaches the upper limit, please try again tomorrow";
var UnLockSecretFolder = {
	txt0: txt0$17,
	txt1: txt1$_,
	txt2: txt2$W,
	txt3: txt3$T,
	txt4: txt4$N,
	txt5: txt5$H,
	txt6: txt6$B,
	txt7: txt7$v,
	txt8: txt8$u,
	txt9: txt9$q
};

var txt0$16 = "Selected";
var txt1$Z = "items";
var txt2$V = "Save To";
var txt3$S = "Unlock Private Folder";
var txt4$M = "Save As ";
var txt5$G = "Succeeded";
var txt6$A = "Failure";
var txt7$u = "The device directory does not support batch operations";
var txt8$t = "Saving file...Please wait";
var txt9$p = "View";
var txt10$p = "does not support saving to a subfolder. Please select again";
var txt11$m = "It may contain illegal content. Download/save-as not allowed.";
var txt12$m = "Waiting for download/save-as. Try again later.";
var txt13$m = "You do not have the Save As permission for this file.";
var FilesSaveAs = {
	txt0: txt0$16,
	txt1: txt1$Z,
	txt2: txt2$V,
	txt3: txt3$S,
	txt4: txt4$M,
	txt5: txt5$G,
	txt6: txt6$A,
	txt7: txt7$u,
	txt8: txt8$t,
	txt9: txt9$p,
	txt10: txt10$p,
	txt11: txt11$m,
	txt12: txt12$m,
	txt13: txt13$m
};

var txt0$15 = "Enterprise team space capacity is full, please adjust team space settings";
var txt1$Y = " Enterprise team space capacity is full, please notify the super administrator";
var txt2$U = "Adjust space";
var txt3$R = "My enterprise document space is full, please adjust the space setting";
var txt4$L = "My enterprise document space is full, please notify the super administrator";
var txt5$F = "Cancel";
var txt6$z = "Management background";
var CorpTeamSpaceFull = {
	txt0: txt0$15,
	txt1: txt1$Y,
	txt2: txt2$U,
	txt3: txt3$R,
	txt4: txt4$L,
	txt5: txt5$F,
	txt6: txt6$z
};

var help = "The update adds a new file to the original folder of the team and does not overwrite the data of the original file.";
var success$3 = "Team updated successfully.";
var error$2 = {
	"40000105": "The team update failed because the space is full.",
	"40000201": "Update failed. Please try again."
};
var GroupTemplateUpdateInfo = {
	help: help,
	success: success$3,
	error: error$2
};

var txt0$14 = "Got it";
var TeamGuide = {
	txt0: txt0$14
};

var txt0$13 = "Team settings";
var txt1$X = "Rename";
var txt8$s = "Transfer team";
var txt10$o = "Team members";
var txt11$l = "Settings";
var txt13$l = "Bulk removal";
var txt16$i = "Add contacts";
var txt17$h = "Add contacts";
var txt18$h = "Disband the team";
var txt19$g = "Delete contact";
var txt20$f = "Unshare";
var qrcode_dialog_title = "Team QR code";
var txt10_beemwork = "Team Members";
var DialogTeamFolderSettings = {
	txt0: txt0$13,
	txt1: txt1$X,
	txt8: txt8$s,
	txt10: txt10$o,
	txt11: txt11$l,
	txt13: txt13$l,
	txt16: txt16$i,
	txt17: txt17$h,
	txt18: txt18$h,
	txt19: txt19$g,
	txt20: txt20$f,
	qrcode_dialog_title: qrcode_dialog_title,
	txt10_beemwork: txt10_beemwork
};

var txt0$12 = "Team name";
var txt1$W = "Modify";
var txt2$T = "Member management";
var txt3$Q = "Members";
var txt4$K = "View";
var txt10$n = "Transfer team";
var txt12$l = "Exit the team";
var txt14$l = "After leaving the team, you will no longer be able to access the team";
var txt18$g = "After transferring the team, you will become a team member";
var txt19$f = "Disband the team";
var txt20$e = "After disbanding, the team files will be visible only to you, other members cannot access";
var TeamFolderSettings = {
	txt0: txt0$12,
	txt1: txt1$W,
	txt2: txt2$T,
	txt3: txt3$Q,
	txt4: txt4$K,
	txt10: txt10$n,
	txt12: txt12$l,
	txt14: txt14$l,
	txt18: txt18$g,
	txt19: txt19$f,
	txt20: txt20$e
};

var txt0$11 = "Cancel";
var txt1$V = "Exit";
var txt2$S = "Retest";
var txt3$P = "In the test of conditions for exiting the enterprise:";
var txt4$J = "Meet the conditions for exiting the enterprise:";
var txt5$E = "Not meet the conditions for exiting the enterprise:";
var txt6$y = "You are not the owner of the team";
var txt7$t = "Details ";
var txt8$r = "The account has been bound to a mobile phone number";
var txt9$o = "Bind";
var txt10$m = "has the following effects:";
var txt11$k = "OK";
var txt12$k = "No more access to enterprise teams or enterprise documents";
var txt13$k = "The membership rights obtained by joining the enterprise will be withdrawn";
var txt14$k = "The exit operation cannot be withdrawn. You need to contact the enterprise administrator to rejoin the enterprise ";
var txt15$i = "You are still the owner of the following team. Please transfer or delete the team and check again";
var txt16$h = "You are still owner of the team";
var txt17$g = "The account is not bound to a mobile phone number";
var txt18$f = "Your Enterprise mailbox is now associated with the account.";
var txt19$e = "Your Enterprise mailbox is not associated with the account.";
var LeaveCompany = {
	txt0: txt0$11,
	txt1: txt1$V,
	txt2: txt2$S,
	txt3: txt3$P,
	txt4: txt4$J,
	txt5: txt5$E,
	txt6: txt6$y,
	txt7: txt7$t,
	txt8: txt8$r,
	txt9: txt9$o,
	txt10: txt10$m,
	txt11: txt11$k,
	txt12: txt12$k,
	txt13: txt13$k,
	txt14: txt14$k,
	txt15: txt15$i,
	txt16: txt16$h,
	txt17: txt17$g,
	txt18: txt18$f,
	txt19: txt19$e
};

var txt0$10 = "We need to use your mobile phone number ";
var txt1$U = " is yours.";
var txt2$R = "Please enter verification code";
var txt3$O = "Send";
var txt4$I = "Reacquire";
var txt5$D = "Cancel";
var txt6$x = "OK";
var txt7$s = "Please fill in verification code";
var txt8$q = "Exit enterprise successfully";
var txt9$n = "Verification code error";
var LeaveCompanyPhoneCheck = {
	txt0: txt0$10,
	txt1: txt1$U,
	txt2: txt2$R,
	txt3: txt3$O,
	txt4: txt4$I,
	txt5: txt5$D,
	txt6: txt6$x,
	txt7: txt7$s,
	txt8: txt8$q,
	txt9: txt9$n
};

var txt0$$ = "text watermark";
var txt1$T = "Suitable for personal brand exposure";
var txt3$N = "visitor watermark";
var txt4$H = "Suitable for tracing visitor screenshots to share document content";
var txt5$C = "Effect preview";
var txt6$w = "transparency";
var txt7$r = "hide the watermark from yourself";
var txt8$p = "Cancel";
var txt9$m = "confirm";
var txt11$j = "Click to enter the text, the author's name will be displayed by default";
var txt12$j = "watermark preview";
var txt13$j = "set successfully";
var txt14$j = "Text watermark is on";
var txt15$h = "Text watermark is off";
var txt16$g = "Guest watermark is on";
var txt17$f = "Guest watermark is off";
var txt18$e = "Visitor Watermark Copy";
var txt19$d = "Watermark loading failed, please reset";
var txt20$d = "After others save it, the watermark is retained and cannot be changed";
var txt21$c = "The watermark is set by the source creator and cannot be changed after saving";
var txt22$a = "Please allow viewers to save as";
var txt23$9 = "Please turn on the text watermark first";
var WaterMarkSetting = {
	txt0: txt0$$,
	txt1: txt1$T,
	txt3: txt3$N,
	txt4: txt4$H,
	txt5: txt5$C,
	txt6: txt6$w,
	txt7: txt7$r,
	txt8: txt8$p,
	txt9: txt9$m,
	txt11: txt11$j,
	txt12: txt12$j,
	txt13: txt13$j,
	txt14: txt14$j,
	txt15: txt15$h,
	txt16: txt16$g,
	txt17: txt17$f,
	txt18: txt18$e,
	txt19: txt19$d,
	txt20: txt20$d,
	txt21: txt21$c,
	txt22: txt22$a,
	txt23: txt23$9
};

var label0 = "Please enter the collection title";
var label1 = "Set the information that the other party needs to submit";
var label2 = "Create committer folder";
var label3 = "Set collection deadline";
var label4 = "The received file will be automatically saved in:";
var placeholder = "Such as personal information, xxx registration form, etc.";
var desc$3 = "The received file will be named automatically according to the information of the other party:{0}.doc";
var descEmpty = "No submission information is set. The received file will be uploaded with the original name.";
var button$1 = "Start collecting";
var text0 = "After opening, the corresponding folder will be created and saved according to the information filled in by the submitting party.";
var text1$3 = "Example: Name + mobile phone number";
var text2$2 = "The default collection is long-term effective.";
var titleError = "Please fill in the collection title";
var error$1 = {
	"10001": "There are already members using this folder to initiate collection."
};
var FileCollection = {
	label0: label0,
	label1: label1,
	label2: label2,
	label3: label3,
	label4: label4,
	placeholder: placeholder,
	desc: desc$3,
	descEmpty: descEmpty,
	button: button$1,
	text0: text0,
	text1: text1$3,
	text2: text2$2,
	titleError: titleError,
	error: error$1
};

var title$m = "Folder \"{0}\" has been created.";
var subTitle$1 = "Copy and forward the link below to start collecting files.";
var button = "Copy link";
var copySuccess$1 = "Copy successfully";
var copyError$1 = "Copy failed";
var FileCollectionLink = {
	title: title$m,
	subTitle: subTitle$1,
	button: button,
	copySuccess: copySuccess$1,
	copyError: copyError$1
};

var dialog0 = {
	title: "File Collection",
	content0: "File collection has been initiated. Go to \"File Collection Management\" to view the details.",
	content1: "This folder has been used to initiate file collection. Select another folder.",
	button0: "Cancel",
	button1: "Confirm",
	button2: "Go to File Collection Management"
};
var dialog1 = {
	title: "Create Collection File"
};
var dialog2 = {
	title: "Invite to Fill"
};
var DialogFileCollection = {
	dialog0: dialog0,
	dialog1: dialog1,
	dialog2: dialog2
};

var txt0$_ = "Cancel";
var txt1$S = "OK";
var txt2$Q = "Are you sure you want to prohibit non-enterprise members to access the team files?";
var txt3$M = "Are you sure you want to prohibit non-team members to access the team files?";
var group = "Team";
var companyAsso = "This Company and Affiliated Organizations";
var tips = "Are you sure you want to change to 'Only share with {0} members'? There may be files already shared with others. How do you want to handle it:";
var recall = "Revoke permissions, only {0} members can access";
var retain = "Keep permissions, collaborators can still access";
var retainDesc = "(If you want to revoke permissions by file, go to <span class=\"link\">[Shared File Management]</span> to revoke permissions one by one.)";
var company = "Our company";
var ShareRangeTips = {
	txt0: txt0$_,
	txt1: txt1$S,
	txt2: txt2$Q,
	txt3: txt3$M,
	group: group,
	companyAsso: companyAsso,
	tips: tips,
	recall: recall,
	retain: retain,
	retainDesc: retainDesc,
	company: company
};

var txt0$Z = "Team Purpose";
var txt1$R = "Team creation applications need to be reviewed and approved.";
var txt2$P = "Briefly describe the purpose of the team within 50 words.";
var txt3$L = "Reviewer";
var txt4$G = "When multiple reviewers are added, a team can be created if any one of them approves the application.";
var txt5$B = "Cancel";
var txt6$v = "OK";
var GroupApply = {
	txt0: txt0$Z,
	txt1: txt1$R,
	txt2: txt2$P,
	txt3: txt3$L,
	txt4: txt4$G,
	txt5: txt5$B,
	txt6: txt6$v
};

var txt0$Y = "Teams In Application";
var txt1$Q = "No team in application.";
var txt2$O = "Team Name";
var txt3$K = "Create time";
var txt4$F = "Status";
var txt5$A = "Reviewer";
var txt6$u = "Operating";
var txt7$q = "Undo";
var txt8$o = "Details";
var txt9$l = "Delete";
var txt10$l = "Success";
var txt11$i = "Failed to delete";
var txt12$i = "Application failed details";
var txt13$i = "Team use";
var txt14$i = "Team members";
var txt15$g = "Invited";
var txt16$f = "Approval comments";
var txt17$e = "Processing time";
var txt18$d = "Confirm";
var txt19$c = "Revocation application record";
var txt20$c = "'s application record";
var txt21$b = "Cancel";
var txt22$9 = "Are you sure to cancel";
var txt23$8 = "Pending";
var txt24$7 = "Passed";
var txt25$6 = "Fail";
var txt26$6 = "Delete";
var txt27$6 = "Processed";
var txt28$6 = "Team Name";
var GroupApplyList = {
	txt0: txt0$Y,
	txt1: txt1$Q,
	txt2: txt2$O,
	txt3: txt3$K,
	txt4: txt4$F,
	txt5: txt5$A,
	txt6: txt6$u,
	txt7: txt7$q,
	txt8: txt8$o,
	txt9: txt9$l,
	txt10: txt10$l,
	txt11: txt11$i,
	txt12: txt12$i,
	txt13: txt13$i,
	txt14: txt14$i,
	txt15: txt15$g,
	txt16: txt16$f,
	txt17: txt17$e,
	txt18: txt18$d,
	txt19: txt19$c,
	txt20: txt20$c,
	txt21: txt21$b,
	txt22: txt22$9,
	txt23: txt23$8,
	txt24: txt24$7,
	txt25: txt25$6,
	txt26: txt26$6,
	txt27: txt27$6,
	txt28: txt28$6
};

var txt0$X = "Your application is pending approval.";
var txt1$P = "Copy the link and send it to the reviewer.";
var txt2$N = "Copy Link";
var txt3$J = "View the Team Under Application";
var txt4$E = "Copy successfully";
var txt5$z = "Copy failed";
var GroupApplySuccess = {
	txt0: txt0$X,
	txt1: txt1$P,
	txt2: txt2$N,
	txt3: txt3$J,
	txt4: txt4$E,
	txt5: txt5$z
};

var txt0$W = "Create Team";
var DialogUpToCorpTeam = {
	txt0: txt0$W
};

var txt0$V = "Create Team";
var DialogGroupApply = {
	txt0: txt0$V
};

var txt0$U = "Search for team members";
var txt1$O = "The following members do not join a team. Add them into a team and then you can grant permissions to them.";
var txt2$M = "Select from Member List";
var txt3$I = "The owner has full document operation permission.";
var txt4$D = "Add and Authorize";
var txt5$y = "Add";
var txt6$t = "Custom";
var txt7$p = "You can customize permissions on document viewing, downloading, and editing.";
var txt8$n = "Remove";
var txt9$k = "Permission Name";
var txt10$k = "Delete Permission";
var txt11$h = "Document Permission Settings";
var txt13$h = "Are you sure you want to modify the subfile/subfolder?";
var txt14$h = "This file/folder is not shared to non-team members. Click";
var txt15$f = "to share it to non-team members.";
var txt16$e = "Custom Group Name";
var txt17$d = "Delete Group";
var txt18$c = "Manage Custom Group";
var txt19$b = "The file/folder is shared to non-team members. Click";
var txt20$b = "to view sharing permissions.";
var txt21$a = "View";
var txt22$8 = "Download";
var txt23$7 = "Upload";
var txt24$6 = "Edit";
var txt25$5 = "Share";
var txt26$5 = "Comment";
var txt27$5 = "Delete";
var txt28$5 = "Owner";
var txt29$3 = "Administrator";
var txt30$2 = "Configured successfully. Permissions on all files/folders in the folder have been updated.";
var txt31$2 = "Are you sure you want to modify the subfile/subfolder?";
var txt32$2 = "User permission added successfully";
var txt33$1 = "Added to the team successfully";
var txt34$1 = "Set successfully";
var txt35$1 = "Reset permissions as default";
var txt44$1 = "Permissions";
var txt36$1 = "Have all permissions of the file (folder)";
var txt37$1 = "Team file permissions will be updated to the following permissions. Are you sure you want to reset?";
var txt38$1 = "File (folder) permissions and parent folder permissions will be synchronized and updated to the following permissions. Are you sure you want to reset?";
var txt39$1 = "No data authorized by default";
var txt40$1 = "Reset";
var txt41$1 = "Cancel";
var txt42$1 = "Authorization List";
var txt43$1 = "Reset successfully.";
var txt47$1 = "Permission Settings";
var txt48$1 = "No permission. Contact the administrator.";
var txt49$1 = "You cannot modify/remove your own permissions.";
var txt50$1 = "Copy Content";
var txt51 = "Print";
var txt45$1 = "Viewable";
var txt46$1 = "Editable";
var txt52 = "Have all permissions on the file (folder)";
var txt53 = "download/save as";
var customizeGroupShareTip = "{icon} custom group name [ {share} ] delete group";
var entJoinByLinkDialogTitle = "people who joined via link";
var countOfJoined$1 = "{0} people have joined";
var searchContacts = "Enter username, group or department";
var contacts = "address book";
var teamOwner = "team owner";
var admin = "administrator";
var fileCreator = "file creator";
var teamWhichOwnsFile = "The team the document belongs to";
var assignPermissionDirectly = "Directly specify to add";
var shareContentForExtendedPermission = "The parent directory has enabled link sharing, the permission is [ {permission} ]";
var anyonePermission = "Anyone {0}";
var memberPermission = "Members of this company {0}";
var onlyAssignedPermission = "Specified only by {0}";
var checkoutDetail = "check the details";
var manageable$1 = "manageable";
var membersUnauthorized = "The company administrator has prohibited sharing outside the company, the following {0} people cannot be added:";
var gotIt = "I see";
var assignPermission$1 = "designated authorization";
var unassigned = "not set";
var etc = "wait";
var addOutsideTip = "Please add the user to the team first";
var canNotShareToOutside = "Adding non-team members or groups is not currently supported";
var addFail = "add failed";
var hasSelect = "Selected";
var batchOperation = "Batch operations";
var batchDel = "batch delete";
var setting = "Set as ";
var myGroup = "Group chat";
var uniquePerm = "Exclusive permission for current file";
var addPersonError = "{0}, the following {1} person(s) cannot be added:";
var sharePeopleGroup = "Share with Users and Groups";
var batchSelectMax = "Up to {0} person(s) can be selected or excluded at a time.";
var txt54 = "Can modify file (folder) permissions";
var requestShareOutside = "Application for outsourcing";
var DialogEnterFilePerSetting = {
	txt0: txt0$U,
	txt1: txt1$O,
	txt2: txt2$M,
	txt3: txt3$I,
	txt4: txt4$D,
	txt5: txt5$y,
	txt6: txt6$t,
	txt7: txt7$p,
	txt8: txt8$n,
	txt9: txt9$k,
	txt10: txt10$k,
	txt11: txt11$h,
	txt13: txt13$h,
	txt14: txt14$h,
	txt15: txt15$f,
	txt16: txt16$e,
	txt17: txt17$d,
	txt18: txt18$c,
	txt19: txt19$b,
	txt20: txt20$b,
	txt21: txt21$a,
	txt22: txt22$8,
	txt23: txt23$7,
	txt24: txt24$6,
	txt25: txt25$5,
	txt26: txt26$5,
	txt27: txt27$5,
	txt28: txt28$5,
	txt29: txt29$3,
	txt30: txt30$2,
	txt31: txt31$2,
	txt32: txt32$2,
	txt33: txt33$1,
	txt34: txt34$1,
	txt35: txt35$1,
	txt44: txt44$1,
	txt36: txt36$1,
	txt37: txt37$1,
	txt38: txt38$1,
	txt39: txt39$1,
	txt40: txt40$1,
	txt41: txt41$1,
	txt42: txt42$1,
	txt43: txt43$1,
	txt47: txt47$1,
	txt48: txt48$1,
	txt49: txt49$1,
	txt50: txt50$1,
	txt51: txt51,
	txt45: txt45$1,
	txt46: txt46$1,
	txt52: txt52,
	txt53: txt53,
	customizeGroupShareTip: customizeGroupShareTip,
	entJoinByLinkDialogTitle: entJoinByLinkDialogTitle,
	countOfJoined: countOfJoined$1,
	searchContacts: searchContacts,
	contacts: contacts,
	teamOwner: teamOwner,
	admin: admin,
	fileCreator: fileCreator,
	teamWhichOwnsFile: teamWhichOwnsFile,
	assignPermissionDirectly: assignPermissionDirectly,
	shareContentForExtendedPermission: shareContentForExtendedPermission,
	anyonePermission: anyonePermission,
	memberPermission: memberPermission,
	onlyAssignedPermission: onlyAssignedPermission,
	checkoutDetail: checkoutDetail,
	manageable: manageable$1,
	membersUnauthorized: membersUnauthorized,
	gotIt: gotIt,
	assignPermission: assignPermission$1,
	unassigned: unassigned,
	etc: etc,
	addOutsideTip: addOutsideTip,
	canNotShareToOutside: canNotShareToOutside,
	addFail: addFail,
	hasSelect: hasSelect,
	batchOperation: batchOperation,
	batchDel: batchDel,
	setting: setting,
	myGroup: myGroup,
	uniquePerm: uniquePerm,
	addPersonError: addPersonError,
	sharePeopleGroup: sharePeopleGroup,
	batchSelectMax: batchSelectMax,
	txt54: txt54,
	requestShareOutside: requestShareOutside
};

var txt0$T = "Permission Name";
var txt1$N = "View";
var txt2$L = "Download/ Copy/Save As";
var txt3$H = "Upload";
var txt4$C = "Comment";
var txt5$x = "Create/Rename/ Edit";
var txt6$s = "Share";
var txt7$o = "Move/ Delete";
var txt8$m = "Add permissions";
var txt9$j = "Cancel";
var txt10$j = "OK";
var txt11$g = "Deleted successfully";
var txt12$h = "Permission name created successfully";
var txt13$g = "You can create up to ";
var txt14$g = " permission groups.";
var txt15$e = "Modified successfully";
var txt16$d = "View Only";
var txt17$c = "Viewable";
var txt18$b = "Editable";
var txt19$a = "operation permission has not been defined.";
var txt20$a = " and ";
var txt21$9 = "have the same permission.";
var txt22$7 = "Permission Setting";
var txt23$6 = "This permission will allow team members to change the permission of files or folders.";
var txt24$5 = "Copy Content";
var txt25$4 = "Print";
var txt26$4 = "Edit";
var txt27$4 = "commentable";
var txt28$4 = "manageable";
var txt29$2 = "This permission will allow team members to Share the file or folder in the team.";
var detail = "Details";
var hasPerm = "Own this permission";
var shareGroupFile = "Share Files (Folders) Within the Team";
var groupUser = "Team members";
var outGroupUser = "External users";
var CustomizeFilePerSetting = {
	txt0: txt0$T,
	txt1: txt1$N,
	txt2: txt2$L,
	txt3: txt3$H,
	txt4: txt4$C,
	txt5: txt5$x,
	txt6: txt6$s,
	txt7: txt7$o,
	txt8: txt8$m,
	txt9: txt9$j,
	txt10: txt10$j,
	txt11: txt11$g,
	txt12: txt12$h,
	txt13: txt13$g,
	txt14: txt14$g,
	txt15: txt15$e,
	txt16: txt16$d,
	txt17: txt17$c,
	txt18: txt18$b,
	txt19: txt19$a,
	txt20: txt20$a,
	txt21: txt21$9,
	txt22: txt22$7,
	txt23: txt23$6,
	txt24: txt24$5,
	txt25: txt25$4,
	txt26: txt26$4,
	txt27: txt27$4,
	txt28: txt28$4,
	txt29: txt29$2,
	detail: detail,
	hasPerm: hasPerm,
	shareGroupFile: shareGroupFile,
	groupUser: groupUser,
	outGroupUser: outGroupUser
};

var txt0$S = "Document Permission Settings";
var DialogCustomizeFilePerSetting = {
	txt0: txt0$S
};

var txt0$R = "Permission Name";
var DialogCreateCustomizePermission = {
	txt0: txt0$R
};

var txt0$Q = "After delete[";
var txt1$M = "Cancel";
var txt2$K = "OK";
var txt3$G = "Operation succeeded";
var txt4$B = "Operation failed";
var txt5$w = "You do not have sufficient permissions.";
var txt6$r = "], Has been granted [";
var txt7$n = "] Which of the following permissions replace the members of the permissions?";
var txt8$l = " members";
var txt9$i = "Remove";
var DeleteCustomizePermission = {
	txt0: txt0$Q,
	txt1: txt1$M,
	txt2: txt2$K,
	txt3: txt3$G,
	txt4: txt4$B,
	txt5: txt5$w,
	txt6: txt6$r,
	txt7: txt7$n,
	txt8: txt8$l,
	txt9: txt9$i
};

var txt0$P = "Enter a permission name, such as edit only or delete.";
var txt1$L = "Cancel";
var txt2$J = "OK";
var txt3$F = "Permission names cannot be duplicated.";
var txt4$A = "Permission names can contain up to 8 characters.";
var txt5$v = "Permission name cannot be empty.";
var noManage = "The name is not supported.";
var CreateCustomizePermission = {
	txt0: txt0$P,
	txt1: txt1$L,
	txt2: txt2$J,
	txt3: txt3$F,
	txt4: txt4$A,
	txt5: txt5$v,
	noManage: noManage
};

var txt0$O = "Enter a name for the custom group, such as Management Group.";
var txt1$K = "Cancel";
var txt2$I = "OK";
var txt3$E = "Group names cannot be duplicated.";
var txt4$z = "Group names can contain up to 10 characters.";
var txt5$u = "Group name cannot be empty.";
var txt6$q = "Are you sure you want to delete the group?";
var txt7$m = "After deletion, the group of authorization will be removed.";
var txt8$k = "Delete";
var txt9$h = "New Custom Group";
var txt10$i = "Rename";
var txt11$f = "Delete Group";
var txt12$g = "Member List";
var txt13$f = "Add Member";
var txt14$f = "No data available";
var txt15$d = "No members";
var txt16$c = "Custom Group Name";
var txt17$b = "Rename Custom Group";
var txt18$a = "Added successfully.";
var txt19$9 = "Add failed.";
var txt20$9 = "The name cannot contain invalid characters or special symbols including /:*?\"<>|%&";
var txt21$8 = "Renamed successfully.";
var txt22$6 = "Rename failed. The number of custom groups exceeds the limit.";
var txt23$5 = "Rename failed.";
var txt24$4 = "Created successfully.";
var txt25$3 = "Creation failed. The number of custom groups exceeds the limit.";
var txt26$3 = "Creation failed.";
var txt27$3 = "Deleted successfully";
var txt28$3 = "Failed to delete";
var validateErr = "You can add up to 50 members at a time.";
var CustomizeGroup = {
	txt0: txt0$O,
	txt1: txt1$K,
	txt2: txt2$I,
	txt3: txt3$E,
	txt4: txt4$z,
	txt5: txt5$u,
	txt6: txt6$q,
	txt7: txt7$m,
	txt8: txt8$k,
	txt9: txt9$h,
	txt10: txt10$i,
	txt11: txt11$f,
	txt12: txt12$g,
	txt13: txt13$f,
	txt14: txt14$f,
	txt15: txt15$d,
	txt16: txt16$c,
	txt17: txt17$b,
	txt18: txt18$a,
	txt19: txt19$9,
	txt20: txt20$9,
	txt21: txt21$8,
	txt22: txt22$6,
	txt23: txt23$5,
	txt24: txt24$4,
	txt25: txt25$3,
	txt26: txt26$3,
	txt27: txt27$3,
	txt28: txt28$3,
	validateErr: validateErr
};

var txt0$N = "Save as Enterprise Template";
var txt1$J = "Rename";
var txt2$H = "Choose Use Scope";
var txt3$D = "Cancel";
var txt4$y = "OK";
var txt5$t = "Saved successfully.";
var txt6$p = "Save failed.";
var txt7$l = "View";
var txt8$j = "1. Only select the team where you are the administrator;";
var txt9$g = "2. After the team is selected, only members of the current team can use the template;";
var txt10$h = "Enterprise";
var txt11$e = "Authorized members";
var txt14$e = "Only me";
var txt15$c = "All enterprise members";
var txt16$b = "Only specified users";
var txt12$f = "Select from Contacts";
var txt13$e = "Delete";
var txt17$a = "Shared successfully.";
var txt18$9 = "Failed to share.";
var CompanyTemplateSaving = {
	txt0: txt0$N,
	txt1: txt1$J,
	txt2: txt2$H,
	txt3: txt3$D,
	txt4: txt4$y,
	txt5: txt5$t,
	txt6: txt6$p,
	txt7: txt7$l,
	txt8: txt8$j,
	txt9: txt9$g,
	txt10: txt10$h,
	txt11: txt11$e,
	txt14: txt14$e,
	txt15: txt15$c,
	txt16: txt16$b,
	txt12: txt12$f,
	txt13: txt13$e,
	txt17: txt17$a,
	txt18: txt18$9
};

var txt0$M = "Enterprise Template Settings";
var txt1$I = "How to Use Enterprise Templates?";
var txt2$G = "Local Upload";
var txt3$C = "Update";
var txt4$x = "Rename";
var txt5$s = "Delete";
var txt6$o = "Select File";
var txt7$k = "Upload Cloud File";
var txt8$i = "After the work template is uploaded, you can directly create a new template in \"Enterprise Template\".";
var txt9$f = "Closing the panel will cancel the upload.";
var txt10$g = "View Details";
var txt11$d = "Return";
var txt12$e = "Failed to obtain the template list.";
var txt13$d = "My Work Templates Settings";
var txt14$d = "Invalid file type. Upload forbidden.";
var txt15$b = "After the work template is uploaded, only members of this team can create a new one for use.";
var txt16$a = "You do not have the permission to perform this operation. Contact the enterprise administrator to enable the permission.";
var txt17$9 = "The file may contain prohibited content and has been disabled.";
var txt18$8 = "Updated successfully";
var allUploadSuccess = "Uploaded successfully";
var allUploadFailed = "Upload failed, try again";
var uploadCompleteFailed_first = "Uploaded successfully (Failed ";
var uploadCompleteFailed_second = " )";
var uploading = "Uploading";
var txt19$8 = "Team members can create files based on the uploaded work template.";
var txt20$8 = "Back to Template List";
var txt21$7 = "Upload File";
var CompanyTemplateSetting = {
	txt0: txt0$M,
	txt1: txt1$I,
	txt2: txt2$G,
	txt3: txt3$C,
	txt4: txt4$x,
	txt5: txt5$s,
	txt6: txt6$o,
	txt7: txt7$k,
	txt8: txt8$i,
	txt9: txt9$f,
	txt10: txt10$g,
	txt11: txt11$d,
	txt12: txt12$e,
	txt13: txt13$d,
	txt14: txt14$d,
	txt15: txt15$b,
	txt16: txt16$a,
	txt17: txt17$9,
	txt18: txt18$8,
	allUploadSuccess: allUploadSuccess,
	allUploadFailed: allUploadFailed,
	uploadCompleteFailed_first: uploadCompleteFailed_first,
	uploadCompleteFailed_second: uploadCompleteFailed_second,
	uploading: uploading,
	txt19: txt19$8,
	txt20: txt20$8,
	txt21: txt21$7
};

var txt0$L = "Rename";
var txt1$H = "Cancel";
var txt2$F = "OK";
var txt3$B = "Success";
var txt4$w = "The template name cannot contain illegal characters or special symbols \\/:*?\"<>|";
var txt5$r = "The template name can contain up to 240 characters.";
var txt6$n = "Please enter a file name";
var CompanyTemplateRename = {
	txt0: txt0$L,
	txt1: txt1$H,
	txt2: txt2$F,
	txt3: txt3$B,
	txt4: txt4$w,
	txt5: txt5$r,
	txt6: txt6$n
};

var txt0$K = "You cannot select documents that are not owned by the enterprise.";
var CompanyTemplateUpload = {
	txt0: txt0$K
};

var txt0$J = "Pending Upload";
var txt1$G = "Uploading...";
var txt2$E = "Uploaded successfully.";
var txt3$A = "Upload failed.";
var txt4$v = "Cancel";
var txt5$q = "Cancelled";
var CompanyTemplateUploadDetail = {
	txt0: txt0$J,
	txt1: txt1$G,
	txt2: txt2$E,
	txt3: txt3$A,
	txt4: txt4$v,
	txt5: txt5$q
};

var txt0$I = "Delete";
var txt1$F = "After the deletion is confirmed, the template cannot be viewed in Enterprise Template and cannot be recovered.";
var txt2$D = "Delete";
var txt3$z = "Cancel";
var txt4$u = "Deleted successfully.";
var txt5$p = "Delete failed.";
var CompanyTemplateDelete = {
	txt0: txt0$I,
	txt1: txt1$F,
	txt2: txt2$D,
	txt3: txt3$z,
	txt4: txt4$u,
	txt5: txt5$p
};

var error = {
	"0": "Unknown error.",
	"40000001": "Low enterprise space. Contact the admin for space expansion.",
	"40010003": "You do not have the permission to perform this operation. Select again.",
	"40010004": "The team does not exist.",
	"40010005": "The file does not exist.",
	"40010006": "You do not have enough permissions to perform this operation. Contact the team administrator for permissions.",
	"40010100": "The enterprise template does not exist. Select another template.",
	"40010102": "The file name already exists.",
	"40010103": "Contains sensitive words.",
	"40010104": "The file may contain prohibited content and has been disabled.",
	"40010300": "You do not have the permission to perform this operation. Contact the enterprise administrator to enable the permission.",
	"40010301": "You do not have enough permissions to perform this operation. Contact the team administrator for permissions.",
	"40010400": "Frequent operations. Try again later.",
	"40010502": "Size limit for a single file is 100 MB",
	"40020009": "The enterprise prohibits this IP from performing this operation on this file (folder).",
	"40020010": "The enterprise prohibits this IP from saving files to \"{0}\".",
	"40020011": "This IP only allows files to be saved to the enterprise space.",
	permissionDenied: "You do not have the permission to perform this operation. Contact the enterprise administrator to enable the permission.",
	groupNormalSpacesFull: "Insufficient team space. Contact the administrator to expand the team space.",
	CorpSpaceFull: "Insufficient enterprise space. Contact the administrator to expand the enterprise space.",
	networkError: "Network error. Try again later.",
	corpSpaceFullError: "Insufficient space, upload failed"
};
var CompanyTemplate = {
	error: error
};

var txt0$H = "Download QR code";
var txt1$E = "QR code Sharing";
var txt2$C = "QR code sharing long press to save QR code";
var txt3$y = "Please press and hold to save the QR code after upgrading to the latest version";
var miniCodeShare = "Share WeChat Applet";
var scan = "Scan the QR code to view";
var contextmenuSave = "Right click to download the QR code";
var rightClickSave = "Right click to save the QR code";
var qrCodeTips = "Save the QR code and send it to friends, friends can scan the code to view";
var enterprise$1 = "enterprise";
var wechatScan = "Use mobile phone WeChat to \"scan\" and share documents with friends";
var dingtalkScan = "Use DingTalk on your mobile phone to \"scan\" and send documents to friends";
var qqScan = "Use mobile QQ to \"scan\" and send documents to friends";
var scanGuide = "Scan the code to send the applet with one click";
var saveQrCode = "Save the QR code and send it to your friends or post it to your circle of friends. Friends can scan the code to view it";
var wxqyScan = "Use WeChat Work to \"Scan\" and share documents with colleagues.";
var QrCode = {
	txt0: txt0$H,
	txt1: txt1$E,
	txt2: txt2$C,
	txt3: txt3$y,
	miniCodeShare: miniCodeShare,
	scan: scan,
	contextmenuSave: contextmenuSave,
	rightClickSave: rightClickSave,
	qrCodeTips: qrCodeTips,
	enterprise: enterprise$1,
	wechatScan: wechatScan,
	dingtalkScan: dingtalkScan,
	qqScan: qqScan,
	scanGuide: scanGuide,
	saveQrCode: saveQrCode,
	wxqyScan: wxqyScan
};

var write$6 = "Editable";
var comment$5 = "Commentable";
var read$7 = "Viewable";
var shareTips = "WeChat Friends/Groups Shared by Me Only";
var copyTipsTxt = "Mobile phone not around？";
var copyHandleTxt = "Copy link";
var copySuccessText = "Copy successfully";
var receiveMessage = "Receive file message notifications";
var followOfficial = "Follow us on WeChat";
var receiveNotification = "Don't miss important information notifications";
var receiveFileMsg = "Receive file notification";
var MiniCode = {
	write: write$6,
	comment: comment$5,
	read: read$7,
	shareTips: shareTips,
	copyTipsTxt: copyTipsTxt,
	copyHandleTxt: copyHandleTxt,
	copySuccessText: copySuccessText,
	receiveMessage: receiveMessage,
	followOfficial: followOfficial,
	receiveNotification: receiveNotification,
	receiveFileMsg: receiveFileMsg
};

var txt0$G = "Recommended";
var TeamFileRecommend = {
	txt0: txt0$G
};

var txt0$F = "Failed to create the file.";
var txt1$D = "File created successfully.";
var txt2$B = "Previous Chapter";
var txt3$x = "Next Chapter";
var txt4$t = "Teaching Guide";
var txt5$o = "Failed to get the status.";
var txt6$m = "Failed to save the status.";
var txt7$j = "Network error. Try again later.";
var TeamFileTop = {
	txt0: txt0$F,
	txt1: txt1$D,
	txt2: txt2$B,
	txt3: txt3$x,
	txt4: txt4$t,
	txt5: txt5$o,
	txt6: txt6$m,
	txt7: txt7$j
};

var txt0$E = "Settings";
var txt1$C = "Team Settings";
var txt2$A = "Manage";
var txt3$w = "Shared File";
var txt4$s = "Basic Information";
var txt5$n = "Test Use";
var DialogEntTeamFuncManage = {
	txt0: txt0$E,
	txt1: txt1$C,
	txt2: txt2$A,
	txt3: txt3$w,
	txt4: txt4$s,
	txt5: txt5$n
};

var txt0$D = "Search filename or share creator";
var txt1$B = "Select All";
var txt2$z = "Filter";
var txt3$v = "Selected ";
var txt4$r = "item(s)";
var txt5$m = "Share Link";
var txt6$l = "Creator:";
var txt7$i = "Link Address:";
var txt8$h = "Link Permission:";
var txt9$e = "Validity Period:";
var txt10$f = "Number of Visitors:";
var txt11$c = "Number of Downloads:";
var txt12$d = "Access Without Sign-in";
var txt13$c = "Modify Link Permission";
var txt14$c = "Modify Validity Period";
var txt15$a = "Disable Access Without Sign-in";
var txt16$9 = "Cancel Sharing";
var txt17$8 = "No files containing \"";
var txt18$7 = "\" were found.";
var txt19$7 = "Search timed out.";
var txt20$7 = "Please try again.";
var txt21$6 = "Confirm to cancel sharing the specified ";
var txt22$5 = " file(s)/folder(s)";
var txt23$4 = "Confirm to disable the Access Without Sign-in feature for the specified ";
var txt24$3 = " file(s)/folder(s)";
var txt25$2 = "Cancel";
var txt26$2 = "Confirm";
var txt27$2 = "No relevant files found.";
var txt28$2 = "Operation succeeded.";
var txt29$1 = "Valid forever";
var txt30$1 = "Valid for 30 days";
var txt31$1 = "Valid for 7 days";
var txt32$1 = "Expire in {number} days";
var txt33 = "Expire today";
var txt34 = "The current package only supports ";
var txt35 = " day(s)";
var txt36 = "If it is necessary, ";
var txt37 = "after the package is upgraded, you can ";
var txt38 = "process authorization upgrade ";
var txt39 = "Set by";
var txt40 = "as";
var txt41 = "Enable Access Without Sign-in";
var txt42 = "Recent ";
var txt43 = "Earlier Files ";
var txt44 = "Please contact ";
var txt45 = "Expired";
var txt46 = "Valid";
var txt47 = "Sharing Management";
var closed = "Closed";
var noLogin = "Access Without Sign-in ";
var update = "Go for Upgrade";
var updateServices = "Upgrade Package ";
var view = "View ";
var search$1 = "Search ";
var download = "Download ";
var today = "Today";
var yesterday = "Yesterday";
var shareTimeByDesc = "New Sharing First";
var shareTimeByAsc = "Old Sharing First";
var anyone$1 = "Anyone ";
var theCompany = "This Enterprise ";
var theSomeone = "Specified Person ";
var companyAdmin = "Enterprise Administrator ";
var superAdmin = "Super Administrator ";
var wpsPD = "WPS Project Manager ";
var closeNoLogin = "The Access Without Sign-in feature is disabled.";
var viewShareDetail = "View Details";
var read$6 = "Viewable";
var write$5 = "Editable";
var txt48 = "or";
var applyOrderAdmin = "Apply to be an order manager";
var txt49 = "View the list of files shared by the enterprise";
var txt50 = "View>>";
var theSomeone2 = "Only specified users can access";
var EntShareManage = {
	txt0: txt0$D,
	txt1: txt1$B,
	txt2: txt2$z,
	txt3: txt3$v,
	txt4: txt4$r,
	txt5: txt5$m,
	txt6: txt6$l,
	txt7: txt7$i,
	txt8: txt8$h,
	txt9: txt9$e,
	txt10: txt10$f,
	txt11: txt11$c,
	txt12: txt12$d,
	txt13: txt13$c,
	txt14: txt14$c,
	txt15: txt15$a,
	txt16: txt16$9,
	txt17: txt17$8,
	txt18: txt18$7,
	txt19: txt19$7,
	txt20: txt20$7,
	txt21: txt21$6,
	txt22: txt22$5,
	txt23: txt23$4,
	txt24: txt24$3,
	txt25: txt25$2,
	txt26: txt26$2,
	txt27: txt27$2,
	txt28: txt28$2,
	txt29: txt29$1,
	txt30: txt30$1,
	txt31: txt31$1,
	txt32: txt32$1,
	txt33: txt33,
	txt34: txt34,
	txt35: txt35,
	txt36: txt36,
	txt37: txt37,
	txt38: txt38,
	txt39: txt39,
	txt40: txt40,
	txt41: txt41,
	txt42: txt42,
	txt43: txt43,
	txt44: txt44,
	txt45: txt45,
	txt46: txt46,
	txt47: txt47,
	closed: closed,
	noLogin: noLogin,
	update: update,
	updateServices: updateServices,
	view: view,
	search: search$1,
	download: download,
	today: today,
	yesterday: yesterday,
	shareTimeByDesc: shareTimeByDesc,
	shareTimeByAsc: shareTimeByAsc,
	anyone: anyone$1,
	theCompany: theCompany,
	theSomeone: theSomeone,
	companyAdmin: companyAdmin,
	superAdmin: superAdmin,
	wpsPD: wpsPD,
	closeNoLogin: closeNoLogin,
	viewShareDetail: viewShareDetail,
	read: read$6,
	write: write$5,
	txt48: txt48,
	applyOrderAdmin: applyOrderAdmin,
	txt49: txt49,
	txt50: txt50,
	theSomeone2: theSomeone2
};

var txt0$C = "File Type";
var txt1$A = "Member";
var txt2$y = "State";
var txt3$u = "Search";
var txt4$q = "Reset";
var txt5$l = "All";
var txt6$k = "Folder";
var txt7$h = "AirPage";
var txt8$g = "AirSheet";
var txt9$d = "Presentation";
var txt10$e = "PDF";
var txt11$b = "Collection Form";
var txt12$c = "Picture";
var txt13$b = "Note";
var txt14$b = "Flowchart";
var txt15$9 = "Mind Map";
var txt16$8 = "Team Member";
var txt17$7 = "Not a team member";
var txt18$6 = "Select Member";
var txt19$6 = "File Creator";
var txt20$6 = "Shared By";
var txt21$5 = "Share expired";
var txt22$4 = "Share not expired";
var txt23$3 = "Unlimited";
var EntFileFilter = {
	txt0: txt0$C,
	txt1: txt1$A,
	txt2: txt2$y,
	txt3: txt3$u,
	txt4: txt4$q,
	txt5: txt5$l,
	txt6: txt6$k,
	txt7: txt7$h,
	txt8: txt8$g,
	txt9: txt9$d,
	txt10: txt10$e,
	txt11: txt11$b,
	txt12: txt12$c,
	txt13: txt13$b,
	txt14: txt14$b,
	txt15: txt15$9,
	txt16: txt16$8,
	txt17: txt17$7,
	txt18: txt18$6,
	txt19: txt19$6,
	txt20: txt20$6,
	txt21: txt21$5,
	txt22: txt22$4,
	txt23: txt23$3
};

var text1$2 = "The access permission for \"{0}\" has been removed. To prevent non-enterprise members from viewing, it is recommended to modify the sharing link to";
var submit$1 = "Modify Now";
var modify = "Sharing range modification reminder";
var nextTime = "Later";
var onlyRead = "Viewable only by members of the enterprise";
var onlyWrite = "Editable only by members of the enterprise";
var modifySuccess = "Sharing range modified successfully.";
var modifyFailed = "Failed to modify the sharing range.";
var ModifyShareScope = {
	text1: text1$2,
	submit: submit$1,
	modify: modify,
	nextTime: nextTime,
	onlyRead: onlyRead,
	onlyWrite: onlyWrite,
	modifySuccess: modifySuccess,
	modifyFailed: modifyFailed
};

var offline = "Remove Access Permission";
var invite$1 = "Invite to Join Enterprise";
var offlineFailed = "Remove failed.";
var offlineSuccess = "Removed successfully.";
var notCompanyMember = "Non-Enterprise Member";
var inviteSuccess = "Invitation sent successfully.";
var inviteFailed = "Invitation failed.";
var inviteError = "Only admins can invite colleagues to join the business";
var CompanyMemberInfoCard = {
	offline: offline,
	invite: invite$1,
	offlineFailed: offlineFailed,
	offlineSuccess: offlineSuccess,
	notCompanyMember: notCompanyMember,
	inviteSuccess: inviteSuccess,
	inviteFailed: inviteFailed,
	inviteError: inviteError
};

var txt1$z = "Purchase ";
var txt2$x = "Support up to ";
var txt3$t = " team(s) .";
var txt4$p = "Support an unlimited number of teams. ";
var txt5$k = "Contact Enterprise Super Administrator ";
var txt6$j = "The current package is ";
var txt7$g = ", Each enterprise only supports ";
var txt8$f = " team(s) ";
var txt9$c = "Any package can enjoy all the corresponding benefits in it. ";
var txt10$d = "Enable Team Watermark ";
var txt11$a = "Set document sharing range control ";
var txt12$b = "Apply to become an \"Order Administrator\"";
var txt13$a = "You can also apply to become an ";
var txt14$a = "\"Order Administrator\"";
var txt15$8 = ", and then upgrade the enterprise package by yourself.";
var txt16$7 = " Upgrade ";
var txt17$6 = "Apply Now >";
var txt18$5 = "You can contact the enterprise super admin (";
var txt19$5 = ") to purchase the enterprise package.";
var txt21$4 = "Not supported";
var txt20$5 = "Got it";
var UpgradePrivilege = {
	txt1: txt1$z,
	txt2: txt2$x,
	txt3: txt3$t,
	txt4: txt4$p,
	txt5: txt5$k,
	txt6: txt6$j,
	txt7: txt7$g,
	txt8: txt8$f,
	txt9: txt9$c,
	txt10: txt10$d,
	txt11: txt11$a,
	txt12: txt12$b,
	txt13: txt13$a,
	txt14: txt14$a,
	txt15: txt15$8,
	txt16: txt16$7,
	txt17: txt17$6,
	txt18: txt18$5,
	txt19: txt19$5,
	txt21: txt21$4,
	txt20: txt20$5
};

var txt0$B = "Cancel";
var txt1$y = "OK";
var txt2$w = "Send Verification Code";
var txt3$s = "Failed to send SMS.";
var txt4$o = "SMS sent successfully.";
var txt5$j = "Enter";
var txt6$i = ". Only letters and digits are allowed.";
var txt7$f = ", up to 8 characters in length";
var txt8$e = ", 11 digits";
var txt9$b = "Enter the verification code";
var txt10$c = "Incorrect verification code.";
var txt11$9 = "Enterprise Name";
var txt12$a = "Your Name";
var txt13$9 = "Your Phone Number";
var txt14$9 = "Verification Code";
var txt15$7 = "Done";
var txt16$6 = "Your operation is not authorized.";
var txt17$5 = "The number of enterprises joined exceeds the limit.";
var txt18$4 = "Operation too frequent. Please try again later.";
var txt19$4 = "Too many verification code requests of this phone number. Try again tomorrow.";
var txt20$4 = "You are not allowed to use prohibited words.";
var txt21$3 = "The number of enterprises that can be created using this phone number has reached the upper limit.";
var txt22$3 = "Incorrect verification code.";
var txt23$2 = "'s team";
var txt24$2 = ", 4 to 30 characters";
var txt25$1 = ", cannot contain special symbols \\/:*?\"<>|";
var txt26$1 = "Thank you for choosing WPS Docs for Enterprise. The following introduces the legal agreements on registration, subscription, and use of this service reached between WPS Office and you and/or the organization you represent.";
var txt27$1 = "Please read";
var txt28$1 = ". By clicking \"Agree\", you agree to the agreement and accept our services.";
var txt29 = "I have read and agree";
var txt30 = "Agree to the service agreement";
var txt31 = "WPS Docs for Enterprise Service Usage Agreement";
var txt32 = "Duplicate enterprise name.";
var CompanyRegister = {
	txt0: txt0$B,
	txt1: txt1$y,
	txt2: txt2$w,
	txt3: txt3$s,
	txt4: txt4$o,
	txt5: txt5$j,
	txt6: txt6$i,
	txt7: txt7$f,
	txt8: txt8$e,
	txt9: txt9$b,
	txt10: txt10$c,
	txt11: txt11$9,
	txt12: txt12$a,
	txt13: txt13$9,
	txt14: txt14$9,
	txt15: txt15$7,
	txt16: txt16$6,
	txt17: txt17$5,
	txt18: txt18$4,
	txt19: txt19$4,
	txt20: txt20$4,
	txt21: txt21$3,
	txt22: txt22$3,
	txt23: txt23$2,
	txt24: txt24$2,
	txt25: txt25$1,
	txt26: txt26$1,
	txt27: txt27$1,
	txt28: txt28$1,
	txt29: txt29,
	txt30: txt30,
	txt31: txt31,
	txt32: txt32
};

var txt0$A = "Enterprise created successfully.";
var txt1$x = "The file has been copied to the enterprise.";
var txt2$v = "Colleagues can join the enterprise and view the files by clicking the link.";
var txt3$r = "Enter Enterprise";
var txt4$n = "Copy File and Share Link";
var txt5$i = "Viewable within Enterprise";
var txt6$h = "Editable within Enterprise";
var txt7$e = "Copied successfully.";
var txt8$d = "Copy failed.";
var CompanyRegisterSuccess = {
	txt0: txt0$A,
	txt1: txt1$x,
	txt2: txt2$v,
	txt3: txt3$r,
	txt4: txt4$n,
	txt5: txt5$i,
	txt6: txt6$h,
	txt7: txt7$e,
	txt8: txt8$d
};

var txt0$z = "Learn Enterprise Index";
var txt1$w = "( points ";
var txt2$u = " than yesterday)";
var txt3$q = "Active Users";
var txt4$m = "Active Teams";
var txt5$h = "Active Documents";
var txt6$g = "Collaborative Office";
var txt7$d = "Organization Management";
var txt8$c = "points";
var txt9$a = "Peer Enterprises (";
var txt10$b = "Current Enterprise (";
var EnterpriseIndexRadar = {
	txt0: txt0$z,
	txt1: txt1$w,
	txt2: txt2$u,
	txt3: txt3$q,
	txt4: txt4$m,
	txt5: txt5$h,
	txt6: txt6$g,
	txt7: txt7$d,
	txt8: txt8$c,
	txt9: txt9$a,
	txt10: txt10$b
};

var txt0$y = "Enterprise Index";
var DialogEnterpriseIndexRadar = {
	txt0: txt0$y
};

var enableFullComment = "Enable Full-Text Comments";
var enableFullCommentTip = "Allow people who join the sharing to view and post full-text comments";
var blockEditApply$2 = "Prohibit applying for editing permission";
var blockEditApplyDesc = "Used for documents published to public.";
var resetLinkText = "Reset Share Link";
var openFullComment = "Open full text comments";
var waterMarkSettingTit = "Set document watermark";
var openWaterMarkStatus = "watermark is on";
var fileWaterMark = "Document watermark";
var transferFileOwner = "Transfer document ownership";
var MShareFileMore = {
	enableFullComment: enableFullComment,
	enableFullCommentTip: enableFullCommentTip,
	blockEditApply: blockEditApply$2,
	blockEditApplyDesc: blockEditApplyDesc,
	resetLinkText: resetLinkText,
	openFullComment: openFullComment,
	waterMarkSettingTit: waterMarkSettingTit,
	openWaterMarkStatus: openWaterMarkStatus,
	fileWaterMark: fileWaterMark,
	transferFileOwner: transferFileOwner
};

var txt0$x = "Visitors are required to use a password for access.";
var txt1$v = "(Password:";
var txt2$t = "Reset Password";
var txt3$p = ")";
var txt4$l = "Copy Link and Password";
var LinkChkCodePerm = {
	txt0: txt0$x,
	txt1: txt1$v,
	txt2: txt2$t,
	txt3: txt3$p,
	txt4: txt4$l
};

var txt0$w = "[Test] Share folders";
var txt1$u = "After this feature is disabled, files opened in the current team will no longer enter the collaborative editing mode by default.";
var txt2$s = "After setup, files opened in the current team will enter the collaborative editing mode by default.";
var title$l = "Open all documents in collaborative editing mode";
var subTitle = "After this feature is enabled, Office documents in the team will be opened in the collaborative editing mode by default.";
var confirm = "Confirm";
var cancel$4 = "Cancel";
var close = "Close";
var setup = "Settings";
var success$2 = "Succeed";
var fail = "Fail";
var tryAgain = "Try again later.";
var EntMultiEditConfirm = {
	txt0: txt0$w,
	txt1: txt1$u,
	txt2: txt2$s,
	title: title$l,
	subTitle: subTitle,
	confirm: confirm,
	cancel: cancel$4,
	close: close,
	setup: setup,
	success: success$2,
	fail: fail,
	tryAgain: tryAgain
};

var title$k = "Edit File";
var txt0$v = "The file is shared by others and is viewable only";
var txt1$t = "Learn More";
var txt2$r = "Edit after permission application";
var txt3$o = "Multi-Person Collaboration";
var txt4$k = "Multiple persons collaborate on the same document. Modified content will be updated in real time";
var txt5$g = "Save File As and Edit";
var txt6$f = "Save the shared file as, edit it, and send it back to the other party";
var txt7$c = "Cancel";
var txt8$b = "OK";
var txt9$9 = "You do not have the Save As permission. The author prohibits document Save As";
var txt10$a = "Save As failed. Please try again later";
var txt11$8 = "Enterprise accounts are not supported";
var txt12$9 = "Failed to obtain the file permission. Please try again";
var txt13$8 = "Application failed. The other party has not bound with the public account";
var txt14$8 = "The team space is full";
var txt15$6 = "The space is full";
var needCertification = "For the safety of the file data, you can only enable edit\nafter verification on the mobile phone.";
var SubText = "Files shared by others support only";
var SubTextRead = "can view only";
var SubTextComment = "can view and comment";
var optionComment = "Apply for comment permission";
var optionCommentSubText = "Can view and comment only";
var applyPermission$1 = "Apply for Permission";
var shareFile = "files, ";
var shareFileAll = "files, ";
var blockEditApply$1 = "The author has prohibited applying for editing permission.";
var txt16$5 = "current file";
var txt17$4 = "Towards";
var txt18$3 = "request for access";
var txt19$3 = "fail";
var txt20$3 = "You can";
var SaveAndEdit = {
	title: title$k,
	txt0: txt0$v,
	txt1: txt1$t,
	txt2: txt2$r,
	txt3: txt3$o,
	txt4: txt4$k,
	txt5: txt5$g,
	txt6: txt6$f,
	txt7: txt7$c,
	txt8: txt8$b,
	txt9: txt9$9,
	txt10: txt10$a,
	txt11: txt11$8,
	txt12: txt12$9,
	txt13: txt13$8,
	txt14: txt14$8,
	txt15: txt15$6,
	needCertification: needCertification,
	SubText: SubText,
	SubTextRead: SubTextRead,
	SubTextComment: SubTextComment,
	optionComment: optionComment,
	optionCommentSubText: optionCommentSubText,
	applyPermission: applyPermission$1,
	shareFile: shareFile,
	shareFileAll: shareFileAll,
	blockEditApply: blockEditApply$1,
	txt16: txt16$5,
	txt17: txt17$4,
	txt18: txt18$3,
	txt19: txt19$3,
	txt20: txt20$3
};

var title$j = "Apply for Editing Permission";
var txt0$u = "Notified the other party";
var txt1$s = "Scan the QR code with WeChat and follow the WPS Docs public account.";
var txt2$q = "You will be notified as soon as the application is approved.";
var txt3$n = "After the other party agrees, you can view the notification in the";
var txt4$j = "WPS Docs mini program:";
var txt5$f = "Me -> Messages -> Office and Collaboration";
var txt6$e = "Please follow the";
var txt7$b = "WPS Docs";
var txt8$a = "public account. You will be notified as soon as the application is approved";
var txt9$8 = "Follow the WPS Docs public account. You will be notified as soon as the application is approved";
var txt10$9 = "Long press to save the QR code";
var txt11$7 = "and identify the QR code in WeChat and follow it";
var txt12$8 = "You will receive a message notification after the application is approved.";
var creatorCustomEditSettings = "The creator has customized the application editing method.";
var applyPermission = "Apply for Permission";
var txt13$7 = "Refresh";
var txt14$7 = "notified";
var txt15$5 = "notified";
var txt16$4 = "After the approval, you will receive a message on the official account of WPS Docs";
var txt17$3 = "Copy approval link";
var txt18$2 = "Please follow the official account of \"WPS Docs\"";
var txt19$2 = "Receive notification as soon as your application is approved";
var txt20$2 = "Long press to identify the QR code to follow";
var txt21$2 = "Take a screenshot and use WeChat to scan and follow";
var txt22$2 = "Or copy and search the public account \"WPS Docs\"";
var txt23$1 = "Scan WeChat and follow the official account of \"WPS Docs\"";
var txt24$1 = "Receive notification as soon as your application is approved";
var applyAfterTxt = "You will receive a notification when your application is approved";
var copy = "copy";
var copyLink$1 = "copy Link";
var refreshPage = "refresh ";
var refreshSuc = "Refresh successfully";
var comment$4 = "Comment";
var read$5 = "access";
var write$4 = "edit";
var kdocsName = "WPS Docs";
var copyLinkSuc = "Copy link successfully";
var copySuc = "Copy successfully";
var showDialog = "go to follow";
var followTips1 = "focus on";
var followTips2 = "Kingsoft Documentation Official Account";
var followTips3 = "Receive application results promptly";
var ApplyPermission = {
	title: title$j,
	txt0: txt0$u,
	txt1: txt1$s,
	txt2: txt2$q,
	txt3: txt3$n,
	txt4: txt4$j,
	txt5: txt5$f,
	txt6: txt6$e,
	txt7: txt7$b,
	txt8: txt8$a,
	txt9: txt9$8,
	txt10: txt10$9,
	txt11: txt11$7,
	txt12: txt12$8,
	creatorCustomEditSettings: creatorCustomEditSettings,
	applyPermission: applyPermission,
	txt13: txt13$7,
	txt14: txt14$7,
	txt15: txt15$5,
	txt16: txt16$4,
	txt17: txt17$3,
	txt18: txt18$2,
	txt19: txt19$2,
	txt20: txt20$2,
	txt21: txt21$2,
	txt22: txt22$2,
	txt23: txt23$1,
	txt24: txt24$1,
	applyAfterTxt: applyAfterTxt,
	copy: copy,
	copyLink: copyLink$1,
	refreshPage: refreshPage,
	refreshSuc: refreshSuc,
	comment: comment$4,
	read: read$5,
	write: write$4,
	kdocsName: kdocsName,
	copyLinkSuc: copyLinkSuc,
	copySuc: copySuc,
	showDialog: showDialog,
	followTips1: followTips1,
	followTips2: followTips2,
	followTips3: followTips3
};

var requestError = "Request exception. Please try again later.";
var copy_success = "Copied successfully.";
var copy_fail = "Copy failed.";
var process = {
	txt1: "Permission approval in progress",
	txt2: "The \"Order Administrator\" is reviewing the permission. Purchase and renewal are not available. You may copy the link and send it to",
	txt3: "for approval, or send an approval message as reminder.",
	txt4: "Send Approval Message",
	txt5: "Copy Link",
	txt6: "Sent successfully.",
	txt7: "Messages sent too frequently. Please try again later."
};
var applySuccess = {
	txt1: "Application submitted.",
	txt2: "You may copy the link and send it to",
	txt3: "as a reminder for permission approval.",
	txt4: "Copy Link"
};
var OrderAdminApplyment = {
	requestError: requestError,
	copy_success: copy_success,
	copy_fail: copy_fail,
	process: process,
	applySuccess: applySuccess
};

var next$1 = "Next";
var FlashPopover = {
	next: next$1
};

var txt0$t = "Claimed successfully.";
var txt1$r = "You've claimed it already.";
var txt2$p = "The current enterprise has purchased package benefits, so it cannot claim any task rewards.";
var txt3$m = "Operation too frequent. Please try again later.";
var txt4$i = "Enterprise Beginner Task";
var NewbieTask = {
	txt0: txt0$t,
	txt1: txt1$r,
	txt2: txt2$p,
	txt3: txt3$m,
	txt4: txt4$i
};

var txt0$s = "Enter the team name.";
var txt1$q = "The team you may want to create";
var txt2$o = "Create";
var txt3$l = "The name cannot contain invalid characters or special symbols /\\;:*?\"<>|%&";
var txt4$h = "Failed to create the team.";
var txt5$e = "Team created successfully.";
var CreateGroupTask = {
	txt0: txt0$s,
	txt1: txt1$q,
	txt2: txt2$o,
	txt3: txt3$l,
	txt4: txt4$h,
	txt5: txt5$e
};

var title$i = "Invite member";
var txt0$r = "Share links to invite more members to join the enterprise for collaboration and sharing";
var txt1$p = "Scan the QR code to send the invitation to colleagues";
var txt2$n = "Copy link and invite colleagues";
var txt3$k = "Failed to get the invitation information.";
var txt4$g = "Copied link successfully.";
var txt5$d = "Copy failed.";
var txt6$d = "You are invited to join [";
var txt7$a = "] to collaborate on documents";
var no_invite_link_tip = "Tips: Currently, you cannot obtain the invitation link to join the company. Please contact the company administrator.";
var InviteTask = {
	title: title$i,
	txt0: txt0$r,
	txt1: txt1$p,
	txt2: txt2$n,
	txt3: txt3$k,
	txt4: txt4$g,
	txt5: txt5$d,
	txt6: txt6$d,
	txt7: txt7$a,
	no_invite_link_tip: no_invite_link_tip
};

var txt0$q = "I have work documents";
var txt1$o = "Upload from Personal Documents";
var txt2$m = "Local Upload";
var txt3$j = "The document is in the hands of a colleague";
var txt4$f = "Scan the QR code to send the invitation to colleagues";
var txt5$c = "Copy the link to invite others to upload the document";
var txt6$c = "Failed to get the invitation information.";
var txt7$9 = "Copied successfully.";
var txt8$9 = "Copy failed.";
var txt9$7 = "Failed to get the path.";
var txt10$8 = "Failed to get the team ID.";
var txt11$6 = "Select a storage path.";
var txt12$7 = "Select the file (folder) to be moved.";
var UploadFileTask = {
	txt0: txt0$q,
	txt1: txt1$o,
	txt2: txt2$m,
	txt3: txt3$j,
	txt4: txt4$f,
	txt5: txt5$c,
	txt6: txt6$c,
	txt7: txt7$9,
	txt8: txt8$9,
	txt9: txt9$7,
	txt10: txt10$8,
	txt11: txt11$6,
	txt12: txt12$7
};

var txt0$p = "Select the template.";
var txt1$n = "Claimed successfully.";
var txt2$l = "Claim failed.";
var txt3$i = "Selected {0}/{1}";
var DialogGetTemplates = {
	txt0: txt0$p,
	txt1: txt1$n,
	txt2: txt2$l,
	txt3: txt3$i
};

var txt0$o = "Note";
var txt1$m = "Copy Link";
var txt2$k = "Got it";
var txt3$h = "WPS Docs cannot ensure the security of this type of file. Pay attention to device safety. If you still want to download it";
var txt4$e = ", copy the download link and visit.";
var txt5$b = "Copy Link";
var txt6$b = "Got it";
var txt7$8 = "Copied successfully.";
var txt8$8 = "Copy failed.";
var txt9$6 = "Auto copy is not supported in your browser. Press {0} + C to copy the content of the input box below.";
var txt10$7 = "File Download";
var KRiskyDownloadTips = {
	txt0: txt0$o,
	txt1: txt1$m,
	txt2: txt2$k,
	txt3: txt3$h,
	txt4: txt4$e,
	txt5: txt5$b,
	txt6: txt6$b,
	txt7: txt7$8,
	txt8: txt8$8,
	txt9: txt9$6,
	txt10: txt10$7
};

var next = "Next";
var end = "Got it";
var StepGuidePopover = {
	next: next,
	end: end
};

var title$h = "Tags";
var create_title = "Create Label";
var empty$2 = "No tags available.";
var empty_tips = "After adding a tag, you can view and manage it in \"Home - Tags\".";
var help_tips = "The tagged file will be displayed in \"Home - Tags\".";
var remove_tips = "Are you sure you want to delete the tag? The file will not be affected after deletion. Only the corresponding tags will be deleted.";
var file_list_empty_1 = "The tagged file will be displayed here.";
var file_list_empty_2 = "You can right click the file name and then click \"Add Tag\" in the menu that appears.";
var favor_label = "\"Common\" is displayed as a tag";
var constant_FAVOR = "Frequently Used";
var rename = "Rename";
var network_error = "Network exception";
var errors_invalidObjPerm = "Permission denied";
var emoji_history_title = "Recently used";
var emoji_article = "Product";
var emoji_recreation = "Amusement";
var emoji_culture = "Culture";
var emoji_people = "Person";
var emoji_animal = "Animal";
var emoji_food = "Food";
var emoji_nature = "Nature";
var emoji_facilities = "Facility";
var emoji_symbol = "Other icon";
var file_label_pending = "To be processed";
var file_label_quick_assess = "Quick access";
var FileLabel = {
	title: title$h,
	create_title: create_title,
	empty: empty$2,
	empty_tips: empty_tips,
	help_tips: help_tips,
	remove_tips: remove_tips,
	file_list_empty_1: file_list_empty_1,
	file_list_empty_2: file_list_empty_2,
	"delete": "Delete Tag",
	favor_label: favor_label,
	constant_FAVOR: constant_FAVOR,
	rename: rename,
	network_error: network_error,
	errors_invalidObjPerm: errors_invalidObjPerm,
	emoji_history_title: emoji_history_title,
	emoji_article: emoji_article,
	emoji_recreation: emoji_recreation,
	emoji_culture: emoji_culture,
	emoji_people: emoji_people,
	emoji_animal: emoji_animal,
	emoji_food: emoji_food,
	emoji_nature: emoji_nature,
	emoji_facilities: emoji_facilities,
	emoji_symbol: emoji_symbol,
	file_label_pending: file_label_pending,
	file_label_quick_assess: file_label_quick_assess
};

var mentioned = "My Mentioned";
var mention = "My Mentioning";
var done = "Completed";
var markFinish = "Marked as completed.";
var removeMark = "Tag removed.";
var undoFinished = "Canceled.";
var markFail = "Marking failed. Try again.";
var removeMarkFail = "Failed to remove the mark. Try again.";
var listLoadError = "Failed to load the list. Try again.";
var refresh2 = "Refresh Now";
var at = "Mention";
var loading$2 = "Loading";
var allMarkTip = "Marked All as Completed.";
var emptyTip01 = "All mentioning records completed.";
var emptyTip02 = "No new mentioning.";
var emptyTip03 = "No records of mentioning others.";
var emptyTip04 = "Type \"@\" in the document to mention others.";
var emptyTip05 = "in";
var emptyTip06 = "The marked are displayed here.";
var emptyTip07 = "The completed mentioning records will be displayed here.";
var mobileTitle = "WPS Docs";
var undo = "Undo";
var refresh = "Refresh";
var from = " is from";
var noMore = "No more";
var loadError = "Loading failed";
var me = "Me";
var InBox = {
	mentioned: mentioned,
	mention: mention,
	done: done,
	markFinish: markFinish,
	removeMark: removeMark,
	undoFinished: undoFinished,
	markFail: markFail,
	removeMarkFail: removeMarkFail,
	listLoadError: listLoadError,
	refresh2: refresh2,
	at: at,
	loading: loading$2,
	allMarkTip: allMarkTip,
	emptyTip01: emptyTip01,
	emptyTip02: emptyTip02,
	emptyTip03: emptyTip03,
	emptyTip04: emptyTip04,
	emptyTip05: emptyTip05,
	emptyTip06: emptyTip06,
	emptyTip07: emptyTip07,
	mobileTitle: mobileTitle,
	undo: undo,
	refresh: refresh,
	from: from,
	noMore: noMore,
	loadError: loadError,
	me: me
};

var txt0$n = "You can invite friends to edit the document together through \"Share\", and update and save it in real time.";
var txt1$l = "Got it";
var ShareTips = {
	txt0: txt0$n,
	txt1: txt1$l
};

var txt0$m = "Tags Visible to Team";
var txt1$k = "Manage Tag";
var txt2$j = "The tag already exists.";
var txt3$g = "Delete Tag";
var txt4$d = "Select, search, or create tags";
var txt5$a = "The tag text is too long.";
var txt6$a = "Save";
var txt7$7 = "No team tag for this file.";
var txt8$7 = "No selectable tag.";
var txt9$5 = "No matching tag. You can press Enter to create one.";
var txt10$6 = "Show All Tags";
var txt12$6 = "Search tags";
var txt13$6 = "The tag name is too long.";
var txt14$6 = "The tag name cannot be empty.";
var txt17$2 = "No search results.";
var txt18$1 = "Are you sure you want to delete \"{0}\"? When deleted, the tag will be removed from all files.";
var txt19$1 = "Unsaved content detected. Are you sure you want to exit?";
var txt11$5 = "Failed to add it.";
var txt15$4 = "Delete ";
var txt16$3 = "Cancel";
var txt20$1 = "Note";
var txt21$1 = "OK";
var txt22$1 = "Rename";
var GroupLabelManager = {
	txt0: txt0$m,
	txt1: txt1$k,
	txt2: txt2$j,
	txt3: txt3$g,
	txt4: txt4$d,
	txt5: txt5$a,
	txt6: txt6$a,
	txt7: txt7$7,
	txt8: txt8$7,
	txt9: txt9$5,
	txt10: txt10$6,
	txt12: txt12$6,
	txt13: txt13$6,
	txt14: txt14$6,
	txt17: txt17$2,
	txt18: txt18$1,
	txt19: txt19$1,
	txt11: txt11$5,
	txt15: txt15$4,
	txt16: txt16$3,
	txt20: txt20$1,
	txt21: txt21$1,
	txt22: txt22$1
};

var title$g = "Purchase Enterprise Package";
var buyPkg = "Purchase Package";
var sample = "Feature Use Case";
var groupAuth = {
	txt1: "Authorization by user group",
	txt2: "The benefits of authorization by user group will be expired after",
	txt3: " day(s). After expiration, authorization by customization/department will not be available.",
	txt4: "Go to"
};
var customRight = {
	txt1: "to set file permission customization",
	txt2: "The benefits of file permissions customization will be expired after",
	txt3: " day(s). After expiration, the customized team document permissions will not be available.",
	txt4: ", go to"
};
var Privilege = {
	title: title$g,
	buyPkg: buyPkg,
	sample: sample,
	groupAuth: groupAuth,
	customRight: customRight,
	"private": {
	txt1: "The features and services purchased have exceeded the maximum quantity. Please contact",
	txt2: "WPS Project Manager",
	txt3: "Super Administrator",
	txt4: "process authorization upgrade",
	txt5: "Upgrade Package"
}
};

var setDocPermTxt = "Set Document Access Permission";
var setFullTextCommentxt = "Set Full-text Comment";
var transformFileOwnerTxt = "Transfer Document Ownership";
var blockEditApply = "Prohibit applying for editing permission.";
var blockEditApplyTip = "When enabled, people who join the sharing will not be able to apply for the permission.";
var ShareFileAdvanceSettings = {
	setDocPermTxt: setDocPermTxt,
	setFullTextCommentxt: setFullTextCommentxt,
	transformFileOwnerTxt: transformFileOwnerTxt,
	blockEditApply: blockEditApply,
	blockEditApplyTip: blockEditApplyTip
};

var title$f = "Benefit Expiration Notification";
var tipPrefix = "Your subscription to \"{0}\" has expired";
var tipText = ". If the following features are used, the management and protection will be invalid after";
var tipDays = "{0} day(s).";
var feature1$2 = "Team settings include multiple features such as watermark, encryption protection, and sharing range control.";
var feature2$2 = "Global settings include mobile control, watermark, sharing range control, and IP access control.";
var feature3$2 = "Backend management includes custom roles, hierarchical management, space allocation, contacts visibility, contacts synchronization, and team creation approval.";
var tipEnd = "For the security of the enterprise document data, {0} immediately.";
var kfService = "Need enterprise-exclusive services?";
var kfBtn = "Click to Contact";
var buynew = "Purchase";
var renew = "Renew";
var notnow = "Not now";
var now = "Now";
var confirmText$1 = "Are you sure you want to {0} and give up the management and protection benefits of the paid package?";
var confirmDanger = "After confirmation, you have {0} days to complete it.";
var confirmDangerSuffix = "Otherwise, your will face the following risks:";
var confirmDanger1 = "Security settings such as encryption protection, watermark, sharing range control, and IP access control of enterprise files will be invalid. Core documents are prone to leakage by employees.";
var confirmDanger2 = "Security settings such as the mobile control of enterprise files will become invalid. Digital assets may be transferred.";
var confirmDanger3 = "Admins who customize the administration role in the backend will not be able to access the corresponding menu in the backend, which makes it difficult to increase the management efficiency.";
var confirmEnd = "I am aware of the above risks and have decided not to ";
var workTime = "Working hours 9:00-18:00";
var ok$2 = "OK";
var cancel$3 = "Cancel";
var operateFail = "Operation failed";
var OutDateService = {
	title: title$f,
	tipPrefix: tipPrefix,
	tipText: tipText,
	tipDays: tipDays,
	feature1: feature1$2,
	feature2: feature2$2,
	feature3: feature3$2,
	tipEnd: tipEnd,
	kfService: kfService,
	kfBtn: kfBtn,
	buynew: buynew,
	renew: renew,
	notnow: notnow,
	now: now,
	confirmText: confirmText$1,
	confirmDanger: confirmDanger,
	confirmDangerSuffix: confirmDangerSuffix,
	confirmDanger1: confirmDanger1,
	confirmDanger2: confirmDanger2,
	confirmDanger3: confirmDanger3,
	confirmEnd: confirmEnd,
	workTime: workTime,
	ok: ok$2,
	cancel: cancel$3,
	operateFail: operateFail
};

var contentIntro1 = "Documents created from";
var contentIntro2 = "support the following cloud features:";
var contentTip1 = "Massive image storage on cloud";
var contentTip2 = "Data change history tracking";
var contentTip3 = "Data referencing among cloud documents";
var recommendWpsOpen = "Continue to open it in WPS Office?";
var exportAs = "Export";
var exportSuccess$1 = "Exported successfully.";
var exportFail = "Export failed.";
var exportProcessing = "File exporting... Please wait.";
var title$e = "Note";
var networkError$1 = "Network exception";
var DialogWPSGuide = {
	contentIntro1: contentIntro1,
	contentIntro2: contentIntro2,
	contentTip1: contentTip1,
	contentTip2: contentTip2,
	contentTip3: contentTip3,
	recommendWpsOpen: recommendWpsOpen,
	exportAs: exportAs,
	exportSuccess: exportSuccess$1,
	exportFail: exportFail,
	exportProcessing: exportProcessing,
	title: title$e,
	networkError: networkError$1
};

var smsValid = "Verify with SMS verification code";
var wxValid = "Verify with WeChat QR code";
var bindPhoneTitle = "Verify phone number";
var qrcodeShowTip = "Open WeChat and scan the QR code for quick verification.";
var finishedTip1 = "Scan completed. Complete the verification on your phone.";
var finishedTip2 = "Scan again. Please";
var successTip1 = "Verification succeeded.";
var finishedTip3 = "Back";
var QrCodeBind = {
	smsValid: smsValid,
	wxValid: wxValid,
	bindPhoneTitle: bindPhoneTitle,
	qrcodeShowTip: qrcodeShowTip,
	finishedTip1: finishedTip1,
	finishedTip2: finishedTip2,
	successTip1: successTip1,
	finishedTip3: finishedTip3
};

var apply_perm = "requests permission to you";
var file_txt = "Document Permissions";
var anyone_txt = "All";
var someone_txt = "Only specified users";
var securetip_head = "This document is encrypted:";
var securetip_txt1 = "The sharing permission is only granted to specified people.";
var perm_comment = " can comment ";
var await_txt = "other";
var person_txt = " person(s)";
var no_member = "None";
var share_setting_perm = "Set permissions for download, print, save-as, etc.";
var share_ksheet_setting_perm = "Set permissions for export, print, save-as, etc.";
var share_other_setting_perm = "Set validity period, etc.";
var has_setting_txt = "Setting completed ";
var count_txt = " items";
var no_modify_txt = "Do not modify";
var open_txt = "Enable";
var modify_change_txt = "Are you sure you want to allow everyone to";
var question_mark = "?";
var expire_change_txt = "The shared link has expired. Enable sharing?";
var no_modify_copy_txt = "The link has been copied. The specified people must request the permission to you.";
var no_modify_apply_txt = "The specified people must request the permission to you.";
var copy_success_edit = "The link has been copied. Now everyone can";
var open_success_edit = "Sharing has been enabled. Now everyone can";
var group_txt_left = "Only \"";
var group_txt_right = "\" members can access";
var del_txt = "People who have joined the sharing will be blocked.";
var perm_change_success = "Permission changed successfully";
var only_self_txt = "Only me";
var switch_link_perm = "Switching permissions. Please wait.";
var copy_title$1 = "WPS Docs";
var copy_txt$1 = "Copied successfully";
var just_txt = "Only";
var member_txt = "Member";
var only_self = "Only oneself";
var securetip_txt2 = "Members authorized in the document can automatically obtain link access permission.";
var perm_read = "Viewable";
var perm_write = "Editable";
var added_members = "People who have joined sharing";
var share_setting = "Sharing settings";
var modify_txt = "Modify";
var cancel_txt = "Cancel";
var primay_txt = "OK";
var coop_txt = "Edit";
var nocoop_txt = "View";
var open_link_success = "Successfully opened the link";
var share_link_expire = "The shared link has expired.";
var share_otl_setting_perm = "Set permissions for export, save as, etc.";
var share_dbt_setting_perm = "Set permissions for export, save as, copy content, etc.";
var personal_share_link_copy = "Copy link";
var total_txt = "common";
var PersonalCoopHasPerm = {
	apply_perm: apply_perm,
	file_txt: file_txt,
	anyone_txt: anyone_txt,
	someone_txt: someone_txt,
	securetip_head: securetip_head,
	securetip_txt1: securetip_txt1,
	perm_comment: perm_comment,
	await_txt: await_txt,
	person_txt: person_txt,
	no_member: no_member,
	share_setting_perm: share_setting_perm,
	share_ksheet_setting_perm: share_ksheet_setting_perm,
	share_other_setting_perm: share_other_setting_perm,
	has_setting_txt: has_setting_txt,
	count_txt: count_txt,
	no_modify_txt: no_modify_txt,
	open_txt: open_txt,
	modify_change_txt: modify_change_txt,
	question_mark: question_mark,
	expire_change_txt: expire_change_txt,
	no_modify_copy_txt: no_modify_copy_txt,
	no_modify_apply_txt: no_modify_apply_txt,
	copy_success_edit: copy_success_edit,
	open_success_edit: open_success_edit,
	group_txt_left: group_txt_left,
	group_txt_right: group_txt_right,
	del_txt: del_txt,
	perm_change_success: perm_change_success,
	only_self_txt: only_self_txt,
	switch_link_perm: switch_link_perm,
	copy_title: copy_title$1,
	copy_txt: copy_txt$1,
	just_txt: just_txt,
	member_txt: member_txt,
	only_self: only_self,
	securetip_txt2: securetip_txt2,
	perm_read: perm_read,
	perm_write: perm_write,
	added_members: added_members,
	share_setting: share_setting,
	modify_txt: modify_txt,
	cancel_txt: cancel_txt,
	primay_txt: primay_txt,
	coop_txt: coop_txt,
	nocoop_txt: nocoop_txt,
	open_link_success: open_link_success,
	share_link_expire: share_link_expire,
	share_otl_setting_perm: share_otl_setting_perm,
	share_dbt_setting_perm: share_dbt_setting_perm,
	personal_share_link_copy: personal_share_link_copy,
	total_txt: total_txt
};

var can_read_txt = "can access";
var creator_txt = "Owner";
var no_share_link_txt = "Sharing is not enabled for the document.";
var no_share_link_txt2 = "Sharing is not enabled for the document.";
var copy_title = "WPS Docs";
var copy_txt = "Copied successfully";
var fname_txt = "File Name";
var encrypter_txt = "Encrypted By";
var file_perm_txt = "File Permissions";
var i_know_txt = "Got it";
var PersonalCoopNoPerm = {
	can_read_txt: can_read_txt,
	creator_txt: creator_txt,
	no_share_link_txt: no_share_link_txt,
	no_share_link_txt2: no_share_link_txt2,
	copy_title: copy_title,
	copy_txt: copy_txt,
	fname_txt: fname_txt,
	encrypter_txt: encrypter_txt,
	file_perm_txt: file_perm_txt,
	i_know_txt: i_know_txt
};

var shareMiniCode$1 = "Send to WeChat friends by applet";
var txt0$l = "Share";
var txt4$c = "QR Code";
var txt2$i = "Unshare";
var perm_setting$1 = "Permission Setting";
var DialogPersonalShareFile = {
	shareMiniCode: shareMiniCode$1,
	txt0: txt0$l,
	txt4: txt4$c,
	txt2: txt2$i,
	perm_setting: perm_setting$1
};

var share_to_txt = "Share to";
var wechat_friend_txt = "WeChat";
var wechat_txt = "WeChat";
var qrcode_txt = "QR code";
var copylink_txt = "Copy";
var changeToOpenShareSucTip = "Link permissions have been adjusted to ";
var dingtalk = "Dingding";
var wework = "WeCom";
var qq_title = "Scan the code and send it to QQ friends";
var dingtalk_title = "Scan the code and send it to DingTalk friends";
var miniShare_title = "Share with {0} WeChat friends via Mini Program";
var enterprise = "enterprise";
var ShareFileChannels = {
	share_to_txt: share_to_txt,
	wechat_friend_txt: wechat_friend_txt,
	wechat_txt: wechat_txt,
	qrcode_txt: qrcode_txt,
	copylink_txt: copylink_txt,
	changeToOpenShareSucTip: changeToOpenShareSucTip,
	dingtalk: dingtalk,
	wework: wework,
	qq_title: qq_title,
	dingtalk_title: dingtalk_title,
	miniShare_title: miniShare_title,
	enterprise: enterprise
};

var txt0$k = "Set Official Document Attribute";
var EntSetPubDocAttr = {
	txt0: txt0$k
};

var txt0$j = "The following files have failed to copy and move";
var txt1$j = "share with me";
var txt2$h = "documents i received";
var txt3$f = "my document";
var txt4$b = "private space";
var txt5$9 = "my cloud documents";
var txt6$9 = "other";
var txt7$6 = "individual team";
var txt8$6 = "corporate team";
var txt9$4 = "Shared folder";
var txt10$5 = "my document";
var CopyMoveFailList = {
	txt0: txt0$j,
	txt1: txt1$j,
	txt2: txt2$h,
	txt3: txt3$f,
	txt4: txt4$b,
	txt5: txt5$9,
	txt6: txt6$9,
	txt7: txt7$6,
	txt8: txt8$6,
	txt9: txt9$4,
	txt10: txt10$5
};

var txt0$i = "Import from another account";
var txt1$i = "The current device is logged in to the following accounts, you can choose from the following accounts";
var txt2$g = "choose";
var txt3$e = "Login has expired";
var txt4$a = "The business is prohibited from transferring the document outside the business";
var MultiAccountSelectList = {
	txt0: txt0$i,
	txt1: txt1$i,
	txt2: txt2$g,
	txt3: txt3$e,
	txt4: txt4$a
};

var txt0$h = "move files";
var txt1$h = "after moving";
var txt2$f = "will no longer keep these files";
var txt3$d = "OK to move";
var txt4$9 = "from";
var txt5$8 = "import in";
var txt6$8 = "Cancel";
var tip$1 = "After moving, {info} may not be moved from the enterprise account. Are you sure you want to move it?";
var subTip = "I have understood the impact of moving files. I confirm to move the file.";
var personalAccount = "Personal Account";
var MultiAccountFileImport = {
	txt0: txt0$h,
	txt1: txt1$h,
	txt2: txt2$f,
	txt3: txt3$d,
	txt4: txt4$9,
	txt5: txt5$8,
	txt6: txt6$8,
	tip: tip$1,
	subTip: subTip,
	personalAccount: personalAccount
};

var txt0$g = "OK";
var txt1$g = "Cancel";
var txt2$e = "The creation of the location is not supported for the time being";
var txt3$c = "A shortcut has been added to";
var txt4$8 = "Add a shortcut to";
var txt5$7 = "The original file (folder) does not exist";
var txt6$7 = "Yes";
var txt7$5 = "no";
var txt8$5 = "Shortcut added successfully";
var txt9$3 = "Check";
var txt10$4 = "Added shortcut to";
var txt11$4 = "Whether to allow members";
var txt12$5 = "document";
var txt13$5 = "edit";
var txt14$5 = "Check";
var CreateShortcut = {
	txt0: txt0$g,
	txt1: txt1$g,
	txt2: txt2$e,
	txt3: txt3$c,
	txt4: txt4$8,
	txt5: txt5$7,
	txt6: txt6$7,
	txt7: txt7$5,
	txt8: txt8$5,
	txt9: txt9$3,
	txt10: txt10$4,
	txt11: txt11$4,
	txt12: txt12$5,
	txt13: txt13$5,
	txt14: txt14$5
};

var yun_views_Avatar0 = "Click to enter the message center";
var yun_views_Avatar1 = "Mini Programs";
var yun_views_Avatar2 = "Load the document into the applet";
var yun_views_Avatar3 = "WeChat scan code experience";
var yun_views_Avatar4 = "Personal Centre";
var yun_views_Avatar5 = "My cloud service";
var yun_views_Avatar6 = "Used:";
var yun_views_Avatar7 = "Create a business";
var yun_views_Avatar8 = "Enable address book for efficient team collaboration";
var yun_views_Avatar11 = "Log Out";
var yun_views_Avatar12 = "Upgrade";
var yun_views_Avatar13 = "Renewal";
var yun_views_Avatar14 = "Corporate Member";
var yun_views_Avatar15 = "Failed to load";
var yun_views_Avatar16 = "Not enough space";
var yun_views_Avatar17 = "Registered user";
var yun_views_Avatar9 = "Management";
var yun_views_Avatar10 = "Feedback";
var yun_views_Avatar18 = "Official Website";
var yun_views_Avatar19 = "Switch Environment";
var yun_views_Avatar20 = "Account";
var yun_views_Avatar21 = "Language";
var yun_views_Avatar_clean = "Clean up";
var yun_views_Avatar_join_member = "Join membership";
var yun_views_Avatar_renew_member = "Renew member";
var yun_views_Avatar_open_member = "Open a super member to enjoy 130+ member privileges";
var yun_views_Avatar_join_yun_time = "Used cloud service for {day} days";
var yun_views_Avatar_account_manage = "Account management";
var yun_views_Avatar_account = "Account:";
var yun_views_Avatar_account_id = "Account ID:";
var yun_views_Avatar_score = "Safety rating:";
var yun_views_Avatar_yun_space = "Cloud space";
var yun_views_Avatar_expired_time = "{type} due: {year}-{month}-{day}";
var yun_views_Avatar_expired_text = "(Expiring soon)";
var yun_views_Avatar_supervip = "Super member";
var yun_views_Avatar_wpsvip = "Member";
var yun_views_Avatar_dockervip = "Husk Member";
var yun_views_Avatar_has = "You already have";
var yun_views_Avatar_expire_has = "Renewal enjoyment";
var yun_views_Avatar_and = "and";
var yun_views_Avatar_supervip_privilege = "130+ Super Member Privileges";
var yun_views_Avatar_wpsvip_privilege = "80+ member privileges";
var yun_views_Avatar_dockervip_privilege = "50+ Template Privileges";
var yun_views_Avatar_upperlimit = "Full";
var yun_views_Avatar_account_id_copySuccess = "Copy successfully";
var yun_views_Avatar_account_id_copyError = "Replication failed";
var yun_views_Avatar_account_expire_date = "Expired on {expiredate}";
var yun_views_Avatar_account_expire_text = "expired";
var yun_views_Avatar_supervip_default = "You have a pending premium order";
var yun_views_Avatar_wpsvip_default = "You have a pending membership order";
var yun_views_Avatar_dockervip_default = "You have a pending order for Rice Husk membership";
var yun_views_Avatar_pay_default = "to pay";
var yun_views_Avatar_company_base = "Enterprise Basic";
var yun_views_Avatar_company_partner = "{name} ({time} expires)";
var yun_views_Avatar_compapy_space_buy = "buy a package";
var yun_views_Avatar_company_space_rebuy = "Renewal";
var yun_views_Avatar_company_space_addbuy = "Purchase additional";
var yun_views_Avatar_company_space = "Corporate space";
var yun_views_Avatar_lougout_title = "Sign out";
var yun_views_Avatar_accountsList_protect = "Ingress upgrade and maintenance";
var yun_views_Avatar_accountsList_idnex0 = "Account switch";
var yun_views_Avatar_accountsList_idnex1 = "Switch account";
var yun_views_Avatar_accountsList_idnex2 = "Account not available";
var yun_views_Avatar_accountsList_idnex3 = "Create a new business account";
var yun_views_Avatar_accountsList_idnex5 = "The account password has expired, you can try";
var yun_views_Avatar_accountsList_idnex6 = "change Password";
var yun_views_Avatar_accountsList_idnex7 = "log back in after";
var yun_views_Avatar_accountsList_idnex8 = "Sign out";
var yun_views_Avatar_accountsList_idnex9 = "Log in to another account";
var yun_views_Avatar_accountsList_idnex10 = "switch failed,";
var yun_views_Avatar_accountsList_idnex11 = "The current device does not support \"Login with other accounts\"";
var yun_views_Avatar_accountsList_idnex12 = "Unverified";
var yun_views_Avatar_accountsList_idnex13 = "The number of currently logged-in accounts has reached the upper limit";
var yun_views_Avatar_Header = "WPS Docs";
var yun_views_Avatar_Header5 = "personal document";
var yun_views_Avatar_ToWelcome0 = "Enter the official website";
var yun_views_Avatar_ToWelcome1 = "The link to the official website of WPS Docs has been copied, go to the browser to open the link to enter";
var yun_views_Avatar_ToWelcome2 = "I see";
var yun_views_Avatar_place_ownership = "IP territory:";
var yun_views_Avatar_expansion = "Expand capacity";
var yun_views_Avatar_enter = "Enter";
var yun_views_Avatar_To_view = "View";
var yun_views_Avatar_check_privilege = "View Privileges";
var yun_views_Avatar_account_expire_date1 = "Expired on {expiredate}";
var yun_views_Avatar_account_expire_date2 = "Expires on {expiredate}";
var yun_views_Avatar_vipPro_default = "You have a pending order for the Super VIP membership.";
var yun_views_Avatar_vipProPlus_default = "You have a pending order for Super VIP Pro.";
var yun_views_Avatar_anyvip_default = "You have a pending payment";
var yun_views_Avatar_accountsList_createCompany_desc = "Accumulate Companies' digital assets";
var yun_views_Avatar_accountsList_mail_list = "Add collaborators for working efficiently";
var yun_views_Avatar_company_package = "Company Package";
var yun_views_Avatar_company_expireTtime = "Expire on";
var yun_views_Avatar_company_expireTtime_tips = "It will automatically renew for one-year free use after the service expires.";
var yun_views_Avatar_company_toVerify = "Go for certification";
var yun_views_Avatar_company_verifiyTip_default = "Complete the company verification for adding the V sign to avoid company name hijacking.";
var yun_views_Avatar_company_isVerify = "Certified";
var yun_views_Avatar_company_unVerify = "Not Certified";
var yun_views_Avatar_company_buy1 = "Purchase Package";
var yun_views_Avatar_company_buy2 = "Add More Members";
var yun_views_Avatar_company_buy3 = "Renew Now";
var AvatarPanel = {
	yun_views_Avatar0: yun_views_Avatar0,
	yun_views_Avatar1: yun_views_Avatar1,
	yun_views_Avatar2: yun_views_Avatar2,
	yun_views_Avatar3: yun_views_Avatar3,
	yun_views_Avatar4: yun_views_Avatar4,
	yun_views_Avatar5: yun_views_Avatar5,
	yun_views_Avatar6: yun_views_Avatar6,
	yun_views_Avatar7: yun_views_Avatar7,
	yun_views_Avatar8: yun_views_Avatar8,
	yun_views_Avatar11: yun_views_Avatar11,
	yun_views_Avatar12: yun_views_Avatar12,
	yun_views_Avatar13: yun_views_Avatar13,
	yun_views_Avatar14: yun_views_Avatar14,
	yun_views_Avatar15: yun_views_Avatar15,
	yun_views_Avatar16: yun_views_Avatar16,
	yun_views_Avatar17: yun_views_Avatar17,
	yun_views_Avatar9: yun_views_Avatar9,
	yun_views_Avatar10: yun_views_Avatar10,
	yun_views_Avatar18: yun_views_Avatar18,
	yun_views_Avatar19: yun_views_Avatar19,
	yun_views_Avatar20: yun_views_Avatar20,
	yun_views_Avatar21: yun_views_Avatar21,
	yun_views_Avatar_clean: yun_views_Avatar_clean,
	yun_views_Avatar_join_member: yun_views_Avatar_join_member,
	yun_views_Avatar_renew_member: yun_views_Avatar_renew_member,
	yun_views_Avatar_open_member: yun_views_Avatar_open_member,
	yun_views_Avatar_join_yun_time: yun_views_Avatar_join_yun_time,
	yun_views_Avatar_account_manage: yun_views_Avatar_account_manage,
	yun_views_Avatar_account: yun_views_Avatar_account,
	yun_views_Avatar_account_id: yun_views_Avatar_account_id,
	yun_views_Avatar_score: yun_views_Avatar_score,
	yun_views_Avatar_yun_space: yun_views_Avatar_yun_space,
	yun_views_Avatar_expired_time: yun_views_Avatar_expired_time,
	yun_views_Avatar_expired_text: yun_views_Avatar_expired_text,
	yun_views_Avatar_supervip: yun_views_Avatar_supervip,
	yun_views_Avatar_wpsvip: yun_views_Avatar_wpsvip,
	yun_views_Avatar_dockervip: yun_views_Avatar_dockervip,
	yun_views_Avatar_has: yun_views_Avatar_has,
	yun_views_Avatar_expire_has: yun_views_Avatar_expire_has,
	yun_views_Avatar_and: yun_views_Avatar_and,
	yun_views_Avatar_supervip_privilege: yun_views_Avatar_supervip_privilege,
	yun_views_Avatar_wpsvip_privilege: yun_views_Avatar_wpsvip_privilege,
	yun_views_Avatar_dockervip_privilege: yun_views_Avatar_dockervip_privilege,
	yun_views_Avatar_upperlimit: yun_views_Avatar_upperlimit,
	yun_views_Avatar_account_id_copySuccess: yun_views_Avatar_account_id_copySuccess,
	yun_views_Avatar_account_id_copyError: yun_views_Avatar_account_id_copyError,
	yun_views_Avatar_account_expire_date: yun_views_Avatar_account_expire_date,
	yun_views_Avatar_account_expire_text: yun_views_Avatar_account_expire_text,
	yun_views_Avatar_supervip_default: yun_views_Avatar_supervip_default,
	yun_views_Avatar_wpsvip_default: yun_views_Avatar_wpsvip_default,
	yun_views_Avatar_dockervip_default: yun_views_Avatar_dockervip_default,
	yun_views_Avatar_pay_default: yun_views_Avatar_pay_default,
	yun_views_Avatar_company_base: yun_views_Avatar_company_base,
	yun_views_Avatar_company_partner: yun_views_Avatar_company_partner,
	yun_views_Avatar_compapy_space_buy: yun_views_Avatar_compapy_space_buy,
	yun_views_Avatar_company_space_rebuy: yun_views_Avatar_company_space_rebuy,
	yun_views_Avatar_company_space_addbuy: yun_views_Avatar_company_space_addbuy,
	yun_views_Avatar_company_space: yun_views_Avatar_company_space,
	yun_views_Avatar_lougout_title: yun_views_Avatar_lougout_title,
	yun_views_Avatar_accountsList_protect: yun_views_Avatar_accountsList_protect,
	yun_views_Avatar_accountsList_idnex0: yun_views_Avatar_accountsList_idnex0,
	yun_views_Avatar_accountsList_idnex1: yun_views_Avatar_accountsList_idnex1,
	yun_views_Avatar_accountsList_idnex2: yun_views_Avatar_accountsList_idnex2,
	yun_views_Avatar_accountsList_idnex3: yun_views_Avatar_accountsList_idnex3,
	yun_views_Avatar_accountsList_idnex5: yun_views_Avatar_accountsList_idnex5,
	yun_views_Avatar_accountsList_idnex6: yun_views_Avatar_accountsList_idnex6,
	yun_views_Avatar_accountsList_idnex7: yun_views_Avatar_accountsList_idnex7,
	yun_views_Avatar_accountsList_idnex8: yun_views_Avatar_accountsList_idnex8,
	yun_views_Avatar_accountsList_idnex9: yun_views_Avatar_accountsList_idnex9,
	yun_views_Avatar_accountsList_idnex10: yun_views_Avatar_accountsList_idnex10,
	yun_views_Avatar_accountsList_idnex11: yun_views_Avatar_accountsList_idnex11,
	yun_views_Avatar_accountsList_idnex12: yun_views_Avatar_accountsList_idnex12,
	yun_views_Avatar_accountsList_idnex13: yun_views_Avatar_accountsList_idnex13,
	yun_views_Avatar_Header: yun_views_Avatar_Header,
	yun_views_Avatar_Header5: yun_views_Avatar_Header5,
	yun_views_Avatar_ToWelcome0: yun_views_Avatar_ToWelcome0,
	yun_views_Avatar_ToWelcome1: yun_views_Avatar_ToWelcome1,
	yun_views_Avatar_ToWelcome2: yun_views_Avatar_ToWelcome2,
	yun_views_Avatar_place_ownership: yun_views_Avatar_place_ownership,
	yun_views_Avatar_expansion: yun_views_Avatar_expansion,
	yun_views_Avatar_enter: yun_views_Avatar_enter,
	yun_views_Avatar_To_view: yun_views_Avatar_To_view,
	yun_views_Avatar_check_privilege: yun_views_Avatar_check_privilege,
	yun_views_Avatar_account_expire_date1: yun_views_Avatar_account_expire_date1,
	yun_views_Avatar_account_expire_date2: yun_views_Avatar_account_expire_date2,
	yun_views_Avatar_vipPro_default: yun_views_Avatar_vipPro_default,
	yun_views_Avatar_vipProPlus_default: yun_views_Avatar_vipProPlus_default,
	yun_views_Avatar_anyvip_default: yun_views_Avatar_anyvip_default,
	yun_views_Avatar_accountsList_createCompany_desc: yun_views_Avatar_accountsList_createCompany_desc,
	yun_views_Avatar_accountsList_mail_list: yun_views_Avatar_accountsList_mail_list,
	yun_views_Avatar_company_package: yun_views_Avatar_company_package,
	yun_views_Avatar_company_expireTtime: yun_views_Avatar_company_expireTtime,
	yun_views_Avatar_company_expireTtime_tips: yun_views_Avatar_company_expireTtime_tips,
	yun_views_Avatar_company_toVerify: yun_views_Avatar_company_toVerify,
	yun_views_Avatar_company_verifiyTip_default: yun_views_Avatar_company_verifiyTip_default,
	yun_views_Avatar_company_isVerify: yun_views_Avatar_company_isVerify,
	yun_views_Avatar_company_unVerify: yun_views_Avatar_company_unVerify,
	yun_views_Avatar_company_buy1: yun_views_Avatar_company_buy1,
	yun_views_Avatar_company_buy2: yun_views_Avatar_company_buy2,
	yun_views_Avatar_company_buy3: yun_views_Avatar_company_buy3
};

var countOfJoined = "People who have joined ({0})";
var quickAction = "Shortcuts";
var removeMemberOutsideCompany = "Remove non-company members";
var removeAll = "remove everyone";
var searchMember = "search user";
var assignPermission = "designated authorization";
var memberInsideCompany = "Member of the company";
var memberOutsideCompany = "Members outside the company";
var justAgo = "Just joined";
var joinHoursAgo = "Joined {0} hours ago";
var joinDaysAgo = "Joined {0} days ago";
var remove = "remove";
var confirmAssignPermission = "Are you sure to grant permission to \"{0}\"【{1}】?";
var confirmAssignPermissionRemark = "After authorization, the user will enter the authorization list on the upper page";
var confirmUpdateSubfilePermission = "Subfolder (folder) modification confirmation";
var updateSubfileSuccessMsg = "The setting is successful, and the permissions of all files (folders) under this folder have been updated synchronously";
var selected$1 = "Selected ({0})";
var batchRemove = "Bulk remove";
var EntJoinByLink = {
	countOfJoined: countOfJoined,
	quickAction: quickAction,
	removeMemberOutsideCompany: removeMemberOutsideCompany,
	removeAll: removeAll,
	searchMember: searchMember,
	assignPermission: assignPermission,
	memberInsideCompany: memberInsideCompany,
	memberOutsideCompany: memberOutsideCompany,
	justAgo: justAgo,
	joinHoursAgo: joinHoursAgo,
	joinDaysAgo: joinDaysAgo,
	remove: remove,
	confirmAssignPermission: confirmAssignPermission,
	confirmAssignPermissionRemark: confirmAssignPermissionRemark,
	confirmUpdateSubfilePermission: confirmUpdateSubfilePermission,
	updateSubfileSuccessMsg: updateSubfileSuccessMsg,
	selected: selected$1,
	batchRemove: batchRemove
};

var morning = "morning";
var afternoon = "afternoon";
var Message = {
	morning: morning,
	afternoon: afternoon
};

var dialogTitle1 = "Manage Team Version Mark";
var dialogTitle2 = "Set Version Mark";
var dialogTex1 = "Only team members can mark a version.";
var dialogTex2 = "A maximum of 20 files can be marked simultaneously.";
var txt6$6 = "Server error.";
var txt12$4 = "Empty tags are not allowed.";
var txt13$4 = "No tags available.";
var txt14$4 = "Tag saved successfully.";
var txt15$3 = "Failed to save the tag.";
var txt16$2 = "Tag deleted successfully.";
var txt17$1 = "Failed to delete the tag.";
var txt101 = "Select, search, or create tags";
var txt102 = "Team Version Mark";
var txt103 = "Manage";
var txt106 = "Server error.";
var txt107 = "Search Results";
var txt111 = "Add Mark";
var txt112 = "Empty tags are not allowed.";
var txt113 = "No matching tags. You can press Enter to create one.";
var txt114 = "No selectable tag.";
var txt116 = "There is already a history version of the document under this version mark. Are you sure you want to modify this mark? After modification, the mark text of the history version will be modified.";
var txt117 = "There is already a history version of the document under this version mark. Are you sure you want to delete this mark? After deletion, the mark of the history version will be deleted.";
var txt120 = "Not now";
var txt122 = "version(s) of the document has/have tags. Batch marking failed.";
var netError = "Server or network error.";
var permissionDefault = "No permission. Contact the admin.";
var txt0$f = "Search";
var txt100 = "Current version";
var txt104 = "Cancel";
var txt105 = "Confirm";
var txt115 = "Note";
var txt118 = "Delete ";
var txt119 = "Modify";
var txt121 = "Saved successfully";
var HistoryVersionLabelManager = {
	dialogTitle1: dialogTitle1,
	dialogTitle2: dialogTitle2,
	dialogTex1: dialogTex1,
	dialogTex2: dialogTex2,
	txt6: txt6$6,
	txt12: txt12$4,
	txt13: txt13$4,
	txt14: txt14$4,
	txt15: txt15$3,
	txt16: txt16$2,
	txt17: txt17$1,
	txt101: txt101,
	txt102: txt102,
	txt103: txt103,
	txt106: txt106,
	txt107: txt107,
	txt111: txt111,
	txt112: txt112,
	txt113: txt113,
	txt114: txt114,
	txt116: txt116,
	txt117: txt117,
	txt120: txt120,
	txt122: txt122,
	netError: netError,
	permissionDefault: permissionDefault,
	txt0: txt0$f,
	txt100: txt100,
	txt104: txt104,
	txt105: txt105,
	txt115: txt115,
	txt118: txt118,
	txt119: txt119,
	txt121: txt121
};

var txt0$e = "No list";
var txt1$f = "Version Tags";
var txt2$d = "No delete permission. Contact the admin.";
var txtDelMark = "Delete Mark";
var txtSave = "Save Version As";
var txtPreview = "Preview ";
var txtDelSuccess = "Deleted successfully";
var txtDelError = "Delete failed.";
var txtConfirmTitle = "Note";
var txtNoSupport = "This type of preview is not currently supported, please save as or download to view";
var noCreatePremission = "No create permission. Contact the admin.";
var VersionTagsList = {
	txt0: txt0$e,
	txt1: txt1$f,
	txt2: txt2$d,
	txtDelMark: txtDelMark,
	txtSave: txtSave,
	txtPreview: txtPreview,
	txtDelSuccess: txtDelSuccess,
	txtDelError: txtDelError,
	txtConfirmTitle: txtConfirmTitle,
	txtNoSupport: txtNoSupport,
	noCreatePremission: noCreatePremission
};

var inviteAdd = "Invite new members to allocate membership rights.";
var inviteBtn = "Copy the invitation link.";
var inviteText1 = "Invite you to join.";
var inviteText2 = "After joining, you can apply for WPS membership privileges.";
var allocationBtn = "Assign WPS member privilege.";
var copySuccess = "Copy successfully";
var copyError = "Copy failed.";
var noticeTitle = "WPS members have been assigned, notify colleagues to enter the enterprise to take effect.";
var noticeLink = "{0}Give you a WPS member，Effective after entering the enterprise\nhttps://www.kdocs.cn/latest";
var noticeCopyBtn = "Copy link notification members";
var noticeTip = "Members of enterprises can continue to be invited to return to the top of the team or \"Management Background-Value-added Center-Equity Distribution\" for allocation.";
var applyError = "Failed to allocate";
var DialogVipAllocation = {
	inviteAdd: inviteAdd,
	inviteBtn: inviteBtn,
	inviteText1: inviteText1,
	inviteText2: inviteText2,
	allocationBtn: allocationBtn,
	copySuccess: copySuccess,
	copyError: copyError,
	noticeTitle: noticeTitle,
	noticeLink: noticeLink,
	noticeCopyBtn: noticeCopyBtn,
	noticeTip: noticeTip,
	applyError: applyError
};

var tips1$1 = "Tips";
var tips2$1 = "Added shortcut to";
var tips3$1 = "Whether to allow members";
var tips4$1 = "document";
var tips5$1 = "Cancel";
var tips6$1 = "allow";
var read$4 = "Check";
var write$3 = "edit";
var comment$3 = "Comment";
var failShare = "no sharing permission";
var AddTeam = {
	tips1: tips1$1,
	tips2: tips2$1,
	tips3: tips3$1,
	tips4: tips4$1,
	tips5: tips5$1,
	tips6: tips6$1,
	read: read$4,
	write: write$3,
	comment: comment$3,
	failShare: failShare
};

var settingTxt$2 = "Set";
var minicodeTxt = "Send to Friends via Applet";
var qrcodeTxt = "QR Code";
var qqScanTxt = "Scan the code and send it to QQ friends";
var shareTxt$1 = "Share";
var settingMenuTxt = "Sharing Settings";
var collsMenuTxt = "Member Management";
var delShareTxt = "Cancel Sharing";
var addContactTxt = "Add Specific Member";
var link404Txt = "The link you want to visit does not exist or has been removed.";
var serverErrTxt = "Server error.";
var linkTimeTxt = "Link Validity Period";
var setLinkTimeTxt = "Set the validity period of document access";
var advanceSettingTxt = "Advanced Settings";
var resetLinkTxt = "Reset Sharing Link";
var selectAllTxt = "Select All";
var linkExpiredTxt = "The document sharing link has expired. Please reselect the validity period.";
var waterSettingTxt = "Document Watermark";
var feedbackTxt = "Feedback";
var addedMemberTxt = "Users who have joined shared";
var delSuccessTxt = "Sharing canceled. Only you can see it.";
var bindPhoneTxt = "Verify Mobile Phone Number";
var userForbiddenTitle = "Reminder for sharing";
var newShareV2 = {
	settingTxt: settingTxt$2,
	minicodeTxt: minicodeTxt,
	qrcodeTxt: qrcodeTxt,
	qqScanTxt: qqScanTxt,
	shareTxt: shareTxt$1,
	settingMenuTxt: settingMenuTxt,
	collsMenuTxt: collsMenuTxt,
	delShareTxt: delShareTxt,
	addContactTxt: addContactTxt,
	link404Txt: link404Txt,
	serverErrTxt: serverErrTxt,
	linkTimeTxt: linkTimeTxt,
	setLinkTimeTxt: setLinkTimeTxt,
	advanceSettingTxt: advanceSettingTxt,
	resetLinkTxt: resetLinkTxt,
	selectAllTxt: selectAllTxt,
	linkExpiredTxt: linkExpiredTxt,
	waterSettingTxt: waterSettingTxt,
	feedbackTxt: feedbackTxt,
	addedMemberTxt: addedMemberTxt,
	delSuccessTxt: delSuccessTxt,
	bindPhoneTxt: bindPhoneTxt,
	userForbiddenTitle: userForbiddenTitle
};

var title$d = "template upload";
var finishTip$1 = "All uploaded";
var closeTip$1 = "Closing the current pop-up window will cancel the file being uploaded";
var scopeName$1 = "Select scope of use";
var scopeTip1$1 = "1. You can only select the team you are the administrator in;";
var scopeTip2$1 = "2. After the team is selected, only current team members can use the template;";
var contactList$1 = "Added using member";
var contactListBtn$1 = "select from address book";
var self$1 = "only me";
var all$1 = "All personnel of the company";
var part$1 = "Select designated person to use";
var templateList$1 = "template content";
var cloudUpload$1 = "Cloud document upload";
var localUpload$1 = "Local Upload";
var ok$1 = "Sure";
var fileTypeError$1 = "Illegal file type, upload prohibited";
var cancel$2 = "Cancel";
var canceled$1 = "Cancelled";
var success$1 = "uploaded successfully";
var failed$1 = "upload failed";
var templateEmpty$1 = "Upload the template file and use it";
var contactListBtnNew$1 = "Address book";
var selectFileTips1$1 = "Selected";
var templateEmptyTips$1 = "No files available";
var uploadBtn$1 = "Select file";
var uploadingBtnText$1 = "Uploading";
var selectFileTips2$1 = "file(s). Are you sure you want to upload as templates?";
var uploadingTips$1 = "Uploading template file";
var uploadFinishTips$1 = "Template file uploaded.";
var uploadButtonText$1 = "Upload Now";
var addFileBtn$1 = "Add File";
var authText$1 = "Template Permissions";
var allNew$1 = "All personnel within the company";
var partNew$1 = "Specified personnel within the company";
var uploadingTitle$1 = "Uploading";
var uploadFinishTitle$1 = "Uploaded.";
var failedSpaceLimit$1 = "Insufficient space, upload failed";
var DialogCompanyTemplateUpload = {
	title: title$d,
	finishTip: finishTip$1,
	closeTip: closeTip$1,
	scopeName: scopeName$1,
	scopeTip1: scopeTip1$1,
	scopeTip2: scopeTip2$1,
	contactList: contactList$1,
	contactListBtn: contactListBtn$1,
	self: self$1,
	all: all$1,
	part: part$1,
	templateList: templateList$1,
	cloudUpload: cloudUpload$1,
	localUpload: localUpload$1,
	ok: ok$1,
	fileTypeError: fileTypeError$1,
	"delete": "delete",
	cancel: cancel$2,
	canceled: canceled$1,
	success: success$1,
	failed: failed$1,
	templateEmpty: templateEmpty$1,
	contactListBtnNew: contactListBtnNew$1,
	selectFileTips1: selectFileTips1$1,
	templateEmptyTips: templateEmptyTips$1,
	uploadBtn: uploadBtn$1,
	uploadingBtnText: uploadingBtnText$1,
	selectFileTips2: selectFileTips2$1,
	uploadingTips: uploadingTips$1,
	uploadFinishTips: uploadFinishTips$1,
	uploadButtonText: uploadButtonText$1,
	addFileBtn: addFileBtn$1,
	authText: authText$1,
	allNew: allNew$1,
	partNew: partNew$1,
	uploadingTitle: uploadingTitle$1,
	uploadFinishTitle: uploadFinishTitle$1,
	failedSpaceLimit: failedSpaceLimit$1
};

var title$c = "Edit Template";
var finishTip = "All uploaded";
var closeTip = "Close the current popup and cancel the uploading files";
var scopeName = "Select usage scope";
var scopeTip1 = "1. Only teams where you are an administrator can be selected;";
var scopeTip2 = "2. After selecting a team, only members of the current team can use this template;";
var contactList = "Added users";
var contactListBtn = "Select from address book";
var contactListBtnNew = "Address book";
var self = "Only myself";
var all = "All employees of this company";
var part = "Select specific individuals to use";
var templateList = "Template content";
var cloudUpload = "Upload from cloud document";
var localUpload = "Upload from local";
var ok = "Confirm";
var fileTypeError = "Invalid file type, uploading is prohibited";
var cancel$1 = "Cancel";
var canceled = "Cancelled";
var success = "Upload successful";
var failed = "Upload failed";
var templateEmpty = "Upload template file to use";
var selectFileTips1 = "Selected";
var selectFileTips2 = "files, please confirm if they are uploaded as templates";
var uploadingTips = "Template file is being uploaded";
var uploadFinishTips = "Template file has been uploaded";
var uploadButtonText = "Upload now";
var templateEmptyTips = "No files available";
var uploadBtn = "Select file";
var addFileBtn = "Add file";
var authText = "Template permissions";
var allNew = "All employees of this company";
var partNew = "Specific individuals of this company";
var uploadingTitle = "Uploading";
var uploadFinishTitle = "Upload complete";
var uploadingBtnText = "Uploading";
var failedSpaceLimit = "Insufficient space, upload failed";
var updateTemplate = "Update template";
var templateName = "Work template name";
var templateNameEmpty = "Template name cannot be empty";
var memberEmpty = "Template permissions cannot be empty";
var editSuccess = "Edit successful";
var editError = "Edit failed";
var team$1 = "Team";
var fileTypeNotPatch = "Please update the corresponding file type";
var useScope = "Usage scope";
var DialogCompanyTemplateEdit = {
	title: title$c,
	finishTip: finishTip,
	closeTip: closeTip,
	scopeName: scopeName,
	scopeTip1: scopeTip1,
	scopeTip2: scopeTip2,
	contactList: contactList,
	contactListBtn: contactListBtn,
	contactListBtnNew: contactListBtnNew,
	self: self,
	all: all,
	part: part,
	templateList: templateList,
	cloudUpload: cloudUpload,
	localUpload: localUpload,
	ok: ok,
	fileTypeError: fileTypeError,
	"delete": "Delete",
	cancel: cancel$1,
	canceled: canceled,
	success: success,
	failed: failed,
	templateEmpty: templateEmpty,
	selectFileTips1: selectFileTips1,
	selectFileTips2: selectFileTips2,
	uploadingTips: uploadingTips,
	uploadFinishTips: uploadFinishTips,
	uploadButtonText: uploadButtonText,
	templateEmptyTips: templateEmptyTips,
	uploadBtn: uploadBtn,
	addFileBtn: addFileBtn,
	authText: authText,
	allNew: allNew,
	partNew: partNew,
	uploadingTitle: uploadingTitle,
	uploadFinishTitle: uploadFinishTitle,
	uploadingBtnText: uploadingBtnText,
	failedSpaceLimit: failedSpaceLimit,
	updateTemplate: updateTemplate,
	templateName: templateName,
	templateNameEmpty: templateNameEmpty,
	memberEmpty: memberEmpty,
	editSuccess: editSuccess,
	editError: editError,
	team: team$1,
	fileTypeNotPatch: fileTypeNotPatch,
	useScope: useScope
};

var title$b = "Quick extraction link plugin";
var mulGet = "Batch export link";
var mulSettingShare = "Batch setting sharing permissions";
var linkStyle = "Link style preview";
var permTitle1 = "Document title";
var permTitle2 = "Sharing permissions";
var linkTitle1 = "Link and Title";
var linkTitle2 = "Pure link";
var linkTitle3 = "Hyperlink";
var chagne = "Revise";
var exportSuccess = "Document export successfully";
var saveAs = "Save to:";
var docCollect = "Document collection";
var exportAsDoc = "Export as a document";
var copyTip = "File permissions prompt";
var copyDesc = "There are unprecedented sharing documents in the copy of the copy. Will others be unable to view. Do you continue to copy?";
var copyLink = "Copy link";
var changeDoc = "Modify the document authority";
var onlyMeText = "Only I can see";
var logoText = "Document Batch Manager";
var exportAsExcel = "export as table";
var choosed = "selected";
var tiao = "strip";
var collecting = "exporting";
var linkCollect = "Link exporting";
var allSuccess = "All export success";
var collectFail = "Export failed,";
var chooseDoc = "Selected documents:";
var gewendang = "documents";
var noPermText = "Operation without permission";
var settingTxt$1 = "setting...";
var settingTip1 = "The setting is complete, there is";
var settingTip2 = "document modification failed, try again";
var settingTip3 = "The setting is complete and all documents have been modified successfully";
var shareRange = "Share scope";
var shareRange1 = "anyone can view";
var shareRange2 = "Anyone can comment";
var shareRange3 = "Anyone can edit";
var day30 = "30 days";
var day7 = "7 days";
var errorTip2 = "Link could not be exported";
var errorTip3 = "Link export failed";
var errorTip4 = "Service exception, please try again";
var exportTip = "export prompt";
var app = "application";
var myCompanyDoc = "my business document";
var forbidPermTxt = "Prevent viewers from downloading, printing, exporting, saving as, and copying content";
var canSeeTxt = "can see";
var settingTip4 = "document advanced settings failed, try again";
var shareRangeCompanyRead = "Viewable by Enterprise Members";
var shareRangeCompanyWrite = "Editable by Enterprise Members";
var shareRangeCompanyComment = "Commentable by Enterprise Members";
var shareRangeDesignatedPerson = "Only the designated person can see";
var settingSheet = "Forbid adding or deleting worksheets";
var textTooltip = "Only Support Operations on Enterprise Documents";
var txtDesignatedPerson = "Batch Settings cannot be set to visible only to the specified person";
var shareCompanyForbid = "Team administrators have disabled document sharing outside the enterprise";
var sharegroupForbid = "The team admin has disabled document sharing outside the team";
var shareGroupForbid2 = "Some enterprise documents do not support sharing outside the team";
var shareCompanyForbid2 = "Some corporate documents do not support setting public permissions";
var feedbackText = "feedback";
var showFolder = "Show folder information";
var QuickCollect = {
	title: title$b,
	mulGet: mulGet,
	mulSettingShare: mulSettingShare,
	linkStyle: linkStyle,
	permTitle1: permTitle1,
	permTitle2: permTitle2,
	linkTitle1: linkTitle1,
	linkTitle2: linkTitle2,
	linkTitle3: linkTitle3,
	"export": "Export",
	chagne: chagne,
	exportSuccess: exportSuccess,
	saveAs: saveAs,
	docCollect: docCollect,
	exportAsDoc: exportAsDoc,
	copyTip: copyTip,
	copyDesc: copyDesc,
	copyLink: copyLink,
	changeDoc: changeDoc,
	onlyMeText: onlyMeText,
	logoText: logoText,
	exportAsExcel: exportAsExcel,
	choosed: choosed,
	tiao: tiao,
	collecting: collecting,
	linkCollect: linkCollect,
	allSuccess: allSuccess,
	collectFail: collectFail,
	chooseDoc: chooseDoc,
	gewendang: gewendang,
	noPermText: noPermText,
	settingTxt: settingTxt$1,
	settingTip1: settingTip1,
	settingTip2: settingTip2,
	settingTip3: settingTip3,
	shareRange: shareRange,
	shareRange1: shareRange1,
	shareRange2: shareRange2,
	shareRange3: shareRange3,
	day30: day30,
	day7: day7,
	errorTip2: errorTip2,
	errorTip3: errorTip3,
	errorTip4: errorTip4,
	exportTip: exportTip,
	app: app,
	myCompanyDoc: myCompanyDoc,
	forbidPermTxt: forbidPermTxt,
	canSeeTxt: canSeeTxt,
	settingTip4: settingTip4,
	shareRangeCompanyRead: shareRangeCompanyRead,
	shareRangeCompanyWrite: shareRangeCompanyWrite,
	shareRangeCompanyComment: shareRangeCompanyComment,
	shareRangeDesignatedPerson: shareRangeDesignatedPerson,
	settingSheet: settingSheet,
	textTooltip: textTooltip,
	txtDesignatedPerson: txtDesignatedPerson,
	shareCompanyForbid: shareCompanyForbid,
	sharegroupForbid: sharegroupForbid,
	shareGroupForbid2: shareGroupForbid2,
	shareCompanyForbid2: shareCompanyForbid2,
	feedbackText: feedbackText,
	showFolder: showFolder
};

var title$a = "Unable to export document link";
var desc$2 = "The link cannot be exported beyond any of the following limits, please select again:";
var imgAlt = "hint";
var QuickCollectLimited = {
	title: title$a,
	desc: desc$2,
	imgAlt: imgAlt
};

var moresetting_title = "advanced settings";
var moresetting_noshare_tip = "Sharing is not enabled for the current document, and the switch cannot be set";
var moresetting_linkdownloadperm_desc = "For documents that prevent viewers from reusing";
var moresetting_publishfile_desc = "Documentation for public release";
var moresetting_linkrenameperm_desc = "Information collection form for multiple people to fill out";
var moresetting_watermarksetting_desc = "Set document watermark";
var moresetting_watermarkopen_desc = "Watermark turned on";
var moresetting_downloadperm_tit = "Prevent viewers from downloading, printing, saving as, and copying content";
var moresetting_downloadperm_subtit = "For documents that prevent viewers from reusing";
var moresetting_downloadperm_pop_tip = "When on, people with view-only access will not be able to download, print, save as, and copy content";
var moresetting_downloadperm_ksheetForbid = "Prevent viewers from exporting, printing, saving as, and copying content";
var moresetting_downloadperm_ksheetPopText = "When turned on, people with view-only access will not be able to export, print, save as, and copy content";
var moresetting_downloadperm_kdbtForbid = "Prevent viewers from exporting, saving as, and copying content";
var moresetting_downloadperm_kfpPopText = "Once enabled, people who only have viewing permissions will not be able to export and save as";
var moresetting_downloadperm_kfpForbid = "Prevent viewers from exporting and saving as";
var moresetting_downloadperm_kdbtPopText = "When on, people with view-only access will not be able to export, save as, and copy content";
var moresetting_downloadperm_kprocessonForbid = "Prevent viewers from exporting and saving as";
var moresetting_downloadperm_kprocessonPopText = "After it is turned on, people who only have viewing permissions will not be able to export or save";
var moresetting_downloadperm_kimgForbid = "Prevent viewers from downloading and saving as";
var moresetting_downloadperm_kimgPopText = "After it is turned on, people who only have viewing permissions will not be able to download and save as";
var moresetting_downloadperm_noshare_right = "Sharing is not enabled for the current document, and the switch cannot be set for the time being";
var moresetting_linkrenameperm_ksheetRenameForbid = "Prohibit adding and deleting worksheets";
var moresetting_linkrenameperm_ksheetRenameForbidPop = "When enabled, collaborators are prohibited from deleting, creating, moving, and renaming worksheets";
var moresetting_linkrenameperm_permissionDenied = "Your operation authority is insufficient";
var moresetting_linkrenameperm_noNetwork = "Network failure, please try again later";
var moresetting_linkrenameperm_serverError = "Server failure, please try again later";
var moresetting_linkrenameperm_error = "Operation failed, please try again later";
var moresetting_fullcomment_openComment = "Allow people who join the sharing to view and post full-text comments";
var moresetting_fullcomment_openCommentTips = "Once enabled, others can post full-text comments and view full-text comments when they open the document";
var moresetting_blockeditApplyswitch_blockEditApply = "Prohibition to apply for editing permission";
var moresetting_blockeditApplyswitch_blockEditApplyTip = "After it is turned on, people who join the sharing will not be able to apply for permission";
var moresetting_share_to_woa_error = "Only the creator is allowed to turn on the watermark";
var DialogAdvancedSetting = {
	moresetting_title: moresetting_title,
	moresetting_noshare_tip: moresetting_noshare_tip,
	moresetting_linkdownloadperm_desc: moresetting_linkdownloadperm_desc,
	moresetting_publishfile_desc: moresetting_publishfile_desc,
	moresetting_linkrenameperm_desc: moresetting_linkrenameperm_desc,
	moresetting_watermarksetting_desc: moresetting_watermarksetting_desc,
	moresetting_watermarkopen_desc: moresetting_watermarkopen_desc,
	moresetting_downloadperm_tit: moresetting_downloadperm_tit,
	moresetting_downloadperm_subtit: moresetting_downloadperm_subtit,
	moresetting_downloadperm_pop_tip: moresetting_downloadperm_pop_tip,
	moresetting_downloadperm_ksheetForbid: moresetting_downloadperm_ksheetForbid,
	moresetting_downloadperm_ksheetPopText: moresetting_downloadperm_ksheetPopText,
	moresetting_downloadperm_kdbtForbid: moresetting_downloadperm_kdbtForbid,
	moresetting_downloadperm_kfpPopText: moresetting_downloadperm_kfpPopText,
	moresetting_downloadperm_kfpForbid: moresetting_downloadperm_kfpForbid,
	moresetting_downloadperm_kdbtPopText: moresetting_downloadperm_kdbtPopText,
	moresetting_downloadperm_kprocessonForbid: moresetting_downloadperm_kprocessonForbid,
	moresetting_downloadperm_kprocessonPopText: moresetting_downloadperm_kprocessonPopText,
	moresetting_downloadperm_kimgForbid: moresetting_downloadperm_kimgForbid,
	moresetting_downloadperm_kimgPopText: moresetting_downloadperm_kimgPopText,
	moresetting_downloadperm_noshare_right: moresetting_downloadperm_noshare_right,
	moresetting_linkrenameperm_ksheetRenameForbid: moresetting_linkrenameperm_ksheetRenameForbid,
	moresetting_linkrenameperm_ksheetRenameForbidPop: moresetting_linkrenameperm_ksheetRenameForbidPop,
	moresetting_linkrenameperm_permissionDenied: moresetting_linkrenameperm_permissionDenied,
	moresetting_linkrenameperm_noNetwork: moresetting_linkrenameperm_noNetwork,
	moresetting_linkrenameperm_serverError: moresetting_linkrenameperm_serverError,
	moresetting_linkrenameperm_error: moresetting_linkrenameperm_error,
	moresetting_fullcomment_openComment: moresetting_fullcomment_openComment,
	moresetting_fullcomment_openCommentTips: moresetting_fullcomment_openCommentTips,
	moresetting_blockeditApplyswitch_blockEditApply: moresetting_blockeditApplyswitch_blockEditApply,
	moresetting_blockeditApplyswitch_blockEditApplyTip: moresetting_blockeditApplyswitch_blockEditApplyTip,
	moresetting_share_to_woa_error: moresetting_share_to_woa_error
};

var title$9 = "hint";
var txt1$e = "No longer accepting edit requests for this document";
var txt2$c = "Anyone can apply to edit";
var txt3$b = "modify settings";
var DialogGoToAdvancedSetting = {
	title: title$9,
	txt1: txt1$e,
	txt2: txt2$c,
	txt3: txt3$b
};

var txt0$d = "Create";
var txt1$d = "Creation failed.";
var txt2$b = "Enter a team name less than 20 characters.";
var txt3$a = "Recommend";
var ShareCreateTeam = {
	txt0: txt0$d,
	txt1: txt1$d,
	txt2: txt2$b,
	txt3: txt3$a
};

var title$8 = "Custom validity period is only available for WPS Premium users";
var tips_1 = "Flexible setting of the sharing validity period, accurate to the specified date and time";
var tips_2 = "Sharing is disabled after the expiration date to protect your privacy";
var vipButton = "Upgrade to WPS Premium";
var PCCustomShareDateDialog = {
	title: title$8,
	tips_1: tips_1,
	tips_2: tips_2,
	vipButton: vipButton
};

var txt01 = "Experience a \"Collaboration Space\"";
var txt02 = "Enter the collaboration space";
var txt03 = "Collaboration Space tries to explore better collaboration methods for small teams in forms other than folders.";
var txt04 = "*This feature is still in the early stage of trial, and it is only available within the company for colleagues to try";
var txt05 = "Go to Collaboration Space";
var txt06 = "Not yet";
var txt07 = "Upgrade failed";
var txt08 = "The current team does not enable collaboration space.";
var txt09 = "You cannot access the current team's collaboration space.";
var txt10$3 = "Please notify the team owner and administrator to enable collaboration space.";
var txt11$3 = "Send Notification";
var txt12$3 = "Go to the official website for more information";
var txt13$3 = "Notification sent.";
var txt14$3 = "Send failed. Please try again.";
var TeamSpace = {
	txt01: txt01,
	txt02: txt02,
	txt03: txt03,
	txt04: txt04,
	txt05: txt05,
	txt06: txt06,
	txt07: txt07,
	txt08: txt08,
	txt09: txt09,
	txt10: txt10$3,
	txt11: txt11$3,
	txt12: txt12$3,
	txt13: txt13$3,
	txt14: txt14$3
};

var showAdInfo = "Display company authentication information";
var popTxt = "After this feature is enabled, the company authentication information will be displayed to the people with whom this document is shared.";
var ShowAuthenticationInfo = {
	showAdInfo: showAdInfo,
	popTxt: popTxt
};

var corpMarkTxt = "Display company authentication information";
var corpMarkTipTxt = "After this feature is enabled, the company authentication information will be displayed to the public.";
var corpMarkSwitch = {
	corpMarkTxt: corpMarkTxt,
	corpMarkTipTxt: corpMarkTipTxt
};

var txt0$c = "Share";
var shareMiniCode = "Send to WeChat Friends by Applet";
var txt4$7 = "QR Code";
var txt2$a = "Cancel Sharing";
var perm_setting = "Permission Settings";
var DialogShareCooperate = {
	txt0: txt0$c,
	shareMiniCode: shareMiniCode,
	txt4: txt4$7,
	txt2: txt2$a,
	perm_setting: perm_setting
};

var txt2$9 = "Cancel";
var txt3$9 = "Confirm";
var txt4$6 = "Successfully removed";
var txt1$c = "Are you sure you want to remove the selected {0} person(s)?";
var txt5$6 = "Removal failed.";
var MultiManageConfirm = {
	txt2: txt2$9,
	txt3: txt3$9,
	txt4: txt4$6,
	txt1: txt1$c,
	txt5: txt5$6
};

var surveyTitle = "Short survey";
var content = "Would you recommend friends or colleagues to use it?";
var thxFeedback = "Thank you for your feedback";
var improve = "What aspects do you think can be improved?";
var submitFeedback = "Submit feedback";
var submitInfo = "We will provide you with a more professional and high-quality service experience";
var certainlyNot = "Definitely not";
var veryWillingTo = "Very willing";
var submit = "Submit";
var submitSuccess = "Submitted successfully";
var contentEnd = " ?";
var Nps = {
	surveyTitle: surveyTitle,
	content: content,
	thxFeedback: thxFeedback,
	improve: improve,
	submitFeedback: submitFeedback,
	submitInfo: submitInfo,
	certainlyNot: certainlyNot,
	veryWillingTo: veryWillingTo,
	submit: submit,
	submitSuccess: submitSuccess,
	contentEnd: contentEnd
};

var dialog_approve_open_coop_title = "Please reopen collaboration";
var dialog_approve_coop_members = "Collaborator";
var comment$2 = "Can comment";
var write$2 = "Can edit";
var common_txt2 = "Failed to open";
var common_txt3 = "Failed to load";
var mobile_txt1 = "Please reopen collaboration";
var mobile_txt2 = "Collaboration has been closed";
var mobile_txt4 = "Open collaboration";
var pc_txt1 = "Please reopen collaboration";
var pc_txt3 = "Open collaboration";
var read$3 = "View Only";
var loading$1 = "Please wait";
var common_txt1 = "Collaboration has been enabled.";
var mobile_txt3 = "Enable collaboration to allow new members to access the file.";
var mobile_txt5 = "Collaborators";
var mobile_txt6 = "New Collaborator Requests";
var mobile_txt7 = "Joined Collaborators";
var mobile_txt8 = "View or modify the member list";
var mobile_txt9 = "Access permissions will be restored.";
var pc_txt2 = "Collaboration is disabled. Enable collaboration to allow new members to access the file.";
var pc_txt4 = "Collaborators";
var pc_txt5 = "New Collaborator Requests";
var pc_txt6 = "Joined Collaborators";
var pc_txt7 = "View or modify the member list";
var pc_txt8 = "Access permissions will be restored together.";
var pc_txt9 = "When collaboration is disabled, collaborators cannot access the file until collaboration is enabled again.";
var ApproveOpenCoop = {
	dialog_approve_open_coop_title: dialog_approve_open_coop_title,
	dialog_approve_coop_members: dialog_approve_coop_members,
	comment: comment$2,
	write: write$2,
	common_txt2: common_txt2,
	common_txt3: common_txt3,
	mobile_txt1: mobile_txt1,
	mobile_txt2: mobile_txt2,
	mobile_txt4: mobile_txt4,
	pc_txt1: pc_txt1,
	pc_txt3: pc_txt3,
	read: read$3,
	loading: loading$1,
	common_txt1: common_txt1,
	mobile_txt3: mobile_txt3,
	mobile_txt5: mobile_txt5,
	mobile_txt6: mobile_txt6,
	mobile_txt7: mobile_txt7,
	mobile_txt8: mobile_txt8,
	mobile_txt9: mobile_txt9,
	pc_txt2: pc_txt2,
	pc_txt4: pc_txt4,
	pc_txt5: pc_txt5,
	pc_txt6: pc_txt6,
	pc_txt7: pc_txt7,
	pc_txt8: pc_txt8,
	pc_txt9: pc_txt9
};

var openTxt = "Enabled";
var settingTxt = "Settings";
var openCoopTxt = "Enable Collaboration";
var applyShareTxt = "Please apply for 'Share' permission from the administrator first";
var sendTxt = "Send";
var sendFileTxt = "Send File";
var hasCoopLinkTxt = "Collaboration enabled";
var hasShareLinkTxt = "Share link enabled";
var noPermCoopLinkTxt = "Collaboration details";
var noPermShareLinkTxt = "Share link details";
var closeTxt = "Disabled";
var coopTxt = "Collaboration";
var shareTxt = "Share Link";
var sendCoopLinkTxt = "Send Collaboration Link";
var sendShareLinkTxt = "Send Share Link";
var openShareTxt = "Enable Share Link";
var unknownErrorTxt = "Unknown error. Please try again.";
var sendImgTxt = "Export as Image";
var sendPDFTxt = "Export as PDF";
var sendXLSXTxt = "Export as XLSX";
var downloadSuccesTxt = "Exported successfully.";
var noPermDownloadTxt = "No download permission.";
var ShareCooperate = {
	openTxt: openTxt,
	settingTxt: settingTxt,
	openCoopTxt: openCoopTxt,
	applyShareTxt: applyShareTxt,
	sendTxt: sendTxt,
	sendFileTxt: sendFileTxt,
	hasCoopLinkTxt: hasCoopLinkTxt,
	hasShareLinkTxt: hasShareLinkTxt,
	noPermCoopLinkTxt: noPermCoopLinkTxt,
	noPermShareLinkTxt: noPermShareLinkTxt,
	closeTxt: closeTxt,
	coopTxt: coopTxt,
	shareTxt: shareTxt,
	sendCoopLinkTxt: sendCoopLinkTxt,
	sendShareLinkTxt: sendShareLinkTxt,
	openShareTxt: openShareTxt,
	unknownErrorTxt: unknownErrorTxt,
	sendImgTxt: sendImgTxt,
	sendPDFTxt: sendPDFTxt,
	sendXLSXTxt: sendXLSXTxt,
	downloadSuccesTxt: downloadSuccesTxt,
	noPermDownloadTxt: noPermDownloadTxt
};

var dialog_logout_title = "Log out";
var dialog_logout_text1 = "The service is being upgraded. You can choose to log in to other accounts to use Kingsoft Documents in the following ways:";
var dialog_logout_text2 = "Method 1: Clear the browser cache and refresh the current page";
var dialog_logout_text3 = "Method 2: Open a new incognito window and re-access Kingsoft Document";
var i_know = "I know";
var LogoutFail = {
	dialog_logout_title: dialog_logout_title,
	dialog_logout_text1: dialog_logout_text1,
	dialog_logout_text2: dialog_logout_text2,
	dialog_logout_text3: dialog_logout_text3,
	i_know: i_know
};

var dialogTitle = "Kingsoft Documentation";
var dialogContent = "Authorize Kingsoft Documents to use real name, student ID and other information for collaborative presentation within the team.";
var dialogCheckboxLabel = "Don't show today";
var dialogConfirmText = "De-authorization";
var TeamAuth = {
	dialogTitle: dialogTitle,
	dialogContent: dialogContent,
	dialogCheckboxLabel: dialogCheckboxLabel,
	dialogConfirmText: dialogConfirmText
};

var invite = {
	txt4: "Copy link",
	txt6: "Cancel",
	txt7: "Confirm",
	txt8: "Failed to copy",
	txt9: "Copy successful",
	txt10: "Settings",
	txt0: "Invitation sent successfully.",
	txt1: "After the members accept the invitation, they join the company.",
	txt2: "Send the link to your colleagues, who can click the link to join the company.",
	txt3: "Scan the QR code to send invitations to colleagues",
	txt5: "My Contacts",
	txt11: "Allow members to invite colleagues to join the company"
};
var approve = {
	txt2: "Rejected",
	txt4: "Reject",
	txt0: "No colleagues joined the company",
	txt1: "Approved",
	txt3: "Approve",
	txt5: "Joined with phone number verification",
	txt6: "Joined with email verification",
	txt7: "Joined without verification",
	txt8: "Approval failed.",
	txt9: "Purchase",
	txt10: "No more members can be added. Purchase more quota before approval.",
	txt11: "No more members can be added. Purchase a package with enough quota before approval.",
	txt12: "Pending Members"
};
var dialog$2 = {
	title: "Employee Onboarding"
};
var CompanyAdminInviteApprove = {
	invite: invite,
	approve: approve,
	dialog: dialog$2
};

var dialog$1 = {
	title: "Handle Employee Departure"
};
var desc$1 = "The administrator can quickly transfer the data of departed employees, including documents in \"My Company Documents,\" team documents, schedules, and secure documents.";
var dimission = {
	txt0: "Departed Employee",
	txt1: "Departure",
	txt2: "No data found",
	txt3: "Go to {0} to process more data",
	txt4: "Management Console",
	handover_status: {
		wait: "Go to transfer",
		part_complete: "Continue to transfer",
		complete: "Transfer Record",
		no_require: "No data for transfer",
		handovering: "Transferring"
	}
};
var CompanyAdminDismission = {
	dialog: dialog$1,
	desc: desc$1,
	dimission: dimission
};

var noPermission = "No permissions";
var dialog = {
	title: "Company Document Security Settings"
};
var shareOutside = {
	title: "Prohibit sharing company documents outside the company"
};
var fileOutside = {
	title: "Prohibit transferring company documents outside the company"
};
var showWatermark = {
	title: "Show Watermark",
	setting: "Watermark Settings"
};
var CompanyAdminDocSettings = {
	noPermission: noPermission,
	dialog: dialog,
	shareOutside: shareOutside,
	fileOutside: fileOutside,
	showWatermark: showWatermark
};

var txt0$b = "Team collaboration, efficient work";
var txt1$b = "Online collaboration with your colleagues, say goodbye to missing local files, messy versions, and collaboration issues";
var OperationBanner = {
	txt0: txt0$b,
	txt1: txt1$b
};

var txt0$a = "is collaborating. Click the avatar to locate";
var txt1$a = "is viewing the file. Click the avatar to locate";
var txt2$8 = "Read-Only Permissions";
var txt3$8 = "Enable Editing";
var txt4$5 = "Commentable permission";
var txt5$5 = "is collaborating";
var txt6$5 = "is viewing the file";
var mine = "(Me)";
var read$2 = "Viewable";
var comment$1 = "can comment";
var write$1 = "Editable";
var notLogin = "Not Logged In";
var creator = "Document Creator";
var encrytUser = "Encryptor";
var owner$1 = "Document Owner";
var changePermSuccess = "Permission set successfully";
var removeSuccess = "{0}has been moved";
var anyWrite = "Anyone can edit";
var anyComment = "Anyone can comment";
var anyRead = "Anyone can view";
var CollaboratorItem = {
	txt0: txt0$a,
	txt1: txt1$a,
	txt2: txt2$8,
	txt3: txt3$8,
	txt4: txt4$5,
	txt5: txt5$5,
	txt6: txt6$5,
	mine: mine,
	read: read$2,
	comment: comment$1,
	write: write$1,
	notLogin: notLogin,
	creator: creator,
	encrytUser: encrytUser,
	owner: owner$1,
	changePermSuccess: changePermSuccess,
	removeSuccess: removeSuccess,
	anyWrite: anyWrite,
	anyComment: anyComment,
	anyRead: anyRead
};

var txt4$4 = "Link copied, can be sent to colleagues to request joining";
var txt5$4 = "Failed to copy";
var txt0$9 = "Invitation sent successfully.";
var txt1$9 = "Invitation failed.";
var txt2$7 = "Recently collaborated with you on a document";
var txt3$7 = "He/She is your contact";
var txt6$4 = "Invite Members to Join";
var txt7$4 = "Send Invitation Messages";
var txt8$4 = "Copy the link to invite members";
var DialogCollaborationInviteMembers = {
	txt4: txt4$4,
	txt5: txt5$4,
	txt0: txt0$9,
	txt1: txt1$9,
	txt2: txt2$7,
	txt3: txt3$7,
	txt6: txt6$4,
	txt7: txt7$4,
	txt8: txt8$4
};

var txt1$8 = "Settings";
var DialogEntFolderShareSetting = {
	txt1: txt1$8
};

var cropTeamDes = "Upgrading a shared folder to an enterprise team can have the following impacts:";
var cropTeamDes1 = "The upgrade operation is irreversible, and all data in the shared folder will be moved to the enterprise  ";
var cropTeamDes2 = "After the upgrade is completed, shared folder members will be synchronized to join the enterprise team";
var cropTeamDes3 = "Membership rights under personal accounts will not be transferred to enterprises";
var createCropErrText = "Failed to create enterprise";
var getRewardErr = "Failed to claim benefits";
var noSupport = "Failed to claim benefits. Insufficient member seats in the enterprise. Please purchase member seats and try upgrading!";
var equityWarn1 = "To enhance the user experience of the enterprise, we will give the following benefits to the enterprise after you start the upgrade:";
var equityWarn2 = "After starting the upgrade";
var equityWarn3 = "Give the following benefits to the company:";
var equityName1 = "enterprise space";
var equityName2 = "Membership seats";
var equityUnitLabel = "Validity period:";
var equityUnitPeople = "people";
var equityUnitDay = "day";
var equityBtn = "Start Upgrade";
var equityBtn1 = "Got it";
var equityBtn2 = "Not used temporarily";
var equityTitle = "Insufficient seats for enterprise members";
var equityTitle1 = "Upgrade benefits limited to free gifts";
var DialogShareFolderUPToCorpTeam = {
	cropTeamDes: cropTeamDes,
	cropTeamDes1: cropTeamDes1,
	cropTeamDes2: cropTeamDes2,
	cropTeamDes3: cropTeamDes3,
	createCropErrText: createCropErrText,
	getRewardErr: getRewardErr,
	noSupport: noSupport,
	equityWarn1: equityWarn1,
	equityWarn2: equityWarn2,
	equityWarn3: equityWarn3,
	equityName1: equityName1,
	equityName2: equityName2,
	equityUnitLabel: equityUnitLabel,
	equityUnitPeople: equityUnitPeople,
	equityUnitDay: equityUnitDay,
	equityBtn: equityBtn,
	equityBtn1: equityBtn1,
	equityBtn2: equityBtn2,
	equityTitle: equityTitle,
	equityTitle1: equityTitle1
};

var fileName = "file name";
var size = "size";
var extract = "Unzip";
var cancel = "Cancel";
var extractTo = "Unzip the file to";
var extracting = "Unzipping files, please wait... {progress}%";
var extractSuccess = "Unzip the file";
var extractFail = "Decompression failed";
var extractRetry = "Refresh and try again";
var extractFailTips = "The current file cannot be decompressed";
var empty$1 = "No content";
var emptyTips = "There is no content in the folder.";
var notSupport = "The compressed file does not support previewing this format.";
var loadingText$1 = "Unzipping";
var networkError = "Network abnormality, please try again later";
var ArchivePreview = {
	fileName: fileName,
	size: size,
	extract: extract,
	cancel: cancel,
	extractTo: extractTo,
	extracting: extracting,
	extractSuccess: extractSuccess,
	extractFail: extractFail,
	extractRetry: extractRetry,
	extractFailTips: extractFailTips,
	empty: empty$1,
	emptyTips: emptyTips,
	notSupport: notSupport,
	loadingText: loadingText$1,
	networkError: networkError
};

var title$7 = "Create Shared Folder";
var desc = "Members can be invited to view and edit files together. All modifications will be synchronized to the shared folder";
var defaultShareFolderName = "New Shared Folder";
var defaultPlaceholder = "Enter the name of the shared folder";
var cancelText = "Cancel";
var confirmText = "Create Now";
var toastSuccess = "Shared folder created successfully";
var toastDefaultError = "Failed to create shared folder";
var toastErrorMissingName = "Please enter the name of the shared folder";
var toastErrorInvalidChars = "Folder name cannot contain special characters: /\\;:*?\"<>|%&,";
var toastErrorNameTooLong = "Folder name cannot exceed 240 characters";
var multiAccountSwitchDialogName = "Switch to a business (team) account to use advanced team sharing";
var multiAccountSwitchDialogDesc = "Create a new business to enable advanced sharing";
var multiAccountSwitchDialogBtn = "Click here to create a new business";
var DialogCreateShareFolder = {
	title: title$7,
	desc: desc,
	defaultShareFolderName: defaultShareFolderName,
	defaultPlaceholder: defaultPlaceholder,
	cancelText: cancelText,
	confirmText: confirmText,
	toastSuccess: toastSuccess,
	toastDefaultError: toastDefaultError,
	toastErrorMissingName: toastErrorMissingName,
	toastErrorInvalidChars: toastErrorInvalidChars,
	toastErrorNameTooLong: toastErrorNameTooLong,
	multiAccountSwitchDialogName: multiAccountSwitchDialogName,
	multiAccountSwitchDialogDesc: multiAccountSwitchDialogDesc,
	multiAccountSwitchDialogBtn: multiAccountSwitchDialogBtn
};

var title$6 = "Switched to enterprise account";
var tip = "Currently, the enterprise does not support the creation of a new team. Please contact the administrator to open it.";
var btnText$2 = "Confirm";
var DialogCreateTeamDenied = {
	title: title$6,
	tip: tip,
	btnText: btnText$2
};

var title$5 = "Create team to start efficient collaboration";
var description = "Team data unified management, easy and efficient multi-terminal office, document security is more guaranteed.";
var feature1$1 = "High-capacity team cloud space";
var feature2$1 = "Many people collaborate at the same time";
var feature3$1 = "Authority control and leakage prevention";
var tipsTitle$1 = "The process for using the following:";
var tip1$2 = "This's restricted to the use of enterprises account,you need to setup enterprise first.";
var noMoreReminderText$1 = "No more reminders";
var btnText$1 = "Create now";
var DialogCreateTeamGuidance = {
	title: title$5,
	description: description,
	feature1: feature1$1,
	feature2: feature2$1,
	feature3: feature3$1,
	tipsTitle: tipsTitle$1,
	tip1: tip1$2,
	noMoreReminderText: noMoreReminderText$1,
	btnText: btnText$1
};

var title1 = "Create a team";
var title2 = "Create team successfully";
var text1$1 = "Team name";
var text2$1 = "Please fill in the team name (2-100 words)";
var text3 = "Share links to invite members to join the team";
var text4 = "You can import files from other accounts into the enterprise team.";
var text5 = "Import other account files";
var text6 = "How to collaborate online among teams? Click";
var text7 = "to view";
var btnText1$1 = "OK";
var createErrorTip$1 = "Create Team failed";
var emptyTip = "Please enter a team name";
var copyText1 = "Copy Link";
var copyText2 = "Copy successfully";
var copyText3 = "Copy failed";
var DialogCreateTeamSimply = {
	title1: title1,
	title2: title2,
	text1: text1$1,
	text2: text2$1,
	text3: text3,
	text4: text4,
	text5: text5,
	text6: text6,
	text7: text7,
	btnText1: btnText1$1,
	createErrorTip: createErrorTip$1,
	emptyTip: emptyTip,
	copyText1: copyText1,
	copyText2: copyText2,
	copyText3: copyText3
};

var title$4 = "New upgrade of team";
var feature1 = "More storage space";
var feature2 = "Data sharing is more convenient";
var feature3 = "Richer permission settings";
var featureDesc1 = "Invite 3 people to enjoy 10TB enterprise storage space";
var featureDesc2 = "Cross-departmental data sharing, real-time data sharing in cloud";
var featureDesc3 = "Flexible setting of editing / viewing permissions, multi-scene control";
var tipsTitle = "The specific impact of this upgrade on you:";
var tip1$1 = "When creating a new team, you need an enterprise account first.";
var noMoreReminderText = "No more reminders";
var btnText = "I see";
var DialogCreateTeamUpgradeAnnouncement = {
	title: title$4,
	feature1: feature1,
	feature2: feature2,
	feature3: feature3,
	featureDesc1: featureDesc1,
	featureDesc2: featureDesc2,
	featureDesc3: featureDesc3,
	tipsTitle: tipsTitle,
	tip1: tip1$1,
	noMoreReminderText: noMoreReminderText,
	btnText: btnText
};

var title$3 = "Import files completed!";
var desc1 = "A total of ";
var desc2 = "files / folders were imported this time.";
var text = "Share links and invite more members to join the collaboration.";
var DialogCreateTeamImportDataSuccessfully = {
	title: title$3,
	desc1: desc1,
	desc2: desc2,
	text: text
};

var title$2 = "Needs to use an enterprise account. Please switch.";
var tip1 = "You can switch the following enterprise accounts:";
var tip2 = "The following accounts must be logged in first:";
var btnText1 = "Switch to the account";
var btnText2 = "Login to the account";
var text1 = "Want to create a new enterprise?";
var text2 = "Click here.";
var switchErrorTip$1 = "Account switching failed";
var MultiAccountSwitch = {
	title: title$2,
	tip1: tip1,
	tip2: tip2,
	btnText1: btnText1,
	btnText2: btnText2,
	text1: text1,
	text2: text2,
	switchErrorTip: switchErrorTip$1
};

var createErrorTip = "Failed to create, please try again";
var switchErrorTip = "Account switching failed";
var CreateEnterprise = {
	createErrorTip: createErrorTip,
	switchErrorTip: switchErrorTip
};

var txt1$7 = "Document collaboration will be enabled and collaboration invitations will be sent to selected users";
var txt2$6 = "Cancel";
var txt3$6 = "Enable collaboration";
var title$1 = "Continue";
var EntSearchAddCollaConfrm = {
	txt1: txt1$7,
	txt2: txt2$6,
	txt3: txt3$6,
	title: title$1
};

var txt0$8 = "Cooperation";
var CooperateTagIcon = {
	txt0: txt0$8
};

var txt0$7 = "Cooperation";
var txt1$6 = "Team affiliation";
var txt2$5 = "Cooperation partner";
var txt3$5 = "Loading...";
var PartnerInformationPanel = {
	txt0: txt0$7,
	txt1: txt1$6,
	txt2: txt2$5,
	txt3: txt3$5
};

var txt0$6 = "Enterprise Disclosure";
var txt1$5 = "The administrator has enabled the enterprise knowledge view for this team, which is visible to all enterprise members.";
var txt3$4 = "Visibility";
var PublicInformationPanel = {
	txt0: txt0$6,
	txt1: txt1$5,
	txt3: txt3$4
};

var associationFailListTitle = "Members are not within the shared scope of the associated organization. The following {0} people failed to be added:";
var externalFailListTitle = "Due to enterprise security policy restrictions, this member is temporarily not supported to join the team. The following {0} people failed to be added:";
var txt0$5 = "close";
var AddMemberFailedTips = {
	associationFailListTitle: associationFailListTitle,
	externalFailListTitle: externalFailListTitle,
	txt0: txt0$5
};

var dialog_title = "Transfer document ownership";
var receive_title = "Document received";
var common_error = "Failed to load";
var step1 = "Transfer object, accept invitation via link";
var step2 = "confirm transfer of document ownership";
var step3 = "Transfer completed";
var tips1 = "View";
var tips2 = "Transfer process:";
var tips3 = "Reset invitation link";
var tips4 = "Copy transfer invitation link";
var tips5 = "Transfer link has expired";
var tips6 = "Waiting for the transfer object to accept the invitation, the invitation link is valid for 24 hours";
var tips7 = "Successfully transferred the document to";
var tips8 = "Confirm transfer";
var tips9 = "Accept transfer invitation";
var tips10 = "Transfer document to you";
var tips11 = "Apply to receive file";
var tips12 = "WPS Docs";
var tips13 = "Copy successfully, send to friends to receive";
var tips14 = "Copy failed";
var tips15 = "Reset successfully, you can invite friends again";
var tips16 = "Reset failed";
var tips17 = "Transfer successfully";
var tips18 = "Has become the transferee, please wait for the owner's confirmation";
var tips20 = "Copy invitation link";
var tips21 = "Copy successful, send to friends for approval";
var tips22 = "Unknown error";
var tips23 = "Refresh";
var tips24 = "Transfer failed";
var tips25 = "Receive failed";
var tips26 = "Delete failed";
var tips19 = "The access permission of";
var TransferFileApprove = {
	dialog_title: dialog_title,
	receive_title: receive_title,
	common_error: common_error,
	step1: step1,
	step2: step2,
	step3: step3,
	tips1: tips1,
	tips2: tips2,
	tips3: tips3,
	tips4: tips4,
	tips5: tips5,
	tips6: tips6,
	tips7: tips7,
	tips8: tips8,
	tips9: tips9,
	tips10: tips10,
	tips11: tips11,
	tips12: tips12,
	tips13: tips13,
	tips14: tips14,
	tips15: tips15,
	tips16: tips16,
	tips17: tips17,
	tips18: tips18,
	tips20: tips20,
	tips21: tips21,
	tips22: tips22,
	tips23: tips23,
	tips24: tips24,
	tips25: tips25,
	tips26: tips26,
	tips19: tips19
};

var txt0$4 = "Webpage to Document";
var txt1$4 = "Saved successfully";
var txt2$4 = "Save failed";
var DialogConvertPage = {
	txt0: txt0$4,
	txt1: txt1$4,
	txt2: txt2$4
};

var txt0$3 = "Enter a web link and save the link content as a Kingsoft document with one click";
var txt1$3 = "Save now";
var txt2$3 = "Please enter the link first";
var txt3$3 = "The link does not meet the specifications, please re-enter";
var txt4$3 = "This type of link is not currently supported";
var txt5$3 = "Open";
var txt6$3 = "Saving...";
var txt7$3 = "Link format error";
var txt8$3 = "Failed to save, the link does not support conversion";
var txt9$2 = "Network abnormality, please try again later";
var txt10$2 = "Service abnormality, please try again later";
var txt11$2 = "Link saved as document";
var txt12$2 = "Failed to save, cloud space is full";
var txt13$2 = "Clear space";
var txt14$2 = "Retry";
var txt15$2 = "Document saved to:";
var txt16$1 = "Saved successfully";
var txt17 = "Save failed";
var txt18 = "return";
var txt19 = "Open Document";
var txt20 = "Cancel";
var txt21 = "Sorry, this link does not support conversion yet.";
var txt22 = "The link does not meet the specifications, please re-enter";
var txt23 = " I know";
var txt24 = "The cloud space is full, please clear the space and try again";
var txt25 = "Automatically saving, remind you when finished";
var txt26 = "Saving";
var txt27 = "Enter a web link and save the link content as PDF with one click";
var txt28 = "This link does not support conversion to PDF";
var ConvertPage = {
	txt0: txt0$3,
	txt1: txt1$3,
	txt2: txt2$3,
	txt3: txt3$3,
	txt4: txt4$3,
	txt5: txt5$3,
	txt6: txt6$3,
	txt7: txt7$3,
	txt8: txt8$3,
	txt9: txt9$2,
	txt10: txt10$2,
	txt11: txt11$2,
	txt12: txt12$2,
	txt13: txt13$2,
	txt14: txt14$2,
	txt15: txt15$2,
	txt16: txt16$1,
	txt17: txt17,
	txt18: txt18,
	txt19: txt19,
	txt20: txt20,
	txt21: txt21,
	txt22: txt22,
	txt23: txt23,
	txt24: txt24,
	txt25: txt25,
	txt26: txt26,
	txt27: txt27,
	txt28: txt28
};

var txt0$2 = "Invitation sent";
var txt1$2 = "Invite failed";
var txt2$2 = "Recently collaborated with you on a document";
var txt3$2 = "TA is your contact person";
var txt4$2 = "The link has been copied and can be sent to colleagues to apply to join";
var txt5$2 = "Copy Failure";
var txt6$2 = "Invite members to join";
var txt7$2 = "Send invitation message";
var txt8$2 = "Copy the link to invite members";
var DialogNewEnterpriseGuidance = {
	txt0: txt0$2,
	txt1: txt1$2,
	txt2: txt2$2,
	txt3: txt3$2,
	txt4: txt4$2,
	txt5: txt5$2,
	txt6: txt6$2,
	txt7: txt7$2,
	txt8: txt8$2
};

var checkAll = "Select All";
var sendNotice = "Send Notification";
var dialogInstructions = "Instructions: Notification message will be sent to the member's personal account";
var loadingText = "Loading...";
var noticeMsg = "Notification message has been sent to the member's personal account";
var initError = "Network error, please try again later";
var empty = "Company usage is relatively good, there are no members who have not been used";
var sendingText = "Sending...";
var notSuperAdmin = "Current account does not have the permission to invite members, please contact the company administrator.";
var subtitle = "View the reminders members will receive";
var popoverTip = "* This notification is only sent to the member's personal account";
var popoverTitle = "Members will receive the following reminders:";
var NotifyUnusedMembers = {
	checkAll: checkAll,
	sendNotice: sendNotice,
	dialogInstructions: dialogInstructions,
	loadingText: loadingText,
	noticeMsg: noticeMsg,
	initError: initError,
	empty: empty,
	sendingText: sendingText,
	notSuperAdmin: notSuperAdmin,
	subtitle: subtitle,
	popoverTip: popoverTip,
	popoverTitle: popoverTitle
};

var read$1 = "Check";
var MessageBubble = {
	read: read$1
};

var addFaceFileDesc = "Do you want to add this document to the existing \"Face to Face Document\"?";
var addFileTxt = "Add to";
var createNewFaceText = "Start a new face-to-face";
var addFaceFilePermDesc = "This document has limited visitors, and \"Face-to-face\" members may not be able to view it. It is recommended to adjust the permissions and try again.";
var still = "still";
var launch = "Initiate";
var tipsText = "hint";
var endFaceByNewFaceDesc = "Initiating a new \"face-to-face document viewing\" will end the current face-to-face session. Are you sure you want to end it?";
var exitFaceByNewFaceDesc = "Initiating a new \"face-to-face document viewing\" will exit the current face-to-face session. Are you sure you want to exit?";
var endTxt = "Confirm the end";
var exitTxt = "Confirm Exit";
var addSuccessTxt = "Added successfully";
var endCurFaceTxt = "End the current \"Face-to-face document\"";
var exitCurFaceTxt = "Exit the current \"Face-to-face document\"";
var ShareV3Face = {
	addFaceFileDesc: addFaceFileDesc,
	addFileTxt: addFileTxt,
	createNewFaceText: createNewFaceText,
	addFaceFilePermDesc: addFaceFilePermDesc,
	still: still,
	launch: launch,
	tipsText: tipsText,
	endFaceByNewFaceDesc: endFaceByNewFaceDesc,
	exitFaceByNewFaceDesc: exitFaceByNewFaceDesc,
	endTxt: endTxt,
	exitTxt: exitTxt,
	addSuccessTxt: addSuccessTxt,
	endCurFaceTxt: endCurFaceTxt,
	exitCurFaceTxt: exitCurFaceTxt
};

var rewardReceived = "Claim reward";
var rewardView = "Go to view";
var rewardSuccess = "Reward claim successful, you can view it in the management backend";
var rewardAlreadyReceived = "You have already claimed this reward, please view it in the management backend";
var rewardFailed = "Claim failed";
var TaskPanelReward = {
	rewardReceived: rewardReceived,
	rewardView: rewardView,
	rewardSuccess: rewardSuccess,
	rewardAlreadyReceived: rewardAlreadyReceived,
	rewardFailed: rewardFailed
};

var rewardClaim = "click here to claim>";
var growthPlan = "Growth Plan>";
var benefitCenter = "Management Backend>";
var TaskPanel = {
	rewardClaim: rewardClaim,
	growthPlan: growthPlan,
	benefitCenter: benefitCenter
};

var txt0$1 = "Link Invitation";
var txt1$1 = "QR Code Invitation";
var txt2$1 = "Enter the invitation link to join {0}";
var txt3$1 = "Copy invitation link";
var txt4$1 = "Scan the {0} QR code to join {0}";
var txt5$1 = "Download QR code";
var txt6$1 = "Copy QR code";
var txt7$1 = "Copied successfully";
var txt8$1 = "Copy failed";
var txt9$1 = "Invite you to collaborate on documents at {0}";
var txt10$1 = "{0} invite you to join";
var txt11$1 = "Scan the QR code above to join {0}";
var txt12$1 = "Validity period:";
var txt13$1 = "Business collaboration, remote meetings, and efficient office work";
var txt14$1 = "enterprise";
var txt15$1 = "permanent";
var txt16 = "Invite QR code";
var CompanyInvitePanel = {
	txt0: txt0$1,
	txt1: txt1$1,
	txt2: txt2$1,
	txt3: txt3$1,
	txt4: txt4$1,
	txt5: txt5$1,
	txt6: txt6$1,
	txt7: txt7$1,
	txt8: txt8$1,
	txt9: txt9$1,
	txt10: txt10$1,
	txt11: txt11$1,
	txt12: txt12$1,
	txt13: txt13$1,
	txt14: txt14$1,
	txt15: txt15$1,
	txt16: txt16
};

var txt0 = "Download the client";
var txt1 = "Local Office";
var txt2 = "Online Office";
var txt3 = "One-stop office platform";
var txt4 = "Kingsoft Document｜WPS Cloud Document";
var txt5 = "WeChat Mini Program";
var txt6 = "Webpage Collection Plugin";
var txt7 = "Download Now";
var txt8 = "Traditional Office";
var txt9 = "Mobile";
var txt10 = "Online collaborative office";
var txt11 = "AI Smart Office";
var txt12 = "Scan the QR code to download";
var txt13 = "Scan the QR code with your mobile phone";
var txt14 = "Pure online office";
var txt15 = "Copy the download client link";
var DownloadClientPanel = {
	txt0: txt0,
	txt1: txt1,
	txt2: txt2,
	txt3: txt3,
	txt4: txt4,
	txt5: txt5,
	txt6: txt6,
	txt7: txt7,
	txt8: txt8,
	txt9: txt9,
	txt10: txt10,
	txt11: txt11,
	txt12: txt12,
	txt13: txt13,
	txt14: txt14,
	txt15: txt15
};

var removeSuggestion = "suggestion";
var message = "The access rights of {0} have been removed. To prevent it from being accessed again, it is recommended that you modify the document link settings.";
var current = "current";
var suggest = "suggestion";
var anyone = "All";
var someone = "Designated person";
var read = "View only";
var write = "Editable";
var comment = "Can view and comment";
var btn_cancel = "Until next time";
var btn_submit = "Modify now";
var many_users = "{0}, {1} and {2} others";
var RemoveSuggestion = {
	removeSuggestion: removeSuggestion,
	message: message,
	current: current,
	suggest: suggest,
	anyone: anyone,
	someone: someone,
	read: read,
	write: write,
	comment: comment,
	btn_cancel: btn_cancel,
	btn_submit: btn_submit,
	many_users: many_users
};

var scanCodeTiptxt0 = "Open WeChat on your phone and scan it.";
var scanCodeTiptxt1 = "Send a private invitation to a friend";
var onlyCreatorTip = "Only your WeChat friends/group members can access it. Forwarding is invalid.";
var scopOfApplicationTip = "Applicable to company WeChat groups, paid private domain groups, private customer service, etc.";
var privicyInvite = "Private Link";
var privicyWaterMark = "Private watermark";
var AddCollaboratorPrivateInvitation = {
	scanCodeTiptxt0: scanCodeTiptxt0,
	scanCodeTiptxt1: scanCodeTiptxt1,
	onlyCreatorTip: onlyCreatorTip,
	scopOfApplicationTip: scopOfApplicationTip,
	privicyInvite: privicyInvite,
	privicyWaterMark: privicyWaterMark
};

var title = "Manage collaborators";
var inviteFriends = "Invite friends to collaborate";
var batchManagement = "Batch Management";
var searchPlaceholder = "Search for collaborators";
var filter = "filter";
var batchLabel = "Adjust to";
var selected = "Selected";
var selectAll = "Select All";
var search = "search";
var noResult = "No {0} results";
var online = "Online";
var team = "Team/Organization";
var joined = "Joined";
var notjoin = "Not Joined";
var visitorRights = "Guest permissions";
var blocked = "Blocked";
var accessBlocked = "Unauthorized";
var notJoined = "Not yet joined";
var removeCollaborator = "Cancel the authorization";
var removeBlock = "Clear History";
var loading = "loading...";
var transferOwnerDisableForSecret = "Encrypted documents are not currently supported for transfer";
var modifiedSuccessfully = "Modification successful";
var changeFail = "Modification failed";
var removePartFail = "Partial removal failed";
var removeFail = "Removal failed";
var canNotChangeGroupMemberPerm = "Currently, it is not possible to adjust the permissions of individual members in a team.";
var multiRemoveSuccess = "Removed successfully";
var transferSuccess = "Transfer Success";
var manageable = "Manageable";
var owner = "Document Owner";
var settingSuccess = "Set up for success";
var clear = "Clear";
var myContact = "My Contacts";
var addCorp = "Add collaboration";
var unAuthorized = "Unauthorized";
var lookUserSetting = "View Member Authorization";
var noCollabortorsCoop = "No friends have joined the collaboration";
var retry = "Retry";
var pleaseRetry = "Loading failed, please try again";
var afterNotify = "This person will be notified later";
var limitCount = "Supports selecting up to 200 collaborators";
var searchResult = "Search Results";
var filterResult = "Filter results";
var isExitNoPerm = "There is an unauthorized user. Please select again.";
var oldNotJoinedDataTip = "If you do not access the document after June 30, 2023, you will be deemed not to have joined";
var CollaboratorsV2 = {
	title: title,
	inviteFriends: inviteFriends,
	batchManagement: batchManagement,
	searchPlaceholder: searchPlaceholder,
	filter: filter,
	batchLabel: batchLabel,
	selected: selected,
	selectAll: selectAll,
	search: search,
	noResult: noResult,
	online: online,
	team: team,
	joined: joined,
	notjoin: notjoin,
	visitorRights: visitorRights,
	blocked: blocked,
	accessBlocked: accessBlocked,
	notJoined: notJoined,
	removeCollaborator: removeCollaborator,
	removeBlock: removeBlock,
	loading: loading,
	transferOwnerDisableForSecret: transferOwnerDisableForSecret,
	modifiedSuccessfully: modifiedSuccessfully,
	changeFail: changeFail,
	removePartFail: removePartFail,
	removeFail: removeFail,
	canNotChangeGroupMemberPerm: canNotChangeGroupMemberPerm,
	multiRemoveSuccess: multiRemoveSuccess,
	transferSuccess: transferSuccess,
	manageable: manageable,
	owner: owner,
	settingSuccess: settingSuccess,
	clear: clear,
	myContact: myContact,
	addCorp: addCorp,
	unAuthorized: unAuthorized,
	lookUserSetting: lookUserSetting,
	noCollabortorsCoop: noCollabortorsCoop,
	retry: retry,
	pleaseRetry: pleaseRetry,
	afterNotify: afterNotify,
	limitCount: limitCount,
	searchResult: searchResult,
	filterResult: filterResult,
	isExitNoPerm: isExitNoPerm,
	oldNotJoinedDataTip: oldNotJoinedDataTip
};

var popperTitle = "Knowledge View";
var SharedWiki = {
	popperTitle: popperTitle
};

var login = {
  logic: {
    AvatarPanel: AvatarPanel,
    AInewfileRecommend: AInewfileRecommend,
    AiProtocol: AiProtocol,
    CreateGroupTask: CreateGroupTask,
    InviteTask: InviteTask,
    UploadFileTask: UploadFileTask,
    QrCode: QrCode,
    BackupSettingSelect: BackupSettingSelect,
    BackupSetting: BackupSetting,
    DialogBackupSettings: DialogBackupSettings,
    FloatBox: FloatBox,
    AddRecommendContact: AddRecommendContact,
    AddressBook: AddressBook,
    AppDownload: AppDownload,
    AppealIllegalFile: AppealIllegalFile,
    AddToCoop: AddToCoop,
    AppFinder: AppFinder,
    ClinkCoopBox: ClinkCoopBox,
    ClinkPerm: ClinkPerm,
    ClinkSettingBox: ClinkSettingBox,
    ClinkTime: ClinkTime,
    CompanyGuidePanel: CompanyGuidePanel,
    CompanyAdminInviteApprove: CompanyAdminInviteApprove,
    CompanyAdminDismission: CompanyAdminDismission,
    CompanyAdminDocSettings: CompanyAdminDocSettings,
    ContactInvitationPanel: ContactInvitationPanel,
    CoopMember: CoopMember,
    CoopMemberList: CoopMemberList,
    CoopMemberSearch: CoopMemberSearch,
    CoopMemberSearcher: CoopMemberSearcher,
    CopyEditLink: CopyEditLink,
    CopyLink: CopyLink,
    CorpSpaceFull: CorpSpaceFull,
    CreateTeam: CreateTeam,
    DocInfo: DocInfo,
    DeleteContact: DeleteContact,
    DialogCorpSpaceFull: DialogCorpSpaceFull,
    DialogCreateTeam: DialogCreateTeam,
    DialogEntCardsGuide: DialogEntCardsGuide,
    DialogEntDemo: DialogEntDemo,
    DialogEntGetCooper: DialogEntGetCooper,
    DialogEntGuide: DialogEntGuide,
    DialogLinkJumpTip: DialogLinkJumpTip,
    DialogModifyFilePermission: DialogModifyFilePermission,
    DialogModifyFilePerSetting: DialogModifyFilePerSetting,
    Ent2019nCovGuide: Ent2019nCovGuide,
    EntCardsGuide: EntCardsGuide,
    EntCardsGuideVideo: EntCardsGuideVideo,
    EntGetCooper: EntGetCooper,
    EntRemoteWorkGuide: EntRemoteWorkGuide,
    EntTeamtopDemo: EntTeamtopDemo,
    EntSharePanel: EntSharePanel,
    EditLabel: EditLabel,
    FileCopy: FileCopy,
    FileDownload: FileDownload,
    FileMove: FileMove,
    FileInfo: FileInfo,
    SecureTeamConfirm: SecureTeamConfirm,
    ShareV2: ShareV2,
    ShareV3: ShareV3,
    FinishCompPrivilege: FinishCompPrivilege,
    GroupTemplateGuide: GroupTemplateGuide,
    GroupTplVideo: GroupTplVideo,
    GuideReminder: GuideReminder,
    GuideSingleTip: GuideSingleTip,
    GuideStepTips: GuideStepTips,
    ImportPersonalFolder: ImportPersonalFolder,
    DialogImportFromSpecail: DialogImportFromSpecail,
    ImportFromSpecailTips: ImportFromSpecailTips,
    ImportFromSpecail: ImportFromSpecail,
    ImportPersonalFolderPlus: ImportPersonalFolderPlus,
    InviteColleague: InviteColleague,
    JoinCompPrivilege: JoinCompPrivilege,
    LinkCoopBox: LinkCoopBox,
    LinkDownloadPerm: LinkDownloadPerm,
    LinkRenamePerm: LinkRenamePerm,
    LinkSettingBox: LinkSettingBox,
    LinkTime: LinkTime,
    LinkToCoop: LinkToCoop,
    MemberSelectorPlus: MemberSelectorPlus,
    ModifyFilePermission: ModifyFilePermission,
    ModifyFilePerSetting: ModifyFilePerSetting,
    ModifyPermission: ModifyPermission,
    ModifyPermissionInfoSub: ModifyPermissionInfoSub,
    ModifyPermissionInfoTip: ModifyPermissionInfoTip,
    OpenShare: OpenShare,
    OpenClient: OpenClient,
    PublishFile: PublishFile,
    Report: Report,
    RequestShareOutside: RequestShareOutside,
    DriveRegisterVip: DriveRegisterVip,
    SendVerfiyMessage: SendVerfiyMessage,
    SlideHelper: SlideHelper,
    TeamSceneSelector: TeamSceneSelector,
    TeamSceneVideo: TeamSceneVideo,
    TeamTopAreaNotice: TeamTopAreaNotice,
    TeamTagPanel: TeamTagPanel,
    Upload: Upload,
    UpToCorpTeam: UpToCorpTeam,
    UpToPersonalTeam: UpToPersonalTeam,
    UpToPersonalTeamGuide: UpToPersonalTeamGuide,
    UpToPersonalTeamSelect: UpToPersonalTeamSelect,
    DialogUpToPersonalTeam: DialogUpToPersonalTeam,
    CompanyHelpContent: CompanyHelpContent,
    TransferTeamMembers: TransferTeamMembers,
    TransferTeamComfirm: TransferTeamComfirm,
    TransferTeam: TransferTeam,
    ShareWithContactsEntry: ShareWithContactsEntry,
    SendAddContactInvitation: SendAddContactInvitation,
    SecureInfo: SecureInfo,
    NoviceTaskList: NoviceTaskList,
    NoviceGuideReminder: NoviceGuideReminder,
    ModifyMemberName: ModifyMemberName,
    MemberApproval: MemberApproval,
    InviteContact: InviteContact,
    InviteBySend: InviteBySend,
    DelLink: DelLink,
    DelMember: DelMember,
    FolderShareSetting: FolderShareSetting,
    EntFolderShareSetting: EntFolderShareSetting,
    FolderShareOpen: FolderShareOpen,
    FolderShareMain: FolderShareMain,
    EntFolderShareMain: EntFolderShareMain,
    FolderShareDelete: FolderShareDelete,
    FolderShareCancel: FolderShareCancel,
    FolderShare: FolderShare,
    DialogNoviceTask: DialogNoviceTask,
    DialogMemberApproval: DialogMemberApproval,
    DialogJoinCompPrivilege: DialogJoinCompPrivilege,
    DialogFolderShare: DialogFolderShare,
    DialogCompanyInvite: DialogCompanyInvite,
    DialogAddEntMember: DialogAddEntMember,
    DeleteEntMember: DeleteEntMember,
    CompanyMemberInviteSetting: CompanyMemberInviteSetting,
    CompanyLogo: CompanyLogo,
    CompanyHelpHead: CompanyHelpHead,
    AddEntMember: AddEntMember,
    ClinkAdvancedSetting: ClinkAdvancedSetting,
    ActivityContent: ActivityContent,
    AppCenter: AppCenter,
    AvatarList: AvatarList,
    CloseSecure: CloseSecure,
    DialogTeamSettings: DialogTeamSettings,
    DialogTeamAppSettings: DialogTeamAppSettings,
    DialogShareFile: DialogShareFile,
    DialogSchedule: DialogSchedule,
    SecurePhoneCheck: SecurePhoneCheck,
    SecureTips: SecureTips,
    TeamDeleteOrExit: TeamDeleteOrExit,
    TeamRename: TeamRename,
    TeamAppRename: TeamAppRename,
    TeamSettings: TeamSettings,
    TeamAppManage: TeamAppManage,
    TransferConfirm: TransferConfirm,
    TransferMembers: TransferMembers,
    TransferTips: TransferTips,
    ContactLeaveMessage: ContactLeaveMessage,
    AppsSidebar: AppsSidebar,
    MContactSelector: MContactSelector,
    UnLockSecretFolder: UnLockSecretFolder,
    FilesSaveAs: FilesSaveAs,
    CorpTeamSpaceFull: CorpTeamSpaceFull,
    GroupTemplateUpdateInfo: GroupTemplateUpdateInfo,
    TeamGuide: TeamGuide,
    DialogTeamFolderSettings: DialogTeamFolderSettings,
    TeamFolderSettings: TeamFolderSettings,
    LeaveCompany: LeaveCompany,
    LeaveCompanyPhoneCheck: LeaveCompanyPhoneCheck,
    WaterMarkSetting: WaterMarkSetting,
    FileCollection: FileCollection,
    FileCollectionLink: FileCollectionLink,
    DialogFileCollection: DialogFileCollection,
    ShareRangeTips: ShareRangeTips,
    GroupApply: GroupApply,
    GroupApplyList: GroupApplyList,
    GroupApplySuccess: GroupApplySuccess,
    DialogUpToCorpTeam: DialogUpToCorpTeam,
    DialogGroupApply: DialogGroupApply,
    DialogEnterFilePerSetting: DialogEnterFilePerSetting,
    CreateCustomizePermission: CreateCustomizePermission,
    CustomizeGroup: CustomizeGroup,
    DeleteCustomizePermission: DeleteCustomizePermission,
    DialogCreateCustomizePermission: DialogCreateCustomizePermission,
    DialogCustomizeFilePerSetting: DialogCustomizeFilePerSetting,
    CustomizeFilePerSetting: CustomizeFilePerSetting,
    CompanyTemplateSaving: CompanyTemplateSaving,
    CompanyTemplateSetting: CompanyTemplateSetting,
    CompanyTemplateRename: CompanyTemplateRename,
    CompanyTemplateUpload: CompanyTemplateUpload,
    CompanyTemplateUploadDetail: CompanyTemplateUploadDetail,
    CompanyTemplateDelete: CompanyTemplateDelete,
    CompanyTemplate: CompanyTemplate,
    TeamFileRecommend: TeamFileRecommend,
    TeamFileTop: TeamFileTop,
    ModifyShareScope: ModifyShareScope,
    CompanyMemberInfoCard: CompanyMemberInfoCard,
    DialogEntTeamFuncManage: DialogEntTeamFuncManage,
    EntShareManage: EntShareManage,
    EntFileFilter: EntFileFilter,
    UpgradePrivilege: UpgradePrivilege,
    CompanyRegister: CompanyRegister,
    CompanyRegisterSuccess: CompanyRegisterSuccess,
    EnterpriseIndexRadar: EnterpriseIndexRadar,
    DialogEnterpriseIndexRadar: DialogEnterpriseIndexRadar,
    LinkChkCodePerm: LinkChkCodePerm,
    MShareFileMore: MShareFileMore,
    TransferOwnerConfirm: TransferOwnerConfirm,
    EntMultiEditConfirm: EntMultiEditConfirm,
    SaveAndEdit: SaveAndEdit,
    ApplyPermission: ApplyPermission,
    OrderAdminApplyment: OrderAdminApplyment,
    FlashPopover: FlashPopover,
    NewbieTask: NewbieTask,
    DialogGetTemplates: DialogGetTemplates,
    KRiskyDownloadTips: KRiskyDownloadTips,
    StepGuidePopover: StepGuidePopover,
    FileLabel: FileLabel,
    Privilege: Privilege,
    InBox: InBox,
    ShareTips: ShareTips,
    GroupLabelManager: GroupLabelManager,
    ShareFileAdvanceSettings: ShareFileAdvanceSettings,
    OutDateService: OutDateService,
    DialogWPSGuide: DialogWPSGuide,
    QrCodeBind: QrCodeBind,
    PersonalCoopHasPerm: PersonalCoopHasPerm,
    PersonalCoopNoPerm: PersonalCoopNoPerm,
    DialogPersonalShareFile: DialogPersonalShareFile,
    ShareFileChannels: ShareFileChannels,
    EntSetPubDocAttr: EntSetPubDocAttr,
    CopyMoveFailList: CopyMoveFailList,
    MultiAccountSelectList: MultiAccountSelectList,
    MultiAccountFileImport: MultiAccountFileImport,
    CreateShortcut: CreateShortcut,
    EntJoinByLink: EntJoinByLink,
    Message: Message,
    HistoryVersionLabelManager: HistoryVersionLabelManager,
    VersionTagsList: VersionTagsList,
    DialogVipAllocation: DialogVipAllocation,
    AddTeam: AddTeam,
    MiniCode: MiniCode,
    newShareV2: newShareV2,
    DialogCompanyTemplateUpload: DialogCompanyTemplateUpload,
    DialogCompanyTemplateEdit: DialogCompanyTemplateEdit,
    QuickCollect: QuickCollect,
    QuickCollectLimited: QuickCollectLimited,
    DialogAdvancedSetting: DialogAdvancedSetting,
    DialogGoToAdvancedSetting: DialogGoToAdvancedSetting,
    ShareCreateTeam: ShareCreateTeam,
    PCCustomShareDateDialog: PCCustomShareDateDialog,
    TeamSpace: TeamSpace,
    ShowAuthenticationInfo: ShowAuthenticationInfo,
    corpMarkSwitch: corpMarkSwitch,
    DialogShareCooperate: DialogShareCooperate,
    MultiManageConfirm: MultiManageConfirm,
    Nps: Nps,
    ApproveOpenCoop: ApproveOpenCoop,
    ShareCooperate: ShareCooperate,
    LogoutFail: LogoutFail,
    TeamAuth: TeamAuth,
    OperationBanner: OperationBanner,
    CollaboratorItem: CollaboratorItem,
    DialogCollaborationInviteMembers: DialogCollaborationInviteMembers,
    DialogEntFolderShareSetting: DialogEntFolderShareSetting,
    DialogShareFolderUPToCorpTeam: DialogShareFolderUPToCorpTeam,
    ArchivePreview: ArchivePreview,
    DialogCreateTeamDenied: DialogCreateTeamDenied,
    DialogCreateTeamGuidance: DialogCreateTeamGuidance,
    DialogCreateTeamSimply: DialogCreateTeamSimply,
    DialogCreateTeamUpgradeAnnouncement: DialogCreateTeamUpgradeAnnouncement,
    DialogCreateTeamImportDataSuccessfully: DialogCreateTeamImportDataSuccessfully,
    MultiAccountSwitch: MultiAccountSwitch,
    CreateEnterprise: CreateEnterprise,
    EntSearchAddCollaConfrm: EntSearchAddCollaConfrm,
    CooperateTagIcon: CooperateTagIcon,
    PartnerInformationPanel: PartnerInformationPanel,
    PublicInformationPanel: PublicInformationPanel,
    AddMemberFailedTips: AddMemberFailedTips,
    TransferFileApprove: TransferFileApprove,
    DialogConvertPage: DialogConvertPage,
    ConvertPage: ConvertPage,
    NotifyUnusedMembers: NotifyUnusedMembers,
    MessageBubble: MessageBubble,
    ShareV3Face: ShareV3Face,
    DownloadClientPanel: DownloadClientPanel,
    DialogNewEnterpriseGuidance: DialogNewEnterpriseGuidance,
    DialogCreateShareFolder: DialogCreateShareFolder,
    TaskPanelReward: TaskPanelReward,
    TaskPanel: TaskPanel,
    CompanyInvitePanel: CompanyInvitePanel,
    RemoveSuggestion: RemoveSuggestion,
    AddCollaboratorPrivateInvitation: AddCollaboratorPrivateInvitation,
    CollaboratorsV2: CollaboratorsV2,
    SharedWiki: SharedWiki
  }
};

var mLogic = {
	MDownloadSingle: {
		txt0: "Click the \"...\" button in the upper right corner",
		txt1: "Use Safari",
		txt2: "turn on",
		txt3: "File exporting... Please wait.",
		txt4: "Exported successfully.",
		txt5: "Export failed."
	},
	MShareFileMember: {
		txt0: "Current team",
		txt1: "People can edit",
		txt2: "People can view, where",
		txt3: "People can view",
		txt4: "Add designated members",
		txt5: "Creator",
		txt6: "Viewable",
		txt7: "Editable",
		txt8: "File creator",
		txt9: "Join via link",
		txt10: "Directly specify to add",
		txt11: "Editable",
		txt12: "Viewable",
		txt13: "Remove",
		txt14: "Cancel",
		txt15: "I",
		txt16: "Document Encrypted By",
		txt17: "Invite Members",
		canComment: " can comment ",
		addedShareMember: "People who have joined sharing",
		addedCollaborator: "Add collaborators"
	},
	MShareFileMore: {
		txt0: "Current link",
		txt1: "Reset link",
		txt3: "Link reset successfully",
		txt4: "Please confirm cancel sharing",
		txt5: "All",
		txt6: "Editors only",
		KsheetDownloadPermText: "Prohibit viewers from exporting, printing, saving a copy, and copying.",
		canDownloadPermText: "People who can download, print, save a copy, and copy the content.",
		KsheetCanDownloadPermText: "People who can export, print, save a copy, and copy the content.",
		ksheetDownloadPermText: "Prohibit viewers from exporting, printing, saving a copy, and copying.",
		dbtDownloadPermText: "Prohibit viewers from saving a copy and copying.",
		imgDownloadPermText: "Prohibit viewers from downloading and saving a copy.",
		txt2: "Unshare",
		txt7: "Only oneself",
		downloadPermText: "Prevent viewers from downloading, saving, and printing files",
		fpDownloadPermText: "Prohibit export and save by viewers",
		processonDownloadPermText: "Prohibit export and save by viewers",
		kdbtPermText: "Prevent viewers from exporting, saving as, and copying content",
		accessConditionTxt: "Information required to access the document",
		accessConditionSubTxt: "Applicable for collecting visitor information when sending and receiving materials",
		copySuccessTxt: "Copy link successfully",
		closeFullComment: "Disable Notes",
		closeFullCommentMsg: "After this feature is disabled, users cannot post or view notes attached to the file."
	},
	MShareFileOpenShare: {
		txt0: "Link permissions",
		txt1: "Link validity period",
		txt2: "Permanent",
		txt3: " effective ",
		txt4: "Copy",
		txt5: "Close the login-free link",
		txt6: "WPS Docs",
		txt7: "Anyone can view",
		txt8: "Anyone can edit",
		txt9: "Members of this enterprise can view",
		txt10: "Members of this enterprise can edit",
		txt11: "Only designated people can view/edit",
		txt12: "Only designated people can view",
		txt13: "Copy successfully",
		txt14: "Copy failed",
		txt15: "Your browser does not support automatic copy, please click",
		txt16: "Copy the content of the input box below",
		txt17: "Sharing function upgrade and maintenance",
		txt18: "Free login link is closed"
	},
	MShareFilePermission: {
		txt0: "Share publicly",
		txt1: "Anyone can view",
		txt2: "Anyone can edit",
		txt3: "Specified sharing",
		txt4: "Members of this enterprise can view",
		txt5: "Members of this enterprise can edit",
		txt6: "Only designated people can view/edit",
		txt7: "Only designated people can view",
		txt8: "Add collaborator",
		txt9: "Cancel",
		txt10: "Confirm",
		txt11: "Successfully modified",
		anyoneComment: "Anyone can comment",
		companyComment: "Enterprise members can comment",
		someoneWrite: "Only specified users can view/comment/edit"
	},
	MShareFileTime: {
		txt0: " link fails, friends will not be able to join the document collaboration through the link",
		txt1: " valid for 7 days",
		txt2: "Valid for 30 days",
		txt3: "Permanent",
		txt4: "Cancel",
		txt5: "Confirm",
		txt6: "The link validity period is set successfully"
	},
	MUpdateVersion: {
		upgradeToNewest: "The current version does not support this feature. Please update to the latest version.",
		upgradeTips: "Update Tips",
		cancelUpgrade: "Cancel",
		downloadSoon: "Download now",
		isLoadding: "Loading the latest version information...",
		isLatest: "The current version is the latest version.",
		error: "Failed to obtain the version update information. Please try again.",
		stopped: "The current version is not supported. Update to the latest version.",
		willStop: "The support of the current version will end by {month}/{day}/{year}. Update to the latest version."
	},
	MClipboardModal: {
		title: "Open Clipboard Link",
		open: "Open Now",
		errOpen: "Got it",
		errFname: "Failed to recognize the link.",
		expired: "The file link has expired."
	},
	MShareFileBindOfficeAccount: {
		title: "Share Online Document to Official Account",
		content: "When you publish an article on your WeChat official account, you can insert the WPS Docs Mini Program card into the article to share the current document.",
		helpText: "For more details, see Help Documentation.",
		bindText: "Bind Info",
		pathText: "Mini Program path:",
		copyMessageText: "Copy the binding info with one click.",
		currentText: "Current permissions are",
		changeText: "Are you sure you want to modify the permission to",
		anyone_comment: "Anyone can comment",
		company_comment: "Enterprise members can comment",
		close_comment: "Only specified users can view/comment/edit",
		cancelText: "Cancel",
		confirmText: "OK",
		copySuccessText: "Copied successfully",
		copyErrorText: "Copy failed",
		anyone_read: "Anyone can view",
		anyone_write: "Anyone can edit",
		company_read: "Members of this enterprise can view",
		company_write: "Members of this enterprise can edit",
		close: "Only specified people can view and edit",
		close_read: "Only specified people can view"
	},
	MShareFileSearch: {
		searchPlaceholder: "Search",
		error: "Unknown error",
		emptyTxt: "No matching contacts found",
		groupMemberTxt: "Team Members",
		confirmTxt: "Confirm"
	},
	MAccessCondition: {
		infoTitle: "Required information",
		infoTxt: "name, phone number",
		recordTxt: "Access to records",
		countTxt: "person has filled in"
	},
	MAccessCreator: {
		titleTxt: "Visitors will be required to complete the following before viewing the document",
		subTitleTxt: "The following settings only take effect for this file",
		creatorTxt: "visitor interface"
	},
	MRecord: {
		dataTxt: "access data",
		todayTxt: "today",
		downloadLeftTxt: "Export access records (",
		downloadRightTxt: "person has filled in)",
		readCountTxt: "time visited",
		readMemberTxt: "View the number of people",
		editTxt: "number of editors"
	},
	FileAccessInfo: {
		accessTxt: "to fill in",
		fileAccessTxt: "Before requesting to view the document, fill in the name and mobile phone number",
		nameTxt: "Name",
		phoneTxt: "Phone number",
		placeholderNameTxt: "Please fill in your name",
		placeholderPhoneTxt: "Please fill in your phone number",
		clearTxt: "clear",
		submitTxt: "View Files",
		warnTxt: "Please fill in your name and phone number correctly",
		unkownMsg: "unknown mistake",
		warnTipTxt: "The information is not officially collected by WPS Docs, please verify the document creator",
		warnTipTxt2: "identity, preventing information leakage",
		inviteTxt: "invite you",
		inviteTopTxt: "Fill in your name and phone number for follow-up contact",
		inviteSubTxt: "If it is not convenient to provide, you can choose to opt out of the document review",
		extDocTxt: "Exit the document",
		writeAndReadTxt: "fill and view"
	},
	MNewShare: {
		cancel: "Cancel",
		application: "Apply",
		permTitle: "Permission",
		dialogTitle: "Suggestion",
		txt10: "Next time",
		txt11: "Modify now",
		txt_remove_2: "Remove",
		txt_noData: "No access record",
		txt_operate: "Operation in progress...",
		txt_success: "Permissions have been set successfully",
		addMemberFromAddressBook: "Add from contacts",
		tab_all: "All",
		selectAll: "Select all",
		pageTtitleShareMember: "Collaborators",
		can_write: "Editable",
		can_read: "Viewable",
		unlogin: "Not logged in",
		subtitle_online: "Online",
		subtitle_today: "Today",
		no_perm: "No permission",
		batch_remove: "Remove",
		remove_success: "Remove successfully",
		delete_success: "Delete successfully",
		set_permission_success: "Set successfully",
		modify_success: "Modify successfully",
		multi_dialog_tips: "Hint",
		multi_dialog_know: "Got it",
		batchTitle: "Batch Operation",
		txt6: "The access permission of",
		txt7: "is removed. To prevent the user from accessing the document again, we recommend that you modify the document link settings.",
		txt8: "Current:",
		txt9: "Suggestion:",
		txt_remove: "Remove from Collaboration",
		txt_remove_1: "Already",
		noPrivilegeTips: "No permission. Contact the company super administrator.",
		tab_latest: "Recent Access",
		batchRemove: "Batch Delete",
		batchAction: "Batch Operation",
		pageTitleJoinByLink: "Joined by Link",
		emptyListTips: "No data.",
		changePerm: "Modify Permission",
		anyone_close_read: "Specified users can view",
		subtitle_just: "Just now",
		subtitle_last: "Recently online",
		menu_remove: "Remove from Collaboration",
		remove_some_success: "Partial removal failed.",
		remove_failed: "Removal failed.",
		remove_success_batch: "Batch removal succeeded.",
		multi_dialog_content: "Permission sources and groups of the current user"
	}
};
var mLogic$1 = {
	mLogic: mLogic
};

var request = {
	drive: {
		txt0: " etc. ",
		txt1: " members",
		txt2: " added failed ",
		txt3: "The number of shared members has reached the upper limit"
	}
};
var request$1 = {
	request: request
};

var utils = {
	errors: {
		txt0: "Your 3 free teams have been used up, you can upgrade your membership to have the privilege of creating 50 teams and 100G cloud space.",
		txt1: "The team name should be at least 2 Chinese characters or 4 letters",
		txt2: "The team name cannot contain the following characters: \\/;:*?\"<>|%&",
		txt3: "Team name cannot exceed 100 characters",
		txt4: "Account has been logged out, please log in again",
		txt5: "Invalid parameters submitted",
		txt6: "The server is busy, please try again later",
		txt7: "Server error",
		txt8: "Account is not authorized",
		txt9: "Account has expired",
		txt10: "Your operation authority is insufficient",
		txt11: "Domain name already exists",
		txt12: "Enterprise does not exist",
		txt13: "Invalid enterprise name",
		txt14: "Enterprise name is too long",
		txt15: "User already exists",
		txt16: "Department is not empty",
		txt17: "This team already exists",
		txt18: "The team has reached the upper limit",
		txt19: "Please enter a correct email/phone number",
		txt21: "The team no longer exists",
		txt22: "Team link no longer exists",
		txt23: "Cannot add business account",
		txt24: "User does not exist",
		txt25: "File name cannot exceed 100 characters",
		txt26: "A file with the same name exists",
		txt27: "File (folder) does not exist",
		txt28: "You are no longer a member of this team",
		txt29: "The name cannot contain illegal characters and special symbols \\/:*?\"<>|",
		txt30: "The name cannot contain illegal characters and special symbols: \\/;:*?\"<>|%&",
		txt31: "File name cannot be empty",
		txt32: "Ordinary members can only move their own files",
		txt33: "The file move position remains unchanged",
		txt34: "Link already exists",
		txt35: "The link does not exist or has been reset",
		txt36: "Private folder privilege has expired",
		txt37: "Permission verification failed, please refresh and try again",
		txt38: "There is no operation permission for the current directory, please contact the administrator",
		txt39: "No new permission for the current directory",
		txt40: "Please keep either email or mobile phone",
		txt41: "Your operating frequency is too fast, please try again later",
		txt42: "This mobile phone has exceeded the maximum number of verification codes, please try again tomorrow",
		txt43: "Incorrect phone format",
		txt44: "This phone has been bound to another account",
		txt45: "Please enter the correct email format",
		txt46: "The mailbox has been bound to another account, please change one",
		txt47: "Verification code error",
		txt48: "The mailbox has been bound to another account, please change one",
		txt49: "Unable to unbind, at least one email or mobile account is required, please bind the email first and then unbind the mobile phone",
		txt50: "Verification code error",
		txt51: "Password is 8-16 digits, 3 combinations of uppercase and lowercase letters, numbers or symbols",
		txt52: "You have bound your phone",
		txt53: "This phone has been bound to another account",
		txt54: "verification code must be filled",
		txt55: "The verification code is incorrect. Please re-enter",
		txt56: "The verification code is incorrect. Please re-enter",
		txt57: "You have bound the mailbox",
		txt58: "Email does not exist",
		txt59: "Illegal operation",
		txt60: "Cannot contain characters! @#$^*<>?",
		txt61: "wrong password",
		txt62: "Failed to open the file, the light address password has been changed.",
		txt63: "Comment content exceeds 255 characters",
		txt64: "Sharing failed",
		txt65: "Comments cannot exceed 255 words",
		txt66: "Failed to move file",
		txt67: "Link closed",
		txt68: "file does not exist",
		txt69: "internal error",
		txt70: "File content read error",
		txt71: "Too many folder levels, please select again",
		txt72: "Download failed, the selected file format does not support download",
		txt73: "Download failed, downloading empty folders is not supported",
		txt74: "You have not selected any physical file, please confirm whether the file exists",
		txt75: "No file search function permission",
		txt76: "Copy to subfolder is not supported, please select again",
		txt77: "Copying directories with subfolders is not supported, please select again",
		txt78: "Copying directories with subfolders is not supported, please select again",
		txt79: "File batch operation task failed",
		txt80: "Does not support operating more than 5000 files, please select again",
		txt81: "File batch operation task does not exist",
		txt82: "File operation is in progress, please try again later",
		txt83: "Name is too long",
		txt84: "Invalid ssid",
		txt85: "User has signed up",
		txt86: "Cannot import data from the same account",
		txt87: "Verification result has expired",
		txt88: "The verification code is incorrect. Please re-enter",
		txt89: "Parameter missing ssid",
		txt90: "ssid parameter error",
		txt91: "Failed to obtain user information of the merged account",
		txt92: "Report merge completion failed",
		txt93: "Cannot merge accounts of different companies",
		txt94: "Users of this enterprise cannot merge accounts",
		txt95: "Failed to obtain user authorized security document",
		txt96: "Unable to get the information of the logged in user",
		txt97: "The verification information is inconsistent with the bound account",
		txt98: "Binding time is too short",
		txt99: "The collaboration has been disbanded",
		txt100: "Exceeded team limit",
		txt101: "You are no longer a member of this group",
		txt102: "Contains sensitive words",
		txt103: "Team name contains sensitive words",
		txt104: "Network exception",
		txt105: "Unknown Error",
		txt106: "The maximum length of the app name is 256 characters.",
		txt107: "The name cannot contain invalid characters and special symbols \\/:*?\"<>|"
	},
	link: {
		txt0: " Only designated person",
		txt1: " Only designated person",
		txt2: "Members of this enterprise ",
		txt3: "Members of this enterprise ",
		txt4: "Share members only",
		txt5: "Designated person below",
		txt6: "Designated person below",
		txt7: "Members of this enterprise ",
		txt8: "Members of this enterprise ",
		txt9: "Share members only",
		txt10: "Only oneself",
		txt11: "Who opened the link ",
		txt12: "Only you can access",
		txt13: " Only designated people can access",
		txt14: "Members of this enterprise ",
		txt15: "Members of this enterprise ",
		txt17: "Anyone",
		txt18: "Who opened the link ",
		txt19: "File sharing link has expired, only designated people can access",
		txt20: "can view/edit",
		txt21: "can view",
		txt22: "can view",
		txt23: "can edit",
		txt24: "can view",
		txt25: "can edit",
		txt26: "can view/edit",
		txt27: "Cancel",
		txt28: " Share",
		txt29: " Share",
		txt30: "Reset Link",
		txt31: "can view",
		txt32: "Share link has expired",
		txt33: "My Contacts",
		comment: " can comment ",
		someoneAllPerm: "can view/comment/edit",
		anyone: "Anyone",
		can_View: "Can view",
		can_comment: "Can comment",
		can_edit: "Can edit",
		anyone_can_view: "Anyone can view",
		anyone_can_comment: "Anyone can comment",
		anyone_can_edit: "Anyone can edit",
		specify_shared_person: "Only specified users ",
		company_can_read: "Members of this company can view",
		company_can_comment: "Members of this company can comment",
		company_can_write: "Members of this company can edit",
		specify_shared_person_share: " Specified User "
	}
};
var utils$1 = {
	utils: utils
};

var config = {
	constants: {
		TEAM_ROLES: {
			admin: "Administrator",
			member: "Member · Editing allowed",
			read_member: "Members · view only"
		},
		COMPANY_ROLES: {
			"1": "Owner",
			"2": "Administrator",
			"3": "Member"
		}
	}
};
var configConstants = {
	config: config
};

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var enUS = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, basic$1), combine$1), miCombine), login), mLogic$1), request$1), utils$1), configConstants);

export { enUS as default };
